import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      brandNameRestriction:
        'We do not recommend including your brand name in the question - it may affect the quality of the response generated by the language model.',
      tools: 'Tools',
      menuGroups: {
        performance: 'Performance',
        prompts: 'Prompts',
        bots: 'Bots',
      },
      collapseMenu: 'Collapse menu',
      expandMenu: 'Expand menu',
      allProjects: 'All projects',
      noProjectsYet: 'No projects Yet',
      noProjectsYetMsg:
        'It looks like you haven\'t created any projects yet. Projects help you organize and track your brand’s performance across multiple queries, providing valuable insights into trends and visibility.<br><br>Start by creating a project to monitor the metrics that matter most to your business.<br><br>Click "Add New Project" to get started and gain real-time insights tailored to your goals',
      noPromptsYet: 'No prompts Yet',
      noPromptsYetMsg:
        'It looks like you haven\'t set up any monitors yet. Prompts help you keep track of your brand\'s position and share of voice across various queries. Start by adding a prompt to begin tracking the metrics that matter most to your business.<br><br>Click "Add new prompt" to get started and stay informed with real-time insights tailored to your needs.',
      addNewQuestion: 'Add new question',
      upgradeNow: 'Upgrade now',
      upgradePlanTrialExportMsg: 'Upgrade now for export features',
      upgradePlanTrialMsg: 'Upgrade now for premium features and better performance!',
      questions: 'Questions',
      promptsQuestions: 'Prompts / Questions',
      questionsPrompts: 'questions/prompts',
      allPrompts: 'All prompts',
      suggestedPrompts: 'Suggested prompts',
      suggestedPromptsGeneratingSoon:
        'Suggested prompts will appear</br>here in a few minutes.',
      regenerateSuggestedPrompts: 'Regenerate suggested prompts',
      regenerateSuggestedPromptsDesc:
        'All existing suggested prompts for this project <bold>will be permanently removed</bold> and regenerated from scratch.',
      regenerate: 'Regenerate',
      regenerating: 'Regenerating...',
      forceLanguageOptional: 'Force language (optional)',
      regenerateSingleSuccess: 'Regenerated ({{deleted}} cached entries removed)',
      regenerateError: 'Failed to regenerate suggested prompts',
      integrations: 'Integrations',
      pricing: 'Pricing',
      settings: 'Settings',
      logout: 'Logout',
      myAccount: 'My account',
      mobileNavHelp: 'Help',
      mobileSearch: 'Search',
      noExamplesAvailable:
        'Brand is mentioned in a factual or descriptive context without strong sentiment drivers.',
      changePaymentMethod: 'Change payment method',
      removePaymentMethod: 'Remove payment method',
      changePassword: 'Change password',
      subscription: 'Subscription',
      competitors: 'Competitors',
      industry: 'Industry',
      website: 'Website',
      orders: 'Orders',
      team: 'Team',
      teamManageDesc: 'Manage and view your team members.',
      invitedAt: 'Invited at',
      yourAccounts: 'Your accounts',
      darkMode: 'Dark mode',
      lightMode: 'Light mode',
      changeYourName: 'Change Your Name',
      changeNameMsg:
        'You can update your first and last name as they appear on your account. Ensure the information is accurate, as it will be used for communication, invoicing, and legal documents. Once updated, your new name will reflect across all areas of your account. Please double-check the spelling before saving any changes.',
      changeBillingAddress: 'Change your Billing Address',
      firstName: 'First name',
      lastName: 'Last name',
      plan: 'Plan',
      questionLimits: 'Question limit',
      userLimits: 'User limit',
      limitReached: "You've exceeded your quota",
      actions: 'Actions',
      startDate: 'Start date',
      paymentMethod: 'Payment method',
      cancelationDate: 'Cancelation date',
      nextPayment: 'Next payment',
      renewAccount: 'Restore account',
      removeAccount: 'Delete account',
      startCancellation: 'Start',
      cancellationProcessSuffix: ' the cancellation process.',
      companyName: 'Company name',
      phoneNumber: 'Phone number',
      taxId: 'TAX ID',
      contactName: 'Contact person',
      contactEmail: 'Contact email',
      emailAddress: 'Email address',
      firstLineAddress: 'Address',
      secondLineAddress: 'Address line 2',
      city: 'City',
      zipCode: 'Zip code',
      country: 'Country',
      selectCountry: 'Select a country',
      countryRequired: 'Select the country this project is tracked for.',
      countryMarketHint: 'Which market do you want to analyze?',
      global: 'Global',
      trialExpired: `Your trial has expired`,
      trialExpiredToday: 'Your trial will expire today',
      trialExpiredOneDay: 'Your trial will expire in 1 day',
      trialExpiredLeft: `Your trial will expire in {{daysLeft}} days`,
      reactivationExpired: 'Your reactivation has expired',
      reactivationExpiredToday: 'Your reactivation expires today',
      reactivationExpiredOneDay: 'Your reactivation is valid for 1 more day',
      reactivationExpiredLeft: `Your reactivation is valid for {{daysLeft}} days`,
      geolocationChanged: 'Geolocation changed {{country}}',
      monitorEventPromptAdded: 'prompt added "{{prompt}}"',
      monitorEventPromptDeleted: 'prompt deleted "{{prompt}}"',
      monitorEventModelAdded: 'model added',
      monitorEventModelDeleted: 'model deleted',
      monitorEventModelReleased: '{{model}} released',
      showMarkers: 'show markers',
      hideMarkers: 'hide markers',
      disabledAccount: 'Your account is currently disabled',
      overdueAccount: 'Your account is overdue',
      upgrade: `Upgrade`,
      stateProvince: 'State/Province',
      save: 'Save',
      interval: 'Interval',
      prompt: 'Prompt',
      addNew: 'Add new',
      remove: 'Remove',
      manageUser: 'Manage user',
      addNewBrand: 'Add new brand',
      logIn: 'Log in',
      currentLimits: 'Current limits',
      manageSubscription: 'Manage subscription',
      resetNow: 'Reset now',
      expandOrganicAnswer: 'Expanded list from the organic answer',
      noModelResponse: 'This model returned no answer for this query.',
      manageUserMsg:
        'User management allows you to view and manage user details such as first name, last name, and email. You can also remove users from the system if needed.',
      availableIntegrations: 'Available integrations',
      chatGPTDesc:
        'ChatGPT, an AI by OpenAI, generates human-like responses for questions, conversations, and text tasks.',
      claudeDesc:
        'Claude, an AI chatbot by Anthropic, is designed for natural conversations, prioritizing safety, clarity, and helpfulness.',
      geminiDesc:
        'Google Gemini is an AI model by Google that processes and generates text and images. Flash is designed for ultra-fast responses with lower computational cost.',
      geminiProDesc:
        'Flash Pro is a more capable version with enhanced reasoning, slightly larger context windows, and better performance on complex tasks.',
      newPassword: 'New password',
      rePassword: 'Re-password',
      comingSoon: 'Coming soon',
      integrationDesc:
        "Integrations in our app allow you to connect with external tools like ChatGPT, Google Gemini and Claude. This enables you to access the additional features these tools offer directly within our app. Integrations help automate processes, analyze data, generate content, and streamline collaboration, allowing you to manage information all in one place. It's a solution that enhances and expands the app’s capabilities, making your work more efficient.",
      changePasswordDesc:
        'In this section, you can update your account password for better security. Please ensure that your new password is at least 6 characters long and difficult to guess. After successfully changing your password, you will be automatically logged out for security reasons, and you will need to log in again with your new password.',
      daily: 'Daily',
      weekly: 'Weekly',
      currentSubscription: 'Current subscription',
      currentSubscriptionDesc:
        'In this section, you can review the details of your current subscription plan. You will find information about the features offered, usage limits, and the benefits available within your plan. You can also compare different plans to understand which additional features may be beneficial for you. If you feel you need more capabilities or better access to advanced features, consider the option to upgrade your plan. Make sure you are taking full advantage of everything our app has to offer!',
      billingData: 'Billing data',
      nip: 'VAT ID',
      role: 'Role',
      admin: 'Admin',
      owner: 'Owner',
      user: 'User',
      guest: 'Guest',
      guestProjectsAccess: 'Projects for the guest',
      guestNeedsProject: 'Select at least one project for the guest',
      guestSelectProjects: 'Select projects',
      guestProjectsSelected: '{0} projects selected',
      guestEditProjects: 'Edit guest projects',
      selectRole: 'Select role',
      users: 'Users',
      usersText: 'Users',
      dashboard: 'Dashboard',
      inviteUser: 'Invite user',
      inviteUserDesc:
        'The invite users feature allows you to send invitations to others, enabling them to share access to your account. This makes collaboration easier by giving team members the ability to work within the same account.',
      invite: 'Invite',
      firstNameRequired: 'First name is required',
      lastNameRequired: 'Last name is required',
      emailRequired: 'Email is required',
      validEmailAddress: 'Please enter a valid email address',
      noRole: 'No role',
      OK: 'OK',
      hourlyFilter: 'Hourly',
      dailyFilter: 'Daily',
      weeklyFilter: 'Weekly',
      monthlyFilter: 'Monthly',
      browserData: 'Browser data',
      apiData: 'API data',
      brandPositioningOverview: 'Brand Positioning Overview',
      stats: 'Stats',
      vsTopCompetitors: 'vs Top Competitors',
      averagePosition: 'Average Position',
      trends: 'Trends',
      selectBrandForMonitoring: 'Select a Brand for Monitoring',
      orWriteCustomName: 'or write custom name',
      exploreAIAnswers: 'Explore AI Answers',
      rowsNumber: 'Rows number',
      date: 'Date',
      addFirm: 'Add firm',
      everyDay: 'Every day',
      everyWeek: 'Every week',
      action: 'Action',
      created: 'Created',
      keyword: 'Keyword',
      keywords: 'Keywords',
      addNewTag: 'Add new tag',
      editTag: 'Edit tag',
      removeTag: 'Remove tag',
      deleteSelected: 'Delete selected',
      importFromCsv: 'Import from CSV',
      csvImportDialogDesc: 'Upload a CSV file to quickly add multiple prompts at once.',
      csvImportFormatOnePerRow: 'One prompt per row',
      csvImportFormatFirstColumn: 'First column only',
      csvImportFormatPlainText: 'No formatting needed - just plain text',
      csvImportClickToSelect: 'Click to select CSV file',
      csvImportUploading: 'Uploading… This may take a moment',
      csvImportSuccess: 'Done! {{count}} prompts added',
      csvImportErrorInvalidFormat: 'Error: Invalid file format - please upload a CSV file',
      csvImportErrorLimitExceeded: 'Error: Too many prompts - maximum is 300',
      csvDownloadTemplate: 'Download CSV template',
      csvImportSlotWarning: 'Your plan allows {{slots}} more prompts. Select which prompts to import.',
      csvImportSelected: '{{selected}}/{{slots}} selected',
      csvImportButton: 'Import {{count}} prompts',
      notificationCenterTitle: 'Notifications',
      notificationCenterEmpty: 'No notifications',
      notificationCenterEmptyDesc: "You're all caught up. You'll see new notifications here.",
      notificationPausedMonitors: '{{count}} paused questions you can reactivate',
      notificationProjectReady: '{{project}} is ready - your AI Visibility data is in',
      notificationAiVisibilityReportReady:
        '{{project}}: AI Visibility report ready ({{period}})',
      notificationCardExpiring: 'Your payment card is expiring ({{date}})',
      notificationPaymentReminder: 'Your subscription renews on {{date}}',
      pausedMonitorsPopupTitle: 'You have paused questions',
      pausedMonitorsPopupDesc:
        'Some of your questions are paused. Select which ones you would like to reactivate.',
      pausedMonitorsPopupSlots: 'Available slots: {{available}} / {{total}}',
      pausedMonitorsPopupActivate: 'Activate',
      pausedMonitorsPopupRemindLater: 'Remind me later',
      errorFetchingSearchVolume: 'An error occurred while fetching search volume. Please try again.',
      loginToYourAccount: 'Login to your account',
      forgotPassword: 'Forgot your password',
      sendMagicLink: 'Send magic link',
      sendMagicLinkInstead: 'Log in with a link',
      signInWithPassword: 'Sign in with password',
      magicLinkSent: 'Magic link sent! Check your email.',
      resetLinkSent: 'Password reset link sent! Check your email.',
      tooManyAttempts: 'Too many attempts. Please wait before trying again.',
      backToSignIn: 'Back to sign in',
      googleAuthFailed: 'Google authentication failed. Please try again.',
      signInWithGoogle: 'Sign in with Google',
      or: 'or',
      cantWaitToShow:
        'Can’t wait to show you what’s new. <strong>Sign in and see</strong> for yourself!',
      password: 'Password',
      dontHaveAnAccount: "Don't have an account",
      signUp: 'Sign Up',
      signIn: 'Sign In',
      alreadyHaveAccount: 'Already have account',
      crateAnAccount: 'Create an account',
      'b24Signup.by': 'A product by',
      'b24Signup.title': 'See how AI sees your brand',
      'b24Signup.subtitle':
        'Track how ChatGPT, Gemini, Perplexity, and other AI platforms mention, rank, and recommend your brand.',
      'b24Signup.emailPlaceholder': 'Enter your business email',
      'b24Signup.passwordPlaceholder': 'Create a password',
      'b24Signup.passwordHint': 'Use 8+ characters, at least one number and an uppercase letter',
      'b24Signup.submit': 'Start free trial',
      'b24Signup.disclaimer':
        "No credit card required. You'll create a separate Chatbeat workspace. Your Brand24 account, projects, and subscription will remain unchanged.",
      'b24Signup.legalPrefix': 'By signing up I agree to the',
      'b24Signup.legalAnd': 'and',
      'b24Signup.haveAccount': 'Already have a Chatbeat account?',
      'b24Signup.logIn': 'Log in',
      'b24Signup.benefit1': "Measure your brand's AI visibility",
      'b24Signup.benefit2': 'Compare your results with competitors',
      'b24Signup.benefit3': 'Discover which sources influence AI answers',
      'b24Signup.bannerPrefix': 'Chatbeat is the AI visibility tool by',
      'b24Signup.bannerSuffix': '- same team, same company.',
      'b24Signup.bannerBack': 'Back to brand24.com',
      'b24Signup.footerProductOf': 'is a product of',
      'b24Signup.footerSameCompany': '- the same company behind Brand24.',
      checkYourEmail: 'Check your email',
      verificationEmailSent:
        'We have sent you a verification email. Please check your inbox and click the verification link to activate your account.',
      resendVerification: 'Resend verification email',
      resendVerificationSuccess: 'Verification email sent! Check your inbox.',
      resendVerificationWait: 'You can resend in {{minutes}}:{{seconds}}',
      emailNotVerified: 'Please verify your email address before logging in.',
      emailVerifiedSuccess: 'Your email has been verified successfully!',
      emailVerifiedDescription: 'You can now log in to your account.',
      emailVerificationFailed: 'Verification link is invalid or has expired.',
      emailVerificationExpiredResent:
        'This verification link has expired. We have sent a new one to your email address.',
      emailVerificationFailedDescription: 'Please try signing up again or contact support.',
      backToLogin: 'Back to login',
      backToSignup: 'Back to signup',
      passwordReset: 'Password reset',
      passwordResetDesc: 'Enter your account email address and we will send you a password reset link.',
      continue: 'Continue',
      back: 'Back',
      language: 'Language',
      polish: 'Polish',
      english: 'English',
      monitoringQuestions: 'Monitoring questions',
      setNewPassword: 'Set new password',
      isRequired: 'is required',
      fieldIsRequired: 'Field is required',
      saveChanges: 'Save changes',
      conflictTagsName: 'A tag with this name already exists',
      loginPageTitle: 'Stay Ahead with Chatbeat',
      loginPageDesc:
        'Monitor your brand mentions and track competitors with AI-powered analytics. Sign up now and discover how Chatbeat can help you stay ahead of the competition!',
      wrongEmailAddress: 'Please enter a valid email address',
      signupPageTitle: 'Unlock Powerful Insights with Chatbeat',
      signupPageDesc:
        'Join Chatbeat today and leverage AI-driven analytics to monitor your brand’s presence. Sign up now to track real-time mentions and outshine the competition with data that matters!',
      next: 'Next',
      addCustomQuestions: 'Choose/add questions',
      saveAndLaunch: 'Save & Launch',
      chooseQuestions: 'Choose questions',
      projects: 'Projects',
      activeProjects: 'Active projects',
      addNewProject: 'Add new project',
      keyPromptsTitle: 'Key prompts / questions',
      keyPromptsFor: 'for {{name}}',
      brandScoreAndAveragePosition: 'Brand Score & Average Position',
      startBuildingAiVisibility: 'Start building your AI Visibility',
      startBuildingAiVisibilityDescription:
        "Your brand isn't visible in AI answers yet. Follow the GEO Recommendations to improve your visibility.",
      brandScoreAndVisibility: 'Brand Score & Visibility',
      brandScoreAndVisibilityTooltip:
        'Brand Score (strength of the brand when it is visible) and Visibility (share of AI responses that mention the brand), both as a percentage.',
      anomalyTooltipTitle: 'Anomaly',
      anomalyTooltipValues: 'Value change',
      anomalyTooltipTopPrompts: 'Main drivers',
      anomalyTooltipTopModels: 'Models contributing most',
      anomalyDirectionPositive: 'Positive change',
      anomalyDirectionNegative: 'Negative change',
      anomalyHeadlineTo: 'to',
      brandScoreImproved: 'improved from',
      brandScoreDeteriorated: 'deteriorated from',
      averagePositionImproved: 'improved from',
      averagePositionDeteriorated: 'deteriorated from',
      visibilityImproved: 'improved from',
      visibilityDeteriorated: 'deteriorated from',
      brandScoreAndMedianPosition: 'Brand Score & Median Position',
      brandScore: 'Brand Score',
      shareOfVoice: 'Share of Voice',
      // Compact-table header abbreviation; language-neutral (industry term).
      sovShort: 'SoV',
      averageShareOfVoice: 'Average Share of Voice',
      traffic: 'Traffic',
      visibility: 'Visibility',
      visibilityBarTooltip: 'How often each brand appears in AI generated discussions',
      showingDataForDays: 'Showing data for {{count}} days',
      lineChart: 'Line chart',
      barChart: 'Bar chart',
      visibilityTooltip:
        'Share of AI responses that mention your brand: responses mentioning your brand ÷ total responses × 100. Shows your brand’s overall presence in AI, regardless of position.',
      projectName: 'Project name',
      checkSearchVolume: 'Check search volume',
      addNewProjectHelp: 'Adding a New Question to Your Project',
      addNewProjectHelpDesc:
        'In the Add New Question section, you can configure automated questions for your project. The Query field allows you to define the question that will be used to interact with the chatbot. Additionally, each question added in this section will be assigned to the project.',
      backToProjects: 'Back to projects',
      backToAgencyHub: 'Back to Agency Hub',
      openProject: 'Open project',
      setupPreparingTitle: 'Analyzing how AI sees your brand',
      setupPreparingSubtitle: "We're building your AI Visibility data. This will take a moment.",
      setupStepBrandAdded: 'Brand added',
      setupStepPromptsSelected: 'Prompts selected',
      setupStepCollectingResponses: 'Collecting responses from AI models',
      setupStepVisibilityAnalysis: 'Analyzing your brand visibility',
      setupStepFinalization: 'Finalizing analysis',
      setupStateDone: 'Done',
      setupStateInProgress: 'In progress',
      setupStateWaiting: 'Waiting',
      setupNoteTitle: 'You can safely close this tab',
      setupNoteText: "We'll notify you as soon as your project is ready.",
      setupMeanwhile: 'In the meantime…',
      setupMeanwhileLead: "Here's what you'll unlock with Chatbeat.",
      setupValueRecommendationsTitle: 'GEO Recommendations',
      setupValueAuditDesc: "What's limiting your website's visibility in AI?",
      setupValueRecommendationsDesc: 'What to do to increase your visibility in AI?',
      setupValueBotsDesc: 'Track how AI crawlers visit and read your site.',
      setupOpen: 'Open',
      loadingDataPleaseWait: 'Loading data, please wait...',
      gatheringInformation:
        "We're preparing your data and insights. This might take a moment - stay tuned!",
      rangeTooltip:
        'Defines the range of data displayed on the chart. Adjusts the start and end points of the data shown to focus on a specific time period or data segment.',
      position: 'Position',
      wrongDomain: 'Invalid domain',
      gatheringStatsForThisRecord: 'Generating statistics for this company',
      noDataAvailable: 'No data available',
      errorLoadingDataRetry: 'Failed to load data. Please try again.',
      projectNoDataAvailableDesc:
        'There is currently no data to display for Traffic & Share of Voice. Please adjust your filters or try again later to see updated results.',
      noShareOfVoiceData: 'Data is on the Way',
      noShareOfVoiceDataDesc:
        "We're working on gathering insights. This chart will show your brand's share of voice once the data is ready.",
      noPositioningData: 'No Positioning Data Yet',
      noPositioningDataDesc:
        "Once insights are collected, this graph will showcase your brand's market positioning.",
      noAIData: 'Awaiting Data',
      noAIDataDesc:
        'There is currently no data to display for your AI Visibility. Make sure your data sources are connected and providing the latest information, and the chart will populate soon.',
      thisCompanyAlreadyExist: 'This company is already on the list',
      noData: 'No data',
      noDataDescription: 'No data available for the selected period',
      all: 'All models',
      modelsSelected: 'models selected',
      modelSelectOnly: 'Only',
      gpt: 'GPT 4o',
      searchVolume: 'Search Volume',
      statsMigration: 'Stats Migration',
      unlockFeature:
        'If you want to unlock this feature, <a href="mailto:help@chatbeat.com">contact&nbsp;us</a>',
      reachedLimit:
        'You have exceeded the limit or do not have the necessary permissions to perform this action. Delete the question or <a href="mailto:help@chatbeat.com">contact us</a> to unlock this feature.',
      reachedLimitProject:
        'You have exceeded the limit or do not have the necessary permissions to perform this action. Delete the project or <a href="mailto:help@chatbeat.com">contact us</a> to unlock this feature.',
      reachedUserLimit:
        'You’ve exceeded your limit or don’t have the necessary permissions to perform this action. Please delete a user or <a href="mailto:help@chatbeat.com">contact us</a> to unlock this feature.',
      areYouSureProceed: 'Are you sure you want to proceed?',
      areYouSure: 'Are you sure?',
      limitExceeded: 'Limit exceeded',
      tooltipAveragePosition:
        'The average position of the keyword in the text, indicating its typical placement relative to other keywords.',
      tooltipShareOfVoice:
        'The percentage of total market exposure your brand has compared to competitors within a specific industry or channel, measured over a selected time period.',
      tooltipTrends:
        'Displays the trend of the average keyword position from the start to the end of the specified range. Tracks how the average position has changed over time',
      tooltipKeyword:
        'Select a brand or keyword to monitor. If your brand is not listed, you can enter a new one to start tracking.',
      gptName: 'GPT',
      aiModeName: 'AI Mode',
      aiOverviewName: 'AI Overview',
      gptSearchName: 'GPT Search',
      geminiSearchName: 'Gemini Search',
      grokSearchName: 'Grok',
      copilotSearchName: 'Copilot',
      geminiName: 'Gemini',
      claudeName: 'Claude',
      deepSeekName: 'DeepSeek',
      perplexityName: 'Perplexity',
      downloadSources: 'Download sources',
      downloadDomains: 'Download domains',
      downloadPdfReport: 'Download PDF report',
      sources: 'Sources',
      positions: 'Brands positions',
      performanceByDomain: 'Performance by Domain',
      performanceByDomainTooltip:
        'Analyze domain performance with mentions, share changes, and trend comparisons across periods. Identify top-performing domains and understand their impact on your brand visibility.',
      performanceByDomainMentions: 'Mentions',
      performanceByDomainMentionsTooltip:
        'The number of times this domain was mentioned in AI-generated responses.',
      performanceByDomainMentionsChange: 'Change',
      performanceByDomainMentionsChangeTooltip:
        'The change in the number of mentions compared to the previous measurement period.',
      performanceByDomainShare: 'Share',
      performanceByDomainShareTooltip:
        'The share of this domain across all citations attributed to the project.',
      performanceByDomainShareChange: 'Change',
      performanceByDomainShareChangeTooltip:
        "The change in this domain's share compared to the previous measurement period.",
      mentions: 'Mentions',
      change: 'Change',
      share: 'Share',
      shareCurrent: 'Share (Current)',
      sharePrevious: 'Share (Previous)',
      shareDelta: 'Δ Share',
      sourceTypesShare: 'Source Types Share',
      sourceTypesShareTooltip:
        'Visualize the distribution of different source types to understand content source diversity. Analysis helps identify dominant categories and balance sources in your content marketing strategy.',
      domainsPerModel: 'Domains per Model',
      domainsPerModelTooltip:
        'Top 10 domains cited by each AI model in the selected time range. Use the domain filter to compare specific domains across models.',
      noSourcesForModelYet: 'No sources found in {{model}} responses.',
      citationTypes: 'Citation Types',
      citationTypesTooltip: 'Breakdown of all citations in the selected period by source type.',
      citationTypeSocial: 'Social',
      citationTypeOwned: 'Owned',
      domainCategoriesShare: 'Domain Categories Share',
      domainCategoriesShareTooltip:
        'Breakdown of citations by domain category (News, Blogs, Videos, etc.) to understand which content types are most frequently cited.',
      categoryColumn: 'Category',
      categoryNews: 'News',
      categoryBlogs: 'Blogs',
      categoryVideos: 'Videos',
      categoryPhotos: 'Photos',
      categorySocial: 'Social Media',
      categoryPodcasts: 'Podcasts',
      categoryOthers: 'Others',
      categoryWeb: 'Web',
      sourceCategoryCorporate: 'Corporate',
      sourceCategoryEditorial: 'Editorial',
      sourceCategoryInstitutional: 'Institutional',
      sourceCategoryUgc: 'UGC',
      sourceCategoryReference: 'Reference',
      sourceCategoryVideo: 'Video',
      sourceCategoryOther: 'Other',
      domains: 'Domains',
      sourceRetrievalByUrl: 'All Responses',
      sourceRetrievalByUrlTooltip: 'Detailed breakdown of all URLs cited under this domain',
      shareView: 'Share %',
      countView: 'Count',
      urlTypes: 'URL Types',
      urlTypesTooltip: 'Distribution of URL types cited under this domain',
      pageType_HOMEPAGE: 'Homepage',
      pageType_CATEGORY_PAGE: 'Category Page',
      pageType_PRODUCT_PAGE: 'Product Page',
      pageType_LISTICLE: 'Listicle',
      pageType_COMPARISON: 'Comparison',
      pageType_PROFILE: 'Profile',
      pageType_ALTERNATIVE: 'Alternative',
      pageType_DISCUSSION: 'Discussion',
      pageType_HOW_TO_GUIDE: 'How-to Guide',
      pageType_ARTICLE: 'Article',
      pageType_OTHER: 'Other',
      pageType_COMPETITOR: 'Competitor',
      pageType_OWN: 'Own',
      chat: 'Chat',
      citations: 'Citations',
      chatsUsingThisDomain: 'Chats using this domain',
      chatsUsingThisDomainTooltip: 'List of AI chats where this domain was cited as a source',
      domainSourcesAnalytics: 'Domain Sources',
      domainSourcesAnalyticsTooltip: 'Detailed breakdown of all URLs cited under this domain',
      brandMentionsPerSource: 'Brand Mentions per Source',
      brandMentionsPerSourceTooltip: 'How often each brand is mentioned across sources in this domain',
      platforms: 'Platforms',
      platformsTooltip: 'Share of citations per AI platform for this domain',
      rank: 'Rank',
      platform: 'Platform',
      promptsUsingThisUrl: 'Prompts using this URL',
      urlType: 'URL Type',
      brandMentioned: 'Brand mentioned',
      mentioned: 'Mentioned',
      usageCount: 'Usage count',
      citationRate: 'Citation rate',
      citationGaps: 'Citation Gaps',
      viewPageContent: 'View page content',
      savedPageCopy: 'Saved copy (dev)',
      savedPageCopyDevNote: 'Development preview — visible only to superadmins holding the SOURCE_PAGE_COPY addon.',
      savedPageCopyFrom: 'Text of the page as our verification read it on {{date}}.',
      savedPageCopyTruncated: 'The copy is cut at 500,000 characters.',
      savedPageCopyMissing:
        'We have no saved copy of this page yet. It is kept the next time the page is checked for your brands.',
      sourceLastSeen: 'Last seen',
      sourceCategoryOwn: 'Own',
      sourceCategoryCompetitor: 'Competitor',
      sourceCategoryNeutral: 'Neutral',
      sourceUrlType: 'URL Type',
      sourceUsage: 'Usage',
      sourceNoOfPrompts: 'No. of prompts',
      sourceLifecycle: 'Lifecycle',
      sourceFirstSeen: 'First seen',
      sourceToday: 'Today',
      sourceYesterday: 'Yesterday',
      sourceDaysAgo: '{{count}} days ago',
      sourceWeekAgo: 'A week ago',
      sourceMonthAgo: 'A month ago',
      sourceOlderThanMonth: 'More than a month ago',
      sourcePromptsTitle: 'Prompts',
      sourcePromptsColumn: 'Prompt',
      sourceQueriesColumn: 'Queries',
      sourceRetrievedColumn: 'Retrieved',
      sourceBrandsTitle: 'Brands mentioned in {{siteName}}',
      sourceBrandColumn: 'Brand',
      sourceBrandPositionColumn: 'Position',
      sourceBrandFrequencyColumn: 'Frequency',
      sourceBrandCitationsColumn: 'Citations',
      sourceUsageChart: 'Usage',
      sourceUsageByModelChart: 'Usage by model',
      highlightOwnDomain: 'Filter own domain',
      citationTrends: 'Citation Trends',
      citationTrendsTooltip:
        'Shows how often each domain is cited in AI-generated responses over the selected time period - you can choose which domains to compare.',
      sourcesAnalytics: 'Top Citation Pages',
      sourcesAnalyticsTooltip:
        'The specific URLs that are most frequently cited in AI-generated answers.',
      sourcesAnalyticsShare: 'Share',
      sourcesAnalyticsShareTooltip:
        'The share of this URL across all citations attributed to the project.',
      sourcesAnalyticsShareChange: 'Change',
      sourcesAnalyticsShareChangeTooltip:
        "The change in this URL's share compared to the previous measurement period.",
      sourcesAnalyticsPrompts: 'Prompts',
      sourcesAnalyticsPromptsTooltip:
        'The number of prompts in which this URL was used as a cited source.',
      sourcesAnalyticsPromptsChange: 'Change',
      sourcesAnalyticsPromptsChangeTooltip:
        'The change in the number of prompts that cited this URL compared to the previous period.',
      domainsWithSourcesAnalytics: 'Top Citation Domains',
      domainsWithSourcesAnalyticsTooltip:
        'Discover which websites are most frequently cited in AI-generated responses to your prompts.',
      domainsWithSourcesAnalyticsShare: 'Share',
      domainsWithSourcesAnalyticsShareTooltip:
        'The share of this domain across all citations attributed to the project.',
      domainsWithSourcesAnalyticsShareChange: 'Change',
      domainsWithSourcesAnalyticsShareChangeTooltip:
        "The change in this domain's share compared to the previous measurement period.",
      domainsWithSourcesAnalyticsPrompts: 'Prompts',
      domainsWithSourcesAnalyticsPromptsTooltip:
        'The number of prompts in which this domain was used as a cited source.',
      domainsWithSourcesAnalyticsPromptsChange: 'Change',
      domainsWithSourcesAnalyticsPromptsChangeTooltip:
        'The change in the number of prompts that cited this domain compared to the previous period.',
      searchPlaceholder: 'Search...',
      source: 'Source',
      shareColumn: 'Share',
      prompts: 'Prompts',
      typeColumn: 'Type',
      watchedPages: 'Watched Pages',
      watchedPagesTooltip:
        'Track specific pages to see if they appear in AI citations. Add URLs and monitor their presence across AI models.',
      addPages: 'Add pages',
      noWatchedPagesYet: 'Monitor specific page URLs<br/>for citation performance and trends.',
      addAnotherPage: 'Add another page',
      mentionedOnPage: 'Mentioned',
      firstSeen: 'First seen',
      page: 'Page',
      category: 'Category',
      added: 'Added',
      competitorVsNonCompetitorSources: 'Domain Share Comparison',
      competitorSourcesTooltip:
        'Breakdown of citation sources by ownership: your own domain, competitor domains, and other non-competitor sources.',
      yourDomains: 'Your domains',
      nonCompetitors: 'Non-competitors',
      more: 'more',
      emptyOwnDomains: 'Your domain is keeping a low profile',
      emptyCompetitors: 'No competitors spotted yet',
      emptyNonCompetitors: 'The stage is all yours',
      improveAIRanking: 'Improve AI Ranking',
      enterDomainDesc: 'Please enter the <b>domain</b> for the brand you would like to track.',
      videoTutorial: 'Video Tutorial',
      educationBannerTitle: 'Understand how AI recommends your brand',
      educationBannerDescription:
        'Learn how AI Visibility works, discover what influences AI recommendations, and master practical GEO strategies with our quick tutorial and free Masterclass.',
      educationBannerWatchQuickStart: 'Watch Quick Start (5 min)',
      educationBannerStartMasterclass: 'Start Chatbeat Masterclass (30 min)',
      educationBannerHide: 'Hide',
      bookADemo: 'Book a Demo',
      goToProject: 'Go to Project',
      advisor: {
        title: 'Your Chatbeat Advisor',
      },
      masterclass: {
        eyebrow: 'Masterclass',
        titleLine1: 'AI Visibility',
        titleLine2: 'Certification',
        description: 'Complete our free course, learn practical GEO tactics, and earn your certificate.',
        cta: 'Start learning',
      },
      firstProjectOnboarding: {
        title: 'Welcome to Chatbeat!',
        copy: 'Hi, I am Sylwia, your go-to person at Chatbeat.<br />Ready to check your AI visibility?',
      },

      // ADMIN
      requestCount: 'Requests',
      monitorId: 'Monitor',
      lp: 'No.',
      dailyMonitorRequest: 'Daily request',
      activeUsers: 'Active users',
      gptAPI: 'GPT API',
      gptSearchApi: 'GPT Search',
      gptBrowser: 'GPT Browser',
      geminiAPI: 'Gemini API',
      geminiBrowser: 'Gemini browser',
      faq: 'FAQ',
      faqFull: 'Frequently Asked Questions',
      whatIsTheContextTab: 'What is the Context Tab?',
      whatIsTheContextTabDesc:
        'Context shows how AI models describe your brand and in what context it appears. It helps identify topics where competitors are visible but your brand isn’t, revealing visibility gaps and content opportunities.\n' +
        "In this section you’ll find:<ul><li>brand sentiment trend over time</li><li>sentiment comparison across AI models</li><li>AI Insights (automated brand narrative summary)</li><li>key narrative drivers (what AI highlights about the product)</li><li>topic analysis where the brand appears</li><li>brand vs. competitors comparison</li><li>context gaps (where competitors appear but your brand doesn't)</li></ul>",
      whatIsChatBeat: 'What is Chatbeat?',
      whatIsChatBeatDesc:
        'Chatbeat is the missing link between AI and your marketing.<br>' +
        'It’s a tool designed to measure your brand’s visibility and exposure within major AI models like Gemini, Claude, GPT, Perplexity, AI Overview, AI Mode, Grok, Copilot and DeepSeek - and compare it directly with your competitors. Using a proprietary visibility estimation algorithm, it reveals what your customers most often ask about, shows how your brand is presented in response to specific queries, identifies the sources AI models rely on, and lets you compare your performance with competitors.<br>' +
        'Chatbeat also helps you track how your brand’s presence changes over time and monitors the sentiment behind it. In short, Chatbeat does for AI-driven search what tools like Semrush do for Google.',
      whatIsBrandScore: 'What is Brand Score?',
      whatIsBrandScoreDesc:
        'Brand Score is a key metric that measures how prominently your brand appears in AI-driven search results. Expressed as a percentage, it reflects your brand’s ranking across multiple queries. The score is determined based on positioning, with higher placements earning more points. A brand that consistently ranks at the top will achieve a perfect 100%, indicating maximum visibility.',
      whatIsShareOfVoice: 'What is Share of Voice?',
      whatIsShareOfVoiceDesc:
        "In Chatbeat, Share of Voice represents how often and how prominently your brand appears in response to selected queries compared to competitors. This percentage-based score reflects your brand’s visibility, with higher rankings contributing more weight. For example:<ul><li>1st position: ~40%</li><li>2nd position: ~20%</li><li>3rd position: ~10%</li><li>And so on...</li></ul>The total Share of Voice across all brands for a given query always adds up to 100%. You can choose specific brands to compare against and even check their results for the questions you’ve added. You can track Share of Voice across all chatbots to see where you're crushing it and where there's room to grow.",
      relevantQuestions: 'How can I find relevant questions?',
      relevantQuestionsDesc:
        'Our tool automatically suggests questions that are most relevant for your brand through a dedicated Suggested Prompts feature, which generates the best queries to track. You can also add your own questions, and Chatbeat will display the search volume - showing you how popular each question is.',
      metricsTrack: 'What metrics can I track?',
      metricsTrackDesc:
        '<b>Brand Score</b> - percentage showing how often and how prominently your brand appears in answers to tracked questions.<br>' +
        '<b>Median Position & Average Position</b> - show your brand’s average ranking across all tracked questions.<br>' +
        '<b>Share of Voice</b> - shows how often your brand appears in responses and how high it ranks compared to competitors.<br>' +
        '<b>Search Volume</b> - shows how popular each question is, helping you decide which ones to prioritize.<br>' +
        '<b>Key Sources</b> - reveals which websites AI models rely on in your industry.<br>' +
        '<b>Context</b> - reveals the key topics and sentiment in LLM responses.',
      mostOutOfChatbeat: 'How can I get the most out of Chatbeat?',
      mostOutOfChatbeatDesc:
        'The best place to start is by reviewing our <a href="https://app.chatbeat.com/howto" target="_blank">Case study</a> on optimizing visibility in AI and learning how Chatbeat can help you achieve it. We’d also be happy to walk you through it during an introductory meeting - just email us at <a href=\'mailto:help@chatbeat.com\'>help@chatbeat.com</a> and we\'ll gladly chat!',
      visibilityRating: 'What is Visibility Rating?',
      visibilityRatingDesc:
        'Visibility Rating helps interpret your Brand Score, providing a benchmark to assess its significance. For example, is a 45% Brand Score good or bad? Chatbeat categorizes scores into the following ranges:<ul><li><b>0% (Not Visible):</b> No measurable visibility.</li><li><b>1-2% (Minimal):</b> Very low visibility, requiring significant improvement.</li><li><b>3-9% (Emerging):</b> Below standard visibility, with room for growth.</li><li><b>10-29% (Decent):</b> Acceptable visibility but could be improved.</li><li><b>30-49% (Respectable):</b> Above average visibility and influence.</li><li><b>50-69% (Good):</b> High visibility with strong positioning.</li><li><b>70-100% (Excellent):</b> Outstanding visibility; a top-performing brand.</li></ul>This classification helps businesses understand their standing and develop strategies to improve their AI-driven presence.',
      modelTrack: 'Which AI Models Does ChatBeat Track?',
      modelTrackDesc:
        'Chatbeat primarily monitors the most popular AI models. Currently, we monitor GPT-5, AI Overviews, GPT Search, Gemini, Claude, Perplexity, AI Mode, Grok, Copilot and DeepSeek.',
      estimateAveragePosition: 'How Does ChatBeat Estimate Average Position?',
      estimateAveragePositionDesc:
        'Chatbeat analyzes responses from AI models and calculates an average ranking based on daily queries per monitored question. This method smooths out fluctuations, providing a more reliable view of your brand’s visibility trends.',
      canITrackMyBrand:
        'Can I Track My Brand in Local Chatbot Results (e.g., Specific Countries or Cities)?',
      canITrackMyBrandDesc:
        'Yes! Adding a question in a specific language automatically localizes the answer. You can also track your brand in local results by adding location-based parameters to your monitored queries, such as:<ul><li><i>“What is the best invoicing tool in Sweden?”</i></li><li><i>“What is the best invoicing tool in Copenhagen?”</i></li></ul>This lets you assess visibility in specific regions. GEO-based answer breakdown is coming soon.<br><br>What’s more, when setting up a project, you can select a specific location',
      rawAIResponses: 'Can I View the Raw AI Responses?',
      rawAIResponsesDesc:
        'Absolutely! Click on any question within Chatbeat, and at the bottom of the page, you can review the exact responses we received from the GPT model (or another monitored AI model).',
      positionDiffer: 'Why Does My Brand’s Position Differ from What I See in ChatGPT?',
      positionDifferDesc:
        'AI-generated responses can vary across individual queries due to personalization and randomness. If a brand frequently appears in your personal ChatGPT interactions, the model may be more likely to recommend it to you.',
      keySource: 'What are Key Sources?',
      keySourceDesc:
        'Shows you which websites AI models rely on in your industry. If your content is present on these sites, it’s more likely to appear in AI-generated answers. You can view this data for specific models to identify where there’s room to optimize your content and increase your brand’s visibility.',
      notVisible: 'Not Visible',
      minimal: 'Minimal',
      yes: 'Yes',
      no: 'No',
      emerging: 'Emerging',
      good: 'Good',
      decent: 'Decent',
      excellent: 'Excellent',
      respectable: 'Respectable',
      notVisibleTooltip: 'No measurable visibility.',
      minimalTooltip: 'Very low visibility, requiring significant improvement.',
      emergingTooltip: 'Below standard visibility, with room for growth.',
      decentTooltip: 'Acceptable visibility but could be improved.',
      respectableTooltip: 'Above average visibility and influence.',
      goodTooltip: 'High visibility with strong positioning.',
      excellentTooltip: 'Outstanding visibility; a top-performing brand.',
      regenerateKeywords: 'Regenerate',
      yourDataChanged: 'Your data has been successfully changed.',
      dataChanged: 'Data Changed',
      outsideTop30: 'Outside Top 30',
      others: 'Others',
      mixedQuestionWarning:
        '[DEV] At least one question in the project is monitoring the brand model. Unlink the selected projects if you want to monitor the brand.',
      changeProject: 'Move to another project',
      cancel: 'Cancel',
      withoutAProject: 'Without a project',
      editProject: 'Edit project',
      monitoringSchedule: 'Monitoring frequency',
      monitoringScheduleDaily: 'Daily',
      monitoringScheduleWeekly: 'Weekly',
      monitoringScheduleHint: 'How often your prompts are sent to the AI models.',
      monitorEventScheduleChanged: 'monitoring frequency changed: {{from}} → {{to}}',
      whereShouldISetTheKeyword: 'Where should I set the keyword?',
      dontChange: "Don't change",
      applyToAllQuestions: 'Apply to all questions',
      applyToPartQuestions:
        'Apply to questions that currently have a keyword set, such as the project name',
      mixedWarning:
        'This question monitors the model, which may cause the information in the project to be imprecise. If you want to monitor the brand, disconnect this question from the project.',
      changeNameTootlip:
        'By default, all questions in the project have the brand name set as the keyword.',
      deepSeekDesc:
        'DeepSeek is an AI-powered tool for precise data search and analysis, uncovering insights to aid decision-making and optimization.',
      perplexityDesc:
        'Perplexity is an AI research assistant that provides accurate, well-sourced answers, helping users explore topics efficiently.',
      noResultsFound: 'No results found',
      noResultsFoundDesc: 'Adjust your filters and try again.',
      emptyGroup: 'No prompts in this tag yet',
      emptyProjectGroup: 'No projects in this group yet',
      dataCollectingNotice:
        'Keep in mind the results visible in the dashboard will be changing for a couple of minutes as we are collecting AI visibility data.',
      computingTitle: 'Computing',
      checkingModel: 'Checking {{model}}…',
      modelsReadyCount: '{{ready}} of {{total}} models ready',
      computingSovTitle: 'Preparing benchmark',
      benchmarkMsgCompetitors: 'Reviewing your competitors…',
      benchmarkMsgShares: 'Calculating share of voice…',
      benchmarkMsgChart: 'Drawing the chart…',
      computingMsgResponses: 'Collecting responses from AI models…',
      computingMsgAnalyzing: 'Analyzing your competitors…',
      computingMsgSov: 'Calculating Share of Voice…',
      computingMsgSources: 'Checking cited sources…',
      computingMsgBrandScore: 'Computing your Brand Score…',
      computingMsgDashboard: 'Preparing your dashboard…',
      configuration: 'Configuration',
      selectDemoType: 'Select type',
      projectAccountDesc:
        'Select the user account to which you want to assign the project. The user will gain access based on the assigned permissions. ',
      demoDesc:
        'You can mark the project as a demo version or remove this status. The demo version allows for limited testing of the project.',
      setAsDemo: 'Set as demo project',
      unsetDemo: 'Unset demo project',
      enterDomain: 'Enter domain',
      domain: 'Domain',
      enterBrandName: 'Enter brand name',
      enterBrandNameDesc: 'Please enter the <b>name</b> of the brand you would like to track.',
      brandName: 'Brand name',
      suggested: 'Suggested',
      linkToBrandNameStep: 'Want to enter a brand name instead of a domain?',
      clickHere: 'Click here!',
      linkToDomainStep: 'Prefer to enter a domain instead?',
      shareOfVoiceOverTime: 'Share of Voice over time',
      shareOfVoiceOverTimeTooltip:
        'Tracks how the Share of Voice for the top brands evolves over the selected period.',
      shareOfVoiceByLlm: 'Share of Voice by AI Chatbots',
      insights: 'Insights',
      overallPosition: 'Overall position',
      insightNotVisible:
        "Currently, there is insufficient data to determine Your brand's visibility across LLMs. As more queries and interactions occur, we will be able to provide deeper insights into its share of voice and ranking trends.",
      stable: 'Stable',
      new: 'New',
      brandScoreTooltip:
        'A metric that indicates how often and how high your brand appears in AI chatbots responses. The higher the score, the better the visibility. The Brand Score ranges from 0 to 100%, where 100% represents maximum exposure – the brand ranks first in all key queries.',
      medianPosition: 'Median Position',
      medianPositionTooltip:
        'A metric that shows the median position your brand appears in AI chatbot responses, providing a more balanced view by reducing the impact of outliers.',
      averagePositionTooltip:
        'A metric that shows the average position your brand appears in AI chatbots responses.',
      shareOfVoiceTooltip:
        'Show how often and how high AI chatbots recommend your brand in responses compared to competitors. This percentage-based score reflects your brand’s visibility, with higher rankings contributing more weight. The total Share of Voice across all brands for a given query always sums to 100%.',
      brandScoreAndMedianPositionTooltip:
        "Tracks how your brand's visibility in AI chatbots responses evolves over time.",
      brandScoreAndAveragePositionTooltip:
        "Tracks how your brand's visibility in AI chatbots responses evolves over time.",
      shareOfVoiceByLlmTooltip: 'See how your brand compares to competitors in different AI chatbots.',
      insightsTooltip:
        'Check a quick summary of your brand’s performance and use the data to improve visibility in AI chatbots.',
      //PROMPTS 2.0 (prompt view V2)
      responsesThisPeriod_one: '{{count}} response in this time period',
      responsesThisPeriod_other: '{{count}} responses in this time period',
      visibilityOverview: 'Visibility Overview',
      visibilityOverviewTooltip:
        'Tracks the percentage of AI answers mentioning each brand over the selected period.',
      top7Brands: 'Top 7 Brands',
      topBrandsTooltip: 'Brands ranked by visibility in AI answers for this prompt.',
      allBrandsRankingTooltip:
        'All brands detected in AI answers for this prompt, ranked by Share of Voice.',
      positionColumnTooltip:
        'Average position at which the brand appears in AI answers - 1 means it is mentioned first.',
      visibilityColumnTooltip: 'Share of AI answers in the selected period that mention the brand.',
      sovColumnTooltip:
        'Share of Voice - the brand’s share of all brand mentions in AI answers, with higher positions weighted more. Sums to 100% across brands.',
      chatgptAdsRowTooltip: 'At least one answer in this row contains ChatGPT ads.',
      shoppingCardsRowTooltip: 'At least one answer in this row contains shopping cards.',
      fanoutQueries: 'Fanout Queries',
      fanoutQueriesSubtitle: 'Search queries AI engines ran to answer this prompt',
      latestFanoutQueries: 'Latest Fanout Queries',
      fanoutQueriesTooltip:
        'Search queries AI engines ran to answer this prompt. "Original prompt" marks a search with your exact question.',
      originalPromptBadge: 'Original prompt',
      productCards: 'Product Cards',
      productCardsTooltip: 'Products AI chatbots showed alongside answers in the selected period.',
      commonTerms: 'Common Terms',
      topPhrases: 'Top Phrases',
      commonTermsTooltip:
        'The most frequent phrases across the fanout queries. Searches repeating your original prompt are not counted.',
      topPhraseBarTooltip:
        'Appears in {{occurrences}} of {{total}} fanout queries in this period.',
      query: 'Query',
      noFanoutData: 'No fanout queries were captured in this period.',
      chatgptAds: 'ChatGPT Ads',
      chatgptAdsTooltip: 'Ads shown by ChatGPT alongside this answer.',
      chatgptAdsPercentTooltip: 'Share of answers in the period that contained ChatGPT ads.',
      shoppingCards: 'Shopping Cards',
      shoppingCardsTooltip: 'Product cards shown alongside this answer.',
      shoppingCardsPercentTooltip: 'Share of answers in the period that contained shopping cards.',
      //EARLY ACCESS
      emailSuccessfullySaved: 'Your email has been successfully saved.',
      dataSaved: 'Data saved',
      completedCaptcha: 'Please complete the reCAPTCHA.',
      elevateYourBrandVisibility: 'Measure<br>Your brand in AI',
      elevateYourBrandVisibilityDesc:
        "Track your brand's recommendations across major AI platforms like ChatGPT, Claude and Gemini.",
      earlyAccess: 'Early access',
      emailIsRequired: 'Email is required',
      joinToBeta: 'Join to beta',
      status: 'Status',
      topicShare: 'Topic Share',
      keywordTooltip:
        'Represents a brand or term being analyzed for its visibility in AI chatbot responses.',
      overallPositionTooltip:
        'Shows your brand’s ranking for a specific query compared to competitors in AI chatbot responses.',
      copyProject: 'Copy the project',
      removeThisProject: 'Remove this project',
      viewDetails: 'View details',
      moveToAnotherProject: 'Move to another project',
      removeThisQuestion: 'Remove this question',
      linkTracking: 'Key Sources',
      url: 'URL',
      count: 'Count',
      linkTrackingTooltip:
        'Sources reveal which websites AI chatbots rely on to generate answers in your industry. The more visibility your content has on those sites, the more likely it is to be featured in responses from AI tools like ChatGPT or Gemini.',
      privacyPolicy: 'Privacy Policy',
      customizeCookie: 'Customize cookie',
      termsAndConditions: 'Terms & Conditions',
      almostThere: 'Almost there!<br><b>Create your new password</b><br>and jump back in',
      enterYourNewPasswordBelow: 'Enter your new password below',
      oopsForgotYourPassword:
        'Oops, forgot your password?<br><b>Let’s get you a new one</b><br>in no time',
      enterYourEmailBelow: 'Enter your email below to receive a password reset link',
      accessTailoredData: 'Access <b>tailored data</b><br>to improve your strategy',
      onceYouSignup: 'Once you sign up, you will be logged in automatically.',
      accounts: 'Accounts',
      noBrandsTooltip:
        'No brands were found in the response to this question. Try modifying the content to get better results.',
      waitingSearchVolume:
        "We're still gathering data to estimate the monthly search volume. This may take some time, especially for queries with lower frequency. Please check back later to see updated insights.",
      outOfRangePromptToday:
        'We will gather results for this prompt/question in the next cycle (within 24 hours).',
      outOfRangePrompt: 'This prompt/question was not monitored during this period.',
      noSearchVolume:
        'The search volume is likely below 100 queries per month. Please note that this is an estimate, and there may be significant value in tracking key questions with fewer than 100 monthly queries.',
      searchVolumeTooltip:
        'Search Volume estimates the number of monthly searches for a particular key question or prompt. It is designed to help you prioritize which key questions or prompts to focus on.',
      invoiceNumber: 'Invoice number',
      total: 'Total',
      invoice: 'Invoice',
      download: 'Download',
      loadingSaveProject: 'Analyzing your brand’s visibility in AI',
      loadingDataSearchVolume: 'Checking search volumes for selected prompts...',
      loadingDataThisMayTakeAMoment: 'Loading data – this may take a moment',
      analyzeVisibilityTitle: 'We’re analyzing your visibility in {{provider}}',
      analyzeSubtitleChatgpt: 'Checking how often your brand appears in answers',
      analyzeSubtitleGemini: 'Tracking mentions in Google’s AI answers',
      analyzeSubtitlePerplexity: 'Examining citations and ranking in sources',
      analyzeVisibilityHint: 'This will only take a moment',
      nextAnnuallyPaymentCost: 'Annually price',
      nextMonthlyPaymentCost: 'Monthly price',
      exclVAT: 'excl. VAT',
      pricingDescStandard: 'For small brands ready to grow.',
      pricingDescPro: 'For scaling businesses.',
      pricingDescAdvanced: 'For agencies and large teams.',
      pricingDescEnterprise: 'For enterprises with custom needs.',
      perMonth: 'per month',
      keyFeatures: 'Key features',
      getStartedWith: 'Get started with',
      prioritySupport: 'Priority support',
      whitelabel: 'Whitelabel',
      unlimitedPrompts: 'Unlimited questions/prompts',
      unlimitedusers: 'Unlimited users',
      billedAnnually: 'billed annually',
      overview: 'Overview',
      custom: 'Custom',
      areYouSureChangePlan: 'Are you sure you want to change the subscription plan for your account?',
      confirm: 'Confirm',
      question: 'Question',
      upgradePlanError: 'Failed to upgrade plan',
      upgradePlanErrorDesc:
        'The upgrade could not be completed. Please check your payment details with your bank or contact our support team for assistance.',
      usersLimitExceeded: 'The account has reached its user limit ({{current}} of {{max}}).',
      inviteError: 'Failed to Invite User',
      inviteErrorContent:
        'Make sure that the entered data is correct and that the specified user is not the owner of this resource. If everything appears to be correct, try again later or contact the administrator.',
      searchVolumeForSelectedQuestions: 'Search Volume for selected questions',
      selectMinimumOne: 'Select at least one question',
      selectAll: 'Select all',
      deselectAll: 'Deselect all',
      selectedCount: 'Selected: {{selected}}',
      customQuestion: 'Custom question',
      reset: 'Reset',
      popularQuestions: 'Popular questions',
      run: 'Run',
      pause: 'Pause',
      monitorLimitReached:
        'You have reached your monitor limit. Upgrade your plan to activate more monitors.',
      pauseModeNotAvailable: 'Pause tracking is not available in your plan. Contact us to unlock it.',
      bulkActivate: 'Run tracking for selected prompts',
      bulkPause: 'Pause tracking for selected prompts',
      bulkRemove: 'Delete selected prompts permanently',
      confirmPausePrompts: 'Are you sure you want to pause these prompts?',
      bulkLimitExceeded:
        "You've selected more monitors than your plan allows. Your plan allows {{maxMonitors}} active monitors, but you already have {{currentActive}} active.",
      pauseLimitExceeded:
        'You can pause up to {{maxPausedMonitors}} monitors. Currently {{currentPaused}} are paused.',
      selectModePrompts: 'Manage selected prompts',
      selectModeProjects: 'Manage selected projects',
      emptyStateProject: "Oops! It looks like you don't</br>have any projects yet.</br>Add one below.",
      emptyStateProjectPromptsNoPermission:
        'Enter your first prompt and see how your brand ranks in AI responses.',
      emptyStateProjectPrompts:
        'Enter your first prompt and see</br>how your brand ranks in AI</br>responses.',
      emptyStatePrompts: "Oops! It looks like you don't</br>have any prompts yet.",
      tagInfo:
        'If your brand appears under different</br>names in LLMs, you can group them into</br>one tag to analyze results together.',
      tagLabel: 'Tags label',
      createNewTag: 'Create new tag',
      expandedInfo:
        'We use an additional prompt to track positions 10–30 in order to monitor AI exposure of brands outside the top 10. The results come from a separate prompt and do not affect the organic response.',
      selectProject: 'Select project',
      searchProjects: 'Search projects...',
      discount: 'Discount',
      noPermission: 'You don’t have permission to perform this action.',
      disableCurrentPlan: 'This plan is already active on your account.',
      disableSelectPlan:
        'You can’t select this plan because usage limits have been exceeded. Reduce usage or choose a higher plan.',
      whatIsSearchVolume: 'What is Search Volume and how does it work?',
      whatIsSearchVolumeDesc:
        "Search Volume indicates the estimated number of monthly searches for a given question. While it's primarily based on user behavior in traditional search engines, we believe some of these patterns are transferable to LLM usage. This metric helps surface questions that are likely to be valuable and widely relevant.",
      weeklyReports: 'Weekly summary reports',
      foundBrandName: 'Detected brand name',
      information: 'Information',
      limitTitle: 'Limit Exceeded',
      addTag: 'Add tag',
      limitExceededMessage:
        'Your current plan does not allow creating additional prompts. Please delete some of the existing ones or upgrade to a higher plan.',
      keyPrompts: 'Key prompts',
      historicalModelDisabled:
        'This model is currently disabled on your account - the data shown is historical.',
      historicalModelDisabledRange:
        'This model is currently disabled on your account. Data shown is from {{from}} – {{to}}.',
      keySources: 'Key Sources',
      downloadStats: 'Download stats',
      downloadPromptStats: 'Download prompt stats',
      downloadBrandScore: 'Download Brand Score',
      downloadAiAnswers: 'Download AI answers',
      removeProject: 'Remove project',
      createGroup: 'Create group',
      groupName: 'Group name',
      groupNamePlaceholder: 'e.g. Brand24',
      groupColor: 'Color',
      editGroup: 'Edit group',
      removeGroup: 'Remove group',
      removeProjectConfirm: 'Are you sure you want to remove the project "{{name}}"?',
      editGroupName: 'Edit name',
      deleteGroupConfirm:
        'Are you sure you want to delete the group "{{name}}"? Its projects will be ungrouped.',
      moveToGroup: 'Move to group',
      cannotMoveProject: 'Cannot move this project to a group',
      exportCsv: 'Export CSV',
      untagged: 'Untagged',
      ungrouped: 'Ungrouped',
      allGroups: 'All groups',
      createPromptGroup: 'Create prompt tag',
      createPromptGroupTooltip:
        'Group prompts into custom categories for easier analysis and filtering.',
      promptGroupName: 'Prompt tag name',
      editPromptGroup: 'Edit prompt tag',
      removePromptGroup: 'Remove prompt tag',
      moveToPromptGroup: 'Move to prompt tag',
      discoverNewPrompts: 'Discover new prompts with Chatbeat. Select the ones you want to follow.',
      addToProject: 'Add to project',
      suggestedPromptAdded: 'Prompt added to the project',
      limitRestriction:
        'Question limit reached. To add or select another question, please deselect one of the already selected ones first.',
      accountOwner: 'Account owner',
      userRole: 'User role',
      active: 'Active',

      pendingUrl: 'Pending URL',
      pending: 'Pending',
      wrongHash: 'Wrong hash',
      somethingWentWrong: 'Something went wrong',
      passwordsIsNotTheSame: 'Passwords are not the same',
      brandShare: 'Brand share by topic',
      brandShareTooltip: 'Shows what percentage of mentions in this topic belong to a given brand.',
      expireLink:
        "This password reset link has expired. Please request a new one using the '<a href='/forgot'>Forgot Password</a>' option.",
      failedChangePassword: 'Failed change password',
      domainsSelectionModalTitle: 'Select domains for analysis',
      domainsSelectionModalSearchPlaceholder: 'Search domains...',
      domainsSelectionModalMaxSelected: 'You can select maximum {{max}} domains',
      domainsSelectionModalLoadingMore: 'Loading more domains... ({{count}} loaded)',
      domainsSelectionModalLoadedInfo: 'Loaded {{count}} domains {{extra}}',
      domainsSelectionModalMorePages: '({{pages}} more pages available)',
      domainsSelectionModalAllLoaded: '(all loaded)',
      selectBrandForAnalysis: 'Select brands for analysis',
      brandMentions: '{{brand}} Mentioned',
      selectBrands: 'Select brands',
      chooseActiveBrandsHint:
        'Brands switched on are active in the project — the same setting as on the Brands page. Changes are saved right away.',
      chooseActiveBrandsMore: '{{count}} more — search to find them',
      chooseActiveBrandsResetHint:
        'Keeps 15 brands switched on: the selected and main brand plus the ones with the highest visibility (or Share of Voice) in the last 30 days. Switches off the rest.',
      chooseActiveBrandsError: 'Could not change the brand status. Try again.',
      statsRecomputingTitle: 'Recalculating statistics',
      statsRecomputingSubtitle: '{{brands}} — the numbers will refresh in a moment',
      statsRecomputingMsgPositions: 'Recalculating positions…',
      statsRecomputingMsgVisibility: 'Recalculating visibility…',
      statsRecomputingBrand: 'Statistics are being recalculated',
      selectDomains: 'Select domains',
      chooseBrandsToCompare: 'Choose brands to compare',
      keywordsPageDesc: 'All unique brands and keywords tracked in this project.',
      brands: 'Brands',
      brandsPageDesc: 'Brands, names and domains tracked in this project.',
      trackedNames: 'Tracked names',
      brandTabBasic: 'Basic',
      brandNamesIntro:
        'Names under which this brand shows up in AI answers. Turn a name off to stop counting it, or split it off as a separate brand.',
      brandStatusDesc: 'An inactive brand is left out of this project\'s charts and reports.',
      brandMainName: 'Main',
      brandProjectBadge: 'Main brand',
      brandSelectedBadge: 'Selected brand',
      brandAttachedTitle: 'Attached brands',
      brandAttachedDesc: 'Brands you added under this one. Detach a brand to count it on its own again.',
      brandDetach: 'Detach brand',
      brandDetachTooltip: 'Detach {{brand}} together with all its names — it becomes a separate brand again.',
      brandAttachTitle: 'Add another brand to this one',
      brandAttachDesc: 'The brand you pick moves under this one together with all its names. You can split it off later.',
      trackedNamesShowAll: 'Show all tracked names',
      brandSplit: 'Split',
      brandSplitTooltip:
        'Track this name as its own brand in this project. Other projects keep the shared grouping.',
      brandMerge: 'Merge back',
      brandMergeTooltip: 'Put this name back under {{brand}}.',
      brandSplitMain: 'This is the brand\'s main name — split off the other names instead.',
      brandAttach: 'Pick a brand…',
      brandLabelEdit: 'Rename this brand (label only — it changes no statistics)',
      brandLabelReset: 'Leave the field empty to bring back the default name.',
      brandDomains: 'Brand domains',
      brandDomainsTooltip:
        'Sites that belong to this brand. Used to tell its own pages apart from everyone else\'s when classifying sources. A domain you remove here stops counting as this brand across the whole project.',
      brandDomainAdd: 'Add a domain',
      brandDomainAddSubmit: 'Add',
      brandDomainsEmpty: 'No domains',
      brandDomainExclude: 'This is not this brand',
      brandDomainInvalid: 'That is not a valid address',
      brandDomainsUnconfirmed:
        'Not confirmed in this project — the dictionary lists every company with this name',
      brandDomainsOthers: 'Other companies with this name ({{count}})',
      brandDomainConfirm: 'This is this brand',
      notThisBrand: 'Not this brand',
      keywordNormalized: 'Normalized keyword',
      noKeywordsFound: 'No keywords found for this project.',
      keywordFilterAll: 'All',
      keywordFilterActive: 'Active',
      keywordFilterInactive: 'Inactive',
      keywordToggleDisabledDefault: 'Default brand cannot be deactivated',
      brandLastActiveName: 'The project brand needs at least one active name',
      keywordToggleDisabledFirm: 'Currently set as project brand - cannot be deactivated',
      keywordUpdateError: 'Failed to update keyword status. Please try again.',
      searchKeywords: 'Search keywords...',
      keywordPromptCount: 'Prompts',
      keywordBulkActivate: 'Activate selected keywords',
      keywordBulkDeactivate: 'Deactivate selected keywords',
      keywordSelectMode: 'Select keywords',
      keywordsEmptyState: 'No keywords tracked yet',
      keywordAliasesTooltip: 'This keyword has alternative names grouped via the brand dictionary',
      resetToDefault: 'Reset to default',
      defaultBrandAlreadyActive: 'The default brand is already active.',
      lastWeek: 'Last week',
      lastMonth: 'Last month',
      last3Months: 'Last 3 months',
      customPeriod: 'Custom',
      today: 'Today',
      yesterday: 'Yesterday',
      currentWeek: 'Current week',
      last7Days: 'Last 7 days',
      last14Days: 'Last 14 days',
      last30Days: 'Last 30 days',
      currentMonth: 'Current month',
      currentQuarter: 'Current quarter',
      previousQuarter: 'Previous quarter',
      lastYear: 'Last year',
      allTime: 'All',
      period: 'Period',
      customDate: 'Custom date',
      selectDateRange: 'Select date range',
      clear: 'Clear',
      apply: 'Apply',
      currentPeriod: 'Current period',
      previousPeriod: 'Previous period',
      previousWeek: 'Previous week',
      previousMonth: 'Previous month',
      dayBefore: 'Day before',
      daysBeforePlural: '{{count}} days before',
      weekBefore: 'Week before',
      weeksBeforePlural: '{{count}} weeks before',
      monthBefore: 'Month before',
      monthsBeforePlural: '{{count}} months before',
      yearBefore: 'Year before',
      compareWith: 'Compare with',
      coverage: 'Coverage',
      coverageTooltip:
        'Coverage represents the percentage of AI-generated responses in which a given source (URL or domain) was referenced. This metric helps evaluate how influential or widely used a specific source is across AI-generated content. Higher Coverage means the source was frequently cited or relied upon in model answers',
      upgradeToAccess: 'to access this model',
      upgradeToAccessContact: 'Contact your account admin to upgrade',
      model: 'Model',
      releaseGpt5: 'GPT-5 release',
      releaseGemini31: 'Gemini Flash 3.1 release',
      releaseGemini30: 'Gemini Flash 3.0 release',
      releaseGemini20: 'Gemini Flash 2.0 release',
      releaseGemini25: 'Gemini Flash 2.5 release',
      releaseSonnet4: 'Sonnet 4 release',
      accountBannedTitle: 'Your account has been suspended',
      accountBannedDescription:
        'Your account has been suspended and your projects are no longer monitored. If you believe this is a mistake, contact us at',
      accountBlockedAbuseTitle: 'Your account has been blocked',
      accountBlockedAbuseDescription:
        'We detected suspicious activity on your account, so it has been blocked and your projects are no longer monitored. If you believe this is a mistake, contact us at',
      accountBlockedAbuseUntilDescription:
        'We detected suspicious activity on your account, so it has been blocked until {{until}} and your projects are paused until then. If you believe this is a mistake, contact us at',
      trialEndedTitle: 'Your trial has ended',
      trialEndedDescription:
        "Your trial period has ended, but don't worry-your data is safe and ready whenever you are! To regain access, simply purchase a plan or reach out to us for assistance.",
      needHelpOrQuestions: 'Need help or have questions?',
      emailUsAt: 'Email us at',
      orBookCall: 'or ',
      bookCall: 'book a call',
      readyToContinue: 'Ready to continue?',
      purchasePlan: 'Purchase a plan',
      weLoveToHaveYouBack:
        "We'd love to have you back, helping you track your AI Visibility.",
      envelopeIcon: 'Envelope icon',
      creditCardIcon: 'Credit card icon',
      opensInNewTab: 'opens in a new tab',
      aiCitations: 'AI Citations',
      pages: 'Pages',
      aiOverviewAvailable: 'This prompt triggers an AI Overview in Google.',
      lookerStudioDesc: 'Connect your data to Google Looker Studio',
      lookerStudioIntegrationDesc:
        'Integrate with Google Looker Studio to build automated, always up-to-date reports and dashboards straight from your Chatbeat data.',
      integrationsIncluded: "What's included",
      lookerStudioFeat1Title: 'Scheduled reports',
      lookerStudioFeat1Desc:
        'Send your Chatbeat metrics to Looker Studio automatically on a daily, weekly or monthly schedule.',
      lookerStudioFeat2Title: 'Custom dashboards',
      lookerStudioFeat2Desc:
        'Visualize brand visibility, share of voice and sources in fully customizable dashboards.',
      lookerStudioFeat3Title: 'Auto-synced data',
      lookerStudioFeat3Desc:
        'Keep every report up to date with a native connector that syncs your data automatically.',
      brand24SignalsPrice: '$199 / month',
      brand24SignalsDesc:
        'Connect real-world Brand24 mentions with AI-generated narratives to shape how AI models describe your brand.',
      brand24Feat1Title: 'Context & sentiment',
      brand24Feat1Desc:
        'Sentiment classification and a source-level breakdown of the narratives feeding AI models.',
      brand24Feat2Title: 'Chatbeat × Brand24',
      brand24Feat2Desc:
        'Real-time sync of Brand24 mentions from social, news and forums into AI answers.',
      brand24Feat3Title: 'Brand anomaly alerts',
      brand24Feat3Desc:
        'Anomaly detection on AI-cited sources so you react before narratives get embedded.',
      brand24Configure: 'Configure',
      brand24ConfigTitle: 'Configure Brand24 AI Signals',
      brand24ModeOwnKey: 'Use your own API key',
      brand24ModeOwnKeyDesc: 'Full integration including Facebook, Instagram and X sources.',
      brand24ModeDefault: 'Use our built-in key',
      brand24ModeDefaultDesc: 'Facebook, Instagram and X integration will not be available.',
      brand24ApiKeyLabel: 'Brand24 API key',
      brand24ApiKeyPlaceholder: 'Your Brand24 API key',
      brand24AccountIdLabel: 'Brand24 account ID',
      brand24AccountIdPlaceholder: 'e.g. 1234567',
      brand24AccountIdHint: 'Find it in your Brand24 dashboard - needed to load your projects.',
      'brand24Config.title': 'Add projects to Brand24',
      'brand24Config.intro':
        'We will create (or reuse) a Brand24 project for your main brand and up to 4 competitors picked by share of voice. You can change any of them.',
      'brand24Config.mainBrand': 'Main brand',
      'brand24Config.competitor': 'Competitor {{n}}',
      'brand24Config.pickBrand': 'Select a brand',
      'brand24Config.createNew': '+ Create new project',
      'brand24Config.continue': 'Continue',
      'brand24Config.addCompetitor': 'Add competitor',
      'brand24Config.removeCompetitor': 'Remove competitor',
      successfullyDisconnected: 'Successfully disconnected from Looker Studio',
      failedToDisconnect: 'Failed to disconnect. Please try again.',
      viewAllReports: 'View all Looker Studio reports',
      viewReports: 'View Reports',
      disconnect: 'Disconnect',
      connect: 'Connect',
      confirmDisconnection: 'Confirm Disconnection',
      confirmDisconnectMessage:
        'Are you sure you want to disconnect from Looker Studio? You will need to reconnect to create new reports.',
      reconnectToCreateReports: 'You will need to reconnect to create new reports.',

      // Looker Studio Callback
      authorizationFailed: 'Authorization failed. Please try again.',
      noAuthorizationCode: 'No authorization code received.',
      successfullyConnectedToLookerStudio: 'Successfully connected to Looker Studio!',
      failedToConnectToLookerStudio: 'Failed to connect to Looker Studio. Please try again.',
      authorizationError: 'An error occurred during authorization.',
      connectingToLookerStudio: 'Connecting to Looker Studio...',
      success: 'Success!',
      error: 'Error',

      // Periodic Reports Page
      periodicReports: 'Periodic Reports',
      lookerStudio: 'Looker Studio',
      unknown: 'Unknown',
      notConnectedToLookerStudio:
        'You are not connected to Looker Studio. Please go to Integrations page and connect first.',
      project: 'Project',
      type: 'Type',
      googlePermissionsChanged:
        'Your Google account permissions have changed. Please reconnect to Looker Studio on the Integrations page.',
      failedToCreateReport: 'Failed to create report',
      confirmDeletePeriodicReport: 'Are you sure you want to delete this periodic report?',
      confirmDeletion: 'Confirm Deletion',
      deactivate: 'Deactivate',
      activate: 'Activate',
      areYouSureYouWantTo: 'Are you sure you want to',
      thisPeriodicReport: 'this periodic report',
      failedToDeleteReport: 'Failed to delete report',
      failedToDeleteReportTryAgain: 'Failed to delete report. Please try again.',
      failedToUpdateReportStatus: 'Failed to update report status. Please try again.',
      paused: 'Paused',
      disabled: 'Disabled',
      report: 'Report',
      createReport: 'Create Report',
      failedToLoadPeriodicReports: 'Failed to load periodic reports',
      failedToOpenReport: 'Failed to open report',
      invalidLookerStudioUrl:
        'Invalid URL. Save the report in Looker Studio first, then paste its address (…/reporting/<id>/…).',
      failedToSaveReportUrl: 'Failed to save report URL. Please try again.',
      reportNotFound: 'Report not found',
      periodicReportCreatedSuccessfully:
        'Your periodic report {{reportName}} has been created successfully!',
      openReport: 'Open Report',
      reportName: 'Report Name',
      lastExecuted: 'Last Executed',
      never: 'Never',
      noPeriodicReportsYet:
        "Oops! It looks like you don't have</br>any periodic reports yet.</br>Add one below.",
      noPeriodicReportsDescription:
        "You haven't created any automated reports yet. Periodic reports can be configured through integrations to deliver automated insights on schedule.",
      projectRequired: 'Project is required',
      name: 'Name',
      schedule: 'Schedule',
      creating: 'Creating...',
      delete: 'Delete',
      retry: 'Retry',
      close: 'Close',
      openReportInLookerStudio: 'Open report in Looker Studio',

      // Report Link Modal
      saveUrl: 'Save URL',
      lookerSetupTitle: 'Looker Studio report',
      lookerSetupStepConfigure: 'Configure the report',
      lookerSetupStepLooker: 'Save the report in Looker Studio',
      lookerSetupProjectDesc:
        'We create a Google Sheet with this project\'s data in your Google Drive and refresh it every night. One report per project and granularity.',
      lookerSetupIntro: 'The data for “{{name}}” is ready. Three short steps left:',
      lookerSetupIntroBuilding:
        'The sheet for “{{name}}” is created and is filling with data right now. Three short steps left:',
      lookerSetupOpenTitle: 'Open Looker Studio',
      lookerSetupOpenDesc:
        'A new tab opens with a report connected to the “{{dataset}}” tab of your sheet.',
      lookerSetupBuildingWait:
        'Looker Studio reads the columns once, when the report is first opened — so the button unlocks when the sheet is filled, usually within a minute or two.',
      lookerSetupBuildStalled:
        'Filling the sheet was stopped by an error — the reason is in the Health column of the report list.',
      lookerSetupOpenDescLegacy: 'A new tab opens with a report that already has your project data connected.',
      lookerSetupOpenDescTemplate:
        'A new tab opens with the ready-made ChatBeat report: a page for every dataset, all connected to your sheet.',
      lookerSetupTemplateEmptyPages:
        'Pages of datasets that are not in this export stay empty — in edit mode you can delete them (right-click the page → Delete).',
      lookerSetupOpenBtn: 'Open Looker Studio',
      lookerSetupSaveTitle: 'Save the report there',
      lookerSetupSaveDesc:
        'In the top right corner click “Edit and share”, then “Acknowledge and save” and “Add to report”. If Looker Studio asks for access to Google Sheets, allow it.',
      lookerSetupPasteTitle: 'Paste the report address',
      lookerSetupPasteDesc:
        'Once saved, copy the address from the browser bar (…/reporting/…/page/…) and paste it here, so you can open the report straight from Chatbeat. You can also do it later from the row menu.',
      lookerSetupAddTabsDesc:
        'To use the other tabs ({{tabs}}), click “Add data” → “Google Sheets” in the report and pick the same sheet and the tab.',
      lookerSetupRefreshNoteLegacy: 'The data in the report refreshes automatically once a day.',
      lookerSetupFinish: 'Finish setup',
      lookerSetupMissingLink: 'The Looker Studio report address is not saved yet, so the report cannot be opened from this list.',
      lookerSetupSkip: 'Skip for now',
      lookerSetupLinkAction: 'Report link',
      lookerGranularityTitle: 'Granularity',
      lookerGranularityDesc:
        'One row per day, per week (Monday–Sunday) or per month. The one the project opens with in the panel is preselected.',
      lookerDatasetsTitle: 'Data',
      lookerDatasetsDesc: 'Each dataset becomes a separate tab of the sheet and a separate data source in Looker Studio.',
      lookerDatasetBrands: 'Brands',
      lookerDatasetPrompts: 'Prompts',
      lookerDatasetDomains: 'Domains',
      lookerDatasetUrls: 'URLs',
      lookerDatasetContext: 'Sentiment & prices',
      lookerDatasetTopics: 'Topics',
      lookerDatasetRequired: 'Select at least one dataset.',
      lookerDatasetNotAvailable: 'Your plan does not include one of the selected datasets.',
      lookerTimelineTitle: 'How the data fills up',
      lookerTimelineTeaser: 'Starts with the last 30 days, then new data is added every night.',
      lookerTimelineTeaserReport: 'Data from {{date}} — new data is added every night.',
      lookerTimelineStartLabel: 'At the start',
      lookerTimelineNowLabel: 'Now',
      lookerTimelineNow: 'The sheet has data from {{date}} to today.',
      lookerTimelineStartDaily: 'The last 30 days — from {{date}} to today.',
      lookerTimelineStartWeekly: 'The last 30 days in whole weeks (Monday–Sunday) — from {{date}} to today.',
      lookerTimelineStartMonthly: 'The last 30 days in whole months — from {{date}} to today.',
      lookerTimelineStartShortHistory: 'If the project has collected data for a shorter time, the sheet starts on its first day with data.',
      lookerTimelineNightlyLabel: 'Every night',
      lookerTimelineNightlyDaily:
        'We add the new day and recompute the last 3 days, whose numbers can still change. The report in Looker Studio picks the data up by itself.',
      lookerTimelineNightlyWeekly:
        'We update the current week — it keeps growing until Sunday, then a new week starts. The report in Looker Studio picks the data up by itself.',
      lookerTimelineNightlyMonthly:
        'We update the current month — it keeps growing until its last day, then a new month starts. The report in Looker Studio picks the data up by itself.',
      lookerTimelineHistoryLabel: 'Over time',
      lookerTimelineHistory: 'The history grows night by night up to {{max}}; after that the oldest periods drop out.',
      lookerRetentionDaily: '90 days',
      lookerRetentionWeekly: '52 weeks',
      lookerRetentionMonthly: '24 months',
      lookerReportExistsForGranularity: 'This project already has a Looker Studio report with this granularity.',
      lookerDatasets: 'Data',
      lookerBuildState: 'Build',
      lookerBuildBuilding: 'Building',
      lookerBuildReady: 'Ready',
      lookerBuildFailed: 'Failed',
      lookerHealth: 'Health',
      lookerHealthOk: 'OK',
      lookerHealthDegraded: 'Issues',
      lookerHealthNeedsAttention: 'Needs attention',
      lastRefresh: 'Last refresh',
      lookerLegacyFormat: 'Legacy format',
      lookerRecomputeAll: 'Recompute all data',
      confirmRecomputeLookerReport:
        'Recompute every period in the sheet? Use it after changes that reach back in time (tags, brands, deleted prompts, domain classification). It takes a few minutes and can be done once every 24 hours.',
      lookerRecomputeBlockedBuilding: 'The report is being built right now.',
      lookerRecomputeBlockedRecent: 'Already recomputed in the last 24 hours.',
      failedToRecomputeReport: 'Failed to start the recompute. Please try again.',
      activeModels: 'Active models',
      cardExpire: 'Card Expiry Date',
      usage: 'Usage',
      currentPlan: 'Current plan',
      occurrences: 'Occurrences',
      trialDays: 'Trial days',
      topBrands: 'Top brands',
      cost: 'Cost',
      free: 'Free',
      of: 'of',
      resetAgain: 'Reset again',
      invalidPasswordResetLink: 'Password reset error',
      invalidPasswordResetLinkDesc:
        "The password reset link you're using is not valid. Please make sure you copied it correctly or try starting the password reset process again.",
      expiredPasswordResetLink: 'Link expired',
      expiredPasswordResetLinkDesc:
        'The password setup link is no longer valid. Click the button below to set a new password.',

      // API Keys
      apiKeys: 'API Keys',
      apiKey: 'API Key',
      createApiKey: 'Create API Key',
      editApiKey: 'Edit API Key',
      extendValidity: 'Extend Validity',
      validity: 'Validity',
      validityPeriod: 'Validity Period',
      selectValidityPeriod: 'Select validity period',
      neverExpires: 'Never expires',
      expired: 'Expired',
      expiresInDays: 'Expires in {{days}} days',
      areYouSureDeleteApiKey: 'Are you sure you want to delete this API key?',
      createApiKeyError: 'Failed to create API key',
      editApiKeyError: 'Failed to edit API key',
      extendValidityError: 'Failed to extend API key validity',
      description: 'Description',
      enterDescription: 'Enter description',
      selectStatus: 'Select status',
      inactive: 'Inactive',
      '30Days': '30 days',
      '90Days': '90 days',
      '180Days': '180 days',
      '365Days': '365 days',
      create: 'Create',
      extend: 'Extend',
      createdBy: 'Created by',
      copy: 'Copy',
      copied: 'Copied!',
      copyFailed: 'Could not copy',
      emptyStateApiKeys:
        "Oops! It looks like you don't</br>have any API keys yet.</br>Create one below.",
      emptyStateApiKeysReadonly:
        'There are no API keys yet.</br>Contact your account owner to create one.',

      // Marketplace
      marketplace: 'Marketplace',
      marketplaceExportTitle: 'Export',
      marketplaceModels: 'Models',
      marketplaceAddons: 'Add-ons',
      marketplaceAddModel: 'Add model',
      marketplaceModelDescription: 'Track how {{model}} answers your prompts and mentions your brand',
      marketplaceModelAnswers: 'Daily answers to all your prompts',
      marketplaceModelStats: 'Visibility, position and sentiment',
      marketplaceModelSources: 'Cited sources and competitors',
      marketplaceExportDescription: 'Export your data to CSV, Excel or PDF formats',
      marketplaceExportCsv: 'CSV export',
      marketplaceExportExcel: 'Excel export',
      marketplaceExportPdf: 'PDF export',
      marketplaceExportScheduled: 'Scheduled exports',
      marketplaceAgencyTitle: 'Agency',
      marketplaceAgencyDescription: 'See all your clients\' projects and prompts in one summary',
      marketplaceAgencyGroups: 'Client groups side by side',
      marketplaceAgencyTrends: 'Changes against the previous period',
      marketplaceAgencyInsights: 'Fastest growing and least active clients',
      marketplaceClaudeWebSearchTitle: 'Claude Web Search',
      marketplaceClaudeWebSearchDescription: 'Enable AI-powered web search capabilities for your monitors',
      marketplaceClaudeRealTime: 'Real-time web data',
      marketplaceClaudeUpToDate: 'Up-to-date results',
      marketplaceClaudePowered: 'Powered by Claude AI',
      marketplaceAdditionalPromptsTitle: 'Additional Prompts',
      marketplaceAdditionalPromptsDescription: 'Purchase additional prompt slots to expand your monitoring coverage',
      marketplacePromptsCoverage: 'Expand monitoring coverage',
      marketplacePromptsSlots: 'More keyword slots',
      marketplacePromptsScaling: 'Flexible scaling',
      marketplaceApiAccessTitle: 'API Access',
      marketplaceApiAccessDescription: 'Get access to the ChatBeat API to integrate with your own tools',
      marketplaceApiRest: 'REST API',
      marketplaceApiFullData: 'Full data access',
      marketplaceApiIntegration: 'Integration ready',
      marketplaceApiKeys: 'API key management',
      marketplacePurchase: 'Purchase',
      marketplaceEnable: 'Enable',
      marketplaceContactUs: 'Contact us',
      marketplaceContactMessage: "Hi! I'm interested in {{offer}} — could you tell me more?",
      emptyStateOrders: "You don't have any orders yet.",
      selectDomain: 'Select domain',
      allDomains: 'All domains',
      changesGptCitations: 'Changes in GPT citations',
      geolocation: 'Geolocation',
      newVersionAvailable: 'A new version is available',
      refresh: 'Refresh',
      monthly: 'Monthly',
      yearly: 'Yearly',
      saveDiscount: 'Save',
      pricingDescEssential: 'For individuals and growing  startups.',
      pricingDescEnterpriseV2:
        'Ideal for industry leaders and large-scale enterprises with custom needs',
      pricingDescEnterpriseV3:
        'For industry leaders with an AI Visibility report and GEO strategy workshops included.',
      pricingDescAdvancedV2: 'For scaling businesses seeking advanced analysis',
      pricingDescAdvancedV3: 'For marketing teams needing advanced AI search insights.',
      pricingDescBusiness: 'Perfect for agencies handling multiple clients and projects',
      pricingDescBusinessV3:
        'Ideal for agencies managing multiple client brands and larger analysis workloads.',
      seats: 'Seats',
      llms3: '3 LLMs',
      llms: '{{value}} LLMs',
      allLlms: 'All LLMs',
      customResponse: 'Custom AI response analysis',
      unlimitedPromptsV2: 'Unlimited prompts',
      unlimitedProjects: 'Unlimited projects',
      unlimitedSeats: 'Unlimited seats',
      countPrompts: '{{count}} prompts',
      dailyRefresh: 'Daily refresh: {{count}} AI responses analyzed',
      customerPromptInsights: 'Customer prompt insights',
      brandVisibilityTracking: 'Brand visibility tracking',
      aiSourcesAnalytics: 'AI sources analytics',
      competitionBenchmarks: 'Competition benchmarks',
      exportableData: 'Exportable data',
      exportableDataApi: 'Advanced exportable data and API',
      lockerStudioIntegration: 'Locker Studio integration',
      earlyAccessToBeta: 'Early access to beta features',
      whitelabeledClientReporting: 'White-labeled client reporting',
      dedicatedProjectManger: 'Dedicated project manager',
      tags: 'Tags',
      tagsDesc:
        'Combine brands into one tag to analyze their total visibility and performance across AI models.',
      brandsRanking: 'Brands ranking',
      allBrandsRanking: 'All Brands Ranking',
      brandsRankingTooltip: 'The brand ranking shows the position and visibility of each brand.',
      brand: 'Brand',
      brandVisibilityText:
        '{{firmName}} has {{visibilityText}} visibility across LLMs, but no data is available to determine share of voice or rankings.',
      brandVisibilityFull: {
        header: '{{firmName}} has {{visibilityText}} visibility across LLMs',
        high: 'with the highest share of voice in <b>{{highestSOVModels}} ({{normalizedMaxSOV}}%)</b> visibility across LLMs.',
        low: 'and the lowest in <b>{{lowestSOVModels}} ({{normalizedMinSOV}}%)</b>',
        topQuery: 'The top-ranking query, "{{prompt}}"',
        topQueryKeywords:
          'sees {{keyword}} holding an average position of {{averagePosition}}, highlighting its relevance in brand monitoring discussions.',
      },
      positive: 'Positive',
      neutral: 'Neutral',
      negative: 'Negative',
      topic: 'Topic',
      sentimentShare: 'Sentiment share',
      contextAnalysis: {
        overTime: 'Over time',
        byAiModel: 'By AI model',
        keyTopicOccurrencesTooltip: 'Total mentions of this topic across all AI responses.',
        topicShareTooltip: 'Percentage of total responses where this topic is present.',
        brandMentionsTooltip:
          'Number of analyzed AI responses within this topic that explicitly mention your brand.',
        functionalPositioning: 'Functional positioning',
        valuePerception: 'Value perception',
        positioningGap: 'Positioning gap',
        businessInsight: 'Business insight',
        header: 'Context',
        desc: 'Analyze how AI models perceive and discuss your brand',
        topicsAnalysis: 'Topics Analysis',
        topicsAnalysisTooltip:
          'Topic Analysis highlights the main thematic areas extracted from all AI responses and indicates where your brand is present within each topic.',
        sentimentAnalysisAiModel: 'Sentiment by AI Model',
        sentimentAnalysisAiModelTooltip:
          'See how each AI model frames your brand and where perceptions differ.',
        topicsShare: 'Topics share',
        topicsShareTooltip:
          'Represents the percentage distribution of topics based on aggregated AI-generated responses across all monitored models.',
        insights: 'Insights',
        insightsTooltip:
          'This is an AI-generated summary based on all analyzed responses across all monitored AI models.',
        sentimentOverTime: 'Sentiment Over Time',
        sentimentOverTimeTooltip:
          'Sentiment shows how positively, negatively, or neutrally AI presents the brand in responses during a given period.',
        narrativeDrivers: 'Narrative drivers',
        narrativeDriversTooltip:
          'Narrative drivers highlight the key themes and associations that most strongly shape how AI describes your brand. They are extracted from all analyzed responses across monitored AI models in the selected period.',
        brandDescription: 'Brand description',
        brandInformation: 'Brand information',
        brandStrengthByTopic: 'Brand Presence by Topic',
        brandStrengthByTopicTooltip:
          'Compare how often each brand appears within each topic across AI responses.',
        contextGap: 'Context Gap',
        contextGapTooltip:
          'Context Gap Analysis highlights topics where competitors are strongly associated but your brand is less visible or absent. It helps identify narrative gaps and missed positioning opportunities in AI-generated responses.',
        gapDescriptionGenerating: 'Description is being generated...',
        modeAnalysis: 'Analysis',
        modeInsights: 'Insights',
        selectInsightPeriod: 'Select period',
      },
      insightPage: {
        header: 'Analytics',
        desc: 'Does AI talk about {{brand}}, or use it as a source',
        announcement: {
          badge: 'New',
          title: 'Meet Analytics',
          desc: "Dive deeper into your brand's AI visibility. Explore additional metrics, competitor comparisons and trends over time in the new Analytics tab under Performance.",
          citationGapTitle: 'Citation Gap',
          citationGapDesc: 'See how often AI mentions your brand vs. cites your website as a source.',
          perPromptTitle: 'Brand performance per prompt',
          perPromptDesc:
            'Compare your brand and competitors across key prompts: visibility, citations, Top 3 and Top 1.',
          funnelTitle: 'Funnel vs competitors',
          funnelDesc:
            'Track the path from brand visibility to Top 3 and Top 1 against your competitors.',
          trendsTitle: 'Trends over time',
          trendsDesc: 'Follow changes per AI platform and per brand, daily, weekly or monthly.',
          later: 'Maybe later',
          cta: 'Explore Analytics',
        },
        overview: {
          brandVisibility: 'Brand visibility',
          citedAsSource: 'Brand cited as source',
          visibilityPlusCited: 'Visibility + cited',
          citationGap: 'Citation Gap',
          responsesOfTotal: '{{value}} of {{total}} AI responses',
          mentionBackedByOwnSource: 'mention backed by own source',
          visibilityMinusCited: 'visibility − cited as source',
          noDomainForBrand:
            "We don't know which domains belong to {{brand}} yet. Add one next to the brand on the Keywords page.",
          insight: {
            marginalPresence:
              '{{brand}} hardly ever appears in AI responses, and its own domains are practically never cited as a source.',
            visibilityUnderCited:
              "AI rarely mentions {{brand}}, even though it cites the brand's own sources.",
            highVisHighCoverage:
              '{{brand}} is frequently mentioned by AI, and in those responses sources related to it are regularly used as well.',
            highVisMidCoverage:
              'AI often mentions {{brand}}, though it relies on its own sources in only some of those responses.',
            highVisLowCoverage:
              'AI often mentions {{brand}}, but rarely relies on its own sources when doing so.',
            lowVisHighCoverage:
              '{{brand}} appears in AI responses rather rarely, but when it does, it often comes with a citation of its own source.',
            lowVisMidCoverage:
              '{{brand}} appears in AI responses rather rarely, and only some of those responses list its own sources.',
            lowVisLowCoverage:
              '{{brand}} appears in AI responses rather rarely, and when it does, it rarely comes with a citation of its own source.',
            coverage:
              'In {{coverage}}% of responses mentioning the brand, its own domain appears among the sources.',
          },
        },
        platforms: {
          title: 'Gap per AI platform',
          tooltip:
            'Per AI platform: how often the analyzed brand is visible in responses versus how often its own domain is cited as a source. A wide gap means the platform talks about the brand without using its website. Click a column header to sort.',
          colPlatform: 'Platform',
          colVisibility: 'Visibility',
          colCited: 'Cited',
          colGap: 'Gap',
          gapValue: '{{value}} pp',
          legendVisibility: 'Brand visibility',
          legendCited: 'Cited as source',
        },
        timeSeries: {
          title: 'Visibility vs. cited over time',
          tooltip:
            'How often AI mentions the analyzed brand versus how often it cites its own domain, per time bucket in the selected range.',
          legendVisibility: 'Brand visibility',
          legendCited: 'Cited as source',
        },
        funnel: {
          title: 'From brand visibility to Top 1',
          tooltip:
            'Funnel on a shared denominator of all AI responses: in how many the analyzed brand appears at all, in how many it ranks in the top 3, and in how many it is the #1 recommendation.',
          rowVisibility: 'Brand visibility',
          rowTop3: 'Top 3',
          rowTop1: 'Top 1',
        },
        funnelOverTime: {
          title: 'Funnel over time',
          tooltip:
            'How the funnel changes over time: the share of all AI responses in which the analyzed brand appears at all, ranks in the top 3 and is the #1 recommendation, per time bucket in the selected range.',
        },
        competitorFunnelOverTime: {
          title: 'Competitor funnel over time',
          tooltip:
            'How the selected brands compare over time on one funnel stage: the share of all AI responses in each time bucket where a brand appears, ranks in the top 3 or is the #1 recommendation. Pick the brands and the stage above the chart.',
        },
        funnelVsCompetitors: {
          title: 'Funnel vs competitors',
          tooltip:
            'Brand visibility, Top 3 and Top 1 shares per brand - all on the same denominator of all AI responses in scope.',
          legendVisibility: 'Brand visibility',
          legendTop3: 'Top 3',
          legendTop1: 'Top 1',
        },
        competitorComparison: {
          title: 'Competitor comparison',
          tooltip:
            'Selected brands side by side: the share of all AI responses in scope where the brand appears versus the share where its own domain is cited as a source. Gap is the difference in percentage points. Click a column header to sort.',
          colBrand: 'Brand',
          colVisibility: 'Visibility',
          colCited: 'Cited',
          colGap: 'Gap',
          gapValue: '{{value}} pp',
          legendVisibility: 'Brand visibility',
          legendCited: 'Cited as source',
        },
        brandPicker: {
          trigger: 'Brands',
        },
        promptMatrix: {
          title: 'Brand visibility per prompt',
          tooltip:
            'Per prompt and brand: the share of that prompt’s AI responses where the brand appears, ranks in the top 3, is the #1 recommendation or has its own domain cited as a source. A dash means the brand’s domains are unknown. Cell intensity follows the value.',
          promptHeader: 'Prompt',
          metricVisibility: 'Visibility',
          metricTop3: 'Top 3',
          metricTop1: 'Top 1',
          metricCited: 'Cited',
        },
        trendsAndAnomalies: 'Trends & Anomalies Overview',
        topSources: 'Top Sources',
        contextInsights: 'Context Insights',
        overallInsights: 'Overall Insights',
        sourcesInsights: 'Sources Insights',
        questionsEvaluation: 'Questions Evaluation',
        competitivePositioning: {
          title: 'Competitive Positioning',
          tooltip:
            'Maps brands by share of voice and sentiment to show how they are positioned relative to competitors in AI-generated responses.',
          xAxis: 'Recommendation Rate (% of prompts in top 3)',
          yAxis: 'Top Position Quality (% of top-3 at #1)',
          xAxisTooltip: 'Recommendation Rate',
          yAxisTooltip: 'Top Position Quality',
          quadrant: {
            topLeft: 'SPECIALIST',
            topRight: 'TOP OF MIND',
            bottomLeft: 'EMERGING',
            bottomRight: 'IN THE MIX',
          },
          series: {
            yourBrand: 'Your brand',
            competitors: 'Competitors',
          },
          view: {
            matrix: 'Matrix',
            trend: 'Trend',
          },
        },
        sourceBrandCoverage: {
          title: 'Source Brand Coverage',
          tooltip:
            'Shows which sources AI uses to build competitor visibility and where your brand is underrepresented.',
          columns: {
            source: 'Source',
            total: 'Total',
          },
        },
      },

      // Sources - new fields
      sourcesKeywords: 'Mentions',
      sourcesKeywordsTooltip: 'List of keywords mentioned in the source',
      sourcesOwnBrand: 'mentioned',
      sourcesOwnBrandHeaderTooltip: 'Whether {{firmName}} was mentioned on this web page.',
      sourcesOwnBrandMentioned: 'Yes',
      sourcesOwnBrandNotMentioned: 'No',
      sourcesOwnBrandNotChecked: 'Not Checked',
      sourcesOwnBrandTooltipMentioned: '{{firmName}} was mentioned on this web page',
      sourcesOwnBrandTooltipNotMentioned: '{{firmName}} was not mentioned on this web page',
      sourcesOwnBrandTooltipNotChecked: "This web page hasn't been analyzed",
      sourcesCited: 'Cited',
      sourcesCitedTooltip: 'Whether the source was directly cited',
      topDomains: 'Top Domains',
      topDomainsTooltip: 'Top 10 domains cited by AI models in this period',
      topUrls: 'Top URLs',
      topUrlsTooltip: 'Top 10 URLs cited by AI models in this period',
      usages: 'Usages',
      usagesCount_one: '{{count}} usage',
      usagesCount_other: '{{count}} usages',
      paymentSuspended: 'Payment Suspended',
      paymentSuspendedInfo: 'Your account payments are suspended - billing changes are disabled',
      paymentSuspendedSubscriptionInfo:
        'Your payment is suspended. Subscription and billing changes are currently unavailable.',
      apiIntegration: 'API Integration',
      apiClientName: 'API Client Name',
      apiExternalAccountId: 'API External Account ID',
      apiExternalAccountSettings: 'API External Account Settings',
      loginAsUser: 'Login as user',
      impersonatingAs: 'You are impersonating: {{email}}',
      returnToAdmin: 'Return to admin',
      onlyCanceledAccounts: 'Only canceled accounts',
      apiAccounts: 'API accounts',
      organicAccounts: 'Organic accounts',
      csAssistedAccounts: 'CS assisted',
      csAssistedBrand24Accounts: 'CS assisted (Brand24)',
      allAccounts: 'All accounts',
      accountType: 'Account type',
      accountStatus: 'Status',
      allAccountTypes: 'All types',
      allStatuses: 'All statuses',
      checklists: 'GEO Recommendations',
      'geoChecklist.title': 'GEO Recommendations',
      'geoChecklist.subtitle': 'Your AI Visibility Action Plan',
      'geoChecklist.tabs.topicsPrompts': 'Topics & Prompts',
      'geoChecklist.tabs.aiVisibility': 'AI Visibility',
      'geoChecklist.tabs.aiVisibilityV2': 'AI Visibility V2',
      'geoChecklist.pb.tasksCompleted': 'tasks completed',
      'geoChecklist.pb.estimatedIncrease': 'Estimated increase',
      'geoChecklist.pb.estimatedIncreaseDesc': 'in AI-driven traffic over 6 months',
      'geoChecklist.pb.actionPlanProgress': 'Your action plan progress',
      'geoChecklist.pb.of': 'of',
      'geoChecklist.pb.actionPlanHint':
        "Complete the recommended actions below to improve your brand's visibility across AI platforms and drive more mentions, traffic and trust.",
      'geoChecklist.pb.aiAnswersTitle': 'How to Get Recommended by AI',
      'geoChecklist.pb.aiAnswersBody':
        'Search is moving to AI - ChatGPT, Claude and Gemini now decide how millions discover brands. Shape how they present yours.',
      'geoChecklist.pb.impact.high': 'High impact',
      'geoChecklist.pb.impact.medium': 'Medium impact',
      'geoChecklist.pb.impact.low': 'Low impact',
      'geoChecklist.pb.filterAll': 'All',
      'geoChecklist.progress': 'Progress',
      'geoChecklist.completed': 'Completed',
      'geoChecklist.selectAll': 'Select all tasks in this section',
      'geoChecklist.learnMore': 'Learn more',
      'geoChecklist.downloadPdf': 'Download PDF',
      'geoChecklist.pdfGenerating': 'Generating PDF...',
      'geoChecklist.resetChecklist': 'Reset checklist',
      'geoChecklist.resetConfirmTitle': 'Reset checklist',
      'geoChecklist.resetConfirmMessage':
        'Are you sure you want to reset all tasks in this checklist? This action cannot be undone.',
      'geoChecklist.resetConfirmYes': 'Yes, reset',
      'geoChecklist.resetConfirmNo': 'Cancel',
      'geoChecklist.chart.yAxis': 'Trials and Traffic',
      'geoChecklist.chart.trials': 'Trials',
      'geoChecklist.chart.traffic': 'Traffic',
      'geoChecklist.tp.introTitle': 'Topics & Prompts Monitoring',
      'geoChecklist.tp.introSubtitle': 'Quick Checklist by chatbeat',
      'geoChecklist.tp.introDesc':
        'A practical guide for turning "we should monitor this" into a clear, repeatable process. This checklist is designed for teams who understand the importance of Topics & Prompts monitoring, but struggle with where to start, what to include, and how to structure it so it actually works.',
      'geoChecklist.tp.introHelper': 'Instead of guessing, this framework helps you:',
      'geoChecklist.tp.introBullet1': 'think in topics, not single phrases',
      'geoChecklist.tp.introBullet2': 'map real user intent to prompts',
      'geoChecklist.tp.introBullet3': 'build a manageable, scalable monitoring setup',
      'geoChecklist.tp.introBullet4': 'continuously improve results based on real data',
      'geoChecklist.tp.introFooter':
        'Use it as a starting point, a sanity check, or a repeatable internal standard.',
      'geoChecklist.av.introTitle': 'GEO Recommendations',
      'geoChecklist.av.introSubtitle': 'Your AI Visibility Action Plan',
      'geoChecklist.av.introDesc':
        "As ChatGPT emerges as a dominant platform with over 1.4 billion monthly visitors, it's revolutionizing how users discover brands and products. Learn how we harnessed its potential to go from 0 to 10,000 new users and how you can position your brand to thrive in this AI-driven landscape.",
      'geoChecklist.av.introHelper': 'Key Takeaways',
      'geoChecklist.av.introFooter':
        "We're in the biggest tech shift in years - for the first time, Google's 90%+ search dominance is weakening.\n\nThis creates both risk and massive opportunity: your brand can now reach millions through ChatGPT, Claude, Gemini, and other AI models. And even if they feel like a \"black box,\" you can influence how they present your brand.\n\nWe did - and here's how our traffic from ChatGPT.com has grown over the past months.",
      'geoChecklist.av.introFooter2': 'Brand24.com growth in traffic from ChatGPT.com in 2025/2026',
      'geoChecklist.av.kt1.title': 'Google is bleeding clicks',
      'geoChecklist.av.kt1.desc':
        'AI Overviews are killing organic traffic. ChatGPT is stealing the spotlight.',
      'geoChecklist.av.kt2.title': 'Your brand ranking is no accident',
      'geoChecklist.av.kt2.desc':
        'You can affect AI visibility with brand mentions and technical upgrades to your website.',
      'geoChecklist.av.kt3.title': 'Open your site for crawlers & bots',
      'geoChecklist.av.kt3.desc':
        'Want to rank in AI? Let OpenAI and Perplexity crawl your site. Deny access and stay invisible.',
      'geoChecklist.av.kt4.title': 'Enable AI training on your YouTube transcripts',
      'geoChecklist.av.kt4.desc':
        'LLMs heavily rely on high quality up to date transcripts and YouTube is one of the most structured and trusted content sources available.',
      'geoChecklist.av.kt5.title': 'Sources that shape AI answers',
      'geoChecklist.av.kt5.desc':
        'See which domains and pages actually influence how AI models recommend brands and where to show up to improve AI visibility.',
      'geoChecklist.av.kt6.title': 'Mentions = AI fuel',
      'geoChecklist.av.kt6.desc':
        'Top-mentioned brands get up to 10\u00d7 more visibility in AI summaries. The key however is to get quality mentions.',
      'geoChecklist.av.kt7.title': 'Reddit is the new PR playground',
      'geoChecklist.av.kt7.desc': 'LLMs feast on Reddit. Be present. Be helpful. Be cited.',
      'geoChecklist.av.kt8.title': 'Content without structure is invisible',
      'geoChecklist.av.kt8.desc':
        'Messy pages confuse AIs. Use schema. Use summaries. Use structure. Or be ignored.',
      'geoChecklist.av.kt9.title': "Don't Skip the SEO Basics",
      'geoChecklist.av.kt9.desc': 'Traditional SEO Is the Bedrock of LLM SEO / GAIO / GEO',
      'geoChecklist.av.kt10.title': 'Your brand is being judged',
      'geoChecklist.av.kt10.desc':
        'LLMs read your reviews, bios, Wikipedia, Crunchbase, G2 Crowd, Trustpilot and others. Control the narrative.',
      'geoChecklist.av.kt11.title': 'ChatGPT reads YouTube',
      'geoChecklist.av.kt11.desc':
        'Even your low-sub channel could be cited - if the content is legit and transcribable.',
      'geoChecklist.av.kt12.title': 'You can build your own GPT',
      'geoChecklist.av.kt12.desc':
        'Why wait to be discovered? Train your own branded GPT and be the source.',
      'geoChecklist.av.kt13.title': 'Slow pages kill your chances',
      'geoChecklist.av.kt13.desc':
        'If your site lags or users bounce, LLMs notice. Optimize or get demoted.',
      'geoChecklist.av.kt14.title': 'Real mentions > backlinks',
      'geoChecklist.av.kt14.desc':
        "In the AI world, it's not who links to you - it's who talks about you.",
      'geoChecklist.av.kt15.title': 'Agent Mode is your secret weapon',
      'geoChecklist.av.kt15.desc':
        'Trigger Deep Research in ChatGPT to crawl your content. Yes, you can force it to index your content.',
      'geoChecklist.av.kt16.title': 'Stop spamming, start solving',
      'geoChecklist.av.kt16.desc':
        'AI watches how you behave online. Spammy Reddit or Medium posts hurt more than help.',
      'geoChecklist.av.kt17.title': 'Leverage social listening tools',
      'geoChecklist.av.kt17.desc':
        'Track mentions with tools like Brand24 to see where your brand shows up, then engage in the key conversations LLMs are learning from.',
      'geoChecklist.section.coreTopics': 'Core Topics',
      'geoChecklist.section.promptGeneration': 'Prompt Generation',
      'geoChecklist.section.systemUpload': 'System Upload',
      'geoChecklist.section.bestPractices': 'Best Practices',
      'geoChecklist.section.evaluationMaintenance': 'Evaluation & Maintenance',
      'geoChecklist.section.accessDiscoverability': 'Access & Discoverability',
      'geoChecklist.section.accessDiscoverabilitySubtitle':
        '(Can AI systems actually access your content?)',
      'geoChecklist.section.contentAiUnderstanding': 'Content Built for AI Understanding',
      'geoChecklist.section.contentAiUnderstandingSubtitle': '(Can AI understand and use your content?)',
      'geoChecklist.section.brandSignals': 'Brand Signals & Authority',
      'geoChecklist.section.brandSignalsSubtitle': '(Does AI trust your brand?)',
      'geoChecklist.section.distributionCommunity': 'Distribution & Community',
      'geoChecklist.section.distributionCommunitySubtitle': '(Is your content present where AI learns?)',
      'geoChecklist.section.monitoringCompetitive': 'Monitoring & Competitive Learning',
      'geoChecklist.section.monitoringCompetitiveSubtitle': '(Are you tracking your performance?)',
      'geoChecklist.section.ownedAiSurfaces': 'Owned AI Surfaces / Direct Influence',
      'geoChecklist.section.ownedAiSurfacesSubtitle': '(Can you influence AI directly?)',
      'geoChecklist.task.tp_1_1.title':
        'Define broad core topics covering all key brand & industry areas',
      'geoChecklist.task.tp_1_2.title': 'Include product/service topics',
      'geoChecklist.task.tp_1_2.example1': 'Project management software',
      'geoChecklist.task.tp_1_2.example2': 'Online grocery delivery',
      'geoChecklist.task.tp_1_2.example3': 'Skincare products',
      'geoChecklist.task.tp_1_3.title': 'Include customer needs / use cases',
      'geoChecklist.task.tp_1_3.example1': 'Remote team collaboration tools',
      'geoChecklist.task.tp_1_3.example2': 'Where to order groceries in under an hour',
      'geoChecklist.task.tp_1_3.example3': 'Face cream for sensitive skin',
      'geoChecklist.task.tp_1_4.title': 'Include industry trends & themes',
      'geoChecklist.task.tp_1_4.example1': 'AI in workplace productivity',
      'geoChecklist.task.tp_1_4.example2': 'Sustainable packaging',
      'geoChecklist.task.tp_1_4.example3': 'Quick commerce growth',
      'geoChecklist.task.tp_1_5.title': 'Include competitors / alternatives',
      'geoChecklist.task.tp_1_5.example1': 'Company vs Company',
      'geoChecklist.task.tp_1_5.example2': 'Alternatives to Instacart',
      'geoChecklist.task.tp_1_5.example3': 'Alternatives to Sephora',
      'geoChecklist.task.tp_1_6.title': 'Include regions & languages',
      'geoChecklist.task.tp_1_7.title': 'Start with 5–10 broad topics',
      'geoChecklist.task.tp_2_1.title': 'Generate 5–10 prompts per topic',
      'geoChecklist.task.tp_2_2.title':
        'Include different types of prompts: informational, comparative, problem-solving, transactional',
      'geoChecklist.task.tp_2_2.example1': 'Informational: "What is project management software?"',
      'geoChecklist.task.tp_2_2.example2': 'Comparative: "Best project management software vs Trello"',
      'geoChecklist.task.tp_2_2.example3':
        'Problem-solving: "How to track deadlines in project management software?"',
      'geoChecklist.task.tp_2_2.example4':
        'Transactional: "Where to buy affordable project management tools?"',
      'geoChecklist.task.tp_2_3.title': 'Use natural user phrasing',
      'geoChecklist.task.tp_2_4.title': 'Leverage internal FAQ / support data',
      'geoChecklist.task.tp_2_4.description':
        'Example: FAQ: "Does the tool integrate with Slack?" → Prompt: "Does project management software integrate with Slack?"',
      'geoChecklist.task.tp_2_5.title': 'Evaluate prompts regularly across platforms and regions',
      'geoChecklist.task.tp_3_1.title':
        'Add prompts to monitoring/analytics platform like Chatbeat and Brand24',
      'geoChecklist.task.tp_3_2.title': 'Check results after 24–48 hours',
      'geoChecklist.task.tp_4_1.title': 'Think in terms of topics, not single keywords',
      'geoChecklist.task.tp_4_1.description':
        'Instead of tracking "cheap flights," create a project "Flight Prices & Deals"',
      'geoChecklist.task.tp_4_2.title': 'Focus on user intent (full sentences, natural questions)',
      'geoChecklist.task.tp_4_2.description':
        'Better: "What is the best way to find cheap flights to Europe?" Less effective: "cheap flights Europe"',
      'geoChecklist.task.tp_4_3.title': 'Prioritize relevance over quantity',
      'geoChecklist.task.tp_4_3.description':
        'Better: "Which travel website has the most accurate hotel reviews?" Less effective: "Good sites with hotel reviews"',
      'geoChecklist.task.tp_5_1.title': 'Review and update prompts regularly',
      'geoChecklist.task.tp_5_2.title': 'Add new topics/prompts as needs change',
      'geoChecklist.task.tp_5_3.title': 'Optimize prompt set based on monitoring results',
      'geoChecklist.task.av_1_1.title': 'Allow AI crawlers',
      'geoChecklist.task.av_1_1.description':
        'Ensure AI crawlers such as OpenAI, Anthropic, Google, Perplexity, and Microsoft can access your website. Blocked crawlers cannot discover or retrieve your content.',
      'geoChecklist.task.av_1_2.title': 'Implement llms.txt',
      'geoChecklist.task.av_1_2.description':
        'Create an llms.txt file to highlight your most valuable content and provide AI systems with an easier path to discover key pages and documentation.',
      'geoChecklist.task.av_1_3.title': 'Make your content AI-readable',
      'geoChecklist.task.av_1_3.description':
        'AI models primarily process HTML, not visual layouts. Ensure important information is available in clean, structured HTML rather than relying on JavaScript, images, or interactive elements.',
      'geoChecklist.task.av_1_4.title': 'Keep important content publicly accessible',
      'geoChecklist.task.av_1_4.description':
        'Ensure your most valuable pages can be accessed without login requirements or paywalls so AI models can retrieve and reference them.',
      'geoChecklist.task.av_1_5.title': 'Improve your site structure',
      'geoChecklist.task.av_1_5.description':
        'Organize your website with logical navigation, internal linking, descriptive headings, and clear page hierarchy so AI systems can better understand relationships between topics.',
      'geoChecklist.task.av_1_6.title': 'Maintain a fast and reliable website',
      'geoChecklist.task.av_1_6.description':
        'Improve loading speed, reliability, and technical health. Slow or unstable websites are crawled less efficiently and provide a poorer experience for both users and AI systems.',
      'geoChecklist.task.av_1_7.title': 'Accelerate content discovery',
      'geoChecklist.task.av_1_7.description':
        'Help AI discover new or updated content faster by maintaining sitemaps, publishing fresh content regularly, and earning links from frequently crawled websites.',
      'geoChecklist.task.av_2_1.title': 'Answer real user questions',
      'geoChecklist.task.av_2_1.description':
        'Create content that directly answers the questions your customers ask. Focus on solving real problems instead of publishing generic marketing articles.',
      'geoChecklist.task.av_2_2.title': 'Add summaries AI can reuse',
      'geoChecklist.task.av_2_2.description':
        'Include concise summaries, key takeaways, and conclusions that AI models can easily understand, extract, and reuse in generated answers.',
      'geoChecklist.task.av_2_3.title': 'Structure content for AI',
      'geoChecklist.task.av_2_3.description':
        'Organize your content with descriptive headings, short paragraphs, lists, and tables so both users and AI models can quickly understand the information.',
      'geoChecklist.task.av_2_4.title': 'Cover topics comprehensively',
      'geoChecklist.task.av_2_4.description':
        'Answer the topic from multiple perspectives, including definitions, use cases, comparisons, FAQs, and practical examples to become the most complete resource.',
      'geoChecklist.task.av_2_5.title': 'Write in simple language',
      'geoChecklist.task.av_2_5.description':
        'Avoid unnecessary jargon and overly complex wording. Clear language makes your content easier for both users and AI models to understand.',
      'geoChecklist.task.av_2_6.title': 'Create comparison content',
      'geoChecklist.task.av_2_6.description':
        'Publish comparison, alternative, versus, and "best" pages that help customers evaluate options during the buying process and increase your chances of being recommended by AI.',
      'geoChecklist.task.av_2_7.title': 'Explain your brand clearly',
      'geoChecklist.task.av_2_7.description':
        'Clearly describe what your company does, who it serves, and how it differs from competitors so AI models can accurately categorize and recommend your brand.',
      'geoChecklist.task.av_2_8.title': 'Optimize for AI selection',
      'geoChecklist.task.av_2_8.description':
        "AI models don't cite every page they find. Create trustworthy, well-structured, and comprehensive content that deserves to be selected and recommended.",
      'geoChecklist.task.av_3_1.title': 'Build a recognizable brand',
      'geoChecklist.task.av_3_1.description':
        "Increase your brand's visibility across the web. AI models are more likely to recommend brands that are consistently mentioned and recognized within their category.",
      'geoChecklist.task.av_3_2.title': 'Earn mentions on trusted websites',
      'geoChecklist.task.av_3_2.description':
        'Increase your presence on authoritative publications, industry websites, communities, and trusted media that AI models frequently use as information sources.',
      'geoChecklist.task.av_3_3.title': 'Earn recommendations, not just mentions',
      'geoChecklist.task.av_3_3.description':
        'Focus on content and brand positioning that lead third-party sources to actively recommend your products or services instead of simply mentioning your company.',
      'geoChecklist.task.av_3_4.title': 'Build strong review signals',
      'geoChecklist.task.av_3_4.description':
        'Encourage authentic customer reviews and actively manage your online reputation. AI models often consider review quality and overall sentiment when generating recommendations.',
      'geoChecklist.task.av_3_5.title': 'Maintain consistent brand messaging',
      'geoChecklist.task.av_3_5.description':
        'Use consistent descriptions, positioning, terminology, and value propositions across your website and external sources so AI models receive clear and reliable signals.',
      'geoChecklist.task.av_3_6.title': 'Keep company profiles up to date',
      'geoChecklist.task.av_3_6.description':
        'Regularly update your company information across directories, knowledge panels, social profiles, and business listings to provide AI models with accurate and consistent information.',
      'geoChecklist.task.av_4_1.title': 'Publish beyond your website',
      'geoChecklist.task.av_4_1.description':
        'Increase your visibility across the web by publishing valuable content on platforms that AI models frequently crawl, cite, and learn from-not just your own website.',
      'geoChecklist.task.av_4_2.title': 'Participate in industry discussions',
      'geoChecklist.task.av_4_2.description':
        'Engage in relevant communities such as Reddit, LinkedIn, GitHub, Quora, forums, and industry groups. AI models increasingly learn from authentic conversations and expert discussions.',
      'geoChecklist.task.av_4_3.title': 'Repurpose your best content',
      'geoChecklist.task.av_4_3.description':
        'Adapt valuable content into multiple formats such as blog posts, videos, presentations, newsletters, and social posts to expand your AI visibility footprint.',
      'geoChecklist.task.av_4_4.title': 'Use YouTube with transcripts',
      'geoChecklist.task.av_4_4.description':
        'Publish educational videos with high-quality transcripts. AI models increasingly use YouTube content and transcripts to understand topics, brands, and expertise.',
      'geoChecklist.task.av_5_1.title': 'Verify your AI visibility',
      'geoChecklist.task.av_5_1.description':
        "Check whether your brand actually appears in AI-generated answers when potential customers ask questions about your category, products, or services. Don't assume - validate it with real AI responses.",
      'geoChecklist.task.av_5_2.title': 'Monitor your ranking and context, not just mentions',
      'geoChecklist.task.av_5_2.description':
        "Visibility alone isn't enough. Measure where your brand appears in AI recommendations and how it is described. Is your brand positioned as a category leader, a premium solution, or simply mentioned among many alternatives?",
      'geoChecklist.task.av_5_3.title': 'Identify the sources influencing AI',
      'geoChecklist.task.av_5_3.description':
        'Understand which websites, communities, reviews, documentation, and media are used by different AI models to generate answers. Compare source usage across models and identify where your brand is underrepresented compared to competitors.',
      'geoChecklist.task.av_5_4.title': 'Compare how AI models recommend brands',
      'geoChecklist.task.av_5_4.description':
        'Every AI model retrieves, ranks, and cites information differently. Monitor ChatGPT, Gemini, Claude, Perplexity, Copilot, and others separately to understand where your visibility is strongest and where optimization is needed.',
      'geoChecklist.task.av_5_5.title': 'Measure AI-driven traffic',
      'geoChecklist.task.av_5_5.description':
        'Track how AI visibility translates into real business impact by monitoring AI referral traffic alongside changes in rankings and recommendations.',
      'geoChecklist.task.av_5_6.title': 'Prioritize high-intent prompts',
      'geoChecklist.task.av_5_6.description':
        'Focus on prompts that influence buying decisions. Use Suggested Prompts based on real user searches or monitor decision-stage queries such as pricing, features, alternatives, comparisons, integrations, reviews, and availability.',
      'geoChecklist.task.av_5_7.title': 'Benchmark against competitors',
      'geoChecklist.task.av_5_7.description':
        'Compare your AI visibility with competitors. Analyze which brands are recommended more often, appear in higher positions, and dominate important customer queries.',
      'geoChecklist.task.av_5_8.title': 'Find visibility gaps',
      'geoChecklist.task.av_5_8.description':
        'Identify prompts where competitors are recommended but your brand is missing. Then analyze which sources mention your competitors but not your brand to uncover the highest-impact content opportunities.',
      'geoChecklist.task.av_5_9.title': 'Build a continuous optimization loop',
      'geoChecklist.task.av_5_9.description':
        'AI Search changes constantly. New sources emerge, rankings shift, and models evolve. Monitor your visibility regularly, implement improvements, measure results, and repeat the process continuously.',
      'geoChecklist.task.av_6_1.title': 'Create your own AI assistant',
      'geoChecklist.task.av_6_1.description':
        'Build a Custom GPT or AI assistant that helps customers discover your products, services, documentation, and expertise directly within AI platforms.',
      'geoChecklist.task.av_6_2.title': 'Provide structured knowledge',
      'geoChecklist.task.av_6_2.description':
        'Organize product information, documentation, FAQs, APIs, and support content into structured formats that AI systems can easily retrieve and understand.',
      'geoChecklist.task.av_6_3.title': 'Accelerate AI discovery',
      'geoChecklist.task.av_6_3.description':
        'Actively submit and promote new content through channels that help AI systems discover updates faster instead of waiting for them to be crawled naturally.',
      'geoChecklist.task.tp_1_1.instruction':
        'List the main topic pillars for your brand and industry. Include customer context, intent, and business priorities before creating prompts.',
      'geoChecklist.task.tp_1_2.instruction':
        'Create a separate topic group for each product or service line. Add synonyms and common naming variants users might use.',
      'geoChecklist.task.tp_1_3.instruction':
        'Turn key customer jobs and pain points into topic groups. Use language that reflects real user needs and outcomes.',
      'geoChecklist.task.tp_1_4.instruction':
        'Include market trends that influence buying decisions. Refresh this list regularly so prompts stay aligned with current demand.',
      'geoChecklist.task.tp_1_5.instruction':
        'Track competitive and alternative topics explicitly. This helps detect where your brand appears or disappears in comparative answers.',
      'geoChecklist.task.tp_1_6.instruction':
        'Separate topics by region and language when intent differs. Local context often changes phrasing, examples, and competitor sets.',
      'geoChecklist.task.tp_1_7.instruction':
        'Start with a focused set of broad topics and expand later. Keep it manageable so you can evaluate quality before scaling.',
      'geoChecklist.task.tp_2_1.instruction':
        'Generate multiple prompts per topic to capture different ways users ask. Keep each prompt specific and comparable over time.',
      'geoChecklist.task.tp_2_2.instruction':
        'Balance prompt types intentionally. Mix informational, comparative, problem-solving, and transactional intents in each topic cluster.',
      'geoChecklist.task.tp_2_3.instruction':
        'Write prompts in natural language, not keyword fragments. Prefer complete questions and realistic user phrasing.',
      'geoChecklist.task.tp_2_4.instruction':
        'Use support tickets and FAQ logs as prompt sources. Prioritize recurring questions that represent real user demand.',
      'geoChecklist.task.tp_2_5.instruction':
        'Review prompt quality by platform, model, and region. Remove weak prompts and improve wording based on observed results.',
      'geoChecklist.task.tp_3_1.instruction':
        'Upload the full prompt set to your monitoring platform. Add naming conventions so topics, intents, and markets are easy to filter.',
      'geoChecklist.task.tp_3_2.instruction':
        'Check first outcomes after one to two days. Use this window to catch indexing gaps and low quality prompts early.',
      'geoChecklist.task.tp_4_1.instruction':
        'Build monitoring around topic clusters, not single isolated keywords. This gives better coverage of real user journeys.',
      'geoChecklist.task.tp_4_2.instruction':
        'Optimize prompts for intent clarity. If a prompt can be interpreted in many ways, rewrite it to match one concrete need.',
      'geoChecklist.task.tp_4_3.instruction':
        'Prefer fewer high signal prompts over many weak ones. Relevance improves insight quality and reduces noisy comparisons.',
      'geoChecklist.task.tp_5_1.instruction':
        'Set a recurring review cadence for prompt health. Update prompts when intent patterns or product priorities change.',
      'geoChecklist.task.tp_5_2.instruction':
        'Add new topics from product launches, seasonality, and customer feedback. Treat prompt coverage as a living system.',
      'geoChecklist.task.tp_5_3.instruction':
        'Iterate based on measured visibility and answer quality. Keep what performs, and rewrite or remove what does not.',
      'geoChecklist.task.av_1_1.instruction':
        'AI tools (like ChatGPT or Perplexity) use bots to read your site. If they can\'t access it - your brand won\'t appear in answers.\n\nWhat to do:\n• Update your robots.txt file\n• Allow: GPTBot, ChatGPT-User, PerplexityBot, Google-Extended\n• Make sure these are NOT blocked by:\n  – Cloudflare / CDN\n  – bot protection\n  – geo restrictions\n• Check access to:\n  – product pages\n  – blog\n  – landing pages\n  – help center\n\nHow to check:\n• Look at server logs (did bots visit?)\n• Use crawl testing tools\n\nPro tip:\nMost teams "allow bots" - but bots never reach key pages.',
      'geoChecklist.task.av_1_2.instruction':
        "This is a simple file that tells AI what matters on your site.\n\nWhat to include:\n• product pages\n• key blog articles\n• comparisons\n• documentation\n\nPro tip:\nDon't list everything - highlight only your best content.",
      'geoChecklist.task.av_1_3.instruction':
        "AI reads your HTML source code, not what users see on screen.\n\nWhat to do:\n• Render key content server-side\n• Avoid hiding content behind JavaScript\n• Don't rely on images for text content\n• Check if content is actually there\n\nPro tip:\nIf content is hidden behind JS - AI may ignore it.",
      'geoChecklist.task.av_1_4.instruction':
        'What to do:\n• Keep key pages publicly accessible\n• Avoid gating:\n  – comparisons\n  – product explanations\n  – educational content\n\nPro tip:\nIf your content is locked, AI will use your competitor.',
      'geoChecklist.task.av_1_5.instruction':
        "AI uses your site structure to understand what matters and how pages relate.\n\nWhat to do:\n• Use a clear heading hierarchy (H1 → H2 → H3)\n• Keep URLs short and descriptive\n• Link related pages together consistently\n• Use breadcrumbs and navigation menus\n\nPro tip:\nIf AI can't understand your site map - it won't prioritize your content.",
      'geoChecklist.task.av_1_6.instruction':
        "Slow sites get deprioritized by crawlers. If your page takes too long to load, bots may skip it entirely.\n\nWhat to do:\n• Optimize Core Web Vitals (LCP, CLS, INP)\n• Reduce server response time (TTFB < 200ms)\n• Avoid frequent downtime or 5xx errors\n\nHow to check:\n• Use Google PageSpeed Insights\n• Monitor uptime with a tool like UptimeRobot\n\nPro tip:\nStability matters more than speed - a page that's down can't be crawled.",
      'geoChecklist.task.av_1_7.instruction':
        "Sometimes AI won't find your content unless you prompt it to look.\n\nWhat to do:\n• Use ChatGPT Deep Research or Agent Mode to explore your site\n• Run controlled prompts that reference your content\n• Share your content in contexts AI actively indexes\n\nPro tip:\nDon't wait for AI to discover you - trigger the discovery yourself.",
      'geoChecklist.task.av_2_1.instruction':
        'AI models look for direct answers to user questions. If your content starts with fluff, it gets skipped.\n\nWhat to do:\n• Lead with a clear, concise answer\n• Add supporting context below\n• Use the exact phrasing your audience searches for\n\nPro tip:\nWrite the answer a busy person would copy-paste.',
      'geoChecklist.task.av_2_2.instruction':
        "AI prefers content that's easy to extract and cite. Long blocks of text without structure get overlooked.\n\nWhat to do:\n• Add a TL;DR at the top of long articles\n• Include key takeaway sections\n• Use bullet points for main conclusions\n\nPro tip:\nIf your article has no summary - AI will summarize your competitor's instead.",
      'geoChecklist.task.av_2_3.instruction':
        'Well-structured content is easier for AI to chunk, index, and retrieve accurately.\n\nWhat to do:\n• Use consistent heading hierarchy\n• Break content into logical sections\n• Use lists, tables, and FAQs\n• Add comparison tables where relevant\n\nPro tip:\nA page with clear sections gets cited more than a wall of text.',
      'geoChecklist.task.av_2_4.instruction':
        'Surface-level content gets outranked by comprehensive resources. AI recommends the most authoritative source.\n\nWhat to do:\n• Go deep on your core topics\n• Cover edge cases and related questions\n• Include original data, examples, or case studies\n\nPro tip:\nBe the page that answers every follow-up question.',
      'geoChecklist.task.av_2_5.instruction':
        'If your content is hard to read, AI may struggle to extract meaning - or choose a simpler source.\n\nWhat to do:\n• Write at a level your audience understands\n• Avoid unnecessary jargon\n• Define technical terms when you use them\n\nPro tip:\nClear writing signals expertise, not simplicity.',
      'geoChecklist.task.av_2_6.instruction':
        'Comparison queries ("X vs Y", "alternatives to Z") are high-intent - AI recommends brands directly.\n\nWhat to do:\n• Create dedicated comparison pages\n• Include honest pros and cons\n• Cover your top competitors by name\n\nPro tip:\nIf you don\'t create the comparison - someone else will.',
      'geoChecklist.task.av_2_7.instruction':
        "AI needs to confidently classify your brand to recommend it. Vague positioning leads to being overlooked.\n\nWhat to do:\n• Use a clear, consistent brand description\n• State your category explicitly\n• Describe what you do in one sentence\n\nPro tip:\nIf AI can't explain your brand in one line - it won't recommend you.",
      'geoChecklist.task.av_2_8.instruction':
        "AI doesn't use everything it finds - it selects the best. Being indexed isn't enough.\n\nWhat to do:\n• Be specific and authoritative\n• Provide unique value competitors don't\n• Back claims with data and examples\n\nPro tip:\nAsk yourself: why would AI choose MY content over 100 others?",
      'geoChecklist.task.av_3_1.instruction':
        'AI models favor brands that appear frequently and consistently across high-quality sources.\n\nWhat to do:\n• Invest in brand recognition across channels\n• Publish thought leadership content\n• Speak at events and be featured in media\n\nPro tip:\nBrand strength in the real world = brand strength in AI answers.',
      'geoChecklist.task.av_3_2.instruction':
        'Third-party mentions are a strong signal for AI. If trusted sites reference you, AI trusts you too.\n\nWhat to do:\n• Get featured in industry publications\n• Contribute guest posts on relevant blogs\n• Appear in rankings and "best of" lists\n\nPro tip:\nOne mention on a trusted site > 10 mentions on unknown blogs.',
      'geoChecklist.task.av_3_3.instruction':
        'A mention says you exist. A recommendation says you\'re good. AI weights these differently.\n\nWhat to do:\n• Aim for "we recommend X because..." context\n• Build case studies with partners\n• Encourage expert endorsements\n\nPro tip:\nName drops don\'t move the needle - genuine recommendations do.',
      'geoChecklist.task.av_3_4.instruction':
        'AI models use review sentiment as a signal when making recommendations.\n\nWhat to do:\n• Actively collect reviews on G2, Trustpilot, Capterra\n• Respond to reviews (positive and negative)\n• Encourage detailed, specific feedback\n\nPro tip:\nA product with 200 reviews beats one with 20 - even at the same rating.',
      'geoChecklist.task.av_3_5.instruction':
        'Inconsistent naming and positioning confuses AI about who you are.\n\nWhat to do:\n• Align brand name across all channels\n• Use the same descriptions everywhere\n• Keep category positioning consistent\n\nPro tip:\nIf you call yourself "AI platform" here and "ML tool" there - AI gets confused too.',
      'geoChecklist.task.av_3_6.instruction':
        'AI models pull data from knowledge bases as primary sources. Outdated profiles = outdated AI answers.\n\nWhat to do:\n• Update Wikipedia, Crunchbase, LinkedIn\n• Keep G2, Trustpilot profiles current\n• Verify information on industry directories\n\nPro tip:\nThese profiles are often the first thing AI reads about your brand.',
      'geoChecklist.task.av_4_1.instruction':
        'Your website alone limits your footprint. AI crawls many platforms - be present where it looks.\n\nWhat to do:\n• Publish on Medium, Substack, or industry blogs\n• Write guest articles for relevant publications\n• Share insights on LinkedIn articles\n\nPro tip:\nMore indexed domains mentioning you = stronger AI signal.',
      'geoChecklist.task.av_4_2.instruction':
        'Community forums are heavily indexed by AI. Genuine, helpful answers carry significant weight.\n\nWhat to do:\n• Engage on Reddit, Quora, Stack Overflow\n• Answer questions in your area of expertise\n• Be helpful - not promotional\n\nPro tip:\nA helpful Reddit answer can influence AI more than a blog post.',
      'geoChecklist.task.av_4_3.instruction':
        'Turn one article into:\n• LinkedIn posts\n• threads\n• short insights\n\nPro tip:\nMore formats = more chances to appear.',
      'geoChecklist.task.av_4_4.instruction':
        'What to do:\n• publish educational videos\n• enable AI training in YouTube Studio\n\nPro tip:\nAI models heavily use YouTube transcripts.',
      'geoChecklist.task.av_5_1.instruction':
        "You can't optimize what you don't measure. Start by checking if AI knows you exist.\n\nWhat to do:\n• Ask ChatGPT, Claude, Gemini about your category\n• Check if your brand appears in recommendations\n• Note where you rank and in what context\n\nPro tip:\nDo this monthly - AI answers change faster than search results.",
      'geoChecklist.task.av_5_2.instruction':
        "Appearing in AI answers isn't enough - your position matters. First mention vs. buried at the bottom is a huge difference.\n\nWhat to do:\n• Track if you're mentioned 1st, 2nd, or 3rd+\n• Monitor how your position changes over time\n• Compare position across different AI models\n\nPro tip:\nPosition 1 gets most of the clicks - just like in search.",
      'geoChecklist.task.av_5_3.instruction':
        "AI cites specific domains and pages. If you know which sources it trusts, you can target them.\n\nWhat to do:\n• Identify domains AI cites in your category\n• Target those sites for mentions or partnerships\n• Create content on platforms AI already trusts\n\nPro tip:\nAppearing on AI's trusted sources is a shortcut to appearing in answers.",
      'geoChecklist.task.av_5_4.instruction':
        "Each AI model uses different retrieval and ranking strategies. What works for ChatGPT may not work for Gemini.\n\nWhat to do:\n• Test your visibility across ChatGPT, Claude, Gemini, Perplexity\n• Note which models cite your content and which don't\n• Adapt your strategy per model\n\nPro tip:\nYou don't optimize for 'AI' - you optimize per model.",
      'geoChecklist.task.av_5_5.instruction':
        'In GA4:\n• filter by source:\n  – chatgpt.com\n  – perplexity.ai\n\nPro tip:\nAI traffic is growing but often hidden.',
      'geoChecklist.task.av_5_6.instruction':
        'Not all AI queries are equal. Focus on the ones closest to a buying decision.\n\nWhat to do:\n• Monitor queries like "best X for Y"\n• Track "X vs Y" and "alternatives to Z"\n• Deprioritize pure informational queries\n\nPro tip:\nHigh-intent queries drive revenue - informational ones drive vanity metrics.',
      'geoChecklist.task.av_5_7.instruction':
        "Understanding what competitors do differently in AI gives you a strategic advantage.\n\nWhat to do:\n• Track competitor visibility in AI answers\n• Note which content AI cites for them\n• Identify strategies you can replicate or improve\n\nPro tip:\nYour competitor's AI strategy is visible - just ask the right questions.",
      'geoChecklist.task.av_5_8.instruction':
        "The highest-value opportunities are queries where you should appear but don't.\n\nWhat to do:\n• Find categories where competitors appear but you don't\n• Identify questions your audience asks that you don't answer\n• Prioritize gaps by business impact\n\nPro tip:\nClosing one visibility gap can be worth more than 10 new blog posts.",
      'geoChecklist.task.av_5_9.instruction':
        'GEO is not a one-time project. AI answers change constantly as models are updated.\n\nWhat to do:\n• Set a monthly or quarterly review cadence\n• Monitor → analyze → optimize → repeat\n• Update content when AI answers shift\n\nPro tip:\nThe brands that win in AI are the ones that keep showing up.',
      'geoChecklist.task.av_6_1.instruction':
        'A custom GPT puts your brand directly inside the ChatGPT ecosystem.\n\nWhat to do:\n• Build a GPT on the ChatGPT platform\n• Include your knowledge base and product info\n• Optimize the GPT description for discoverability\n\nPro tip:\nYour GPT is a branded channel inside AI - treat it like a product page.',
      'geoChecklist.task.av_6_2.instruction':
        'AI systems consume structured data more easily than unstructured content.\n\nWhat to do:\n• Add Schema.org markup and JSON-LD to your site\n• Create clean data feeds and APIs\n• Provide downloadable knowledge files\n\nPro tip:\nStructured data is the language AI speaks natively.',
      'geoChecklist.task.av_6_3.instruction':
        "Don't wait for AI to find you - actively push your content into AI discovery channels.\n\nWhat to do:\n• Submit content to AI search indexes\n• Use Deep Research prompts referencing your content\n• Create content designed specifically for AI retrieval\n\nPro tip:\nProactive discovery beats passive waiting every time.",
      'geoReport.title': 'GEO Audit',
      'geoReport.emptyState':
        'No audits yet - run your first audit</br>to see how your website performs in AI',
      'geoReport.subtitle':
        'An audit of your website’s accessibility, content, metadata, and authority to uncover AI visibility opportunities.',
      'geoReport.navLabel': 'GEO Audit',
      'geoReport.formTitle': 'Generate a new GEO audit',
      'geoReport.urlPlaceholder': 'example.com',
      'geoReport.urlInvalid': 'Please enter a valid domain',
      'geoReport.generateBtn': 'Generate Audit',
      'geoReport.generating': 'Generating...',
      'geoReport.generatingInfoTitle': 'Generating your audit...',
      'geoReport.generatingInfo':
        'This usually takes 5–10 minutes, depending on your website size. Feel free to leave this page - your report will be ready when you return.',
      'geoReport.limitReached': 'You have reached your monthly audit limit.',
      'geoReport.usageCounter': '{{used}}/{{limit}} audits used this month',
      'geoReport.noReports': 'No audits yet. Enter a URL above to generate your first GEO audit.',
      'geoReport.colUrl': 'URL',
      'geoReport.colStatus': 'Status',
      'geoReport.colScore': 'GEO Score',
      'geoReport.colDate': 'Date',
      'geoReport.colActions': 'Actions',
      'geoReport.viewBtn': 'View',
      'geoReport.hideBtn': 'Hide',
      'geoReport.downloadPdf': 'Download Audit',
      'geoReport.pdfGenerating': 'Generating...',
      'geoReport.geoScore': 'GEO Score',
      'geoReport.noContent': 'No audit content available.',
      'geoReport.cachedResultNote':
        'This result is from your recent audit (served from cache). GEO audits refresh every 48 hours - run it again after that to force a fresh crawl.',
      'geoReport.status.pending': 'Pending',
      'geoReport.status.generating': 'Generating',
      'geoReport.status.completed': 'Completed',
      'geoReport.status.failed': 'Failed',
      'geoReport.reportsTitle': 'Audits',
      'botsActivity.navLabel': 'Bots Activity',
      'botsActivity.title': 'Bots Activity',
      'botsActivity.connect.title': 'Connect to your website',
      'botsActivity.connect.subtitle':
        'Let Chatbeat analyze traffic on your website to gain insights into AI traffic and usage.',
      'botsActivity.crawlActivity': 'Bots Activity',
      'botsActivity.crawlBreakdown': 'Bots breakdown',
      'botsActivity.content': 'Content Activity',
      'botsActivity.byFolder': 'By Section',
      'botsActivity.byUrl': 'Top URLs',
      'botsActivity.homepage': 'Homepage',
      'botsActivity.byFolderExcludedHint_one':
        '{{count}} bot visit to a root-level config file (e.g. robots.txt) is shown in By URL only.',
      'botsActivity.byFolderExcludedHint_other':
        '{{count}} bot visits to root-level config files (e.g. robots.txt, sitemap.xml) are shown in By URL only.',
      'botsActivity.byFolderEmptyFilesOnly':
        'No content sections crawled in this period - only root-level files (robots.txt, sitemap.xml) were requested. See By URL for details.',
      'botsActivity.byPlatform': 'By platform',
      'botsActivity.byBot': 'By bot',
      'botsActivity.byBotType': 'By bot type',
      'botsActivity.noData': 'No bots data yet. Connect a provider to start tracking.',
      'botsActivity.vsLastPeriod': 'vs last period',
      'botsActivity.backfillInProgress':
        'Backfilling historical data - newer hours show first, older ones fill in over the next few minutes.',
      'botsActivity.backfillOnly':
        'Connected - fetching the first batch of data, this usually takes under a minute. If nothing shows up here after a few minutes, your provider may not have seen AI bot traffic in this period yet.',
      'botsActivity.ranges.1d': 'Last 24 hours',
      'botsActivity.ranges.7d': 'Last 7 days',
      'botsActivity.ranges.30d': 'Last 30 days',
      'botsActivity.ranges.90d': 'Last 90 days',
      'botsActivity.ranges.365d': 'Last year',
      'botsActivity.totalBotVisits': 'Total bot visits',
      'botsActivity.indexedUrls': 'Indexed URLs',
      'botsActivity.indexedUrlsHint': 'Index coverage across your website',
      'botsActivity.botRequestErrorsHint': 'Share of failed AI bot requests across your website.',
      'botsActivity.totalBotVisitsHint': 'Total AI bot requests across your website.',
      'botsActivity.botsActivityHint':
        'Tracks how often AI bots and crawlers access your website over time.',
      'botsActivity.contentActivityHint':
        'Analyze which sections and pages of your website receive the most AI crawler activity.',
      'botsActivity.bySectionHint': 'Breakdown of AI bot activity by website section.',
      'botsActivity.topUrlsHint':
        'Shows the individual pages most frequently visited by AI bots and crawlers.',
      'botsActivity.lastIndexed': 'Last indexed',
      'botsActivity.change': 'Change',
      'botsActivity.never': '-',
      'botsActivity.timeAgo.justNow': 'just now',
      'botsActivity.timeAgo.minutes_one': '{{count}} minute ago',
      'botsActivity.timeAgo.minutes_other': '{{count}} minutes ago',
      'botsActivity.timeAgo.hours_one': '{{count}} hour ago',
      'botsActivity.timeAgo.hours_other': '{{count}} hours ago',
      'botsActivity.timeAgo.days_one': '{{count}} day ago',
      'botsActivity.timeAgo.days_other': '{{count}} days ago',
      'botsActivity.botVisits': 'Bot visits',
      'botsActivity.activeBots': 'Active bots',
      'botsActivity.failureRate': 'Bot Request Errors',
      'botsActivity.urlsCrawled': 'URLs crawled',
      'botsActivity.visitOverTime': 'Visits over time',
      'botsActivity.noPlatformData': 'No platform data yet',
      'botsActivity.noTrafficData': 'No AI bot traffic data for this period',
      'botsActivity.viewDetails': 'View details',
      'botsActivity.vsLastDays': 'vs last {{days}} days',
      'botsActivity.connect.setupHint': 'Choose where Chatbeat should pull AI bot request logs from.',
      'botsActivity.connect.logsProvider': 'Logs provider:',
      'botsActivity.connect.pleaseSelect': 'Please select',
      'botsActivity.connect.cdnPartners': 'CDN Partners',
      'botsActivity.connect.noProvider': "Don't see your provider?",
      'botsActivity.connect.requestIntegration': 'Request an integration',
      'botsActivity.connect.viewAnalysis': 'View analysis',
      'botsActivity.connect.viewAnalysisAria': 'Open BotsActivity analysis',
      'botsActivity.connect.uploadFile': 'Upload',
      'botsActivity.connect.openSetup': 'Open setup',
      'botsActivity.connect.noBotsMatched':
        'Parsed {{count}} log lines but none of them matched a known AI crawler. The dashboard tracks AI bots only (GPTBot, ClaudeBot, PerplexityBot, etc.) so this file produced no events. Upload a log that contains traffic from those user-agents to see data.',
      dismiss: 'Dismiss',
      'botsActivity.sourceMenuAria': 'Source actions',
      'botsActivity.uploadLog': 'Upload log file',
      'botsActivity.disconnectCloudflare': 'Disconnect Cloudflare',
      'botsActivity.openConnect': 'Manage integrations',
      'botsActivity.disconnectConfirmHeader': 'Disconnect Cloudflare',
      'botsActivity.disconnectConfirmMessage':
        'Are you sure you want to disconnect Cloudflare? Crawl data collection will stop.',
      'botsActivity.clearLogData': 'Clear log data',
      'botsActivity.clearingLogData': 'Clearing...',
      'botsActivity.clearLogDataConfirmHeader': 'Clear log data',
      'botsActivity.clearLogDataConfirmMessage':
        'This permanently deletes every log file upload and all crawl events derived from those uploads for this project. Charts will lose the historical data. Continue?',
      'botsActivity.sourceLockedByCloudflare': 'Disconnect Cloudflare to upload log files.',
      'botsActivity.sourceLockedByLogs': 'Clear log data to switch to this source.',
      'botsActivity.connectErrorCloudflareActive':
        'Cloudflare integration is currently active. Disconnect Cloudflare first to switch sources.',
      'botsActivity.connectErrorLogHistory':
        'Project has log upload history. Clear log data first to switch to Cloudflare.',
      'cloudflare.disconnecting': 'Disconnecting...',
      'botsActivity.connectionRequired': 'Connect a provider to see analysis',
      'botsActivity.connectionRequiredHint':
        'BotsActivity needs first-party request logs to render. Open the setup screen to connect Cloudflare or upload a log file.',
      'botsActivity.noActivityYet':
        'No activity yet. Data will appear here once AI bots start visiting your site.',
      'botsActivity.emptyBannerTitle': 'No bots data yet',
      'botsActivity.emptyBannerHint':
        'Cloudflare polls your zone every 15 minutes. Run analysis now to fetch the latest events on demand.',
      'botsActivity.emptyBannerHintLog':
        'Log file uploads are aggregated every few minutes. Upload more files or wait for the next aggregation cycle.',
      'botsActivity.runAnalysis': 'Run analysis now',
      'botsActivity.runningAnalysis': 'Running analysis...',
      'botsActivity.runAnalysisOk': 'Analysis complete · {{rows}} new event(s) ingested',
      'botsActivity.runAnalysisOkEmptyCloudflare':
        'Analysis complete · Cloudflare returned no new events in the last window',
      'botsActivity.runAnalysisOkEmptyFastly':
        'Analysis complete · Fastly returned no new events in the last window',
      'botsActivity.runAnalysisOkEmptyLog': 'Analysis complete · log aggregation refreshed',
      'botsActivity.runAnalysisRateLimited': 'Please wait {{seconds}}s before running analysis again.',
      'botsActivity.runAnalysisAuthFailedCloudflare':
        'Cloudflare rejected the API token - reconnect your integration.',
      'botsActivity.runAnalysisAuthFailedFastly':
        'Fastly rejected the API token - reconnect your integration.',
      'botsActivity.runAnalysisFailed': 'Failed to run analysis · {{error}}',
      'botsActivity.runAnalysisNoIntegration':
        'No active integration found. Connect Cloudflare, Fastly or upload a log file to run analysis.',
      'botsActivity.botVisitTrend': 'Bot visit trend - by platform',
      'botsActivity.contentHint': 'What bots are looking for - by folders and pages',
      'botsActivity.breakdownHint': 'Who is visiting your site - by platform, agent and purpose',
      'botsActivity.allPlatforms': 'All Platforms',
      'botsActivity.allBotTypes': 'All Bot Types',
      'botsActivity.allBots': 'All Bots',
      'botsActivity.updatedAt': 'Refreshed · {{date}}',
      'botsActivity.vsLastDaysShort': 'vs last {{days}} days',
      'botsActivity.showMore': 'Show more ({{count}})',
      'botsActivity.showLess': 'Show less',
      'botsActivity.unknownPlatform': 'Unknown',
      'botsActivity.visits': 'Visits',
      'cloudflare.planFree': 'Free',
      'botsActivity.headline':
        '{{platform}} leads with {{sharePct}}% of requests - {{folder}} is your most visited folder',
      'botsActivity.headlineFallback': 'AI bot activity overview',
      'botsActivity.heroSubtitle':
        'AI bots made {{visits}} requests across {{urls}} URLs in the last {{days}} days',
      visits: 'Visits',
      noDataYet: 'No data yet - waiting for first events',
      'botAccess.navLabel': 'Bots Access',
      'botAccess.title': 'Bots Access',
      'botAccess.heroTitle':
        '{{project}} - {{restrictions}} bots with restrictions, {{open}} fully open',
      'botAccess.heroSubtitle':
        'How AI bots are instructed to access your domain based on your robots.txt rules',
      'botAccess.reloadRobots': 'Reload robots.txt',
      'botAccess.viewRobots': 'View robots.txt',
      'botAccess.cooldownMinutes_one': '{{count}} minute',
      'botAccess.cooldownMinutes_other': '{{count}} minutes',
      'botAccess.cooldownToast': 'Robots.txt was just refreshed. You can run another check in {{time}}.',
      'botAccess.refreshError': 'Could not refresh robots.txt. Please try again.',
      'botAccess.aiBotCrawlRules': 'AI bots crawl rules',
      'botAccess.botCount': '{{visible}} of {{total}}',
      'botAccess.searchPlaceholder': 'Search bot name',
      'botAccess.noData': 'No Bots Access data yet. Click Reload robots.txt to run a check.',
      'botAccess.noWebsite':
        'No website configured for this project. Add a website URL in project settings to enable Bots Access checks.',
      'botAccess.goToSettings': 'Go to project settings',
      'botAccess.colBot': 'Bot',
      'botAccess.colType': 'Type',
      'botAccess.colPlatform': 'Platform',
      'botAccess.colStatus': 'Status',
      'botAccess.statusOpen': 'Open',
      'botAccess.statusDefaultAllow': 'Default allow',
      'botAccess.statusBlocked': 'Blocked',
      'botAccess.statusNotVerified': 'Not verified',
      'botAccess.tileOpenHint': 'Bots can crawl your entire site freely',
      'botAccess.tileDefaultAllowHint': 'Not restricted in robots.txt - crawlable by default',
      'botAccess.tileBlockedHint': 'Fully disallowed - bot cannot crawl any page',
      'botAccess.categoryTraining': 'Training',
      'botAccess.categorySearch': 'Search',
      'botAccess.categoryAgent': 'Agent',
      'botAccess.categoryEcosystem': 'Ecosystem',
      'providers.cloudflare.title': 'Cloudflare',
      'providers.cloudflare.description':
        'Connect your Cloudflare zone to pull AI crawler traffic data automatically.',
      'providers.fastly.title': 'Fastly',
      'providers.fastly.description': 'Stream real-time log data from Fastly to Chatbeat.',
      'providers.log.title': 'Log file',
      'providers.log.description':
        'Upload server access logs (Apache CLF / Nginx / Caddy / JSON Lines) or a CSV export with timestamp + user-agent columns.',
      'providers.log.uploadTitle': 'Upload log file',
      'providers.log.recentUploads': 'Recent uploads',
      'providers.log.quotaRemaining': '{{used}} / {{limit}} uploads used today',
      'providers.log.dropzoneText': 'Click to select or drag and drop a log file',
      'providers.log.dropzoneHint': '.csv, .log, .txt - max 100 MB',
      'providers.log.errorExtension': 'Invalid file type. Please upload a .csv, .log, or .txt file.',
      'providers.log.errorTooLarge': 'File is too large. Maximum size is 100 MB.',
      'providers.log.errorUploadFailed': 'Upload failed. Please try again.',
      'providers.log.noUploads': 'No uploads yet',
      'providers.log.formatTitle': 'Expected file format',
      'providers.log.formatIntro':
        'Two formats are supported. The required columns are <0>timestamp</0> and <1>user_agent</1>; everything else is optional.',
      'providers.log.formatClf': 'Apache/Nginx Combined Log Format (.log) - standard access log lines.',
      'providers.log.formatCsv':
        'CSV with a header row. Accepted column aliases (any one per group): timestamp/ts/time/datetime · user_agent/ua · path/url/uri · method · status_code/status · bytes/size · ip/client_ip.',
      'providers.log.downloadExample': 'Download example CSV',
      connected: 'Connected',
      uploading: 'Uploading...',
      upload: 'Upload',
      details: 'Details',
      events: 'Events',
      filename: 'Filename',
      failed: 'failed',
      'csvStatus.PENDING': 'Pending',
      'csvStatus.PROCESSING': 'Processing',
      'csvStatus.COMPLETED': 'Completed',
      'csvStatus.FAILED': 'Failed',
      'csvDetails.parsed': 'parsed',
      'cloudflare.infoDescription':
        'To connect Cloudflare, you need an API token with Zone:Read and Zone:Analytics:Read permissions.',
      'cloudflare.createTokenButton': 'Create token in Cloudflare',
      'cloudflare.manualStepsToggle': 'Or create manually',
      'cloudflare.manualStep1': '1. Go to dash.cloudflare.com → My Profile → API Tokens',
      'cloudflare.manualStep2': '2. Click "Create Token"',
      'cloudflare.manualStep3': '3. Choose "Create Custom Token"',
      'cloudflare.manualStep4': '4. Add permissions: Zone > Zone (Read) and Zone > Analytics (Read)',
      'cloudflare.manualStep5': '5. Set Zone Resources to "All zones" or specific zone',
      'cloudflare.manualStep6': '6. Click "Continue to summary", then "Create Token"',
      'cloudflare.apiTokenLabel': 'API Token',
      'cloudflare.apiTokenPlaceholder': 'Paste your Cloudflare API token',
      'cloudflare.testConnectionButton': 'Test connection',
      'cloudflare.testingConnection': 'Testing...',
      'cloudflare.errorEmptyToken': 'API token is required',
      'cloudflare.errorInvalidToken': 'Invalid token or no accessible zones found',
      'cloudflare.errorInsufficientPermissions':
        'Invalid token or insufficient permissions. Ensure the token has Zone:Read and Zone:Analytics:Read.',
      'cloudflare.errorRateLimit': 'Rate limit reached. Please try again in a moment.',
      'cloudflare.errorGeneric': 'Connection test failed. Please check your token and try again.',
      'cloudflare.errorConnectFailed': 'Failed to connect. Please try again.',
      'cloudflare.bestMatch': 'Best match',
      'cloudflare.searchZones': 'Search zones...',
      'cloudflare.confirmZoneLabel': 'Zone:',
      'cloudflare.confirmPlanLabel': 'Plan:',
      'cloudflare.backfillInfo':
        "We'll fetch the most history your Cloudflare plan allows. Fresh data lands every 15 minutes.",
      'cloudflare.connecting': 'Connecting...',
      'cloudflare.confirmConnect': 'Connect',
      'cloudflare.stepInfoTitle': 'Connect Cloudflare',
      'cloudflare.stepTokenTitle': 'Enter API Token',
      'cloudflare.stepZonesTitle': 'Select Zone',
      'cloudflare.stepConfirmTitle': 'Confirm Connection',
      'fastly.infoDescription':
        'To connect Fastly, paste an API token with `global:read` and `stats` scopes. We use it to list your services and pull historical stats for AI crawler traffic.',
      'fastly.createTokenButton': 'Create token in Fastly',
      'fastly.apiTokenLabel': 'API Token',
      'fastly.apiTokenPlaceholder': 'Paste your Fastly API token',
      'fastly.testConnectionButton': 'Test connection',
      'fastly.testingConnection': 'Testing...',
      'fastly.errorEmptyToken': 'API token is required',
      'fastly.errorInvalidToken': 'Invalid token or no accessible services found',
      'fastly.errorInsufficientPermissions':
        'Invalid token or insufficient permissions. Ensure the token has the global:read and stats scopes.',
      'fastly.errorRateLimit': 'Rate limit reached. Please try again in a moment.',
      'fastly.errorGeneric': 'Connection test failed. Please check your token and try again.',
      'fastly.errorConnectFailed': 'Failed to connect. Please try again.',
      'fastly.bestMatch': 'Best match',
      'fastly.searchServices': 'Search services...',
      'fastly.confirmServiceLabel': 'Service:',
      'fastly.confirmServiceIdLabel': 'Service ID:',
      'fastly.backfillInfo':
        "We'll backfill the last 30 days of stats. Fresh data lands every 15 minutes.",
      'fastly.connecting': 'Connecting...',
      'fastly.confirmConnect': 'Connect',
      'fastly.stepInfoTitle': 'Connect Fastly',
      'fastly.stepServicesTitle': 'Select Service',
      'fastly.stepConfirmTitle': 'Confirm Connection',
      'botsActivity.sourceLockedByFastly': 'Disconnect Fastly to switch to this source.',
      'aiSignals.navLabel': 'AI Signals',
      'ads.navLabel': 'Ads',
      'ads.title': 'AI Ads',
      'ads.desc': 'Ad tracking is currently available for ChatGPT only.',
      'ads.reportingPausedNotice':
        'ChatGPT has changed its ad format, so advertiser reporting is temporarily paused. We’ll resume reporting once ads are available again.',
      'ads.dismissNotice': 'Dismiss',
      'ads.adsDetected': 'Ads',
      'ads.adsDetectedSub': 'Ad occurrences · {{count}} unique ads',
      'ads.adsDetectedTooltip':
        'Ads - the total number of ad occurrences detected on your tracked prompts; every detection counts separately. Unique ads ({{count}}) - the number of unique ad creatives: advertiser + headline + description + canonical destination URL (tracking parameters such as UTM removed).',
      'ads.promptsWithAds': 'Prompts with ads',
      'ads.promptsWithAdsSub': '{{percent}}% of monitored prompts',
      'ads.promptsWithAdsTooltip':
        'Monitored prompts where at least one ad appeared in the selected period - {{percent}}% of all monitored prompts.',
      'ads.advertisersDetected': 'Advertisers',
      'ads.advertisersDetectedSub': 'unique brands buying ad space',
      'ads.advertisersDetectedTooltip':
        'Number of distinct brands whose ads were detected in the selected period.',
      'ads.advertisersCount': 'Advertisers: {{count}}',
      'ads.showMore': 'Show more ({{count}})',
      'ads.showLess': 'Show less',
      'ads.presenceTitle': 'Ad presence over time',
      'ads.presenceDesc': 'See how frequently ads appear across your monitored AI answers.',
      'ads.viewOccurrences': 'Ad occurrences',
      'ads.viewByAdvertiser': 'By advertiser',
      'ads.byAdvertiserNote':
        'Each {{unit}} shows its top {{top}} advertisers; {{ads}} ads outside them are not drawn.',
      'ads.otherAdvertisers': 'Other advertisers',
      'ads.unitDay': 'day',
      'ads.unitWeek': 'week',
      'ads.unitMonth': 'month',
      'ads.yourBrand': 'Your brand',
      'ads.otherBrands': 'Other brands',
      'ads.tooltipTotal': 'Total',
      'ads.shareTitle': 'Ad share by advertiser',
      'ads.shareDesc': 'Advertisers ranked by their share of detected ad appearances.',
      'ads.colAdvertiser': 'Advertiser',
      'ads.colShare': 'Share',
      'ads.colSeen': 'Seen',
      'ads.colPrompts': 'Prompts',
      'ads.colAdvertiserDomain': 'Advertiser domain',
      'ads.colFirstSeen': 'First time seen',
      'ads.colAdCopy': 'Ad copy',
      'ads.colAdCreative': 'Ad creative & copy',
      'ads.colSendsTo': 'Sends to',
      'ads.colTimesSeen': 'Times seen',
      'ads.colModel': 'Model',
      'ads.colVisibility': 'Visibility',
      'ads.colAdCoverage': 'Ad coverage',
      'ads.adCoverageTooltip':
        'Share of this prompt\'s tracked answers that showed at least one ad (answers with ads / answers measured).',
      'ads.colPrompt': 'Prompt',
      'ads.colAds': 'Ads',
      'ads.colAdvertisers': 'Advertisers',
      'ads.colLatest': 'Latest',
      'ads.visibilityTooltip': 'Organic visibility of your brand for this prompt.',
      'ads.youBadge': 'You',
      'ads.tabByAdvertiser': 'By advertiser',
      'ads.tabByAd': 'By ad',
      'ads.tabByPrompt': 'By prompt',
      'ads.breakdownTitle': 'Detailed breakdown',
      'ads.breakdownTooltip':
        'Analyze detected ads by advertiser or by ad creative. Search and CSV export apply to the active view.',
      'ads.searchPlaceholder':
        'Search ads or advertisers...',
      'ads.searchPromptsPlaceholder': 'Search prompts...',
      'ads.promptsTooltip': 'Monitored prompts where ads appeared: which brands advertised there, how many ad occurrences, and your organic visibility for the prompt.',
      'ads.allAdvertisers': 'All advertisers',
      'ads.advertisersSelected': 'advertisers selected',
      'ads.searchAdvertisers': 'Search advertisers…',
      'ads.sponsoredLabel': 'Sponsored',
      'ads.emptyTitle': 'No ads detected for the selected filters.',
      'ads.emptyDesc': 'Try changing the date range or prompt group.',
      'ads.errorTitle': 'Something went wrong.',
      'ads.errorDesc': 'We could not load this data.',
      'ads.notEnabledTitle': 'AI Ads monitoring is not enabled for this project.',
      'ads.notEnabledDesc':
        'This project does not monitor ChatGPT - ad tracking is currently available for ChatGPT only.',
      'ads.announcement.badge': 'New in Chatbeat',
      'ads.announcement.titlePrefix': 'AI Ads is',
      'ads.announcement.titleAccent': 'live',
      'ads.announcement.desc':
        'See exactly which ads show up inside AI answers - who buys them, where they lead, and whether your brand is part of the conversation.',
      'ads.announcement.previewTitle': 'Ad presence over time',
      'ads.announcement.statAds': 'Ads',
      'ads.announcement.statPrompts': 'Prompts with ads',
      'ads.announcement.statAdvertisers': 'Advertisers',
      'ads.announcement.later': 'Maybe later',
      'ads.announcement.cta': 'Explore AI Ads',
      'aiVisibilityReport.navLabel': 'AI Visibility Insights',
      'aiVisibilityReport.title': 'AI Visibility Insights',
      'aiVisibilityReport.subtitle':
        'Generate an AI-powered report with insights about your brand visibility.',
      'aiVisibilityReport.periodLabel': 'Period',
      'aiVisibilityReport.generateBtn': 'Generate report',
      'aiVisibilityReport.generating': 'Starting…',
      'aiVisibilityReport.generatingInfoTitle': 'Generating your report…',
      'aiVisibilityReport.generatingInfo':
        'This can take around 15 minutes. You can leave this page - the report will appear in the list when ready.',
      'aiVisibilityReport.periodTooLong': 'Period must be at most {{max}} days.',
      'aiVisibilityReport.runsTitle': 'In progress',
      'aiVisibilityReport.reportsTitle': 'Reports',
      'aiVisibilityReport.emptyState': 'No reports yet. Choose a period above to generate the first one.',
      'aiVisibilityReport.colPeriod': 'Period',
      'aiVisibilityReport.colStatus': 'Status',
      'aiVisibilityReport.colDate': 'Created',
      'aiVisibilityReport.colActions': 'Actions',
      'aiVisibilityReport.downloadBtn': 'Download PDF',
      'aiVisibilityReport.deleteBtn': 'Delete',
      'aiVisibilityReport.dismissBtn': 'Dismiss',
      'aiVisibilityReport.cancelBtn': 'Cancel',
      'aiVisibilityReport.confirmCancelRunHeader': 'Cancel generation',
      'aiVisibilityReport.confirmCancelRun':
        'Cancel this report generation? You can generate the report again for the same period afterwards.',
      'aiVisibilityReport.confirmDeleteReport':
        'Are you sure you want to delete this report? You will be able to regenerate it for the same period afterwards.',
      'aiVisibilityReport.confirmDismissRun':
        'Are you sure you want to dismiss this failed run? It will be removed from the list.',
      'aiVisibilityReport.status.pending': 'Pending',
      'aiVisibilityReport.status.generating': 'Generating',
      'aiVisibilityReport.status.failed': 'Failed',
      'aiVisibilityReport.errorReportExists': 'A report for this period already exists. Delete it first to regenerate.',
      'aiVisibilityReport.errorActiveRun': 'A report for this period is already being generated.',
      'aiVisibilityReport.errorMonthlyLimit':
        'Monthly report limit reached for your account. Cancel a pending run or wait for the reset.',
      'aiVisibilityReport.quotaRemaining':
        '{{remaining}} of {{limit}} reports left this month · renews on {{date}}',
      'aiVisibilityReport.quotaExhausted':
        'Monthly limit reached ({{limit}}) · renews on {{date}}',
      'aiVisibilityReport.errorGeneric': 'Could not start report generation.',
      'aiVisibilityReport.errorDownload': 'Could not download the PDF.',
      'promptAnalyst.navLabel': 'Prompt Analyst',
      'promptAnalyst.title': 'Prompt Analyst',
      'promptAnalyst.subtitle': 'Check a prompt before you monitor it: which brands AI names, where your brand stands and how to phrase it better.',
      'promptAnalyst.promptPlaceholder': 'Type a question people might ask AI…',
      'promptAnalyst.analyzeBtn': 'Analyze',
      'promptAnalyst.analyzing': 'Starting…',
      'promptAnalyst.quotaRemaining': '{{remaining}} of {{limit}} reviews left this month (resets {{date}})',
      'promptAnalyst.quotaExhausted': 'Monthly limit of {{limit}} reviews used up - resets {{date}}',
      'promptAnalyst.errorMonthlyLimit': 'Monthly review limit reached.',
      'promptAnalyst.errorDemo': 'Demo projects are read-only.',
      'promptAnalyst.errorInvalidPrompt': 'The prompt must be 3-500 characters long.',
      'promptAnalyst.errorGeneric': 'Could not start the review.',
      'promptAnalyst.errorAddPrompt': 'Could not add the prompt.',
      'promptAnalyst.historyTitle': 'History',
      'promptAnalyst.newAnalysis': 'New analysis',
      'promptAnalyst.composerTitle': 'Which prompt do you want to check?',
      'promptAnalyst.searchHistory': 'Search analyses…',
      'promptAnalyst.historyEmpty': 'No analyses found.',
      'promptAnalyst.collapseHistory': 'Collapse history',
      'promptAnalyst.expandHistory': 'Expand history',
      'promptAnalyst.today': 'Today',
      'promptAnalyst.yesterday': 'Yesterday',
      'promptAnalyst.status.PENDING': 'Queued',
      'promptAnalyst.status.RUNNING': 'Analyzing',
      'promptAnalyst.status.DONE': 'Done',
      'promptAnalyst.status.FAILED': 'Failed',
      'promptAnalyst.inProgress': 'Analyzing - this usually takes under a minute.',
      'promptAnalyst.failed': 'The review failed. It did not count towards your monthly limit - try again.',
      'promptAnalyst.verdict.keep': 'Keep',
      'promptAnalyst.verdict.rewrite': 'Rewrite',
      'promptAnalyst.verdict.add_variants': 'Add variants',
      'promptAnalyst.verdict.worth_adding': 'Worth monitoring',
      'promptAnalyst.questionType.neutral': 'Neutral question',
      'promptAnalyst.questionType.positive': 'Positive question',
      'promptAnalyst.questionType.negative': 'Negative question',
      'promptAnalyst.aiOverview': 'AI Overview in Google',
      'promptAnalyst.similarAccounts': 'Monitored by {{value}} other accounts',
      'promptAnalyst.summaryTitle': 'Analysis summary',
      'promptAnalyst.summaryTooltip': 'The reviewed prompt, the slant of the question and a short summary of how AI answers it.',
      'promptAnalyst.tileOwnAnswers': 'Answers with your brand',
      'promptAnalyst.tileOwnAnswersTooltip': 'In how many AI answers from the last 30 days your brand (with its variants) appears.',
      'promptAnalyst.tileAvgPosition': 'Avg. position',
      'promptAnalyst.tileAvgPositionTooltip': 'Average position of your brand in the answers that mention it.',
      'promptAnalyst.tileBrandsPerAnswer': 'Brands per answer',
      'promptAnalyst.tileBrandsPerAnswerTooltip': 'How many brands an answer names on average. Fewer than 2 means the prompt hardly measures competition.',
      'promptAnalyst.tileSourcesPerAnswer': 'Sources per answer',
      'promptAnalyst.tileSourcesPerAnswerTooltip': 'How many web sources an answer cites on average.',
      'promptAnalyst.tileMentioned': 'Brand mentioned',
      'promptAnalyst.tileMentionedTooltip': 'Whether your brand (or a variant of it) appears in the answer.',
      'promptAnalyst.tilePosition': 'Position in answer',
      'promptAnalyst.tilePositionTooltip': 'Where your brand appears among the brands the answer names.',
      'promptAnalyst.tileBrands': 'Brands compared',
      'promptAnalyst.tileBrandsTooltip': 'How many brands, products or providers the answer recommends or compares.',
      'promptAnalyst.tileSources': 'Sources cited',
      'promptAnalyst.tileSourcesTooltip': 'How many web sources the answer cites.',
      'promptAnalyst.tileVerdict': 'Verdict',
      'promptAnalyst.tileVerdictTooltip': 'Computed from the numbers: rewrite when answers name fewer than 2 brands, add variants when your brand is in under 20% of answers.',
      'promptAnalyst.answersTitle': 'How AI answers (last 30 days)',
      'promptAnalyst.answersTooltip': 'Brands named most often in this prompt\'s AI answers from the last 30 days.',
      'promptAnalyst.liveTitle': 'How AI answers',
      'promptAnalyst.liveTooltip': 'One answer from ChatGPT with web search, fetched during the review - a sample, not a measurement.',
      'promptAnalyst.brand': 'Brand',
      'promptAnalyst.brandAnswers': 'Answers',
      'promptAnalyst.avgPosition': 'Avg. position',
      'promptAnalyst.noBrands': 'The answer names no brands.',
      'promptAnalyst.answerTitle': 'AI\'s response',
      'promptAnalyst.answerTooltip': 'The whole answer ChatGPT gave during the review. Sources are listed above.',
      'promptAnalyst.citedSources': 'Cited sources',
      'promptAnalyst.citedSourcesTooltip': 'Web sources the model cited.',
      'promptAnalyst.noSources': 'No sources cited.',
      'promptAnalyst.domain': 'Domain',
      'promptAnalyst.searchQueries': 'What AI searched for',
      'promptAnalyst.searchQuery': 'Search query',
      'promptAnalyst.searchQueriesTooltip': 'Queries the model sent to its search engine while answering.',
      'promptAnalyst.improveTitle': 'What to improve',
      'promptAnalyst.improveTooltip': 'Observations based on the data above.',
      'promptAnalyst.rewrites': 'Recommended prompts',
      'promptAnalyst.rewritesTooltip': 'Alternative prompts that would measure better. Add them to the project with one click.',
      'promptAnalyst.suggestionsCount': '{{value}} suggestions',
      'promptAnalyst.peopleTitle': 'What people ask on Google',
      'promptAnalyst.peopleTooltip': 'People Also Ask and related searches from Google - how real people phrase this topic.',
      'visibilityReport.navLabel': 'Reports',
      'visibilityReport.title': 'Reports',
      'visibilityReport.subtitle':
        "Build a shareable report of your brand's visibility across AI chatbots. Pick filters and export it instantly.",
      'visibilityReport.periodLabel': 'Period',
      'visibilityReport.modelsLabel': 'AI models',
      'visibilityReport.modelsAll': 'All models',
      'visibilityReport.dialogTitle': 'Generate report',
      'visibilityReport.periodHint': 'Up to 3 months',
      'visibilityReport.periodTypeLabel': 'Granularity',
      'visibilityReport.periodTypeHint': 'How statistics are bucketed',
      'visibilityReport.colPeriodType': 'Granularity',
      'visibilityReport.previewLabel': 'Report preview',
      'visibilityReport.generateBtn': 'Generate report',
      'visibilityReport.generating': 'Generating…',
      'visibilityReport.generatingInfo':
        'Crunching the numbers - this takes a few seconds. The report opens as soon as it is ready.',
      'visibilityReport.periodTooLong': 'The period must not exceed 3 months.',
      'visibilityReport.emptyState': 'No reports generated yet for this project',
      'visibilityReport.colName': 'Name',
      'visibilityReport.reportName': 'Report {{period}}',
      'visibilityReport.colBrand': 'Brand',
      'visibilityReport.colModels': 'AI models',
      'visibilityReport.colDate': 'Created',
      'visibilityReport.colActions': 'Actions',
      'visibilityReport.openBtn': 'Open report',
      'visibilityReport.deleteBtn': 'Delete',
      'visibilityReport.confirmDelete':
        'Are you sure you want to delete this report? The link stops working for everyone who has it.',
      'visibilityReport.confirmUnshare':
        'Stop sharing this report? The link stops working for everyone who has it.',
      'visibilityReport.confirmDeleteMany':
        'Delete {{count}} selected reports? Their links stop working for everyone who has them.',
      'visibilityReport.bulkRemove': 'Delete selected reports',
      'visibilityReport.selectMode': 'Manage selected reports',
      'visibilityReport.backToList': 'Back to reports',
      'visibilityReport.notFound': 'This report is not available.',
      'visibilityReport.errorGeneric': 'Could not generate the report.',
      'visibilityReport.modelsHint': 'Models with data in the selected period',
      'visibilityReport.promptsLabel': 'Prompts',
      'visibilityReport.promptsHint': 'Leave empty to cover every prompt',
      'visibilityReport.promptsAll': 'All prompts',
      'visibilityReport.promptsSelected': '{{count}} prompts selected',
      'visibilityReport.promptsSearch': 'Search prompts...',
      'visibilityReport.noDataInPeriod': 'No model collected data in this period - pick a different range.',
      'visibilityReport.shareBtn': 'Share link',
      'visibilityReport.shareEnabled': 'Report shared publicly',
      'visibilityReport.shareCopyLink': 'Copy link',
      'visibilityReport.shareRevoke': 'Stop sharing',
      'visibilityReport.sharedUnavailableTitle': 'This report is no longer available',
      'visibilityReport.sharedUnavailableDesc':
        'The link has been revoked or the report was deleted. Ask the sender for a new one.',
      'aiSignals.title': 'Brand24 AI Signals',
      'aiSignals.badge': 'Add-on',
      'aiSignals.subtitle':
        'Connecting real-world brand mentions with AI-generated narratives - so you can shape how AI models talk about your brand.',
      'aiSignals.priceLabel': 'Add-on price',
      'aiSignals.price': '$199',
      'aiSignals.pricePeriod': '/ month',
      'aiSignals.priceNote': 'Billed in addition to your Chatbeat plan.',
      'aiSignals.activate': 'Activate add-on',
      'aiSignals.addProject': 'Add project to Brand24',
      'aiSignals.unlink': 'Unlink project',
      'aiSignals.contact': 'Contact your account manager to enable.',
      'aiSignals.included': "What's included",
      'aiSignals.highlight.title': 'Context & Sentiment of Mentions on AI Sources',
      'aiSignals.highlight.desc':
        'Sentiment classification per source, AI Backlink competitor benchmarking and source-level breakdown of the narratives feeding AI models.',
      'aiSignals.features.integration.title': 'Chatbeat × Brand24 Integration',
      'aiSignals.features.integration.desc':
        'Unified view of brand mentions across the web and AI chats - real-time sync of Brand24 mentions, mapped from social, news and forums into AI answers.',
      'aiSignals.features.topics.title': 'Top Industry Topics - Suggested Prompts',
      'aiSignals.features.topics.desc':
        'Trending topic detection from millions of mentions with auto-generated prompt suggestions tied to high-impact themes in your industry.',
      'aiSignals.features.anomaly.title': 'Brand Anomaly Alerts',
      'aiSignals.features.anomaly.desc':
        'Anomaly detection on AI-cited sources (Reddit, Forbes, YouTube, LinkedIn, niche publishers) - react before narratives become embedded in AI responses.',
      'aiSignals.footer': 'Need this for your team? Contact your account manager for availability.',
      'aiSignals.activation.title': 'Activating AI Signals',
      'aiSignals.activation.subtitle': 'This will only take a moment…',
      'aiSignals.activation.step1': 'Activating your project',
      'aiSignals.activation.step2': 'Collecting insights and mentions',
      'aiSignals.activation.step3': 'Analyzing source sentiment',
      'aiSignals.activation.step4': 'Building the AI Backlinks Index',
      'aiSignals.results.header': 'AI Signals',
      'aiSignals.results.title': 'Mentions in AI Sources',
      'aiSignals.results.subtitle':
        'Monitor your brand mentions across AI sources, analyze sentiment and build a competitive edge.',
      'aiSignals.results.mentions.title': 'Mentions in AI Sources',
      'aiSignals.results.mentions.of': 'of',
      'aiSignals.results.mentions.desc':
        "The share of your brand's mentions that appear on sources AI models cite - how much of your overall coverage sits on AI-visible domains. A higher share means more of your brand's mentions are where AI can surface them; a lower one points to coverage AI isn't drawing from yet.",
      'aiSignals.results.competitors.title': 'AI Backlink Competitors',
      'aiSignals.results.competitors.brands': 'Brands',
      'aiSignals.results.competitors.mentions': 'Mentions',
      'aiSignals.results.competitors.backlinks': 'AI Backlinks',
      'aiSignals.results.competitors.sentiment': 'Sentiment',
      'aiSignals.results.sources.added': 'Added',
      'aiSignals.results.sources.notAdded': 'Not added',
      'aiSignals.results.trend.title': 'Mentions in AI Sources - Trend',
      'aiSignals.results.domains.title': 'Top AI Source Domains',
      'aiSignals.results.domains.tooltip':
        'The most frequently cited domains per AI model, ranked by number of mentions.',
      'aiSignals.results.sourcesPerModel.title': 'Mentions per Model - Top Sources',
      'aiSignals.results.sourcesPerModel.note': 'Top 6 sources across all AI models',
      'aiSignals.results.context.title': 'Context of a discussion',
      'aiSignals.results.context.share': 'Appears in {{share}}% of mentions',
      'aiSignals.results.context.tooltip':
        'The most common terms appearing alongside your brand in AI-cited discussions.',
      'aiSignals.results.context.showSentiment': 'Show sentiment',
      'aiSignals.results.context.hideSentiment': 'Hide sentiment',
      'aiSignals.results.sentiment.positive': 'Positive',
      'aiSignals.results.sentiment.neutral': 'Neutral',
      'aiSignals.results.sentiment.negative': 'Negative',
      'aiSignals.results.topics.title': 'Discussion Topics',
      'aiSignals.results.topics.subtitle':
        'Auto-detected themes from AI-cited sources. Add any to your tracked tags.',
      'aiSignals.results.topics.addToTags': 'Add to tags',
      'aiSignals.results.topics.removeTag': 'Remove',
      'aiSignals.results.topics.topic': 'Topic',
      'aiSignals.results.topics.sentiment': 'Sentiment',
      'aiSignals.results.topics.mentions': 'Mentions',
      'aiSignals.results.backlinks.title': 'AI Backlinks',
      'aiSignals.results.backlinks.source': 'Source',
      'aiSignals.results.backlinks.mentions': 'Mentions',
      'aiSignals.results.backlinks.models': 'Models',
      'aiSignals.results.backlinks.reach': 'Reach',
      'aiSignals.results.backlinks.sentiment': 'Sentiment',
      agencyStats: 'Agency',
      agencyStatsTitle: 'Agency Statistics',
      agencyHub: 'Agency Hub',
      agencyHubSubtitle: 'Manage projects and client access.',
      agencyHubInUse: 'in use',
      agencyHubNoLimit: 'No limit',
      agencyHubAllocatedAcrossProjects: 'Used across projects',
      agencyHubTeamNote: '{{active}} active · {{pending}} pending',
      agencyHubUpgradePlan: 'Upgrade plan',
      agencyHubProjectsTooltip: 'All projects on the account with their prompt allocation.',
      agencyHubTeamTooltip: 'Everyone with access to the account, grouped by role.',
      aiModels: 'AI models',
      agencyHubModelsUnit: 'active',
      agencyHubModelLocked: '{{model}} · available in a higher plan',
      agencyHubAdminsNote: 'Full access to all projects and this hub',
      agencyHubUsersNote: 'Access to all projects, without this hub',
      agencyHubGuestsNote: 'Read-only access to shared projects',
      allProjectsCount: 'All projects · {{count}}',
      inviteMember: 'Invite member',
      member: 'Member',
      admins: 'Admins',
      guests: 'Guests',
      assign: 'Assign',
      removeMember: 'Remove member',
      start: 'Start',
      allocatePrompts: 'Allocate prompts',
      allocatePromptsSubtitle: "Split your plan's prompt pool between projects.",
      allocated: 'Used',
      promptsLeftInPool: '{{count}} prompts left in the pool',
      promptsOverLimit: '{{count}} over your plan limit',
      minUsed: 'min. {{count}} (in use)',
      allocateStartPoolShort: 'Not enough free prompts in the pool ({{count}} short)',
      needMorePrompts: 'Need more prompts? Upgrade your plan',
      changeLimit: 'Change limit',
      shareProject: 'Share project',
      shareProjectHint: 'Guests see only the projects you share with them.',
      shareProjectNoGuests: 'No guests on the team yet. Invite a guest to share only selected projects.',
      roleChanged: '{{name}}: role changed to {{role}}',
      guestOnlyProject: 'only project',
      guestOnlyProjectHint:
        'A guest needs at least one project. Share another one first or remove the guest from the team.',
      pauseProject: 'Pause project',
      startProject: 'Start project',
      removeProjectsConfirm:
        'Remove {{count}} selected projects? Their prompts stop collecting and the allocations return to the pool.',
      removeMemberConfirm: 'Remove {{name}} from the team?',
      projectRemoved: 'Project removed',
      projectsRemoved_one: '{{count}} project removed',
      projectsRemoved: '{{count}} projects removed',
      memberRemoved: 'Removed from the team',
      promptAllocation: 'Prompt allocation',
      promptAllocationHint:
        "A reservation from the account's pool for this project. At least as many as the project's prompts.",
      promptAllocationFree: 'free in the pool: {{count}}',
      promptAllocationNoLimit: 'No limit',
      agencyHubNoAllocationLimit: 'no allocation limit',
      agencyHubPausedPrompts_one: 'Paused · {{count}} prompt',
      agencyHubPausedPrompts: 'Paused · {{count}} prompts',
      agencyHubPausedNoPrompts: 'Paused · no prompts to resume',
      agencyHubPausedPromptsHint: 'Starting the project reserves these prompts from the pool',
      overAllocationLimit: '({{count}} over allocation limit)',
      promptAllocationMissing:
        "{{count}} prompts short in the pool. Change other projects' prompt allocation.",
      promptAllocationPaused: 'A paused project reserves no prompts. Set the allocation when you start it.',
      promptAllocationLowerHint: "To lower the allocation, pause or delete the project's prompts",
      startProjectMissing:
        '{{count}} prompts short to start. Free the pool in "Allocate prompts" or delete some of the project\'s prompts.',
      projectsPaused_one: '{{count}} project paused',
      projectsPaused: '{{count}} projects paused',
      projectsStarted_one: '{{count}} project started',
      projectsStarted: '{{count}} projects started',
      allocationsSaved: 'Allocations saved',
      allocationLimitTooltip: 'Project allocation limit reached ({{used}} / {{allocation}})',
      projectPausedInHubTooltip: 'Project paused',
      allocationExceededTitle: 'Project prompt limit',
      allocationExceeded:
        'Project “{{name}}” uses {{used}} of {{allocation}} allocated prompts. Raise the allocation in the project settings to add or resume more.',
      allocationExceededAskAdmin:
        'Project “{{name}}” uses {{used}} of {{allocation}} allocated prompts. Ask an account administrator to raise the allocation to add or resume more.',
      projectPausedInHubTitle: 'Project paused',
      projectPausedInHub: 'Project “{{name}}” is paused. Start it to resume its prompts.',
      projectPausedInHubAskAdmin:
        'Project “{{name}}” was paused by an account administrator. Ask an administrator to start it.',
      confirmPauseProject:
        "The project's prompts stop collecting after today's run and the allocation returns to the pool. Pause?",
      bulkPauseProjects: 'Pause selected projects',
      bulkStartProjects: 'Start selected projects',
      bulkRemoveProjects: 'Remove selected projects',
      agencyStatsProjects: 'Projects',
      agencyStatsPrompts: 'Prompts',
      agencyStatsActive: 'Active',
      agencyStatsPaused: 'Paused',
      agencyStatsPending: 'Pending',
      agencyStatsDeletedPrompts: 'Deleted',
      agencyStatsTotals: 'Total',
      agencyStatsAdded: 'Added (period)',
      agencyStatsDeleted: 'Deleted (period)',
      agencyStatsPromptsPerGroup: 'Prompts per group',
      agencyStatsProjectDistribution: 'Project distribution',
      agencyStatsEstCost: 'Est. Cost',
      agencyStatsCostPerPrompt: 'Cost per prompt',
      agencyStatsActiveOverTime: 'Active prompts over time',
      agencyStatsPromptsOverTime: 'Projects over time',
      agencyStatsTableTitle: 'Group statistics',
      agencyStatsShareOfTotal: 'Share %',
      agencyStatsProjectsDelta: 'Projects Δ',
      agencyStatsPromptsDelta: 'Prompts Δ',
      agencyStatsUsageScore: 'Usage',
      agencyStatsNewPrompts: 'New',
      agencyStatsExisting: 'Existing',
      agencyStatsStatus: 'Status',
      agencyStatsTrend: 'Trend',
      agencyStatsDailyAvg: 'Avg/day',
      agencyStatsFastestGrowing: 'Fastest Growing',
      agencyStatsInsightsTitle: 'Top insights',
      agencyStatsHighestUsage: 'Highest Usage',
      agencyStatsLowestActivity: 'Lowest Activity',
      usageHigh: 'High',
      usageMedium: 'Medium',
      usageLow: 'Low',
      alertHighGrowth: 'High growth',
      alertSpike: 'Spike',
      alertLowActivity: 'Low activity',
      groups: 'Groups',
      groupsTooltip: 'Number of groups',
      projectsTooltip: 'Total number of projects',
      promptsTooltip: 'Total number of prompts',

      'botsActivity.dataQuality.badge.fastlyBmOn': 'AI bots only',
      'botsActivity.dataQuality.badge.fastlyBmOff': 'All bots',
      'botsActivity.dataQuality.badge.cloudflareBmOn': 'Full precision',
      'botsActivity.dataQuality.badge.cloudflareBmOff': 'UA-based ID',
      'botsActivity.dataQuality.badge.log': 'Server logs',

      'botsActivity.dataQuality.popover.log.title': 'Highest precision (server logs)',
      'botsActivity.dataQuality.popover.log.body':
        'Bots are identified by the User-Agent in your log file. Full per-bot, per-URL and per-status breakdown - the same quality as Cloudflare with Bot Management.',
      'botsActivity.dataQuality.popover.log.secondary':
        'Upload more log files to extend history. Each upload adds to existing data (a second upload of the same file will double the counts).',

      'botsActivity.dataQuality.popover.fastlyBmOn.title': 'Counting only AI bots',
      'botsActivity.dataQuality.popover.fastlyBmOn.body':
        'Fastly Bot Management is on - the number covers verified AI crawlers (GPTBot, ClaudeBot, Perplexity, …) and nothing else.',
      'botsActivity.dataQuality.popover.fastlyBmOn.secondary':
        'Fastly does not return a per-bot or per-URL breakdown. To see which bot hit which URL, also connect Cloudflare or upload server logs.',

      'botsActivity.dataQuality.popover.fastlyBmOff.title': 'Count includes all bots',
      'botsActivity.dataQuality.popover.fastlyBmOff.body':
        'Without Bot Management, Fastly cannot separate AI traffic from search engines, scrapers and monitoring tools. Real AI share is typically 20–40% of the number you see.',
      'botsActivity.dataQuality.popover.fastlyBmOff.cta': 'Enable Bot Management in Fastly',
      'botsActivity.dataQuality.popover.fastlyBmOff.secondary':
        'For a per-bot breakdown (GPTBot, ClaudeBot, …) connect Cloudflare or upload server logs.',

      'botsActivity.dataQuality.popover.cloudflareBmOn.title': 'Highest precision',
      'botsActivity.dataQuality.popover.cloudflareBmOn.body':
        'Bots are identified by Cloudflare Detection IDs. Per-bot, per-URL and per-status breakdown all run on verified bot signatures - the most precise view available.',

      'botsActivity.dataQuality.popover.cloudflareBmOff.title': 'Bots matched by User-Agent',
      'botsActivity.dataQuality.popover.cloudflareBmOff.body':
        'Per-bot, per-URL and per-status breakdown still works fully. Only bot identification reads from the User-Agent header - less precise than Cloudflare Detection IDs, which come with Business / Enterprise plans.',
      'botsActivity.dataQuality.popover.cloudflareBmOff.cta': 'See Cloudflare plans',

      'fastly.botManagementInfoTitle': 'What you will see depends on Bot Management',
      'fastly.botManagementInfoLine1':
        'With Bot Management on (paid Fastly add-on): we count only verified AI crawlers (GPTBot, ClaudeBot, Perplexity, …).',
      'fastly.botManagementInfoLine2':
        'Without Bot Management: we count every detected bot (AI + Googlebot/Bingbot + scrapers + monitoring) - real AI is usually 20–40% of that.',
      'fastly.botManagementInfoLimit':
        'Either way Fastly Stats does not return per-bot or per-URL breakdown. For that, also connect Cloudflare or upload server logs.',

      'cloudflare.planInfoTitle': 'Higher Cloudflare plan = more precision and longer history',
      'cloudflare.planInfoLine1':
        'Free: 1 day of history at initial backfill, bots identified by User-Agent.',
      'cloudflare.planInfoLine2': 'Pro: 7 days of history, bots identified by User-Agent.',
      'cloudflare.planInfoLine3':
        'Business / Enterprise: 30 days of history, bots identified by Cloudflare Detection IDs (significantly more precise).',
      'cloudflare.planInfoLimit':
        'You can always upload server logs alongside Cloudflare for additional precision.',

      'cloudflare.backfillInfoFree':
        "For your Free plan we will fetch the last 1 day of history (Cloudflare's hard cap). Fresh data lands every 15 minutes. Higher plans give a longer backfill.",
      'cloudflare.backfillInfoPro':
        "For your Pro plan we will fetch the last 7 days of history (Cloudflare's hard cap). Fresh data lands every 15 minutes. Business / Enterprise plans give 30 days of backfill.",
      'cloudflare.backfillInfoBusiness':
        'For your Business plan we will fetch the last 30 days of history. Fresh data lands every 15 minutes.',
      'cloudflare.backfillInfoEnterprise':
        'For your Enterprise plan we will fetch the last 30 days of history. Fresh data lands every 15 minutes.',
      pageTraffic: 'URL Overview',
      pageTrafficTooltip: 'How often URLs appear in AI responses.',
      pageTrafficEmptyTitle: 'No changes detected',
      pageTrafficEmptyDescription: "We didn't detect any URL changes in the selected period.",
      pageTrafficNoDomainTitle: 'No domain set for this project',
      pageTrafficNoDomainDescription:
        'We need to know which domain is yours. Add your website to the project, or mark a domain as yours in Domain Share Comparison.',
      pageTrafficTabTop: 'Top',
      pageTrafficTabTopTooltip:
        'The most-used URLs in the current period, ranked by total usage count regardless of growth.',
      pageTrafficTabTopGainers: 'Top gainers',
      pageTrafficTabTopGainersTooltip:
        'URLs whose retrieval count grew the most vs the previous period.',
      pageTrafficTabTopDecliners: 'Top decliners',
      pageTrafficTabTopDeclinersTooltip:
        'URLs whose retrieval count dropped the most vs the previous period.',
      pageTrafficTabNewlyCited: 'Newly cited',
      pageTrafficTabNewlyCitedTooltip:
        'URLs cited for the first time in the current period - no prior history in this project.',
      pageTrafficTabDroppedOff: 'Dropped off',
      pageTrafficTabDroppedOffTooltip:
        'URLs that were cited in the previous period but disappeared in the current one.',
      lastUsed: 'Last used',
      models: 'Models',
      top: 'Top',
      pageTrafficShowingTopN: 'Showing the top {{shown}} of {{total}} URLs',
      noPromptsForSource: 'No prompts cited this URL in the selected period.',
      openInNewTab: 'Open in new tab',
      promptsCitingThisPage: 'Prompts citing this page',
      scanFormTitle: 'Check how AI models see your brand',
      scanFormDesc:
        'We ask ChatGPT, Gemini, Perplexity and other models the questions your customers ask - and turn their answers into a visibility report.',
      scanFormSubmit: 'Get my free report',
      scanFormNote:
        'We send a confirmation link to your inbox. Collecting the answers takes a few minutes.',
      scanEmailSentTitle: 'Check your inbox',
      scanEmailSentDesc:
        'We sent you a confirmation link. Click it and we will start asking the models about your brand.',
      scanRequestFailed: 'We could not start the scan. Please try again in a moment.',
      scanTooManyRequests: 'You have reached the scan limit for today. Please try again tomorrow.',
      scanProgressTitle: 'Collecting AI answers',
      scanProgressDesc: 'We are asking the models about {{domain}}. This usually takes a few minutes.',
      scanProgressDescGeneric: 'We are asking the models about your brand. This usually takes a few minutes.',
      scanProgressNote: 'You can close this page - the link in your email always brings you back here.',
      scanStepQuestions: 'Generating questions for your category',
      scanStepAsking: 'Asking the AI models',
      scanStepBuilding: 'Building your report',
      scanFailedTitle: 'We could not finish this scan',
      scanFailedDesc: 'Something went wrong while collecting the answers. Please request a new scan.',
      reportSavePdf: 'Save as PDF',
      reportCoverSubtitle: 'Visibility Report',
      reportAllResponses: 'All responses',
      reportSummaryTitle: 'Where you',
      reportSummaryTitleAccent: 'stand today.',
      reportSummarySubtitle:
        '{{brand}} is visible in {{visibility}}% of relevant AI answers and holds {{share}}% share of voice.',
      reportPlatformTitle: 'Platform',
      reportPlatformTitleAccent: 'Performance.',
      reportPlatformEven: 'Consistent visibility',
      reportPlatformEvenDesc: 'Your brand performs identically on all {{count}} platforms.',
      reportPlatformDominant: 'Dominant model',
      reportPlatformWeakest: 'Weakest model',
      reportPlatformShare: '{{value}}% visibility share',
      reportPlatformMetricsTitle: 'Platform Metrics',
      reportPlatformMetricsDesc: 'Visibility share across AI platforms.',
      reportRankingTitle: 'You rank {{rank}}',
      reportRankingTitleAccent: 'in AI Visibility.',
      reportRankingSubtitle:
        'Share of AI answers mentioning each brand across all tracked prompts. Read the ranking to see where {{brand}} stands against competitors.',
      reportRankingYourBrand: 'Your brand',
      reportSovTitle: 'Share of',
      reportSovTitleAccent: 'Voice.',
      reportSovLeads:
        '{{brand}} leads the market with a {{share}}% share, ahead of {{rival}} by {{gap}} percentage points.',
      reportSovTrails:
        '{{brand}} holds a {{share}}% share, {{gap}} percentage points behind {{rival}}.',
      reportSovOnly: '{{brand}} holds a {{share}}% share of voice.',
      reportSovChartTitle: 'Share Breakdown',
      reportSovChartDesc: 'How the answers split between you and the brands you compete with.',
      reportMatrixTitle: 'Competitor',
      reportMatrixTitleAccent: 'Visibility.',
      reportMatrixSubtitle:
        'How competitors rank across different AI models. Darker cells mean stronger presence.',
      reportMatrixFootnote:
        'Visibility per platform; "-" means the platform returned no data for that brand.',
      reportTrendTitle: 'Brand score &',
      reportTrendVisibilityAccent: 'visibility.',
      reportTrendSubtitle: 'How your brand performed day by day across the selected period.',
      reportTopicsTitle: 'Topics',
      reportTopicsTitleAccent: 'share.',
      reportTopicsSubtitle: 'Which topics generate the AI conversations your brand appears in.',
      reportPresenceTitle: 'Brand presence',
      reportPresenceTitleAccent: 'by topic.',
      reportPresenceSubtitle:
        'Where each brand shows up across the topics your buyers ask AI about.',
      reportFunnelTitle: 'From mentioned',
      reportFunnelTitleAccent: 'to recommended.',
      reportFunnelSubtitle:
        'The funnel shows how many AI responses move from "mentioned" to "recommended".',
      reportFunnelMentioned: 'Mentioned',
      reportFunnelMentionedDesc: '{{responses}} of {{total}} AI responses contain {{brand}}',
      reportFunnelTop3: 'Top-3 (consideration)',
      reportFunnelTop3Desc: '{{responses}} responses with the brand in the first three positions',
      reportFunnelTop1: 'Top-1 (recommended)',
      reportFunnelTop1Desc: '{{responses}} responses with {{brand}} as the first choice',
      reportFunnelStepTop3: 'Mention Top-3',
      reportFunnelStepTop3Desc: '{{value}}% of mentions reach the consideration set.',
      reportFunnelStepTop1: 'Mention Top-1',
      reportFunnelStepTop1Desc: '{{value}}% of mentions end up in the first position.',
      reportGapsTitle: 'Context',
      reportGapsTitleAccent: 'gap.',
      reportGapsSubtitle:
        'Topics where your presence is behind competitors and the fastest content wins.',
      reportDomainsTitle: 'Top cited',
      reportDomainsTitleAccent: 'domains.',
      reportDomainsSubtitle:
        'The domains AI assistants rely on when answering prompts in your category.',
      reportDomainsShare: '{{value}}% of citations',
      reportPagesTitle: 'Top cited',
      reportPagesTitleAccent: 'pages.',
      reportPagesSubtitle:
        'Individual pages that AI models quote most often - the content shaping your answers.',
      reportPromptsTitle: 'Prompt',
      reportPromptsTitleAccent: 'analysis.',
      reportPromptsSubtitle:
        'Detailed breakdown of prompt-level performance. Momentum is positive this period, with strong visibility signals across the top performing prompts.',
      'publicScanGate.title': 'This page is not public yet',
      'publicScanGate.desc': 'Enter the access password to continue.',
      'publicScanGate.placeholder': 'Access password',
      'publicScanGate.submit': 'Unlock',
      'publicScanGate.error': 'Wrong password.',
      reportPromptsLockedTitle: 'Prompt analysis is part of the full report',
      reportPromptsLockedDesc:
        'See which prompts bring your brand into AI answers - and which ones hand them to competitors.',
      reportPromptsLockedCta: 'Create a free account',
      reportPromptsTopTitle: 'Top performing prompts',
      reportPromptsTopDesc: 'Prompts with the highest brand visibility across AI responses.',
      reportPromptsTopTitleGroups: 'Prompts & prompt groups',
      reportPromptsTopDescGroups: 'Brand visibility per prompt; groups aggregate related questions.',
      reportPromptsGroupTag: 'Group',
      reportPromptsGroupTagCount: 'Group · {{count}} prompts',
      reportPromptsEven: 'Consistent visibility',
      reportPromptsEvenDesc: 'No weak spots - every one of the {{count}} prompts scores the same.',
      reportPromptsBest: 'Highest visibility',
      reportPromptsWorst: 'Lowest visibility',
      reportPromptsLowest: 'Lowest performing prompt',
    },
  },
  pl: {
    translation: {
      brandNameRestriction:
        'Nie zalecamy używania nazwy własnej marki w pytaniu – może to wpłynąć na jakość odpowiedzi generowanych przez model językowy.',
      tools: 'Narzędzia',
      menuGroups: {
        performance: 'Performance',
        prompts: 'Prompty',
        bots: 'Boty',
      },
      collapseMenu: 'Zwiń menu',
      expandMenu: 'Rozwiń menu',
      allProjects: 'Wszystkie projekty',
      selectProject: 'Wybierz projekt',
      searchProjects: 'Szukaj projektów...',
      noPromptsYet: 'Brak dostępnych pytań',
      noPromptsYetMsg:
        'Wygląda na to, że jeszcze nie dodałeś żadnych monitorów. Podpowiedzi pomagają śledzić pozycję Twojej marki oraz udział w różnych zapytaniach. Zacznij od dodania podpowiedzi, aby rozpocząć monitorowanie najważniejszych metryk dla Twojego biznesu.<br><br>Kliknij "Dodaj nowe zapytanie", aby rozpocząć i być na bieżąco dzięki spersonalizowanym informacjom w czasie rzeczywistym.',
      addNewQuestion: 'Dodaj nowe pytanie',
      upgradeNow: 'Zmień plan teraz',
      upgradePlanTrialExportMsg: 'Zmień plan na wyższy, aby korzystać z eksportu.',
      upgradePlanTrialMsg:
        'Zmień plan na wyższy, aby uzyskać dostęp do funkcji premium i lepszej wydajności!',
      promptsQuestions: 'Prompty / Pytania',
      questionsPrompts: 'pytań/promptów',
      allPrompts: 'Wszystkie prompty',
      suggestedPrompts: 'Sugerowane pytania',
      suggestedPromptsGeneratingSoon:
        'Sugerowane pytania pojawią się</br>tu za kilka minut.',
      regenerateSuggestedPrompts: 'Regeneruj sugerowane pytania',
      regenerateSuggestedPromptsDesc:
        'Wszystkie dotychczasowe sugerowane pytania dla tego projektu <bold>zostaną trwale usunięte</bold> i wygenerowane od nowa.',
      regenerate: 'Regeneruj',
      regenerating: 'Regeneruję...',
      forceLanguageOptional: 'Wymuś język (opcjonalnie)',
      regenerateSingleSuccess: 'Zregenerowano (usunięto {{deleted}} wpisów z cache)',
      regenerateError: 'Nie udało się zregenerować pytań',
      questions: 'Pytania',
      integrations: 'Integracje',
      pricing: 'Cennik',
      settings: 'Ustawienia',
      logout: 'Wyloguj',
      myAccount: 'Moje konto',
      mobileNavHelp: 'Pomoc',
      mobileSearch: 'Szukaj',
      changePassword: 'Zmień hasło',
      subscription: 'Subskrypcja',
      competitors: 'Konkurenci',
      industry: 'Branża',
      website: 'Strona internetowa',
      orders: 'Zamówienia',
      team: 'Zespół',
      teamManageDesc: 'Zarządzaj i przeglądaj członków zespołu.',
      invitedAt: 'Zaproszono',
      changeYourName: 'Zmień swoje imię i nazwisko',
      changeNameMsg:
        'Możesz zaktualizować swoje imię i nazwisko, tak jak są one widoczne na Twoim koncie. Upewnij się, że informacje są poprawne, ponieważ będą one używane do komunikacji, fakturowania i dokumentów prawnych. Po dokonaniu zmiany, nowe dane będą widoczne we wszystkich obszarach Twojego konta. Proszę dokładnie sprawdzić pisownię przed zapisaniem jakichkolwiek zmian.',
      changeBillingAddress: 'Zmień swój adres rozliczeniowy',
      firstName: 'Imię',
      lastName: 'Nazwisko',
      companyName: 'Nazwa firmy',
      taxId: 'NIP',
      plan: 'Plan',
      questionLimits: 'Limit pytań',
      limitReached: 'Przekroczyłeś swój limit',
      startDate: 'Data uruchomienia',
      brandScoreAndAveragePosition: 'Wynik marki i średnia pozycja',
      startBuildingAiVisibility: 'Zacznij budować swoją widoczność w AI',
      startBuildingAiVisibilityDescription:
        'Twoja marka nie jest jeszcze widoczna w odpowiedziach AI. Postępuj zgodnie z Rekomendacjami GEO, aby poprawić widoczność.',
      brandScoreAndVisibility: 'Wynik marki i widoczność',
      brandScoreAndVisibilityTooltip:
        'Wynik marki (siła marki, gdy jest widoczna) i Widoczność (udział odpowiedzi AI wspominających markę) - oba jako procent.',
      anomalyTooltipTitle: 'Anomalia',
      anomalyTooltipValues: 'Zmiana wartości',
      anomalyTooltipTopPrompts: 'Źródła największej zmiany',
      anomalyTooltipTopModels: 'Modele z największym wpływem',
      anomalyDirectionPositive: 'Pozytywna zmiana',
      anomalyDirectionNegative: 'Negatywna zmiana',
      anomalyHeadlineTo: 'na',
      brandScoreImproved: 'polepszył się z',
      brandScoreDeteriorated: 'pogorszył się z',
      averagePositionImproved: 'polepszyła się z',
      averagePositionDeteriorated: 'pogorszyła się z',
      visibilityImproved: 'polepszyła się z',
      visibilityDeteriorated: 'pogorszyła się z',
      paymentMethod: 'Metoda płatności',
      cancelationDate: 'Data anulowania',
      nextPayment: 'Następna płatność',
      userLimits: 'Limit użytkowników',
      actions: 'Akcja',
      visibility: 'Widoczność',
      visibilityBarTooltip: 'Jak często każda marka pojawia się w dyskusjach generowanych przez AI',
      showingDataForDays: 'Dane z {{count}} dni',
      lineChart: 'Wykres liniowy',
      barChart: 'Wykres słupkowy',
      visibilityTooltip:
        'Udział odpowiedzi AI wspominających Twoją markę: odpowiedzi z marką ÷ wszystkie odpowiedzi × 100. Pokazuje całkowitą obecność marki w AI, niezależnie od pozycji.',
      removeAccount: 'Usuń konto',
      renewAccount: 'Przywróć konto',
      startCancellation: 'Rozpocznij',
      cancellationProcessSuffix: ' proces anulowania.',
      phoneNumber: 'Numer telefonu',
      contactName: 'Osoba kontaktowa',
      contactEmail: 'E-mail osoby kontaktowej',
      emailAddress: 'Adres e-mail',
      firstLineAddress: 'Adres',
      secondLineAddress: 'Adres cd.',
      city: 'Miasto',
      zipCode: 'Kod pocztowy',
      country: 'Kraj',
      selectCountry: 'Wybierz kraj',
      countryRequired: 'Wybierz kraj, dla którego śledzimy ten projekt.',
      countryMarketHint: 'Jaki rynek chcesz analizować?',
      stateProvince: 'Województwo',
      save: 'Zapisz',
      interval: 'Interwał',
      prompt: 'Prompt',
      addNew: 'Dodaj nowy',
      remove: 'Usuń',
      noPermission: 'Brak uprawnień do wykonania tej operacji.',
      manageUser: 'Zarządzaj użytkownikiem',
      outsideTop30: 'Poza Top 30',
      stable: 'Bez zmian',
      new: 'Nowe',
      addNewBrand: 'Dodaj nową markę',
      expandOrganicAnswer: 'Rozszerzona lista z odpowiedzi organicznej',
      noModelResponse: 'Ten model nie zwrócił żadnej odpowiedzi na to zapytanie.',
      manageUserMsg:
        'Zarządzanie użytkownikami umożliwia przeglądanie i edytowanie szczegółów użytkownika, takich jak imię, nazwisko i adres e-mail. Możesz również usunąć użytkowników z systemu w razie potrzeby.',
      availableIntegrations: 'Dostępne integracje',
      chatGPTDesc:
        'ChatGPT, sztuczna inteligencja stworzona przez OpenAI, generuje ludzkopodobne odpowiedzi na pytania, rozmowy i zadania tekstowe.',
      claudeDesc:
        'Claude, chatbot AI stworzony przez Anthropic, został zaprojektowany do naturalnych rozmów, kładąc nacisk na bezpieczeństwo, klarowność i pomocność.',
      geminiDesc:
        'Google Gemini to model AI stworzony przez Google, który przetwarza i generuje tekst oraz obrazy. Flash został zaprojektowany do ultraszybkich odpowiedzi przy niższym koszcie obliczeniowym.',
      geminiProDesc:
        'Flash Pro to bardziej zaawansowana wersja z ulepszonym rozumowaniem, nieco większym kontekstem oraz lepszą wydajnością w złożonych zadaniach.',
      newPassword: 'Nowe hasło',
      rePassword: 'Powtórz hasło',
      comingSoon: 'Już wkrótce',
      integrationDesc:
        'Integracje w naszej aplikacji pozwalają na połączenie z zewnętrznymi narzędziami, takimi jak ChatGPT, Google Gemini i Claude. Umożliwia to bezpośredni dostęp do dodatkowych funkcji, które te narzędzia oferują w ramach naszej aplikacji. Integracje pomagają automatyzować procesy, analizować dane, generować treści i usprawniać współpracę, co pozwala na zarządzanie informacjami w jednym miejscu. To rozwiązanie zwiększa i rozszerza możliwości aplikacji, czyniąc Twoją pracę bardziej efektywną.',
      changePasswordDesc:
        'W tej sekcji możesz zaktualizować swoje hasło do konta w celu poprawy bezpieczeństwa. Upewnij się, że Twoje nowe hasło ma co najmniej 6 znaków i jest trudne do odgadnięcia. Po pomyślnym zmianie hasła zostaniesz automatycznie wylogowany z powodów bezpieczeństwa i będziesz musiał zalogować się ponownie za pomocą nowego hasła.',
      daily: 'Codzienne',
      weekly: 'Tygodniowe',
      currentSubscription: 'Obecny plan',
      currentSubscriptionDesc:
        'W tej sekcji możesz sprawdzić szczegóły swojego obecnego planu subskrypcyjnego. Zobaczysz informacje na temat oferowanych funkcji, limitów oraz korzyści, które są dostępne w ramach Twojego planu. Możesz również porównać różne plany, aby zrozumieć, które z dodatkowych funkcji mogą być dla Ciebie przydatne. Jeśli czujesz, że potrzebujesz więcej możliwości lub lepszego dostępu do zaawansowanych funkcji, rozważ możliwość aktualizacji swojego planu. Upewnij się, że korzystasz z pełni możliwości, które nasza aplikacja ma do zaoferowania!',
      billingData: 'Dane rozliczeniowe',
      trialExpired: 'Twój okres próbny wygasł',
      trialExpiredToday: 'Twój okres próbny wygasa dzisiaj',
      trialExpiredOneDay: 'Twój okres próbny wygaśnie za 1 dzień',
      global: 'Globalną',
      trialExpiredLeft: 'Twój okres próbny wygaśnie za {{daysLeft}} dni',
      reactivationExpired: 'Twoja reaktywacja wygasła',
      reactivationExpiredToday: 'Twoja reaktywacja wygasa dzisiaj',
      reactivationExpiredOneDay: 'Twoja reaktywacja jest ważna jeszcze 1 dzień',
      reactivationExpiredLeft: 'Twoja reaktywacja jest ważna jeszcze {{daysLeft}} dni',
      geolocationChanged: 'Zmiana lokalizacji na {{country}}',
      monitorEventPromptAdded: 'dodano pytanie "{{prompt}}"',
      monitorEventPromptDeleted: 'usunięto pytanie "{{prompt}}"',
      monitorEventModelAdded: 'dodano model',
      monitorEventModelDeleted: 'usunięto model',
      monitorEventModelReleased: 'aktualizacja modelu {{model}}',
      showMarkers: 'pokaż znaczniki',
      hideMarkers: 'ukryj znaczniki',
      disabledAccount: 'Twoje konto jest obecnie wyłączone',
      overdueAccount: 'Twoje konto jest przeterminowane',
      disableCurrentPlan: 'Ten plan jest już aktywny na Twoim koncie.',
      disableSelectPlan:
        'Nie możesz wybrać tego planu, ponieważ limity użytkowania zostały przekroczone. Zmniejsz zużycie lub wybierz wyższy plan.',
      upgrade: 'Uaktualnij',
      nip: 'NIP',
      role: 'Rola',
      selectRole: 'Wybierz role',
      admin: 'Administrator',
      owner: 'Właściciel',
      user: 'Użytkownik',
      guest: 'Gość',
      guestProjectsAccess: 'Projekty dla gościa',
      guestNeedsProject: 'Wybierz gościowi co najmniej jeden projekt',
      guestSelectProjects: 'Wybierz projekty',
      guestProjectsSelected: 'Wybrane projekty: {0}',
      guestEditProjects: 'Edytuj projekty gościa',
      users: 'Użytkownicy',
      usersText: 'Użytkowników',
      dashboard: 'Dashboard',
      noResultsFound: 'Brak wyników',
      noResultsFoundDesc: 'Dostosuj filtry i spróbuj ponownie.',
      emptyGroup: 'Brak promptów w tym tagu',
      emptyProjectGroup: 'Brak projektów w tej grupie',
      dataCollectingNotice:
        'Pamiętaj, że wyniki widoczne w dashboardzie będą się zmieniać przez kilka minut, ponieważ trwa zbieranie danych o widoczności AI.',
      computingTitle: 'Trwa obliczanie',
      checkingModel: 'Sprawdzamy {{model}}…',
      modelsReadyCount: '{{ready}} z {{total}} modeli gotowych',
      computingSovTitle: 'Przygotowujemy benchmark',
      benchmarkMsgCompetitors: 'Przeglądamy konkurencję…',
      benchmarkMsgShares: 'Liczymy udział głosu…',
      benchmarkMsgChart: 'Rysujemy wykres…',
      computingMsgResponses: 'Zbieramy odpowiedzi z modeli AI…',
      computingMsgAnalyzing: 'Analizujemy konkurencję…',
      computingMsgSov: 'Obliczamy Share of Voice…',
      computingMsgSources: 'Sprawdzamy cytowane źródła…',
      computingMsgBrandScore: 'Obliczamy Brand Score…',
      computingMsgDashboard: 'Przygotowujemy Twój dashboard…',
      inviteUser: 'Zaproś użytkownika',
      inviteUserDesc:
        'Funkcja zapraszania użytkowników umożliwia wysyłanie zaproszeń do innych osób, dając im dostęp do Twojego konta. Ułatwia to współpracę, pozwalając członkom zespołu na wspólne działanie w ramach tego samego konta.',
      invite: 'Zaproś',
      firstNameRequired: 'Imię jest wymagane',
      lastNameRequired: 'Nazwisko jest wymagane',
      emailRequired: 'Email jest wymagany',
      validEmailAddress: 'Proszę wprowadzić poprawny adres email',
      noRole: 'Brak roli',
      OK: 'OK',
      hourlyFilter: 'Godzinowe',
      dailyFilter: 'Dzienne',
      weeklyFilter: 'Tygodniowe',
      overview: 'Przegląd',
      monthlyFilter: 'Miesięczne',
      browserData: 'Dane z przeglądarki',
      apiData: 'Dane z API',
      brandPositioningOverview: 'Przegląd Pozycjonowania Marki',
      stats: 'Statystyki',
      vsTopCompetitors: 'vs Najwięksi konkurenci',
      averagePosition: 'Średnia pozycja',
      averageShareOfVoice: 'Średnia Share of Voice',
      trends: 'Trend',
      yourAccounts: 'Twoje konta',
      darkMode: 'Tryb ciemny',
      lightMode: 'Tryb jasny',
      selectBrandForMonitoring: 'Wybierz markę do śledzenia',
      orWriteCustomName: 'lub wpisz własną frazę',
      exploreAIAnswers: 'Przeglądaj odpowiedzi AI',
      rowsNumber: 'Ilość wierszy',
      date: 'Data',
      noExamplesAvailable:
        'Marka jest wspomniana w kontekście faktograficznym lub opisowym, bez wyraźnych czynników wskazujących na silny wydźwięk emocjonalny.',
      changePaymentMethod: 'Zmień metodę płatności',
      removePaymentMethod: 'Usuń metodę płatności',
      addFirm: 'Dodaj firmę',
      everyDay: 'Każdego dnia',
      everyWeek: 'W weekend',
      action: 'Akcje',
      created: 'Stworzono',
      keyword: 'Słowo kluczowe',
      keywords: 'Słowa kluczowe',
      addNewTag: 'Dodaj nowy tag',
      editTag: 'Edytuj tag',
      removeTag: 'Usuń tag',
      deleteSelected: 'Usuń zaznaczone',
      importFromCsv: 'Importuj z CSV',
      csvImportDialogDesc: 'Prześlij plik CSV, aby szybko dodać wiele promptów naraz.',
      csvImportFormatOnePerRow: 'Jeden prompt na wiersz',
      csvImportFormatFirstColumn: 'Tylko pierwsza kolumna',
      csvImportFormatPlainText: 'Bez formatowania - tylko zwykły tekst',
      csvImportClickToSelect: 'Kliknij, aby wybrać plik CSV',
      csvImportUploading: 'Przesyłanie… To może chwilę potrwać',
      csvImportSuccess: 'Gotowe! Dodano {{count}} promptów',
      csvImportErrorInvalidFormat: 'Błąd: Nieprawidłowy format pliku - prześlij plik CSV',
      csvImportErrorLimitExceeded: 'Błąd: Za dużo promptów - maksymalnie 300',
      csvDownloadTemplate: 'Pobierz szablon CSV',
      csvImportSlotWarning:
        'Twój plan pozwala na {{slots}} kolejnych promptów. Wybierz, które zaimportować.',
      csvImportSelected: '{{selected}}/{{slots}} wybranych',
      csvImportButton: 'Importuj {{count}} promptów',
      notificationCenterTitle: 'Powiadomienia',
      notificationCenterEmpty: 'Brak powiadomień',
      notificationCenterEmptyDesc: 'Wszystko na bieżąco. Nowe powiadomienia pojawią się tutaj.',
      notificationPausedMonitors: '{{count}} zapauzowanych pytań, które możesz reaktywować',
      notificationProjectReady: '{{project}} gotowy - dane AI Visibility są już dostępne',
      notificationAiVisibilityReportReady:
        '{{project}}: raport AI Visibility gotowy ({{period}})',
      notificationCardExpiring: 'Twoja karta płatnicza wygasa ({{date}})',
      notificationPaymentReminder: 'Twoja subskrypcja odnawia się {{date}}',
      pausedMonitorsPopupTitle: 'Masz zapauzowane pytania',
      pausedMonitorsPopupDesc:
        'Niektóre z Twoich pytań są zapauzowane. Wybierz, które chcesz ponownie uruchomić.',
      pausedMonitorsPopupSlots: 'Dostępne sloty: {{available}} / {{total}}',
      pausedMonitorsPopupActivate: 'Aktywuj',
      pausedMonitorsPopupRemindLater: 'Przypomnij później',
      errorFetchingSearchVolume:
        'Wystąpił błąd podczas pobierania wolumenu wyszukiwania. Spróbuj ponownie.',
      loginToYourAccount: 'Zaloguj się do swojego konta',
      forgotPassword: 'Zapomniałeś hasła',
      sendMagicLink: 'Wyślij magic link',
      sendMagicLinkInstead: 'Zaloguj się przez link',
      signInWithPassword: 'Zaloguj się hasłem',
      magicLinkSent: 'Magic link wysłany! Sprawdź swoją skrzynkę.',
      resetLinkSent: 'Link do resetu hasła wysłany! Sprawdź swoją skrzynkę.',
      tooManyAttempts: 'Zbyt wiele prób. Poczekaj chwilę przed ponowną próbą.',
      backToSignIn: 'Wróć do logowania',
      googleAuthFailed: 'Logowanie przez Google nie powiodło się. Spróbuj ponownie.',
      signInWithGoogle: 'Zaloguj się przez Google',
      or: 'lub',
      activeModels: 'Aktywne modele',
      cantWaitToShow:
        'Nie mogę się doczekać, aby pokazać Ci nowości. <strong>Zaloguj się i sprawdź</strong> sam!',
      password: 'Hasło',
      dontHaveAnAccount: 'Nie masz konta',
      signUp: 'Zarejestruj',
      signIn: 'Zaloguj',
      alreadyHaveAccount: 'Masz już konto',
      crateAnAccount: 'Załóż konto',
      'b24Signup.by': 'Produkt marki',
      'b24Signup.title': 'Zobacz, jak AI widzi Twoją markę',
      'b24Signup.subtitle':
        'Śledź, jak ChatGPT, Gemini, Perplexity i inne platformy AI wymieniają, oceniają i polecają Twoją markę.',
      'b24Signup.emailPlaceholder': 'Podaj firmowy adres e-mail',
      'b24Signup.passwordPlaceholder': 'Utwórz hasło',
      'b24Signup.passwordHint': 'Użyj min. 8 znaków, w tym cyfry i wielkiej litery',
      'b24Signup.submit': 'Rozpocznij darmowy trial',
      'b24Signup.disclaimer':
        'Bez karty kredytowej. Zakładasz osobną przestrzeń w Chatbeat - Twoje konto, projekty i subskrypcja w Brand24 zostają bez zmian.',
      'b24Signup.legalPrefix': 'Rejestrując się, akceptuję',
      'b24Signup.legalAnd': 'oraz',
      'b24Signup.haveAccount': 'Masz już konto w Chatbeat?',
      'b24Signup.logIn': 'Zaloguj się',
      'b24Signup.benefit1': 'Zmierz widoczność swojej marki w AI',
      'b24Signup.benefit2': 'Porównaj wyniki z konkurencją',
      'b24Signup.benefit3': 'Sprawdź, które źródła kształtują odpowiedzi AI',
      'b24Signup.bannerPrefix': 'Chatbeat to narzędzie do analizy widoczności w AI od',
      'b24Signup.bannerSuffix': '- ten sam zespół, ta sama firma.',
      'b24Signup.bannerBack': 'Wróć na brand24.com',
      'b24Signup.footerProductOf': 'to produkt firmy',
      'b24Signup.footerSameCompany': '- tej samej, która stoi za Brand24.',
      checkYourEmail: 'Sprawdź swoją skrzynkę',
      verificationEmailSent:
        'Wysłaliśmy Ci email weryfikacyjny. Sprawdź swoją skrzynkę odbiorczą i kliknij link weryfikacyjny, aby aktywować konto.',
      resendVerification: 'Wyślij ponownie email weryfikacyjny',
      resendVerificationSuccess: 'Email weryfikacyjny wysłany! Sprawdź skrzynkę.',
      resendVerificationWait: 'Możesz wysłać ponownie za {{minutes}}:{{seconds}}',
      emailNotVerified: 'Zweryfikuj swój adres email przed zalogowaniem.',
      emailVerifiedSuccess: 'Twój email został zweryfikowany!',
      emailVerifiedDescription: 'Możesz teraz zalogować się na swoje konto.',
      emailVerificationFailed: 'Link weryfikacyjny jest nieprawidłowy lub wygasł.',
      emailVerificationExpiredResent:
        'Ten link weryfikacyjny wygasł. Wysłaliśmy nowy na Twój adres email.',
      emailVerificationFailedDescription:
        'Spróbuj zarejestrować się ponownie lub skontaktuj się z pomocą techniczną.',
      backToLogin: 'Powrót do logowania',
      backToSignup: 'Powrót do rejestracji',
      passwordReset: 'Reset hasła',
      passwordResetDesc: 'Wprowadź adres e-mail swojego konta, a wyślemy Ci link do zresetowania hasła.',
      continue: 'Kontynuj',
      back: 'Wróć',
      language: 'Język',
      polish: 'Polski',
      english: 'Angielski',
      monitoringQuestions: 'Monitorowane pytania',
      setNewPassword: 'Ustaw nowe hasło',
      isRequired: 'jest wymagane',
      fieldIsRequired: 'Pole jest wymagane',
      saveChanges: 'Zapisz zmiany',
      conflictTagsName: 'Tag o tej nazwie już istnieje',
      loginPageTitle: 'Wyprzedź konkurencję z Chatbeat',
      loginPageDesc:
        'Monitoruj wzmianki o swojej marce i śledź konkurencję dzięki analizom AI. Zarejestruj się teraz i odkryj, jak Chatbeat może pomóc Ci wyprzedzić konkurencję!',
      wrongEmailAddress: 'Niepoprawny adres e-mail',
      signupPageTitle: 'Odblokuj potężne dane z Chatbeat',
      signupPageDesc:
        'Dołącz do Chatbeat i korzystaj z analiz wspieranych przez AI, aby monitorować obecność swojej marki. Zarejestruj się już teraz, aby śledzić wzmianki w czasie rzeczywistym i wyprzedzić konkurencję dzięki kluczowym danym!',
      next: 'Dalej',
      addCustomQuestions: 'Wybierz/dodaj pytania',
      saveAndLaunch: 'Zapisz i uruchom',
      chooseQuestions: 'Wybierz pytania',
      projects: 'Projekty',
      activeProjects: 'Aktywne projekty',
      addNewProject: 'Dodaj nowy projekt',
      projectName: 'Nazwa projektu',
      checkSearchVolume: 'Sprawdź search volume',
      addNewProjectHelp: 'Dodawanie Nowego Pytania do Projektu',
      addNewProjectHelpDesc:
        'W sekcji Dodaj Nowe Pytanie możesz skonfigurować automatyczne pytania dla swojego projektu. Pole Zapytanie pozwala określić pytanie, które będzie używane do interakcji z chatbotem. Dodatkowo, każde pytanie dodane w tej sekcji zostanie przypisane do projektu.',
      backToProjects: 'Wróć do projektów',
      backToAgencyHub: 'Wróć do Agency Hub',
      openProject: 'Otwórz projekt',
      setupPreparingTitle: 'Analizujemy, jak AI widzi Twoją markę',
      setupPreparingSubtitle: 'Tworzymy dane AI Visibility dla Twojej marki. To potrwa jeszcze chwilę.',
      setupStepBrandAdded: 'Marka dodana',
      setupStepPromptsSelected: 'Prompty wybrane',
      setupStepCollectingResponses: 'Zbieramy odpowiedzi z modeli AI',
      setupStepVisibilityAnalysis: 'Analizujemy widoczność Twojej marki',
      setupStepFinalization: 'Finalizujemy analizę',
      setupStateDone: 'Zakończono',
      setupStateInProgress: 'W toku',
      setupStateWaiting: 'Oczekuje',
      setupNoteTitle: 'Możesz bezpiecznie zamknąć tę kartę',
      setupNoteText: 'Powiadomimy Cię, gdy projekt będzie gotowy.',
      setupMeanwhile: 'W międzyczasie…',
      setupMeanwhileLead: 'Oto, co zyskasz dzięki Chatbeat.',
      setupValueRecommendationsTitle: 'GEO Recommendations',
      setupValueAuditDesc: 'Co ogranicza widoczność Twojej strony w AI?',
      setupValueRecommendationsDesc: 'Co zrobić, aby zwiększyć widoczność w AI?',
      setupValueBotsDesc: 'Śledź, jak roboty AI odwiedzają i czytają Twoją stronę.',
      setupOpen: 'Otwórz',
      loadingDataPleaseWait: 'Ładowanie danych, proszę czekać...',
      gatheringInformation:
        'Przygotowujemy Twoje dane i analizy. To może chwilę potrwać - bądź na bieżąco!',
      rangeTooltip: 'Określa zakres danych wyświetlanych na wykresie.',
      position: 'Pozycja',
      wrongDomain: 'Nieprawidłowa domena',
      gatheringStatsForThisRecord: 'Trwa generowanie statystyk dla tej firmy',
      noDataAvailable: 'Brak danych',
      errorLoadingDataRetry: 'Nie udało się załadować danych. Spróbuj ponownie.',
      projectNoDataAvailableDesc:
        'Obecnie brak danych do wyświetlenia. Spróbuj zmienić filtry lub sprawdź ponownie później, aby zobaczyć zaktualizowane wyniki.',
      thisCompanyAlreadyExist: 'Ta firma już istnieje',
      all: 'Wszystkie',
      modelsSelected: 'modeli wybranych',
      modelSelectOnly: 'Tylko',
      gpt: 'GPT',
      geminiApi: 'Gemini',
      deepSeekName: 'DeepSeek',
      reachedLimit:
        'Przekroczyłeś limit lub nie masz odpowiednich uprawnień do wykonania tej akcji. Usuń pytanie lub  <a href="mailto:help@chatbeat.com">skontaktuj się z nami</a>, aby odblokować tę funkcję.',
      reachedLimitProject:
        'Przekroczyłeś limit lub nie masz odpowiednich uprawnień do wykonania tej akcji. Usuń projekt lub  <a href="mailto:help@chatbeat.com">skontaktuj się z nami</a>, aby odblokować tę funkcję.',
      reachedUserLimit:
        'Przekroczono limit lub nie masz wymaganych uprawnień do wykonania tej akcji. Usuń użytkownika lub <a href="mailto:help@chatbeat.com">skontaktuj się z nami</a>, aby odblokować tę funkcję.',
      noShareOfVoiceData: 'Dane są w drodze',
      noShareOfVoiceDataDesc: 'Pracujemy nad zbieraniem informacji. Ten wykres pokaże Share of voice',
      noPositioningData: 'Brak danych o pozycjonowaniu',
      noPositioningDataDesc: 'Gdy zbierzemy dane, ten wykres pokaże pozycję Twojej marki na rynku.',
      noAIData: 'Oczekiwanie na dane',
      noAIDataDesc:
        'Aktualnie brak danych do wyświetlenia dla Twojego wskaźnika widoczności AI. Upewnij się, że Twoje źródła danych są połączone i dostarczają najnowsze informacje, a wykres wkrótce zostanie zaktualizowany.',
      areYouSureProceed: 'Czy na pewno chcesz kontynuować?',
      areYouSure: 'Czy jesteś pewien?',
      limitExceeded: 'Przekroczono limit',
      deepSeekDesc:
        'DeepSeek to narzędzie wspierane przez sztuczną inteligencję, służące do precyzyjnego wyszukiwania i analizy danych, odkrywające informacje wspierające podejmowanie decyzji i optymalizację.',
      perplexityDesc:
        'Perplexity to asystent badawczy oparty na sztucznej inteligencji, który dostarcza dokładnych odpowiedzi opartych na wiarygodnych źródłach, pomagając użytkownikom efektywnie zgłębiać tematy.',
      tooltipAveragePosition:
        'Średnia pozycja słowa kluczowego w tekście, wskazująca jego typowe umiejscowienie względem innych słów kluczowych.',
      tooltipShareOfVoice:
        'Procent całkowitej ekspozycji rynkowej Twojej marki w porównaniu do konkurencji w określonej branży lub kanale, mierzony w wybranym zakresie czasowym.',
      tooltipTrends:
        'Wyświetla trend średniej pozycji słowa kluczowego od początku do końca określonego zakresu. Śledzi, jak średnia pozycja zmieniała się w czasie.',
      tooltipKeyword:
        'Wybierz markę lub słowo kluczowe do monitorowania. Jeśli Twojej marki nie ma na liście, możesz wprowadzić nową, aby rozpocząć śledzenie.',
      faq: 'FAQ',
      whatIsTheContextTab: 'Czym jest zakładka Context?',
      whatIsTheContextTabDesc:
        'Context pokazuje, jak modele AI opisują Twoją markę i w jakim kontekście się ona pojawia. Pomaga zidentyfikować tematy, w których widoczni są konkurenci, a Twojej marki brakuje - ujawniając luki w widoczności i możliwości contentowe.\n' +
        'W tej sekcji znajdziesz:<ul><li>trend sentymentu marki w czasie</li><li>porównanie sentymentu między modelami AI</li><li>AI Insights (automatyczne podsumowanie narracji o marce)</li><li>kluczowe czynniki narracyjne (co AI podkreśla w produkcie)</li><li>analizę tematów, w których pojawia się marka</li><li>porównanie marki z konkurencją</li><li>luki kontekstowe (gdzie konkurenci się pojawiają, a Twoja marka nie)</li></ul>',
      whatIsChatBeat: 'Czym jest ChatBeat?',
      whatIsChatBeatDesc:
        'Chatbeat to brakujące ogniwo między AI a marketingiem.<br>' +
        'To narzędzie zaprojektowane do mierzenia widoczności i ekspozycji Twojej marki w głównych modelach AI, takich jak Gemini, Claude, GPT, Perplexity, AI Overview, AI Mode, Grok, Copilot i DeepSeek - oraz bezpośredniego porównywania jej z konkurencją. Wykorzystując autorski algorytm estymacji widoczności, pokazuje, o co najczęściej pytają Twoi klienci, jak Twoja marka jest prezentowana w odpowiedzi na konkretne zapytania, identyfikuje źródła, z których korzystają modele AI, oraz umożliwia porównanie wyników z konkurencją.<br>' +
        'Chatbeat pomaga również śledzić, jak obecność Twojej marki zmienia się w czasie oraz monitorować związany z nią sentyment. W skrócie: Chatbeat robi dla wyszukiwania opartego na AI to, co narzędzia takie jak Semrush robią dla Google.',
      whatIsBrandScore: 'Czym jest Brand Score?',
      whatIsBrandScoreDesc:
        'Brand Score to kluczowy wskaźnik mierzący, jak często i na jakich pozycjach pojawia się Twoja marka w wynikach wyszukiwania generowanych przez AI. Wyrażony w procentach, odzwierciedla ranking Twojej marki w wielu zapytaniach. Wynik jest ustalany na podstawie pozycji – im wyższa lokata, tym więcej punktów. Marka, która stale zajmuje czołowe miejsca, może osiągnąć maksymalne 100%, co oznacza najwyższą możliwą widoczność.',
      whatIsShareOfVoice: 'Czym jest Share of Voice?',
      whatIsShareOfVoiceDesc:
        'W Chatbeat, Share of Voice oznacza, jak często i jak wyraźnie Twoja marka pojawia się w odpowiedziach na wybrane zapytania w porównaniu z konkurencją. Ten oparty na procentach wskaźnik odzwierciedla widoczność Twojej marki, przy czym wyższe pozycje mają większy wpływ na wynik. Na przykład:<ul><li>1. pozycja: ~40%</li><li>2. pozycja: ~20%</li><li>3. pozycja: ~10%</li><li>I tak dalej...</li></ul>Łączny Share of Voice dla wszystkich marek w danym zapytaniu zawsze sumuje się do 100%. Możesz wybrać konkretne marki do porównania, a nawet sprawdzić ich wyniki dla pytań, które dodałeś. Możesz śledzić Share of Voice we wszystkich chatbotach, aby zobaczyć, gdzie osiągasz świetne wyniki, a gdzie jest jeszcze pole do poprawy.',
      relevantQuestions: 'Jak mogę znaleźć odpowiednie pytania?',
      relevantQuestionsDesc:
        'Nasze narzędzie automatycznie sugeruje pytania najbardziej istotne dla Twojej marki dzięki dedykowanej funkcji Sugerowane pytania, która generuje najlepsze zapytania do śledzenia. Możesz także dodać własne pytania, a Chatbeat wyświetli wolumen wyszukiwania – pokazując, jak popularne jest każde z nich.',
      metricsTrack: 'Jakie metryki mogę śledzić?',
      metricsTrackDesc:
        '<b>Brand Score</b> – procent pokazujący, jak często i jak wyraźnie Twoja marka pojawia się w odpowiedziach na śledzone pytania.<br>' +
        '<b>Median Position & Average Position</b> – pokazują średnią pozycję Twojej marki we wszystkich śledzonych pytaniach.<br>' +
        '<b>Share of Voice</b> – pokazuje, jak często Twoja marka pojawia się w odpowiedziach i jak wysoko plasuje się w porównaniu z konkurencją.<br>' +
        '<b>Search Volume</b> – pokazuje, jak popularne jest każde pytanie, pomagając Ci zdecydować, które z nich priorytetyzować.<br>' +
        '<b>Key Sources</b> – ujawnia, na których stronach internetowych modele AI opierają się w Twojej branży.<br>' +
        '<b>Context</b> – pokazuje kluczowe tematy i sentyment w odpowiedziach LLM.',
      mostOutOfChatbeat: 'Jak mogę w pełni wykorzystać Chatbeat?',
      mostOutOfChatbeatDesc:
        'Najlepiej zacząć od zapoznania się z naszym <a href="https://app.chatbeat.com/howto" target="_blank">Case study</a> dotyczącym optymalizacji widoczności w AI i dowiedzieć się, jak Chatbeat może Ci w tym pomóc. Chętnie przeprowadzimy Cię przez to podczas spotkania wprowadzającego - napisz do nas na <a href=\'mailto:help@chatbeat.com\'>help@chatbeat.com</a>, a z przyjemnością porozmawiamy!',
      visibilityRating: 'Czym jest Wskaźnik widoczności?',
      visibilityRatingDesc:
        'Wskaźnik widoczności pomaga interpretować Twój Brand Score, dostarczając punkt odniesienia do oceny jego znaczenia. Na przykład, czy wynik Brand Score na poziomie 45% jest dobry czy zły? Chatbeat dzieli wyniki na następujące zakresy:<ul><li><b>0% (Not Visible):</b> Brak mierzalnej widoczności.</li><li><b>1-2% (Minimal):</b> Bardzo niska widoczność, wymagająca znacznej poprawy.</li><li><b>3-9% (Emerging):</b> Widoczność poniżej standardu, z dużym potencjałem wzrostu.</li><li><b>10-29% (Decent):</b> Akceptowalna widoczność, ale możliwa do poprawy.</li><li><b>30-49% (Respectable):</b> Ponadprzeciętna widoczność i wpływ.</li><li><b>50-69% (Good):</b> Wysoka widoczność i silna pozycja.</li><li><b>70-100% (Excellent):</b> Wyjątkowa widoczność; marka z czołówki.</li></ul>Ta klasyfikacja pomaga firmom zrozumieć swoją pozycję i opracować strategie poprawy obecności w wyszukiwaniu opartym na AI.',
      modelTrack: 'Które modele AI śledzi ChatBeat?',
      modelTrackDesc:
        'Chatbeat monitoruje przede wszystkim najpopularniejsze modele AI. Obecnie śledzimy GPT-5, AI Overviews, GPT Search, Gemini, Claude, Perplexity, AI Mode, Grok, Copilot oraz DeepSeek.',
      estimateAveragePosition: 'Jak ChatBeat szacuje średnią pozycję?',
      estimateAveragePositionDesc:
        'Chatbeat analizuje odpowiedzi modeli AI i oblicza średnią pozycję na podstawie dziennych zapytań dla każdego monitorowanego pytania. Ta metoda wygładza wahania, zapewniając bardziej wiarygodny obraz trendów widoczności Twojej marki.',
      canITrackMyBrand:
        'Czy mogę śledzić moją markę w lokalnych wynikach chatbotów (np. w określonych krajach lub miastach)?',
      canITrackMyBrandDesc:
        'Tak! Dodanie pytania w określonym języku automatycznie lokalizuje odpowiedź. Możesz również śledzić swoją markę w wynikach lokalnych, dodając parametry lokalizacyjne do monitorowanych zapytań, np.:<ul><li><i>„Jaki jest najlepszy program do fakturowania w Szwecji?”</i></li><li><i>„Jaki jest najlepszy program do fakturowania w Kopenhadze?”</i></li></ul>To pozwala ocenić widoczność w konkretnych regionach. Szczegółowy podział odpowiedzi według GEO już wkrótce.<br><br>Co więcej, podczas tworzenia projektu możesz wybrać konkretną lokalizację',
      rawAIResponses: 'Czy mogę zobaczyć surowe odpowiedzi AI?',
      rawAIResponsesDesc:
        'Oczywiście! Kliknij dowolne pytanie w Chatbeat, a na dole strony możesz przejrzeć dokładne odpowiedzi, które otrzymaliśmy od modelu GPT (lub innego monitorowanego modelu AI).',
      positionDiffer: 'Dlaczego pozycja mojej marki różni się od tego, co widzę w ChatGPT?',
      positionDifferDesc:
        'Odpowiedzi generowane przez AI mogą się różnić w zależności od zapytania ze względu na personalizację i losowość. Jeśli marka często pojawia się w Twoich własnych interakcjach z ChatGPT, model może być bardziej skłonny do jej rekomendowania.',
      keySource: 'Czym są Kluczowe Źródła?',
      keySourceDesc:
        'Pokazuje, na których stronach internetowych opierają się modele AI w Twojej branży. Jeśli Twoje treści znajdują się na tych stronach, istnieje większe prawdopodobieństwo, że pojawią się w odpowiedziach generowanych przez AI. Możesz przeglądać te dane dla konkretnych modeli, aby zidentyfikować miejsca, gdzie warto zoptymalizować treści i zwiększyć widoczność swojej marki.',
      notVisibleTooltip: 'Brak mierzalnej widoczności.',
      minimalTooltip: 'Bardzo niska widoczność, wymagająca znacznej poprawy.',
      emergingTooltip: 'Widoczność poniżej standardu, z możliwością rozwoju.',
      decentTooltip: 'Akceptowalna widoczność, ale możliwa do poprawy.',
      respectableTooltip: 'Widoczność powyżej średniej, z wpływem na rynek.',
      goodTooltip: 'Wysoka widoczność z silną pozycją.',
      excellentTooltip: 'Wyjątkowa widoczność; marka o najlepszych wynikach.',
      regenerateKeywords: 'Zregeneruj firmy',
      yourDataChanged: 'Twoje dane zostały zapisane.',
      dataChanged: 'Zmiana danych',
      keyPromptsTitle: 'Kluczowe polecenia / pytania',
      keyPromptsFor: 'dla {{name}}',
      others: 'Inne',
      improveAIRanking: 'Poprawa rankingu AI',
      noData: 'Brak danych',
      noDataDescription: 'Brak danych dla wybranego okresu',
      mixedQuestionWarning:
        '[DEV] Przynajmniej jedno pytanie w projekcie monitoruje model marki. Odepnij zaznaczone projekty, jeśli chcesz monitorować markę.',
      changeProject: 'Przenieś do innego projektu',
      cancel: 'Anuluj',
      withoutAProject: 'Bez projektu',
      editProject: 'Edytuj projekt',
      monitoringSchedule: 'Częstotliwość monitoringu',
      monitoringScheduleDaily: 'Codziennie',
      monitoringScheduleWeekly: 'Co tydzień',
      monitoringScheduleHint: 'Jak często Twoje prompty są wysyłane do modeli AI.',
      monitorEventScheduleChanged: 'zmiana częstotliwości monitoringu: {{from}} → {{to}}',
      whereShouldISetTheKeyword: 'Gdzie mam ustawić słowo kluczowe?',
      dontChange: 'Nie zmieniaj',
      applyToAllQuestions: 'Zastosuj do wszystkich pytań',
      applyToPartQuestions:
        'Zastosuj do pytań, które mają obecnie ustawione słowo kluczowe, takie jak nazwa projektu',
      mixedWarning:
        'To pytanie monitoruje model, przez co informacje w projekcie mogą być nieprecyzyjne. Jeśli chcesz monitorować markę, odepnij to pytanie od projektu',
      changeNameTootlip:
        'Domyślnie wszystkie pytania w projekcie mają nazwę marki ustawioną jako słowo kluczowe.',
      unlockFeature:
        'Jeśli chcesz odblokować tę funkcję, <a href="mailto:help@chatbeat.com">skontaktuj się z nami</a>',
      configuration: 'Konfiguracja',
      selectDemoType: 'Wybierz typ',
      projectAccountDesc:
        'Wybierz konto użytkownika, do którego chcesz przypisać projekt. Użytkownik uzyska dostęp do projektu zgodnie z przypisanymi uprawnieniami.',
      demoDesc:
        'Możesz oznaczyć projekt jako wersję demo lub usunąć ten status. Wersja demonstracyjna umożliwia testowanie projektu w ograniczonym zakresie.',
      setAsDemo: 'Ustaw jako projekt demo',
      unsetDemo: 'Usuń projekt demo',
      enterDomainDesc: 'Proszę wprowadzić <b>domenę</b> marki, którą chciałbyś śledzić.',
      brandScore: 'Wynik marki',
      videoTutorial: 'Wideo Tutorial',
      educationBannerTitle: 'Zrozum, jak AI poleca Twoją markę',
      educationBannerDescription:
        'Dowiedz się, jak działa widoczność w AI, odkryj, co wpływa na rekomendacje AI, i opanuj praktyczne strategie GEO dzięki naszemu krótkiemu tutorialowi i darmowemu Masterclass.',
      educationBannerWatchQuickStart: 'Obejrzyj Quick Start (5 min)',
      educationBannerStartMasterclass: 'Rozpocznij Chatbeat Masterclass (30 min)',
      educationBannerHide: 'Ukryj',
      bookADemo: 'Umów demo',
      goToProject: 'Przejdź do projektu',
      advisor: {
        title: 'Twój doradca Chatbeat',
      },
      masterclass: {
        eyebrow: 'Masterclass',
        titleLine1: 'AI Visibility',
        titleLine2: 'Certification',
        description: 'Ukończ nasz darmowy kurs, poznaj praktyczne taktyki GEO i zdobądź certyfikat.',
        cta: 'Zacznij naukę',
      },
      firstProjectOnboarding: {
        title: 'Witaj w Chatbeat!',
        copy: 'Cześć, jestem Sylwia, Twoja osoba kontaktowa w Chatbeat. Gotowy sprawdzić widoczność w AI?',
      },
      enterDomain: 'Wprowadź domenę',
      domain: 'Domena',
      enterBrandName: 'Wprowadź nazwę marki',
      enterBrandNameDesc: 'Proszę wprowadzić <b>nazwę</b> marki, którą chciałbyś śledzić.',
      suggested: 'Sugerowane',
      upgradeToAccess: 'aby odblokować ten model',
      upgradeToAccessContact: 'Skontaktuj się z administratorem konta, aby ulepszyć plan',
      brandName: 'Nazwa marki',
      linkToBrandNameStep: 'Chcesz podać nazwę marki zamiast domeny?',
      clickHere: 'Kliknij tutaj!',
      linkToDomainStep: 'Wolisz wprowadzić domenę zamiast nazwy marki?',
      insights: 'Wnioski',
      insightNotVisible:
        'Obecnie nie ma wystarczających danych, aby określić widoczność Twojej marki wśród modeli LLM. Wraz ze wzrostem liczby zapytań i interakcji będziemy mogli dostarczyć bardziej szczegółowe informacje na temat share of voice i trendów w rankingach.',
      brandScoreTooltip:
        'Metryka wskazująca, jak często i na jakiej pozycji Twoja marka pojawia się w odpowiedziach chatbotów AI. Im wyższy wynik, tym lepsza widoczność. Wynik marki (Brand Score) mieści się w zakresie od 0 do 100%, gdzie 100% oznacza maksymalną ekspozycję – marka zajmuje pierwsze miejsce we wszystkich kluczowych zapytaniach.',
      medianPosition: 'Mediana pozycji',
      medianPositionTooltip:
        'Metryka pokazująca medianę pozycji, na której pojawia się Twoja marka w odpowiedziach chatbotów AI – daje bardziej reprezentatywny obraz, ograniczając wpływ skrajnych wyników.',
      averagePositionTooltip:
        'Metryka pokazująca średnią pozycję, na której pojawia się Twoja marka w odpowiedziach chatbotów AI.',
      shareOfVoiceTooltip:
        'Pokazuje, jak często i na jakiej pozycji chatboty AI rekomendują Twoją markę w porównaniu do konkurencji. Ten wynik procentowy odzwierciedla widoczność Twojej marki – wyższe pozycje mają większą wagę. Całkowity udział w rynku (Share of Voice) dla danego zapytania zawsze sumuje się do 100%.',
      brandScoreAndMedianPositionTooltip:
        'Śledzi, jak zmienia się widoczność Twojej marki w odpowiedziach chatbotów AI na przestrzeni czasu.',
      brandScoreAndAveragePositionTooltip:
        'Śledzi, jak zmienia się widoczność Twojej marki w odpowiedziach chatbotów AI na przestrzeni czasu.',
      shareOfVoiceOverTime: 'Share of Voice w czasie',
      shareOfVoiceOverTimeTooltip:
        'Śledzi, jak zmienia się Share of Voice czołowych marek w wybranym okresie.',
      shareOfVoiceByLlm: 'Share of Voice według chatbotów AI',
      shareOfVoiceByLlmTooltip:
        'Sprawdź, jak Twoja marka wypada na tle konkurencji w różnych chatbotach AI.',
      insightsTooltip:
        'Sprawdź szybkie podsumowanie wyników Twojej marki i wykorzystaj dane do poprawy widoczności w chatbotach AI.',
      //PROMPTS 2.0 (widok prompta V2)
      responsesThisPeriod_one: '{{count}} odpowiedź w tym okresie',
      responsesThisPeriod_few: '{{count}} odpowiedzi w tym okresie',
      responsesThisPeriod_many: '{{count}} odpowiedzi w tym okresie',
      responsesThisPeriod_other: '{{count}} odpowiedzi w tym okresie',
      visibilityOverview: 'Przegląd widoczności',
      visibilityOverviewTooltip:
        'Śledzi odsetek odpowiedzi AI wspominających każdą markę w wybranym okresie.',
      top7Brands: 'Top 7 marek',
      topBrandsTooltip: 'Marki uszeregowane według widoczności w odpowiedziach AI dla tego promptu.',
      allBrandsRankingTooltip:
        'Wszystkie marki wykryte w odpowiedziach AI dla tego promptu, uszeregowane według Share of Voice.',
      positionColumnTooltip:
        'Średnia pozycja, na której marka pojawia się w odpowiedziach AI - 1 oznacza wzmiankę na pierwszym miejscu.',
      visibilityColumnTooltip: 'Odsetek odpowiedzi AI w wybranym okresie, które wspominają markę.',
      sovColumnTooltip:
        'Share of Voice - udział marki we wszystkich wzmiankach o markach w odpowiedziach AI; wyższe pozycje ważą więcej. Sumuje się do 100% dla wszystkich marek.',
      chatgptAdsRowTooltip: 'Co najmniej jedna odpowiedź w tym wierszu zawiera reklamy ChatGPT.',
      shoppingCardsRowTooltip: 'Co najmniej jedna odpowiedź w tym wierszu zawiera karty zakupowe.',
      fanoutQueries: 'Zapytania fanout',
      fanoutQueriesSubtitle: 'Zapytania, które silniki AI wykonały, aby odpowiedzieć na ten prompt',
      latestFanoutQueries: 'Najnowsze zapytania fanout',
      fanoutQueriesTooltip:
        'Zapytania, które silniki AI wykonały, aby odpowiedzieć na ten prompt. „Oryginalny prompt" oznacza wyszukiwanie dokładnie Twoim pytaniem.',
      originalPromptBadge: 'Oryginalny prompt',
      productCards: 'Karty produktów',
      productCardsTooltip: 'Produkty, które chatboty AI pokazały przy odpowiedziach w wybranym okresie.',
      commonTerms: 'Najczęstsze frazy',
      topPhrases: 'Top Frazy',
      commonTermsTooltip:
        'Najczęściej powtarzające się frazy w zapytaniach fanout. Wyszukiwania powtarzające Twój prompt nie są wliczane.',
      topPhraseBarTooltip:
        'Występuje w {{occurrences}} z {{total}} zapytań fanout w tym okresie.',
      query: 'Zapytanie',
      noFanoutData: 'W tym okresie nie zarejestrowano zapytań fanout.',
      chatgptAds: 'Reklamy ChatGPT',
      chatgptAdsTooltip: 'Reklamy wyświetlone przez ChatGPT obok tej odpowiedzi.',
      chatgptAdsPercentTooltip: 'Odsetek odpowiedzi w okresie zawierających reklamy ChatGPT.',
      shoppingCards: 'Karty zakupowe',
      shoppingCardsTooltip: 'Karty zakupowe wyświetlone obok tej odpowiedzi.',
      shoppingCardsPercentTooltip: 'Odsetek odpowiedzi w okresie zawierających karty produktów.',
      emailSuccessfullySaved: 'Twój email został pomyślnie zapisany.',
      dataSaved: 'Dane zapisane',
      completedCaptcha: 'Proszę wypełnij reCAPTCHA.',
      elevateYourBrandVisibility: 'Mierz<br>swoją markę w AI',
      elevateYourBrandVisibilityDesc:
        'Śledź rekomendacje swojej marki na głównych platformach AI, takich jak ChatGPT, Claude i Gemini.',
      earlyAccess: 'Wczesny dostęp',
      emailIsRequired: 'Adres e-mail jest wymagany',
      joinToBeta: 'Dołącz do bety',
      topicShare: 'Udział tematu',
      resetNow: 'Zresetuj teraz',
      resetAgain: 'Zresetuj ponownie',
      keywordTooltip:
        'Reprezentuje markę lub termin analizowany pod kątem widoczności w odpowiedziach AI chatbotów.',
      overallPositionTooltip:
        'Pokazuje ranking Twojej marki dla konkretnego zapytania w porównaniu do konkurencji w odpowiedziach AI chatbotów.',
      copyProject: 'Skopiuj projekt',
      removeThisProject: 'Usuń projekt',
      viewDetails: 'Szczegóły',
      moveToAnotherProject: 'Przenieś do innego projektu',
      removeThisQuestion: 'Usuń pytanie',
      noProjectsYet: 'Brak dostępnych projektów',
      noProjectsYetMsg:
        'Wygląda na to, że nie masz jeszcze żadnych projektów. Projekty pomagają organizować i śledzić wyniki Twojej marki w różnych zapytaniach, dostarczając cennych informacji na temat trendów i widoczności.<br><br>Rozpocznij od utworzenia projektu, aby monitorować najważniejsze dla Twojego biznesu wskaźniki.<br><br>Kliknij "Dodaj nowy projekt", aby rozpocząć i uzyskać bieżące informacje dopasowane do Twoich celów.',
      count: 'Ilość',
      linkTrackingTooltip:
        'Źródła ujawniają, na których stronach internetowych chatboty AI opierają się przy generowaniu odpowiedzi w Twojej branży. Im większa widoczność Twoich treści na tych stronach, tym większa szansa, że zostaną one uwzględnione w odpowiedziach narzędzi AI, takich jak ChatGPT czy Gemini.',
      linkTracking: 'Kluczowe źródła',
      privacyPolicy: 'Polityka prywatności',
      customizeCookie: 'Ustawienia cookie',
      termsAndConditions: 'Regulamin',
      almostThere: 'Prawie gotowe!<br><b>Utwórz nowe hasło</b><br>i wróć do działania',
      enterYourNewPasswordBelow: 'Wprowadź swoje nowe hasło poniżej',
      oopsForgotYourPassword:
        'Ups, zapomniałeś hasła?<br><b>Za chwilę odzyskasz dostęp</b><br>bez problemu',
      enterYourEmailBelow: 'Wpisz swój adres e-mail, aby otrzymać link do resetu hasła',
      accessTailoredData: 'Uzyskaj dostęp do <b>dopasowanych danych</b><br>i ulepsz swoją strategię',
      onceYouSignup: 'Po rejestracji zostaniesz automatycznie zalogowany.',
      noBrandsTooltip:
        'W odpowiedzi na to pytanie nie znaleziono żadnych marek. Spróbuj zmodyfikować treść, by uzyskać lepsze wyniki.',
      waitingSearchVolume:
        'Wciąż zbieramy dane, aby oszacować miesięczną liczbę wyszukiwań. Może to zająć trochę czasu, zwłaszcza w przypadku rzadziej wyszukiwanych zapytań. Prosimy o ponowne sprawdzenie później, aby zobaczyć zaktualizowane dane.',
      outOfRangePromptToday:
        'Wyniki dla tego promptu/pytania zostaną zebrane w kolejnym cyklu (w ciągu 24 godzin).',
      outOfRangePrompt: 'Ten prompt/pytanie nie było monitorowane w tym okresie.',
      noSearchVolume:
        'Liczba wyszukiwań prawdopodobnie wynosi poniżej 100 zapytań miesięcznie. Należy pamiętać, że jest to szacunkowa wartość i nawet pytania z mniejszą liczbą niż 100 zapytań miesięcznie mogą mieć istotną wartość analityczną.',
      searchVolumeTooltip:
        'Search Volume pokazuje miesięczną liczbę wyszukiwań dla danego kluczowego pytania lub frazy. Pomaga ustalić, na których pytaniach lub frazach warto się skupić.',
      invoiceNumber: 'Numer faktury',
      total: 'Suma',
      invoice: 'Faktura',
      download: 'Pobierz',
      loadingSaveProject: 'Analiza widoczności Twojej marki w systemach AI',
      loadingDataSearchVolume: 'Sprawdzanie wolumenów wyszukiwań dla wybranych promptów...',
      loadingDataThisMayTakeAMoment: 'Trwa ładowanie danych – to może chwilę potrwać',
      analyzeVisibilityTitle: 'Analizujemy Twoją widoczność w {{provider}}',
      analyzeSubtitleChatgpt: 'Sprawdzamy, jak często Twoja marka pojawia się w odpowiedziach',
      analyzeSubtitleGemini: 'Śledzimy wzmianki w odpowiedziach AI Google',
      analyzeSubtitlePerplexity: 'Badamy cytowania i pozycję w źródłach',
      analyzeVisibilityHint: 'To potrwa tylko chwilę…',
      nextAnnuallyPaymentCost: 'Roczny koszt',
      nextMonthlyPaymentCost: 'Miesięczny koszt',
      exclVAT: 'bez VAT',
      pricingDescStandard: 'Dla małych marek gotowych na rozwój.',
      pricingDescPro: 'Dla rozwijających się firm.',
      pricingDescAdvanced: 'Dla agencji i dużych zespołów.',
      pricingDescEnterprise: 'Dla wymagających przedsiębiorstw.',
      perMonth: 'miesięcznie',
      keyFeatures: 'Kluczowe funkcje',
      getStartedWith: 'Rozpocznij z',
      prioritySupport: 'Priorytetowe wsparcie',
      whitelabel: 'Whitelabel ',
      unlimitedPrompts: 'Nielimitowane pytania/prompty',
      unlimitedusers: 'Nielimitowani użytkownicy',
      billedAnnually: 'rozliczenie roczne',
      custom: 'Indywidualny',
      areYouSureChangePlan: 'Czy na pewno chcesz zmienić plan subskrypcji dla swojego konta?',
      confirm: 'Zatwierdź',
      question: 'Pytanie',
      upgradePlanError: 'Nie udało się zaktualizować planu',
      upgradePlanErrorDesc:
        'Aktualizacja planu nie została zakończona. Sprawdź szczegóły płatności w swoim banku lub skontaktuj się z naszym zespołem wsparcia.',
      usersLimitExceeded: 'Konto osiągnęło limit użytkowników ({{current}} z {{max}}).',
      inviteError: 'Nie udało się zaprosić użytkownika',
      inviteErrorContent:
        'Upewnij się, że wprowadzone dane są poprawne i że wskazany użytkownik nie jest właścicielem tego zasobu. Jeśli wszystko się zgadza, spróbuj ponownie później lub skontaktuj się z administratorem.',
      searchVolumeForSelectedQuestions: 'Search Volume dla wybranych pytań',
      selectMinimumOne: 'Wybierz co najmniej jedno pytanie',
      selectAll: 'Zaznacz wszystkie',
      deselectAll: 'Odznacz wszystkie',
      selectedCount: 'Zaznaczono: {{selected}}',
      customQuestion: 'Własne pytanie',
      reset: 'Wyczyść',
      popularQuestions: 'Popularne pytania',
      run: 'Uruchom',
      pause: 'Zatrzymaj',
      monitorLimitReached: 'Osiągnąłeś limit pytań. Ulepsz swój plan, aby aktywować więcej pytań.',
      pauseModeNotAvailable:
        'Funkcja wstrzymania śledzenia nie jest dostępna w Twoim planie. Skontaktuj się z nami, aby ją odblokować.',
      bulkActivate: 'Uruchom śledzenie dla wybranych zapytań',
      bulkPause: 'Wstrzymaj śledzenie dla wybranych zapytań',
      bulkRemove: 'Usuń wybrane zapytania na stałe',
      confirmPausePrompts: 'Czy na pewno chcesz wstrzymać te zapytania?',
      bulkLimitExceeded:
        'Zaznaczyłeś więcej monitorów niż pozwala Twój plan. Twój plan pozwala na {{maxMonitors}} aktywnych monitorów, a już masz {{currentActive}} aktywnych.',
      pauseLimitExceeded:
        'Możesz wstrzymać maksymalnie {{maxPausedMonitors}} monitorów. Obecnie wstrzymanych jest {{currentPaused}}.',
      selectModePrompts: 'Zarządzaj wybranymi zapytaniami',
      selectModeProjects: 'Zarządzaj wybranymi projektami',
      emptyStateProject:
        'Ups! Wygląda na to, że nie masz</br>jeszcze żadnych projektów.</br>Dodaj jeden poniżej.',
      emptyStateProjectPromptsNoPermission:
        'Ups! Wygląda na to, że nie masz</br>jeszcze żadnych pytań w projekcie.',
      emptyStateProjectPrompts:
        'Wprowadź swój pierwszy prompt</br>i zobacz, jak Twoja marka wypada</br>w odpowiedziach AI.',
      emptyStatePrompts: 'Ups! Wygląda na to, że nie masz</br>jeszcze żadnych promptów.',
      tagInfo:
        'Jeśli Twoja marka pojawia się w modelach</br>LLM pod różnymi nazwami, możesz je</br>zgrupować w jeden tag, aby analizować wyniki łącznie.',
      tagLabel: 'Etykieta taga',
      createNewTag: 'Stwórz nowy tag',
      expandedInfo:
        'Używamy dodatkowego prompta do śledzenia pozycji 10–30, aby monitorować ekspozycję AI marek spoza top 10. Wyniki pochodzą z osobnego prompta i nie wpływają na odpowiedź organiczną.',
      discount: 'Zniżka',
      manageSubscription: 'Zarządzaj subskrypcją',
      currentLimits: 'Aktualne limity',
      whatIsSearchVolume: 'Czym jest Search Volume i jak działa?',
      whatIsSearchVolumeDesc:
        'Search Volume wskazuje szacunkową liczbę miesięcznych wyszukiwań dla danego pytania. Choć opiera się głównie na zachowaniach użytkowników w tradycyjnych wyszukiwarkach, wierzymy, że część tych wzorców można przenieść na korzystanie z LLM. Ten wskaźnik pomaga wyłonić pytania, które prawdopodobnie będą wartościowe i szeroko istotne.',
      weeklyReports: 'Raporty tygodniowe',
      foundBrandName: 'Wykryta nazwa marki',
      information: 'Informacja',
      limitTitle: 'Limit został przekroczony',
      limitExceededMessage:
        'Twój obecny plan nie pozwala na utworzenie większej liczby promptów. Usuń niektóre z istniejących lub wybierz wyższy plan.',
      keyPrompts: 'Kluczowe pytania',
      historicalModelDisabled:
        'Ten model jest obecnie wyłączony na koncie - pokazane dane są historyczne.',
      historicalModelDisabledRange:
        'Ten model jest obecnie wyłączony na koncie. Dane pochodzą z okresu {{from}} – {{to}}.',
      keySources: 'Kluczowe źródła',
      downloadStats: 'Pobierz statystyki',
      downloadPromptStats: 'Pobierz statystyki pytań',
      downloadBrandScore: 'Pobierz wyniki marek',
      downloadAiAnswers: 'Pobierz odpowiedz AI',
      removeProject: 'Usuń projekt',
      createGroup: 'Stwórz grupę',
      groupName: 'Nazwa grupy',
      groupNamePlaceholder: 'np. Brand24',
      groupColor: 'Kolor',
      create: 'Utwórz',
      editGroup: 'Edytuj grupę',
      removeGroup: 'Usuń grupę',
      removeProjectConfirm: 'Czy na pewno chcesz usunąć projekt „{{name}}”?',
      editGroupName: 'Edytuj nazwę',
      deleteGroupConfirm:
        'Czy na pewno chcesz usunąć grupę „{{name}}”? Jej projekty zostaną odgrupowane.',
      moveToGroup: 'Przypisz do grupy',
      cannotMoveProject: 'Nie można przypisać projektu do grupy',
      exportCsv: 'Eksportuj CSV',
      untagged: 'Bez taga',
      ungrouped: 'Bez grupy',
      allGroups: 'Wszystkie grupy',
      createPromptGroup: 'Stwórz taga promptu',
      createPromptGroupTooltip:
        'Grupuj prompty w niestandardowe kategorie dla łatwiejszej analizy i filtrowania.',
      promptGroupName: 'Nazwa taga promptu',
      editPromptGroup: 'Edytuj taga promptu',
      removePromptGroup: 'Usuń taga promptu',
      moveToPromptGroup: 'Przenieś do taga promptu',
      discoverNewPrompts: 'Odkryj nowe pytania z Chatbeat. Wybierz te, które chcesz obserwować.',
      addToProject: 'Dodaj do projektu',
      suggestedPromptAdded: 'Pytanie dodane do projektu',
      limitRestriction:
        'Osiągnięto limit pytań. Aby dodać lub zaznaczyć inne pytanie, najpierw odznacz jedno z już wybranych.',
      accountOwner: 'Właściciel konta',
      userRole: 'Rola użytkownika',
      active: 'Aktywny',

      pendingUrl: 'Oczekuje na URL',
      pending: 'Oczekujący',
      wrongHash: 'Nieprawidłowy hash',
      somethingWentWrong: 'Coś poszło nie tak',
      passwordsIsNotTheSame: 'Hasła nie są takie same',
      brandShare: 'Udział marki w temacie',
      brandShareTooltip: 'Pokazuje procentowy udział wzmianek danej marki w tym temacie.',
      expireLink:
        "Ten link do resetowania hasła wygasł. Proszę wygenerować nowy używając '<a href='/forgot'>Nie pamiętam hasła</a>'.",
      failedChangePassword: 'Nieudana zmiana hasła',
      domainsSelectionModalTitle: 'Wybierz domeny do analizy',
      domainsSelectionModalSearchPlaceholder: 'Szukaj domen...',
      domainsSelectionModalMaxSelected: 'Można wybrać maksymalnie {{max}} domen',
      domainsSelectionModalLoadingMore: 'Ładowanie kolejnych domen... ({{count}} załadowanych)',
      domainsSelectionModalLoadedInfo: 'Załadowano {{count}} domen {{extra}}',
      domainsSelectionModalMorePages: '(jeszcze {{pages}} stron)',
      domainsSelectionModalAllLoaded: '(wszystkie)',
      selectBrandForAnalysis: 'Wybierz marki do analizy ',
      brandMentions: 'Wzmianka o {{brand}}',
      selectDomains: 'Wybierz domeny',
      selectBrands: 'Wybierz marki',
      chooseActiveBrandsHint:
        'Włączone marki są aktywne w projekcie — to samo ustawienie co na stronie Marki. Zmiany zapisują się od razu.',
      chooseActiveBrandsMore: 'Jeszcze {{count}} — wyszukaj, żeby je znaleźć',
      chooseActiveBrandsResetHint:
        'Zostawia włączonych 15 marek: wybraną, główną i te z najwyższą widocznością (albo Share of Voice) z ostatnich 30 dni. Resztę wyłącza.',
      chooseActiveBrandsError: 'Nie udało się zmienić statusu marki. Spróbuj ponownie.',
      statsRecomputingTitle: 'Przeliczamy statystyki',
      statsRecomputingSubtitle: '{{brands}} — liczby odświeżą się za chwilę',
      statsRecomputingMsgPositions: 'Przeliczamy pozycje…',
      statsRecomputingMsgVisibility: 'Przeliczamy widoczność…',
      statsRecomputingBrand: 'Statystyki są przeliczane',
      chooseBrandsToCompare: 'Wybierz marki do porównania',
      keywordsPageDesc: 'Wszystkie unikalne marki i frazy kluczowe śledzone w tym projekcie.',
      brands: 'Marki',
      brandsPageDesc: 'Marki, nazwy i domeny śledzone w tym projekcie.',
      trackedNames: 'Śledzone nazwy',
      brandTabBasic: 'Podstawowe',
      brandNamesIntro:
        'Nazwy, pod którymi ta marka pojawia się w odpowiedziach AI. Wyłącz nazwę, żeby przestała się liczyć, albo odłącz ją jako osobną markę.',
      brandStatusDesc: 'Nieaktywna marka nie jest uwzględniana na wykresach i w raportach tego projektu.',
      brandMainName: 'Główna',
      brandProjectBadge: 'Marka główna',
      brandSelectedBadge: 'Wybrana marka',
      brandAttachedTitle: 'Dołączone marki',
      brandAttachedDesc: 'Marki dodane pod tę markę. Odłącz markę, żeby znów liczyła się osobno.',
      brandDetach: 'Odłącz markę',
      brandDetachTooltip: 'Odłącz {{brand}} razem ze wszystkimi nazwami — znów będzie osobną marką.',
      brandAttachTitle: 'Dołącz inną markę',
      brandAttachDesc: 'Wybrana marka razem ze wszystkimi nazwami trafi pod tę markę. Możesz ją potem odłączyć.',
      trackedNamesShowAll: 'Pokaż wszystkie śledzone nazwy',
      brandSplit: 'Rozdziel',
      brandSplitTooltip:
        'Śledź tę nazwę jako osobną markę w tym projekcie. Pozostałe projekty zachowują wspólne grupowanie.',
      brandMerge: 'Scal z powrotem',
      brandMergeTooltip: 'Wróć z tą nazwą pod {{brand}}.',
      brandSplitMain: 'To główna nazwa marki — odłącz pozostałe nazwy.',
      brandAttach: 'Wybierz markę…',
      brandLabelEdit: 'Zmień nazwę marki (sama etykieta — nie rusza żadnych statystyk)',
      brandLabelReset: 'Puste pole przywraca nazwę domyślną.',
      brandDomains: 'Domeny marki',
      brandDomainsTooltip:
        'Strony należące do tej marki. Służą do odróżnienia jej własnych stron od cudzych przy klasyfikacji źródeł. Domena usunięta tutaj przestaje liczyć się jako ta marka w całym projekcie.',
      brandDomainAdd: 'Dodaj domenę',
      brandDomainAddSubmit: 'Dodaj',
      brandDomainsEmpty: 'Brak domen',
      brandDomainExclude: 'To nie jest ta marka',
      brandDomainInvalid: 'To nie jest poprawny adres',
      brandDomainsUnconfirmed:
        'Niepotwierdzone w tym projekcie — słownik zna każdą firmę o tej nazwie',
      brandDomainsOthers: 'Inne firmy o tej nazwie ({{count}})',
      brandDomainConfirm: 'To jest ta marka',
      notThisBrand: 'To nie ta marka',
      keywordNormalized: 'Znormalizowana fraza',
      noKeywordsFound: 'Brak fraz kluczowych dla tego projektu.',
      keywordFilterAll: 'Wszystkie',
      keywordFilterActive: 'Aktywne',
      keywordFilterInactive: 'Nieaktywne',
      keywordToggleDisabledDefault: 'Domyślnej marki nie można dezaktywować',
      brandLastActiveName: 'Marka projektu musi mieć przynajmniej jedną aktywną nazwę',
      keywordToggleDisabledFirm: 'Aktualnie ustawiona marka projektu - nie można dezaktywować',
      keywordUpdateError: 'Nie udało się zmienić statusu frazy. Spróbuj ponownie.',
      searchKeywords: 'Szukaj fraz...',
      keywordPromptCount: 'Prompty',
      keywordBulkActivate: 'Aktywuj zaznaczone frazy',
      keywordBulkDeactivate: 'Dezaktywuj zaznaczone frazy',
      keywordSelectMode: 'Zaznacz frazy',
      keywordsEmptyState: 'Brak śledzonych fraz kluczowych',
      keywordAliasesTooltip: 'Ta fraza ma alternatywne nazwy pogrupowane przez słownik marek',
      yes: 'Tak',
      no: 'Nie',
      resetToDefault: 'Przywróć domyślne',
      defaultBrandAlreadyActive: 'Domyślna marka jest już aktywna.',
      lastWeek: 'Ostatni tydzień',
      lastMonth: 'Ostatni miesiąc',
      last3Months: 'Ostatnie 3 miesiące',
      customPeriod: 'Własny zakres',
      today: 'Dzisiaj',
      yesterday: 'Wczoraj',
      currentWeek: 'Bieżący tydzień',
      last7Days: 'Ostatnie 7 dni',
      last14Days: 'Ostatnie 14 dni',
      last30Days: 'Ostatnie 30 dni',
      currentMonth: 'Bieżący miesiąc',
      currentQuarter: 'Bieżący kwartał',
      previousQuarter: 'Poprzedni kwartał',
      lastYear: 'Ostatni rok',
      allTime: 'Wszystko',
      period: 'Okres',
      customDate: 'Własna data',
      selectDateRange: 'Wybierz zakres dat',
      clear: 'Wyczyść',
      apply: 'Zastosuj',
      currentPeriod: 'Bieżący okres',
      previousPeriod: 'Poprzedni okres',
      dayBefore: 'Dzień wcześniej',
      daysBeforePlural: '{{count}} dni wcześniej',
      weekBefore: 'Tydzień wcześniej',
      weeksBeforePlural: '{{count}} tygodni wcześniej',
      monthBefore: 'Miesiąc wcześniej',
      monthsBeforePlural: '{{count}} miesięcy wcześniej',
      yearBefore: 'Rok wcześniej',
      compareWith: 'Porównaj z',
      coverage: 'Zasięg',
      coverageTooltip:
        'Zasięg oznacza procent wygenerowanych przez AI odpowiedzi, w których odniesiono się do danego źródła (adresu URL lub domeny). Ta metryka pomaga ocenić, jak wpływowe lub powszechnie używane jest konkretne źródło w treściach generowanych przez AI. Wyższe pokrycie oznacza, że źródło było często cytowane lub wykorzystywane w odpowiedziach modelu.',
      model: 'Model',
      releaseGpt5: 'Wydanie GPT-5',
      releaseGemini31: 'Wydanie Gemini Flash 3.1',
      releaseGemini30: 'Wydanie Gemini Flash 3.0',
      releaseGemini20: 'Wydanie Gemini Flash 2.0',
      releaseGemini25: 'Wydanie Gemini Flash 2.5',
      releaseSonnet4: 'Wydanie Sonnet 4',
      accountBannedTitle: 'Twoje konto zostało zawieszone',
      accountBannedDescription:
        'Twoje konto zostało zawieszone, a Twoje projekty nie są już monitorowane. Jeśli uważasz, że to pomyłka, napisz do nas na',
      accountBlockedAbuseTitle: 'Twoje konto zostało zablokowane',
      accountBlockedAbuseDescription:
        'Wykryliśmy podejrzaną aktywność na Twoim koncie, dlatego zostało ono zablokowane, a Twoje projekty nie są już monitorowane. Jeśli uważasz, że to pomyłka, napisz do nas na',
      accountBlockedAbuseUntilDescription:
        'Wykryliśmy podejrzaną aktywność na Twoim koncie, dlatego zostało ono zablokowane do {{until}}, a Twoje projekty są do tego czasu wstrzymane. Jeśli uważasz, że to pomyłka, napisz do nas na',
      trialEndedTitle: 'Twój okres próbny się zakończył',
      trialEndedDescription:
        'Twój okres próbny się zakończył, ale nie martw się - Twoje dane są bezpieczne i gotowe, gdy tylko będziesz gotowy! Aby odzyskać dostęp, po prostu wykup plan lub skontaktuj się z nami po pomoc.',
      needHelpOrQuestions: 'Potrzebujesz pomocy lub masz pytania?',
      emailUsAt: 'Napisz do nas na',
      orBookCall: 'lub ',
      bookCall: 'umów rozmowę',
      readyToContinue: 'Jesteś gotowy by kontynuować?',
      purchasePlan: 'Wykup plan',
      weLoveToHaveYouBack:
        'Chcielibyśmy Cię mieć z powrotem i dalej pomagać Ci śledzić widoczność Twojej marki w AI.',
      envelopeIcon: 'Ikona koperty',
      creditCardIcon: 'Ikona karty kredytowej',
      opensInNewTab: 'otwiera się w nowej karcie',
      aiCitations: 'Cytowania AI',
      pages: 'Strony',
      aiOverviewAvailable: 'Ten prompt wywołuje podsumowanie AI w Google.',
      lookerStudioDesc: 'Połącz swoje dane z Google Looker Studio',
      lookerStudioIntegrationDesc:
        'Zintegruj się z Google Looker Studio, aby tworzyć automatyczne, zawsze aktualne raporty i dashboardy prosto z danych Chatbeat.',
      integrationsIncluded: 'Co zawiera',
      lookerStudioFeat1Title: 'Zaplanowane raporty',
      lookerStudioFeat1Desc:
        'Wysyłaj metryki Chatbeat do Looker Studio automatycznie w cyklu dziennym, tygodniowym lub miesięcznym.',
      lookerStudioFeat2Title: 'Własne dashboardy',
      lookerStudioFeat2Desc:
        'Wizualizuj widoczność marki, share of voice i źródła w pełni konfigurowalnych dashboardach.',
      lookerStudioFeat3Title: 'Automatyczna synchronizacja',
      lookerStudioFeat3Desc:
        'Utrzymuj każdy raport aktualny dzięki natywnemu konektorowi, który synchronizuje dane automatycznie.',
      brand24SignalsPrice: '$199 / miesiąc',
      brand24SignalsDesc:
        'Połącz realne wzmianki z Brand24 z narracjami generowanymi przez AI, aby wpływać na to, jak modele AI opisują Twoją markę.',
      brand24Feat1Title: 'Kontekst i sentyment',
      brand24Feat1Desc:
        'Klasyfikacja sentymentu i szczegółowy rozkład narracji zasilających modele AI.',
      brand24Feat2Title: 'Chatbeat × Brand24',
      brand24Feat2Desc:
        'Synchronizacja wzmianek Brand24 w czasie rzeczywistym z social media, newsów i forów do odpowiedzi AI.',
      brand24Feat3Title: 'Alerty o anomaliach marki',
      brand24Feat3Desc:
        'Wykrywanie anomalii w źródłach cytowanych przez AI, byś reagował, zanim narracje się utrwalą.',
      brand24Configure: 'Konfiguruj',
      brand24ConfigTitle: 'Konfiguracja Brand24 AI Signals',
      brand24ModeOwnKey: 'Użyj własnego klucza API',
      brand24ModeOwnKeyDesc: 'Pełna integracja, w tym źródła Facebook, Instagram i X.',
      brand24ModeDefault: 'Użyj naszego wbudowanego klucza',
      brand24ModeDefaultDesc: 'Integracja z Facebookiem, Instagramem i X nie będzie dostępna.',
      brand24ApiKeyLabel: 'Klucz API Brand24',
      brand24ApiKeyPlaceholder: 'Twój klucz API Brand24',
      brand24AccountIdLabel: 'ID konta Brand24',
      brand24AccountIdPlaceholder: 'np. 1234567',
      brand24AccountIdHint: 'Znajdziesz je w panelu Brand24 - potrzebne do wczytania Twoich projektów.',
      'brand24Config.title': 'Dodaj projekty do Brand24',
      'brand24Config.intro':
        'Utworzymy (lub użyjemy ponownie) projekt Brand24 dla Twojej głównej marki i maksymalnie 4 konkurentów wybranych wg share of voice. Każdego możesz zmienić.',
      'brand24Config.mainBrand': 'Marka główna',
      'brand24Config.competitor': 'Konkurent {{n}}',
      'brand24Config.pickBrand': 'Wybierz markę',
      'brand24Config.createNew': '+ Utwórz nowy projekt',
      'brand24Config.continue': 'Kontynuuj',
      'brand24Config.addCompetitor': 'Dodaj konkurenta',
      'brand24Config.removeCompetitor': 'Usuń konkurenta',
      successfullyDisconnected: 'Pomyślnie rozłączono z Looker Studio',
      failedToDisconnect: 'Nie udało się rozłączyć. Spróbuj ponownie.',
      viewAllReports: 'Zobacz wszystkie raporty Looker Studio',
      viewReports: 'Zobacz raporty',
      disconnect: 'Rozłącz',
      connect: 'Połącz',
      confirmDisconnection: 'Potwierdź rozłączenie',
      confirmDisconnectMessage:
        'Czy na pewno chcesz rozłączyć się z Looker Studio? Będziesz musiał połączyć się ponownie, aby tworzyć nowe raporty.',
      reconnectToCreateReports: 'Będziesz musiał połączyć się ponownie, aby tworzyć nowe raporty.',

      // Looker Studio Callback
      authorizationFailed: 'Autoryzacja nie powiodła się. Spróbuj ponownie.',
      noAuthorizationCode: 'Nie otrzymano kodu autoryzacji.',
      successfullyConnectedToLookerStudio: 'Pomyślnie połączono z Looker Studio!',
      failedToConnectToLookerStudio: 'Nie udało się połączyć z Looker Studio. Spróbuj ponownie.',
      authorizationError: 'Wystąpił błąd podczas autoryzacji.',
      connectingToLookerStudio: 'Łączenie z Looker Studio...',
      success: 'Sukces!',
      error: 'Błąd',

      // Periodic Reports Page
      periodicReports: 'Raporty okresowe',
      lookerStudio: 'Looker Studio',
      unknown: 'Nieznany',
      notConnectedToLookerStudio:
        'Nie jesteś połączony z Looker Studio. Przejdź do strony Integracje i połącz się najpierw.',
      project: 'Projekt',
      type: 'Typ',
      status: 'Status',
      googlePermissionsChanged:
        'Twoje uprawnienia konta Google zostały zmienione. Połącz się ponownie z Looker Studio na stronie Integracje.',
      failedToCreateReport: 'Nie udało się utworzyć raportu',
      confirmDeletePeriodicReport: 'Czy na pewno chcesz usunąć ten raport okresowy?',
      confirmDeletion: 'Potwierdź usunięcie',
      deactivate: 'Dezaktywuj',
      activate: 'Aktywuj',
      areYouSureYouWantTo: 'Czy na pewno chcesz',
      thisPeriodicReport: 'ten raport okresowy',
      failedToDeleteReport: 'Nie udało się usunąć raportu',
      failedToDeleteReportTryAgain: 'Nie udało się usunąć raportu. Spróbuj ponownie.',

      // Sources - new fields
      sourcesKeywords: 'Wzmianki',
      sourcesKeywordsTooltip: 'Lista słów kluczowych wspomnianych w źródle',
      sourcesOwnBrand: 'wspomniane',
      sourcesOwnBrandHeaderTooltip: 'Czy {{firmName}} zostało wspomniane na tej stronie.',
      sourcesOwnBrandMentioned: 'Tak',
      sourcesOwnBrandNotMentioned: 'Nie',
      sourcesOwnBrandNotChecked: 'Nie sprawdzono',
      sourcesOwnBrandTooltipMentioned: '{{firmName}} zostało wspomniane na tej stronie',
      sourcesOwnBrandTooltipNotMentioned: '{{firmName}} nie zostało wspomniane na tej stronie',
      sourcesOwnBrandTooltipNotChecked: 'Ta strona nie została przeanalizowana',
      sourcesCited: 'Cytowane',
      sourcesCitedTooltip: 'Czy źródło zostało bezpośrednio cytowane',
      topDomains: 'Top domeny',
      topDomainsTooltip: 'Top 10 domen cytowanych przez modele AI w tym okresie',
      topUrls: 'Top URL-e',
      topUrlsTooltip: 'Top 10 URL-ów cytowanych przez modele AI w tym okresie',
      usages: 'Użycia',
      usagesCount_one: '{{count}} użycie',
      usagesCount_few: '{{count}} użycia',
      usagesCount_many: '{{count}} użyć',
      usagesCount_other: '{{count}} użycia',
      url: 'URL',
      failedToUpdateReportStatus: 'Nie udało się zaktualizować statusu raportu. Spróbuj ponownie.',
      paused: 'Wstrzymany',
      disabled: 'Wyłączony',
      report: 'Raport',
      createReport: 'Utwórz raport',
      failedToLoadPeriodicReports: 'Nie udało się załadować raportów okresowych',
      failedToOpenReport: 'Nie udało się otworzyć raportu',
      invalidLookerStudioUrl:
        'Nieprawidłowy URL. Najpierw zapisz raport w Looker Studio, potem wklej jego adres (…/reporting/<id>/…).',
      failedToSaveReportUrl: 'Nie udało się zapisać URL raportu. Spróbuj ponownie.',
      reportNotFound: 'Raport nie został znaleziony',
      periodicReportCreatedSuccessfully:
        'Twój raport okresowy {{reportName}} został pomyślnie utworzony!',
      openReport: 'Otwórz raport',
      reportName: 'Nazwa raportu',
      lastExecuted: 'Ostatnie wykonanie',
      never: 'Nigdy',
      noPeriodicReportsYet:
        'Ups! Wygląda na to, że nie masz</br>jeszcze żadnych raportów okresowych.</br>Dodaj jeden poniżej.',
      noPeriodicReportsDescription:
        'Nie utworzyłeś jeszcze żadnych automatycznych raportów. Raporty okresowe można skonfigurować przez integracje, aby dostarczać automatyczne analizy zgodnie z harmonogramem.',
      projectRequired: 'Projekt jest wymagany',
      name: 'Nazwa',
      schedule: 'Harmonogram',
      creating: 'Tworzenie...',
      delete: 'Usuń',
      retry: 'Spróbuj ponownie',
      close: 'Zamknij',
      openReportInLookerStudio: 'Otwórz raport w Looker Studio',

      // Report Link Modal
      saveUrl: 'Zapisz URL',
      lookerSetupTitle: 'Raport Looker Studio',
      lookerSetupStepConfigure: 'Skonfiguruj raport',
      lookerSetupStepLooker: 'Zapisz raport w Looker Studio',
      lookerSetupProjectDesc:
        'Utworzymy na Twoim Dysku Google arkusz z danymi tego projektu i będziemy go odświeżać co noc. Jeden raport na projekt i gradację.',
      lookerSetupIntro: 'Dane dla „{{name}}” są gotowe. Zostały trzy krótkie kroki:',
      lookerSetupIntroBuilding:
        'Arkusz dla „{{name}}” jest utworzony i właśnie wypełnia się danymi. Zostały trzy krótkie kroki:',
      lookerSetupOpenTitle: 'Otwórz Looker Studio',
      lookerSetupOpenDesc:
        'W nowej karcie otworzy się raport podpięty do karty „{{dataset}}” Twojego arkusza.',
      lookerSetupBuildingWait:
        'Looker Studio odczytuje kolumny raz, przy pierwszym otwarciu raportu — dlatego przycisk odblokuje się, gdy arkusz się wypełni, zwykle w ciągu minuty lub dwóch.',
      lookerSetupBuildStalled:
        'Wypełnianie arkusza zatrzymał błąd — powód widać w kolumnie Stan na liście raportów.',
      lookerSetupOpenDescLegacy: 'W nowej karcie otworzy się raport z podpiętymi już danymi projektu.',
      lookerSetupOpenDescTemplate:
        'W nowej karcie otworzy się gotowy raport ChatBeat: strona dla każdego zestawu danych, wszystkie podpięte do Twojego arkusza.',
      lookerSetupTemplateEmptyPages:
        'Strony zestawów danych, których nie ma w tym eksporcie, pozostaną puste — w trybie edycji możesz je usunąć (prawy przycisk na stronie → Usuń).',
      lookerSetupOpenBtn: 'Otwórz Looker Studio',
      lookerSetupSaveTitle: 'Zapisz tam raport',
      lookerSetupSaveDesc:
        'W prawym górnym rogu kliknij „Edytuj i udostępnij”, potem „Potwierdź i zapisz” i „Dodaj do raportu”. Jeśli Looker Studio poprosi o dostęp do Arkuszy Google, zezwól.',
      lookerSetupPasteTitle: 'Wklej adres raportu',
      lookerSetupPasteDesc:
        'Po zapisaniu skopiuj adres z paska przeglądarki (…/reporting/…/page/…) i wklej tutaj, żeby otwierać raport prosto z Chatbeat. Możesz to też zrobić później z menu wiersza.',
      lookerSetupAddTabsDesc:
        'Żeby użyć pozostałych kart ({{tabs}}), kliknij w raporcie „Dodaj dane” → „Arkusze Google” i wybierz ten sam arkusz oraz kartę.',
      lookerSetupRefreshNoteLegacy: 'Dane w raporcie odświeżają się automatycznie raz dziennie.',
      lookerSetupFinish: 'Dokończ konfigurację',
      lookerSetupMissingLink: 'Nie zapisano jeszcze adresu raportu w Looker Studio, więc nie otworzysz go z tej listy.',
      lookerSetupSkip: 'Pomiń na razie',
      lookerSetupLinkAction: 'Link do raportu',
      lookerGranularityTitle: 'Gradacja',
      lookerGranularityDesc:
        'Jeden wiersz na dzień, tydzień (pon.–niedz.) albo miesiąc. Domyślnie zaznaczamy tę, z którą projekt otwiera się w panelu.',
      lookerDatasetsTitle: 'Dane',
      lookerDatasetsDesc: 'Każdy zbiór to osobna karta arkusza i osobne źródło danych w Looker Studio.',
      lookerDatasetBrands: 'Marki',
      lookerDatasetPrompts: 'Pytania',
      lookerDatasetDomains: 'Domeny',
      lookerDatasetUrls: 'Adresy URL',
      lookerDatasetContext: 'Sentyment i ceny',
      lookerDatasetTopics: 'Tematy',
      lookerDatasetRequired: 'Wybierz co najmniej jeden zbiór danych.',
      lookerDatasetNotAvailable: 'Twój plan nie obejmuje jednego z wybranych zbiorów.',
      lookerTimelineTitle: 'Jak przybywają dane',
      lookerTimelineTeaser: 'Na start ostatnie 30 dni, potem co noc dopisujemy nowe dane.',
      lookerTimelineTeaserReport: 'Dane od {{date}} — co noc dopisujemy nowe.',
      lookerTimelineStartLabel: 'Na start',
      lookerTimelineNowLabel: 'Teraz',
      lookerTimelineNow: 'Arkusz ma dane od {{date}} do dziś.',
      lookerTimelineStartDaily: 'Ostatnie 30 dni — od {{date}} do dziś.',
      lookerTimelineStartWeekly: 'Ostatnie 30 dni w pełnych tygodniach (pon.–niedz.) — od {{date}} do dziś.',
      lookerTimelineStartMonthly: 'Ostatnie 30 dni w pełnych miesiącach — od {{date}} do dziś.',
      lookerTimelineStartShortHistory: 'Jeśli projekt zbiera dane krócej, arkusz zaczyna się od pierwszego dnia z danymi.',
      lookerTimelineNightlyLabel: 'Co noc',
      lookerTimelineNightlyDaily:
        'Dopisujemy nowy dzień i przeliczamy 3 ostatnie, bo ich wyniki mogą się jeszcze zmienić. Raport w Looker Studio pobiera dane sam.',
      lookerTimelineNightlyWeekly:
        'Aktualizujemy bieżący tydzień — rośnie do niedzieli, potem zaczyna się nowy. Raport w Looker Studio pobiera dane sam.',
      lookerTimelineNightlyMonthly:
        'Aktualizujemy bieżący miesiąc — rośnie do jego ostatniego dnia, potem zaczyna się nowy. Raport w Looker Studio pobiera dane sam.',
      lookerTimelineHistoryLabel: 'Z czasem',
      lookerTimelineHistory: 'Historia rośnie z każdą nocą do {{max}} — potem najstarsze okresy wypadają.',
      lookerRetentionDaily: '90 dni',
      lookerRetentionWeekly: '52 tygodni',
      lookerRetentionMonthly: '24 miesięcy',
      lookerReportExistsForGranularity: 'Ten projekt ma już raport Looker Studio o tej gradacji.',
      lookerDatasets: 'Dane',
      lookerBuildState: 'Budowa',
      lookerBuildBuilding: 'W budowie',
      lookerBuildReady: 'Gotowy',
      lookerBuildFailed: 'Błąd',
      lookerHealth: 'Stan',
      lookerHealthOk: 'OK',
      lookerHealthDegraded: 'Problemy',
      lookerHealthNeedsAttention: 'Wymaga uwagi',
      lastRefresh: 'Ostatnie odświeżenie',
      lookerLegacyFormat: 'Stary format',
      lookerRecomputeAll: 'Przelicz wszystkie dane',
      confirmRecomputeLookerReport:
        'Przeliczyć wszystkie okresy w arkuszu? Przydaje się po zmianach działających wstecz (tagi, marki, usunięte pytania, klasyfikacja domen). Potrwa kilka minut i jest możliwe raz na 24 godziny.',
      lookerRecomputeBlockedBuilding: 'Raport jest właśnie budowany.',
      lookerRecomputeBlockedRecent: 'Raport był przeliczany w ciągu ostatnich 24 godzin.',
      failedToRecomputeReport: 'Nie udało się uruchomić przeliczania. Spróbuj ponownie.',
      cardExpire: 'Ważność karty',
      usage: 'Użycie',
      currentPlan: 'Aktualny plan',
      occurrences: 'Wystąpienia',
      trialDays: 'Dni próbne',
      topBrands: 'Najlepsze marki',
      cost: 'Koszt',
      free: 'Bezpłatny',
      of: 'z',

      invalidPasswordResetLink: 'Błąd resetu hasła',
      invalidPasswordResetLinkDesc:
        'Wygląda na to, że link do resetu hasła, którego używasz, jest niepoprawny. Upewnij się, że skopiowałeś go w całości lub spróbuj ponownie rozpocząć proces resetowania hasła.',
      expiredPasswordResetLink: 'Link wygasł',
      expiredPasswordResetLinkDesc:
        'Link do ustawienia hasła jest już nieważny. Skorzystaj z przycisku poniżej, aby przejść do ustawiania nowego hasła.',
      selectDomain: 'Wybierz domenę',
      allDomains: 'Wszystkie domeny',

      // API Keys
      apiKeys: 'Klucze API',
      apiKey: 'Klucz API',
      createApiKey: 'Utwórz klucz API',
      editApiKey: 'Edytuj klucz API',
      extendValidity: 'Przedłuż ważność',
      validity: 'Ważność',
      validityPeriod: 'Okres ważności',
      selectValidityPeriod: 'Wybierz okres ważności',
      neverExpires: 'Nigdy nie wygasa',
      expired: 'Wygasł',
      expiresInDays: 'Wygasa za {{days}} dni',
      areYouSureDeleteApiKey: 'Czy na pewno chcesz usunąć ten klucz API?',
      createApiKeyError: 'Nie udało się utworzyć klucza API',
      editApiKeyError: 'Nie udało się edytować klucza API',
      extendValidityError: 'Nie udało się przedłużyć ważności klucza API',
      description: 'Opis',
      enterDescription: 'Wprowadź opis',
      selectStatus: 'Wybierz status',
      inactive: 'Nieaktywny',
      '30Days': '30 dni',
      '90Days': '90 dni',
      '180Days': '180 dni',
      '365Days': '365 dni',
      extend: 'Przedłuż',
      createdBy: 'Utworzony przez',
      copy: 'Kopiuj',
      copied: 'Skopiowano!',
      copyFailed: 'Nie udało się skopiować',
      emptyStateApiKeys:
        'Ups! Wygląda na to, że nie masz</br>jeszcze żadnych kluczy API.</br>Utwórz jeden poniżej.',
      emptyStateApiKeysReadonly:
        'Nie ma jeszcze żadnych kluczy API.</br>Skontaktuj się z właścicielem konta, aby je utworzyć.',

      // Marketplace
      marketplace: 'Marketplace',
      marketplaceExportTitle: 'Eksport',
      marketplaceModels: 'Modele',
      marketplaceAddons: 'Dodatki',
      marketplaceAddModel: 'Dodaj model',
      marketplaceModelDescription: 'Sprawdzaj, jak {{model}} odpowiada na Twoje prompty i wspomina Twoją markę',
      marketplaceModelAnswers: 'Codzienne odpowiedzi na wszystkie prompty',
      marketplaceModelStats: 'Widoczność, pozycja i sentyment',
      marketplaceModelSources: 'Cytowane źródła i konkurencja',
      marketplaceExportDescription: 'Eksportuj dane do formatu CSV, Excel lub PDF',
      marketplaceExportCsv: 'Eksport do CSV',
      marketplaceExportExcel: 'Eksport do Excela',
      marketplaceExportPdf: 'Eksport do PDF',
      marketplaceExportScheduled: 'Eksporty cykliczne',
      marketplaceAgencyTitle: 'Agencja',
      marketplaceAgencyDescription: 'Projekty i prompty wszystkich klientów w jednym podsumowaniu',
      marketplaceAgencyGroups: 'Grupy klientów obok siebie',
      marketplaceAgencyTrends: 'Zmiany względem poprzedniego okresu',
      marketplaceAgencyInsights: 'Najszybciej rosnący i najmniej aktywni klienci',
      marketplaceClaudeWebSearchTitle: 'Claude Web Search',
      marketplaceClaudeWebSearchDescription: 'Włącz wyszukiwanie AI w internecie dla swoich monitorów',
      marketplaceClaudeRealTime: 'Dane z sieci na bieżąco',
      marketplaceClaudeUpToDate: 'Aktualne wyniki',
      marketplaceClaudePowered: 'Napędzane przez Claude AI',
      marketplaceAdditionalPromptsTitle: 'Dodatkowe prompty',
      marketplaceAdditionalPromptsDescription: 'Kup dodatkowe sloty na prompty, aby rozszerzyć zakres monitorowania',
      marketplacePromptsCoverage: 'Szerszy zakres monitorowania',
      marketplacePromptsSlots: 'Więcej slotów na słowa kluczowe',
      marketplacePromptsScaling: 'Elastyczne skalowanie',
      marketplaceApiAccessTitle: 'Dostęp do API',
      marketplaceApiAccessDescription: 'Uzyskaj dostęp do API ChatBeat, aby integrować się z własnymi narzędziami',
      marketplaceApiRest: 'REST API',
      marketplaceApiFullData: 'Pełny dostęp do danych',
      marketplaceApiIntegration: 'Gotowe do integracji',
      marketplaceApiKeys: 'Zarządzanie kluczami API',
      marketplacePurchase: 'Kup',
      marketplaceEnable: 'Włącz',
      marketplaceContactUs: 'Skontaktuj się z nami',
      marketplaceContactMessage: 'Cześć! Interesuje mnie {{offer}} — możecie powiedzieć coś więcej?',
      emptyStateOrders: 'Nie masz jeszcze żadnych zamówień.',
      changesGptCitations: 'Zmiany w cytowaniach GPT',
      geolocation: 'Geolokalizacja',
      newVersionAvailable: 'Dostępna jest nowa wersja aplikacji',
      refresh: 'Odśwież',
      monthly: 'Miesięczny',
      yearly: 'Roczny',
      saveDiscount: 'Oszczędź',
      pricingDescEssential: 'Dla osób prywatnych i rozwijających się startupów.',
      pricingDescEnterpriseV2:
        'Idealne dla liderów branży i dużych przedsiębiorstw o niestandardowych potrzebach',
      pricingDescEnterpriseV3:
        'Dla liderów branży – raport AI Visibility i warsztaty strategii GEO w pakiecie.',
      pricingDescAdvancedV2: 'Dla rozwijających się firm poszukujących zaawansowanej analizy',
      pricingDescAdvancedV3:
        'Dla zespołów marketingowych potrzebujących zaawansowanych analiz wyszukiwania AI.',
      pricingDescBusiness: 'Idealne dla agencji obsługujących wielu klientów i projekty jednocześnie',
      pricingDescBusinessV3:
        'Idealny dla agencji zarządzających wieloma markami i większą liczbą analiz.',
      seats: 'Użytkowników',
      llms3: '3 modele',
      llms: '{{value}} modeli',
      allLlms: 'Modele',
      customResponse: 'Custom AI response analysis',
      countPrompts: '{{count}} pytań',
      dailyRefresh: 'Codzienna analiza: {{count}} odpowiedzi AI',
      unlimitedPromptsV2: 'Nielimitowane pytania',
      unlimitedProjects: 'Nielimitowane projekty',
      unlimitedSeats: 'Nielimitowani użytkownicy',
      customerPromptInsights: 'Analiza pytań klientów',
      brandVisibilityTracking: 'Śledzenie widoczności marki',
      aiSourcesAnalytics: 'Analiza źródeł AI',
      competitionBenchmarks: 'Porównania z konkurencją',
      exportableData: 'Eksport danych',
      exportableDataApi: 'Zaawansowany eksport danych i API',
      lockerStudioIntegration: 'Integracja z Locker Studio',
      earlyAccessToBeta: 'Wczesny dostęp do funkcji beta',
      whitelabeledClientReporting: 'Raporty white-label',
      dedicatedProjectManger: 'Dedykowany menedżer projektu',
      downloadSources: 'Pobierz źródła',
      downloadDomains: 'Pobierz domeny',
      downloadPdfReport: 'Pobierz raport PDF',
      sources: 'Źródła',
      positions: 'Pozycje marek',
      performanceByDomain: 'Wydajność według domeny',
      performanceByDomainTooltip:
        'Analizuj wydajność domen z wzmiankami, zmianami udziału i porównaniami trendów między okresami. Identyfikuj najlepiej radzące sobie domeny i zrozum ich wpływ na widoczność marki.',
      performanceByDomainMentions: 'Wzmianki',
      performanceByDomainMentionsTooltip:
        'Liczba wystąpień tej domeny w odpowiedziach generowanych przez AI.',
      performanceByDomainMentionsChange: 'Zmiana',
      performanceByDomainMentionsChangeTooltip:
        'Zmiana liczby wzmianek w porównaniu z poprzednim okresem pomiarowym.',
      performanceByDomainShare: 'Udział',
      performanceByDomainShareTooltip:
        'Udział tej domeny we wszystkich cytowaniach przypisanych do projektu.',
      performanceByDomainShareChange: 'Zmiana',
      performanceByDomainShareChangeTooltip:
        'Zmiana udziału tej domeny w porównaniu z poprzednim okresem pomiarowym.',
      mentions: 'Wzmianki',
      change: 'Zmiana',
      share: 'Udział',
      shareCurrent: 'Udział (Obecny)',
      sharePrevious: 'Udział (Poprzedni)',
      shareDelta: 'Δ Udział',
      sourceTypesShare: 'Udział typów źródeł',
      sourceTypesShareTooltip:
        'Wizualizuj rozkład różnych typów źródeł, aby zrozumieć różnorodność źródeł treści. Analiza pozwala na identyfikację dominujących kategorii i zrównoważenie źródeł w Twojej strategii content marketingu.',
      domainsPerModel: 'Domeny według modelu',
      domainsPerModelTooltip:
        'Top 10 domen cytowanych przez każdy model AI w wybranym przedziale czasowym. Użyj filtra domen, aby porównać konkretne domeny między modelami.',
      noSourcesForModelYet: 'Nie znaleziono źródeł w odpowiedziach {{model}}.',
      citationTypes: 'Typy cytowań',
      citationTypesTooltip: 'Podział cytowań w wybranym okresie według typu źródła.',
      citationTypeSocial: 'Social',
      citationTypeOwned: 'Własne',
      domainCategoriesShare: 'Udział kategorii domen',
      domainCategoriesShareTooltip:
        'Podział cytowań według kategorii domeny (News, Blogi, Wideo itp.), aby zrozumieć, które typy treści są najczęściej cytowane.',
      categoryColumn: 'Kategoria',
      categoryNews: 'Newsy',
      categoryBlogs: 'Blogi',
      categoryVideos: 'Wideo',
      categoryPhotos: 'Zdjęcia',
      categorySocial: 'Social Media',
      categoryPodcasts: 'Podcasty',
      categoryOthers: 'Inne',
      categoryWeb: 'Web',
      sourceCategoryCorporate: 'Korporacyjne',
      sourceCategoryEditorial: 'Redakcyjne',
      sourceCategoryInstitutional: 'Instytucjonalne',
      sourceCategoryUgc: 'UGC',
      sourceCategoryReference: 'Encyklopedyczne',
      sourceCategoryVideo: 'Wideo',
      sourceCategoryOther: 'Inne',
      domains: 'Domeny',
      sourceRetrievalByUrl: 'Wszystkie odpowiedzi',
      sourceRetrievalByUrlTooltip: 'Szczegółowy rozkład wszystkich URLi cytowanych w ramach tej domeny',
      shareView: 'Udział %',
      countView: 'Ilość',
      urlTypes: 'Typy URL',
      urlTypesTooltip: 'Rozkład typów URLi cytowanych w ramach tej domeny',
      pageType_HOMEPAGE: 'Strona główna',
      pageType_CATEGORY_PAGE: 'Strona kategorii',
      pageType_PRODUCT_PAGE: 'Strona produktu',
      pageType_LISTICLE: 'Listicle',
      pageType_COMPARISON: 'Porównanie',
      pageType_PROFILE: 'Profil',
      pageType_ALTERNATIVE: 'Alternatywa',
      pageType_DISCUSSION: 'Dyskusja',
      pageType_HOW_TO_GUIDE: 'Poradnik',
      pageType_ARTICLE: 'Artykuł',
      pageType_OTHER: 'Inne',
      pageType_COMPETITOR: 'Konkurencja',
      pageType_OWN: 'Własna',
      chat: 'Chat',
      citations: 'Cytowania',
      chatsUsingThisDomain: 'Chaty wykorzystujące tę domenę',
      chatsUsingThisDomainTooltip: 'Lista chatów AI, w których ta domena została zacytowana jako źródło',
      domainSourcesAnalytics: 'Źródła domeny',
      domainSourcesAnalyticsTooltip:
        'Szczegółowy rozkład wszystkich URLi cytowanych w ramach tej domeny',
      brandMentionsPerSource: 'Wzmianki marek w źródłach',
      brandMentionsPerSourceTooltip: 'Jak często każda marka jest wymieniana w źródłach tej domeny',
      platforms: 'Platformy',
      platformsTooltip: 'Udział cytowań per platforma AI dla tej domeny',
      rank: 'Pozycja',
      platform: 'Platforma',
      promptsUsingThisUrl: 'Prompty używające tego URL',
      urlType: 'Typ URL',
      brandMentioned: 'Marka wspomniana',
      mentioned: 'Wspomniana',
      usageCount: 'Użycia',
      citationRate: 'Współczynnik cytowań',
      citationGaps: 'Luki w cytowaniach',
      viewPageContent: 'Zobacz zawartość strony',
      savedPageCopy: 'Zapisana kopia (dev)',
      savedPageCopyDevNote: 'Wersja deweloperska — widoczna tylko dla superadminów z addonem SOURCE_PAGE_COPY.',
      savedPageCopyFrom: 'Tekst strony w wersji, którą nasza weryfikacja odczytała {{date}}.',
      savedPageCopyTruncated: 'Kopia jest ucięta po 500 000 znaków.',
      savedPageCopyMissing:
        'Nie mamy jeszcze zapisanej kopii tej strony. Zapiszemy ją przy następnym sprawdzeniu strony pod kątem Twoich marek.',
      sourceLastSeen: 'Ostatnio widziano',
      sourceCategoryOwn: 'Własna',
      sourceCategoryCompetitor: 'Konkurencja',
      sourceCategoryNeutral: 'Neutralna',
      sourceUrlType: 'Typ URL',
      sourceUsage: 'Użycia',
      sourceNoOfPrompts: 'Liczba promptów',
      sourceLifecycle: 'Cykl życia',
      sourceFirstSeen: 'Pierwszy raz',
      sourceToday: 'Dzisiaj',
      sourceYesterday: 'Wczoraj',
      sourceDaysAgo: '{{count}} dni temu',
      sourceWeekAgo: 'Tydzień temu',
      sourceMonthAgo: 'Miesiąc temu',
      sourceOlderThanMonth: 'Ponad miesiąc temu',
      sourcePromptsTitle: 'Prompty',
      sourcePromptsColumn: 'Prompt',
      sourceQueriesColumn: 'Zapytania',
      sourceRetrievedColumn: 'Pobrane',
      sourceBrandsTitle: 'Marki wymienione w {{siteName}}',
      sourceBrandColumn: 'Marka',
      sourceBrandPositionColumn: 'Pozycja',
      sourceBrandFrequencyColumn: 'Częstotliwość',
      sourceBrandCitationsColumn: 'Cytowania',
      sourceUsageChart: 'Użycia',
      sourceUsageByModelChart: 'Użycia wg modelu',
      highlightOwnDomain: 'Filtruj własną domenę',
      citationTrends: 'Trendy cytowań',
      citationTrendsTooltip:
        'Pokazuje, jak często każda domena jest cytowana w odpowiedziach generowanych przez AI w wybranym okresie - możesz wybrać domeny do porównania.',
      sourcesAnalytics: 'Ranking stron',
      sourcesAnalyticsTooltip:
        'Konkretne adresy URL najczęściej cytowane w odpowiedziach generowanych przez AI.',
      sourcesAnalyticsShare: 'Udział',
      sourcesAnalyticsShareTooltip:
        'Udział tego URL-a we wszystkich cytowaniach przypisanych do projektu.',
      sourcesAnalyticsShareChange: 'Zmiana',
      sourcesAnalyticsShareChangeTooltip:
        'Zmiana udziału tego URL-a w porównaniu z poprzednim okresem pomiarowym.',
      sourcesAnalyticsPrompts: 'Prompty',
      sourcesAnalyticsPromptsTooltip:
        'Liczba promptów, w których ten URL został wykorzystany jako cytowane źródło.',
      sourcesAnalyticsPromptsChange: 'Zmiana',
      sourcesAnalyticsPromptsChangeTooltip:
        'Zmiana liczby promptów cytujących ten URL w porównaniu z poprzednim okresem.',
      domainsWithSourcesAnalytics: 'Ranking domen',
      domainsWithSourcesAnalyticsTooltip:
        'Sprawdź, które strony internetowe są najczęściej cytowane w odpowiedziach generowanych przez AI na Twoje prompty.',
      domainsWithSourcesAnalyticsShare: 'Udział',
      domainsWithSourcesAnalyticsShareTooltip:
        'Udział tej domeny we wszystkich cytowaniach przypisanych do projektu.',
      domainsWithSourcesAnalyticsShareChange: 'Zmiana',
      domainsWithSourcesAnalyticsShareChangeTooltip:
        'Zmiana udziału tej domeny w porównaniu z poprzednim okresem pomiarowym.',
      domainsWithSourcesAnalyticsPrompts: 'Prompty',
      domainsWithSourcesAnalyticsPromptsTooltip:
        'Liczba promptów, w których ta domena została użyta jako cytowane źródło.',
      domainsWithSourcesAnalyticsPromptsChange: 'Zmiana',
      domainsWithSourcesAnalyticsPromptsChangeTooltip:
        'Zmiana liczby promptów, które cytowały tę domenę, w porównaniu z poprzednim okresem.',
      searchPlaceholder: 'Szukaj...',
      source: 'Źródło',
      shareColumn: 'Udział',
      prompts: 'Prompty',
      typeColumn: 'Typ',
      watchedPages: 'Obserwowane strony',
      watchedPagesTooltip:
        'Śledź konkretne strony, aby sprawdzić czy pojawiają się w cytowaniach AI. Dodaj adresy URL i monitoruj ich obecność w modelach AI.',
      addPages: 'Dodaj strony',
      noWatchedPagesYet: 'Monitoruj konkretne adresy URL<br/>pod kątem cytowań i trendów.',
      addAnotherPage: 'Dodaj kolejną stronę',
      mentionedOnPage: 'Wspomniane',
      firstSeen: 'Pierwsze pojawienie',
      page: 'Strona',
      category: 'Kategoria',
      added: 'Dodano',
      competitorVsNonCompetitorSources: 'Udział Twojej domeny',
      competitorSourcesTooltip:
        'Podział źródeł cytowań: Twoja domena, domeny konkurentów i inne źródła.',
      yourDomains: 'Twoje domeny',
      nonCompetitors: 'Pozostali',
      more: 'więcej',
      emptyOwnDomains: 'Twoja domena trzyma się w cieniu',
      emptyCompetitors: 'Brak konkurentów na horyzoncie',
      emptyNonCompetitors: 'Scena należy do Ciebie',
      tags: 'Tagi',
      tagsDesc: 'Połącz marki w jeden tag, aby analizować ich łączne wyniki w modelach AI.',
      brandsRanking: 'Ranking marek',
      allBrandsRanking: 'Ranking wszystkich marek',
      brandsRankingTooltip: 'Ranking marek pokazuje pozycję i widoczność każdej marki.',
      brand: 'Marka',
      addTag: 'Dodaj tag',
      brandVisibilityText:
        '{{firmName}} ma widoczność {{visibilityText}} wśród modeli LLM, ale brak danych do określenia udziału w dyskusjach lub pozycji w rankingach.',
      brandVisibilityFull: {
        header: '{{firmName}} ma widoczność {{visibilityText}} wśród modeli LLM',
        high: 'z największym share of voice w <b>{{highestSOVModels}} ({{normalizedMaxSOV}}%)</b>',
        low: 'i najniższym w <b>{{lowestSOVModels}} ({{normalizedMinSOV}}%)</b>',
        topQuery: 'Najwyżej sklasyfikowane zapytanie, "{{prompt}}"',
        topQueryKeywords:
          'osiąga średnią pozycję {{averagePosition}} dla {{keyword}}, podkreślając ich znaczenie w dyskusjach na temat monitorowaina marki.',
      },
      positive: 'Pozytywny',
      neutral: 'Neutralny',
      negative: 'Negatywny',
      topic: 'Temat',
      sentimentShare: 'Udział sentymentu',
      contextAnalysis: {
        overTime: 'W czasie',
        byAiModel: 'Przez model AI',
        keyTopicOccurrencesTooltip:
          'Łączna liczba wzmianek o tym temacie we wszystkich odpowiedziach AI.',
        topicShareTooltip: 'Procent wszystkich odpowiedzi w których występuje ten temat.',
        brandMentionsTooltip:
          'Liczba przeanalizowanych odpowiedzi AI w ramach tego tematu, które wprost wspominają Twoją markę.',
        functionalPositioning: 'Pozycjonowanie funkcjonalne',
        valuePerception: 'Postrzeganie wartości',
        positioningGap: 'Luka pozycjonowania',
        businessInsight: 'Wnioski biznesowe',
        header: 'Kontekst',
        desc: 'Analizuj, jak modele AI postrzegają i omawiają Twoją markę',
        topicsAnalysis: 'Analiza tematów',
        topicsAnalysisTooltip:
          'Analiza tematów wskazuje główne obszary tematyczne wyodrębnione ze wszystkich odpowiedzi AI oraz pokazuje, gdzie Twoja marka jest obecna w ramach każdego tematu.',
        sentimentAnalysisAiModel: 'Sentyment według modelu AI',
        sentimentAnalysisAiModelTooltip:
          'Zobacz, jak każdy model AI przedstawia Twoją markę i gdzie różnią się postrzegania.',
        topicsShare: 'Udział tematów',
        topicsShareTooltip:
          'Przedstawia procentowy rozkład tematów na podstawie zagregowanych odpowiedzi generowanych przez AI we wszystkich monitorowanych modelach.',
        insights: 'Wnioski',
        insightsTooltip:
          'To jest podsumowanie wygenerowane przez AI na podstawie wszystkich przeanalizowanych odpowiedzi ze wszystkich monitorowanych modeli AI.',
        sentimentOverTime: 'Sentyment w czasie',
        sentimentOverTimeTooltip:
          'Sentyment pokazuje, jak pozytywnie, negatywnie lub neutralnie AI przedstawia markę w odpowiedziach w danym okresie.',
        narrativeDrivers: 'Czynniki narracyjne',
        narrativeDriversTooltip:
          'Czynniki narracyjne wskazują kluczowe tematy i skojarzenia, które najsilniej kształtują sposób, w jaki AI opisuje Twoją markę. Są one wyodrębniane ze wszystkich analizowanych odpowiedzi w monitorowanych modelach AI w wybranym okresie.',
        brandDescription: 'Opis marki',
        brandInformation: 'Informacje o marce',
        brandStrengthByTopic: 'Obecność marki według tematu',
        brandStrengthByTopicTooltip:
          'Porównaj, jak często każda marka pojawia się w ramach każdego tematu w odpowiedziach AI.',
        contextGap: 'Luka kontekstowa',
        contextGapTooltip:
          'Analiza luki kontekstowej wskazuje tematy, z którymi konkurenci są silnie kojarzeni, podczas gdy Twoja marka jest mniej widoczna lub nieobecna. Pomaga zidentyfikować luki narracyjne i niewykorzystane możliwości pozycjonowania w odpowiedziach generowanych przez AI.',
        gapDescriptionGenerating: 'Opis jest generowany...',
        modeAnalysis: 'Analiza',
        modeInsights: 'Insights',
        selectInsightPeriod: 'Wybierz okres',
      },
      insightPage: {
        header: 'Analityka',
        desc: 'Czy AI mówi o marce {{brand}}, czy korzysta z niej jako źródła',
        announcement: {
          badge: 'Nowość',
          title: 'Poznaj Analitykę',
          desc: 'Zajrzyj głębiej w widoczność swojej marki w AI. Odkryj dodatkowe metryki, porównania z konkurencją i trendy w czasie w nowej zakładce Analityka w sekcji Performance.',
          citationGapTitle: 'Luka cytowań',
          citationGapDesc:
            'Zobacz, jak często AI wspomina o Twojej marce, a jak często cytuje Twoją stronę jako źródło.',
          perPromptTitle: 'Wyniki marek per prompt',
          perPromptDesc:
            'Porównaj swoją markę i konkurentów w kluczowych promptach: widoczność, cytowania, Top 3 i Top 1.',
          funnelTitle: 'Lejek vs konkurencja',
          funnelDesc: 'Śledź drogę od widoczności marki do Top 3 i Top 1 na tle konkurencji.',
          trendsTitle: 'Trendy w czasie',
          trendsDesc: 'Śledź zmiany per platforma AI i per marka: dziennie, tygodniowo lub miesięcznie.',
          later: 'Może później',
          cta: 'Zobacz Analitykę',
        },
        overview: {
          brandVisibility: 'Widoczność marki',
          citedAsSource: 'Marka cytowana jako źródło',
          visibilityPlusCited: 'Widoczność + cytowanie',
          citationGap: 'Luka cytowań',
          responsesOfTotal: '{{value}} z {{total}} odpowiedzi AI',
          mentionBackedByOwnSource: 'wzmianka poparta własnym źródłem',
          visibilityMinusCited: 'widoczność − cytowanie jako źródło',
          noDomainForBrand:
            'Nie znamy jeszcze domen marki {{brand}}. Dodaj domenę przy tej marce na stronie Keywords.',
          insight: {
            marginalPresence:
              'Marka {{brand}} prawie nie pojawia się w odpowiedziach AI, a jej własne domeny praktycznie nie są cytowane jako źródło.',
            visibilityUnderCited:
              'AI wspomina o marce {{brand}} rzadko, pomimo tego, że cytuje jej własne źródła.',
            highVisHighCoverage:
              'Marka {{brand}} jest często wspominana przez AI, a źródła z nią związane są przy tym regularnie używane.',
            highVisMidCoverage:
              'AI często wspomina o marce {{brand}}, choć tylko w części tych odpowiedzi opiera się przy tym na jej własnych źródłach.',
            highVisLowCoverage:
              'AI często wspomina o marce {{brand}}, ale rzadko opiera się przy tym na jej własnych źródłach.',
            lowVisHighCoverage:
              'Marka {{brand}} pojawia się w odpowiedziach AI dość rzadko, a gdy się pojawia, często towarzyszy temu cytowanie jej własnego źródła.',
            lowVisMidCoverage:
              'Marka {{brand}} pojawia się w odpowiedziach AI dość rzadko i tylko w części tych odpowiedzi wymieniane są jej własne źródła.',
            lowVisLowCoverage:
              'Marka {{brand}} pojawia się w odpowiedziach AI dość rzadko, a gdy się pojawia, rzadko towarzyszy temu cytowanie jej własnego źródła.',
            coverage: 'W {{coverage}}% odpowiedzi z marką w źródłach pojawia się jej własna domena.',
          },
        },
        platforms: {
          title: 'Luka per platforma AI',
          tooltip:
            'Per platforma AI: jak często analizowana marka jest widoczna w odpowiedziach, a jak często jej domena jest cytowana jako źródło. Duża luka oznacza, że platforma mówi o marce, nie korzystając z jej strony. Kliknij nagłówek kolumny, aby posortować.',
          colPlatform: 'Platforma',
          colVisibility: 'Widoczność',
          colCited: 'Cytowana',
          colGap: 'Luka',
          gapValue: '{{value}} pp',
          legendVisibility: 'Widoczność marki',
          legendCited: 'Cytowana jako źródło',
        },
        timeSeries: {
          title: 'Widoczność vs. cytowania w czasie',
          tooltip:
            'Jak często AI wspomina analizowaną markę, a jak często cytuje jej domenę - w podziale na okresy w wybranym zakresie.',
          legendVisibility: 'Widoczność marki',
          legendCited: 'Cytowana jako źródło',
        },
        funnel: {
          title: 'Od widoczności marki do Top 1',
          tooltip:
            'Lejek na wspólnym mianowniku wszystkich odpowiedzi AI: w ilu marka w ogóle występuje, w ilu jest w top 3, a w ilu jest rekomendacją nr 1.',
          rowVisibility: 'Widoczność marki',
          rowTop3: 'Top 3',
          rowTop1: 'Top 1',
        },
        funnelOverTime: {
          title: 'Lejek w czasie',
          tooltip:
            'Jak lejek zmienia się w czasie: odsetek wszystkich odpowiedzi AI, w których analizowana marka w ogóle występuje, jest w top 3 i jest rekomendacją nr 1 - w podziale na okresy w wybranym zakresie.',
        },
        competitorFunnelOverTime: {
          title: 'Lejek konkurencji w czasie',
          tooltip:
            'Jak wybrane marki wypadają w czasie na jednym etapie lejka: odsetek wszystkich odpowiedzi AI w danym okresie, w których marka występuje, jest w top 3 albo jest rekomendacją nr 1. Marki i etap wybierasz nad wykresem.',
        },
        funnelVsCompetitors: {
          title: 'Lejek na tle konkurencji',
          tooltip:
            'Widoczność marki, Top 3 i Top 1 per marka - wszystko na wspólnym mianowniku wszystkich odpowiedzi AI w zakresie.',
          legendVisibility: 'Widoczność marki',
          legendTop3: 'Top 3',
          legendTop1: 'Top 1',
        },
        competitorComparison: {
          title: 'Porównanie z konkurencją',
          tooltip:
            'Wybrane marki obok siebie: odsetek wszystkich odpowiedzi AI w zakresie, w których marka występuje, a odsetek, w których jej domena jest cytowana jako źródło. Luka to różnica w punktach procentowych. Kliknij nagłówek kolumny, aby posortować.',
          colBrand: 'Marka',
          colVisibility: 'Widoczność',
          colCited: 'Cytowana',
          colGap: 'Luka',
          gapValue: '{{value}} pp',
          legendVisibility: 'Widoczność marki',
          legendCited: 'Cytowana jako źródło',
        },
        brandPicker: {
          trigger: 'Marki',
        },
        promptMatrix: {
          title: 'Widoczność marki per prompt',
          tooltip:
            'Per prompt i marka: odsetek odpowiedzi AI danego promptu, w których marka występuje, jest w top 3, jest rekomendacją nr 1 albo jej domena jest cytowana jako źródło. Kreska oznacza, że domeny marki nie są znane. Intensywność komórki odpowiada wartości.',
          promptHeader: 'Prompt',
          metricVisibility: 'Widoczność',
          metricTop3: 'Top 3',
          metricTop1: 'Top 1',
          metricCited: 'Cytowana',
        },
        competitivePositioning: {
          title: 'Pozycjonowanie konkurencyjne',
          tooltip:
            'Mapa marek według udziału głosu i sentymentu, pokazująca ich pozycję względem konkurencji w odpowiedziach generowanych przez AI.',
          xAxis: 'Wskaźnik rekomendacji (% promptów w top 3)',
          yAxis: 'Jakość pozycji top (% top-3 na #1)',
          xAxisTooltip: 'Wskaźnik rekomendacji',
          yAxisTooltip: 'Jakość pozycji top',
          quadrant: {
            topLeft: 'SPECJALISTA',
            topRight: 'TOP OF MIND',
            bottomLeft: 'WSCHODZĄCY',
            bottomRight: 'W GRZE',
          },
          series: {
            yourBrand: 'Twoja marka',
            competitors: 'Konkurenci',
          },
          view: {
            matrix: 'Matrix',
            trend: 'Trend',
          },
        },
        sourceBrandCoverage: {
          title: 'Pokrycie marek w źródłach',
          tooltip:
            'Pokazuje, z jakich źródeł AI buduje widoczność konkurencji i gdzie Twoja marka jest niedoreprezentowana.',
          columns: {
            source: 'Źródło',
            total: 'Suma',
          },
        },
      },
      paymentSuspended: 'Płatność zawieszona',
      paymentSuspendedInfo: 'Płatności konta są zawieszone - zmiany rozliczeniowe są wyłączone',
      paymentSuspendedSubscriptionInfo:
        'Płatność jest zawieszona. Zmiany subskrypcji i rozliczeń są obecnie niedostępne.',
      apiIntegration: 'Integracja API',
      apiClientName: 'Nazwa klienta API',
      apiExternalAccountId: 'ID Zewnętrznego Konta API',
      apiExternalAccountSettings: 'Ustawienia Zewnętrznego Konta API',
      loginAsUser: 'Zaloguj jako użytkownik',
      impersonatingAs: 'Jesteś zalogowany jako: {{email}}',
      returnToAdmin: 'Powrót do admina',
      onlyCanceledAccounts: 'Tylko anulowane konta',
      apiAccounts: 'Konta API',
      organicAccounts: 'Konta organiczne',
      csAssistedAccounts: 'CS assisted',
      csAssistedBrand24Accounts: 'CS assisted (Brand24)',
      allAccounts: 'Wszystkie konta',
      accountType: 'Typ konta',
      accountStatus: 'Status',
      allAccountTypes: 'Wszystkie typy',
      allStatuses: 'Wszystkie statusy',
      checklists: 'Rekomendacje GEO',
      'geoChecklist.title': 'Rekomendacje GEO',
      'geoChecklist.subtitle': 'Twój plan działania na widoczność w AI',
      'geoChecklist.tabs.topicsPrompts': 'Topics & Prompts',
      'geoChecklist.tabs.aiVisibility': 'AI Visibility',
      'geoChecklist.tabs.aiVisibilityV2': 'AI Visibility V2',
      'geoChecklist.pb.tasksCompleted': 'ukończonych zadań',
      'geoChecklist.pb.estimatedIncrease': 'Szacowany wzrost',
      'geoChecklist.pb.estimatedIncreaseDesc': 'ruchu z AI w ciągu 6 miesięcy',
      'geoChecklist.pb.actionPlanProgress': 'Twój postęp planu działania',
      'geoChecklist.pb.of': 'z',
      'geoChecklist.pb.actionPlanHint':
        'Wykonaj poniższe rekomendowane działania, aby zwiększyć widoczność Twojej marki na platformach AI oraz zdobyć więcej wzmianek, ruchu i zaufania.',
      'geoChecklist.pb.aiAnswersTitle': 'Jak sprawić, by AI polecała Twoją markę',
      'geoChecklist.pb.aiAnswersBody':
        'Wyszukiwanie przenosi się do AI. To ChatGPT, Claude i Gemini decydują o tym, jak miliony ludzi odkrywają marki. Zadbaj o to, jak prezentują Twoją.',
      'geoChecklist.pb.impact.high': 'Wysoki wpływ',
      'geoChecklist.pb.impact.medium': 'Średni wpływ',
      'geoChecklist.pb.impact.low': 'Niski wpływ',
      'geoChecklist.pb.filterAll': 'Wszystkie',
      'geoChecklist.progress': 'Postęp',
      'geoChecklist.completed': 'Wykonane',
      'geoChecklist.selectAll': 'Zaznacz wszystkie zadania w tej sekcji',
      'geoChecklist.learnMore': 'Dowiedz się więcej',
      'geoChecklist.downloadPdf': 'Pobierz PDF',
      'geoChecklist.pdfGenerating': 'Generowanie PDF...',
      'geoChecklist.resetChecklist': 'Resetuj checklistę',
      'geoChecklist.resetConfirmTitle': 'Resetuj checklistę',
      'geoChecklist.resetConfirmMessage':
        'Czy na pewno chcesz zresetować wszystkie zadania w tej checkliście? Tej operacji nie można cofnąć.',
      'geoChecklist.resetConfirmYes': 'Tak, resetuj',
      'geoChecklist.resetConfirmNo': 'Anuluj',
      'geoChecklist.chart.yAxis': 'Próby i ruch',
      'geoChecklist.chart.trials': 'Próby',
      'geoChecklist.chart.traffic': 'Ruch',
      'geoChecklist.tp.introTitle': 'Monitoring Topics & Prompts',
      'geoChecklist.tp.introSubtitle': 'Szybka checklista od chatbeat',
      'geoChecklist.tp.introDesc':
        'Praktyczny przewodnik zamieniający "powinniśmy to monitorować" w jasny, powtarzalny proces. Ta checklista jest przeznaczona dla zespołów, które rozumieją znaczenie monitorowania Topics & Prompts, ale nie wiedzą od czego zacząć, co uwzględnić i jak to ustrukturyzować.',
      'geoChecklist.tp.introHelper': 'Zamiast zgadywać, ten framework pomoże Ci:',
      'geoChecklist.tp.introBullet1': 'myśleć w kategoriach tematów, nie pojedynczych fraz',
      'geoChecklist.tp.introBullet2': 'mapować rzeczywiste intencje użytkowników na prompty',
      'geoChecklist.tp.introBullet3': 'budować zarządzalny, skalowalny system monitoringu',
      'geoChecklist.tp.introBullet4': 'ciągle ulepszać wyniki na podstawie prawdziwych danych',
      'geoChecklist.tp.introFooter':
        'Użyj jako punkt startowy, weryfikację lub powtarzalny wewnętrzny standard.',
      'geoChecklist.av.introTitle': 'Rekomendacje GEO',
      'geoChecklist.av.introSubtitle': 'Twój plan działania na widoczność w AI',
      'geoChecklist.av.introDesc':
        'ChatGPT stał się dominującą platformą z ponad 1,4 miliarda wizyt miesięcznie i rewolucjonizuje sposób, w jaki użytkownicy odkrywają marki i produkty. Dowiedz się, jak wykorzystaliśmy jego potencjał, aby przejść od 0 do 10 000 nowych użytkowników i jak możesz pozycjonować swoją markę w tym krajobrazie napędzanym przez AI.',
      'geoChecklist.av.introHelper': 'Kluczowe wnioski',
      'geoChecklist.av.introFooter':
        'Jesteśmy w środku największej zmiany technologicznej od lat - po raz pierwszy dominacja Google w wyszukiwaniu (90%+) słabnie.\n\nTo tworzy zarówno ryzyko, jak i ogromną szansę: Twoja marka może teraz dotrzeć do milionów przez ChatGPT, Claude, Gemini i inne modele AI. I nawet jeśli wydają się "czarną skrzynką", możesz wpływać na to, jak prezentują Twoją markę.\n\nNam się udało - oto jak rósł nasz ruch z ChatGPT.com w ostatnich miesiącach.',
      'geoChecklist.av.introFooter2': 'Wzrost ruchu Brand24.com z ChatGPT.com w 2025/2026',
      'geoChecklist.av.kt1.title': 'Google traci kliki',
      'geoChecklist.av.kt1.desc': 'AI Overviews zabijają ruch organiczny. ChatGPT kradnie uwagę.',
      'geoChecklist.av.kt2.title': 'Ranking Twojej marki to nie przypadek',
      'geoChecklist.av.kt2.desc':
        'Możesz wpływać na widoczność w AI poprzez wzmianki o marce i ulepszenia techniczne strony.',
      'geoChecklist.av.kt3.title': 'Otwórz stronę dla crawlerów i botów',
      'geoChecklist.av.kt3.desc':
        'Chcesz rankować w AI? Pozwól OpenAI i Perplexity crawlować Twoją stronę. Zablokuj dostęp i pozostań niewidoczny.',
      'geoChecklist.av.kt4.title': 'Włącz trenowanie AI na transkryptach YouTube',
      'geoChecklist.av.kt4.desc':
        'LLM-y mocno polegają na aktualnych transkryptach, a YouTube jest jednym z najbardziej ustrukturyzowanych i zaufanych źródeł contentu.',
      'geoChecklist.av.kt5.title': 'Źródła kształtujące odpowiedzi AI',
      'geoChecklist.av.kt5.desc':
        'Zobacz, które domeny i strony faktycznie wpływają na to, jak modele AI rekomendują marki i gdzie się pojawić, aby poprawić widoczność.',
      'geoChecklist.av.kt6.title': 'Wzmianki = paliwo AI',
      'geoChecklist.av.kt6.desc':
        'Najczęściej wymieniane marki uzyskują do 10\u00d7 większą widoczność w podsumowaniach AI. Kluczem są jednak jakościowe wzmianki.',
      'geoChecklist.av.kt7.title': 'Reddit to nowy plac zabaw PR',
      'geoChecklist.av.kt7.desc': 'LLM-y żywią się Redditem. Bądź obecny. Bądź pomocny. Bądź cytowany.',
      'geoChecklist.av.kt8.title': 'Content bez struktury jest niewidoczny',
      'geoChecklist.av.kt8.desc':
        'Bałagan na stronach myli AI. Używaj schematów. Podsumowań. Struktury. Albo zostań zignorowany.',
      'geoChecklist.av.kt9.title': 'Nie pomijaj podstaw SEO',
      'geoChecklist.av.kt9.desc': 'Tradycyjne SEO to fundament LLM SEO / GAIO / GEO',
      'geoChecklist.av.kt10.title': 'Twoja marka jest oceniana',
      'geoChecklist.av.kt10.desc':
        'LLM-y czytają Twoje recenzje, biografie, Wikipedię, Crunchbase, G2 Crowd, Trustpilot i inne. Kontroluj narrację.',
      'geoChecklist.av.kt11.title': 'ChatGPT czyta YouTube',
      'geoChecklist.av.kt11.desc':
        'Nawet kanał z niewielką liczbą subskrybentów może być cytowany - jeśli content jest dobry i ma transkrypcję.',
      'geoChecklist.av.kt12.title': 'Możesz zbudować własnego GPT',
      'geoChecklist.av.kt12.desc':
        'Po co czekać na odkrycie? Wytrenuj własnego brandowego GPT i bądź źródłem.',
      'geoChecklist.av.kt13.title': 'Wolne strony zabijają szanse',
      'geoChecklist.av.kt13.desc':
        'Jeśli strona laguje lub użytkownicy odbijają, LLM-y to zauważają. Optymalizuj albo zostań zdegradowany.',
      'geoChecklist.av.kt14.title': 'Prawdziwe wzmianki > backlinki',
      'geoChecklist.av.kt14.desc':
        'W świecie AI nie chodzi o to, kto do Ciebie linkuje - chodzi o to, kto o Tobie mówi.',
      'geoChecklist.av.kt15.title': 'Agent Mode to Twoja tajna broń',
      'geoChecklist.av.kt15.desc':
        'Uruchom Deep Research w ChatGPT, aby crawlować Twój content. Tak, możesz wymusić indeksowanie.',
      'geoChecklist.av.kt16.title': 'Przestań spamować, zacznij rozwiązywać',
      'geoChecklist.av.kt16.desc':
        'AI obserwuje jak zachowujesz się online. Spamerskie posty na Reddit czy Medium bardziej szkodzą niż pomagają.',
      'geoChecklist.av.kt17.title': 'Wykorzystaj narzędzia social listening',
      'geoChecklist.av.kt17.desc':
        'Śledź wzmianki za pomocą narzędzi jak Brand24, aby zobaczyć gdzie Twoja marka się pojawia, a potem angażuj się w kluczowe rozmowy, z których uczą się LLM-y.',
      'geoChecklist.section.coreTopics': 'Kluczowe tematy',
      'geoChecklist.section.promptGeneration': 'Generowanie promptów',
      'geoChecklist.section.systemUpload': 'Upload do systemu',
      'geoChecklist.section.bestPractices': 'Najlepsze praktyki',
      'geoChecklist.section.evaluationMaintenance': 'Ewaluacja i utrzymanie',
      'geoChecklist.section.accessDiscoverability': 'Dostęp i wykrywalność',
      'geoChecklist.section.accessDiscoverabilitySubtitle':
        '(Czy systemy AI mogą faktycznie uzyskać dostęp do Twojego contentu?)',
      'geoChecklist.section.contentAiUnderstanding': 'Content stworzony dla zrozumienia przez AI',
      'geoChecklist.section.contentAiUnderstandingSubtitle':
        '(Czy AI może zrozumieć i wykorzystać Twój content?)',
      'geoChecklist.section.brandSignals': 'Sygnały marki i autorytet',
      'geoChecklist.section.brandSignalsSubtitle': '(Czy AI ufa Twojej marce?)',
      'geoChecklist.section.distributionCommunity': 'Dystrybucja i społeczność',
      'geoChecklist.section.distributionCommunitySubtitle':
        '(Czy Twój content jest obecny tam, gdzie AI się uczy?)',
      'geoChecklist.section.monitoringCompetitive': 'Monitoring i analiza konkurencji',
      'geoChecklist.section.monitoringCompetitiveSubtitle': '(Czy śledzisz swoją wydajność?)',
      'geoChecklist.section.ownedAiSurfaces': 'Własne powierzchnie AI / Bezpośredni wpływ',
      'geoChecklist.section.ownedAiSurfacesSubtitle': '(Czy możesz wpływać na AI bezpośrednio?)',
      'geoChecklist.task.tp_1_1.title':
        'Zdefiniuj kluczowe tematy obejmujące wszystkie obszary marki i branży',
      'geoChecklist.task.tp_1_2.title': 'Uwzględnij tematy produktów/usług',
      'geoChecklist.task.tp_1_2.example1': 'Project management software',
      'geoChecklist.task.tp_1_2.example2': 'Online grocery delivery',
      'geoChecklist.task.tp_1_2.example3': 'Skincare products',
      'geoChecklist.task.tp_1_3.title': 'Uwzględnij potrzeby klientów / przypadki użycia',
      'geoChecklist.task.tp_1_3.example1': 'Remote team collaboration tools',
      'geoChecklist.task.tp_1_3.example2': 'Where to order groceries in under an hour',
      'geoChecklist.task.tp_1_3.example3': 'Face cream for sensitive skin',
      'geoChecklist.task.tp_1_4.title': 'Uwzględnij trendy i tematy branżowe',
      'geoChecklist.task.tp_1_4.example1': 'AI in workplace productivity',
      'geoChecklist.task.tp_1_4.example2': 'Sustainable packaging',
      'geoChecklist.task.tp_1_4.example3': 'Quick commerce growth',
      'geoChecklist.task.tp_1_5.title': 'Uwzględnij konkurentów / alternatywy',
      'geoChecklist.task.tp_1_5.example1': 'Company vs Company',
      'geoChecklist.task.tp_1_5.example2': 'Alternatives to Instacart',
      'geoChecklist.task.tp_1_5.example3': 'Alternatives to Sephora',
      'geoChecklist.task.tp_1_6.title': 'Uwzględnij regiony i języki',
      'geoChecklist.task.tp_1_7.title': 'Zacznij od 5–10 szerokich tematów',
      'geoChecklist.task.tp_2_1.title': 'Wygeneruj 5–10 promptów na temat',
      'geoChecklist.task.tp_2_2.title':
        'Uwzględnij różne typy promptów: informacyjne, porównawcze, problemowe, transakcyjne',
      'geoChecklist.task.tp_2_2.example1': 'Informational: "What is project management software?"',
      'geoChecklist.task.tp_2_2.example2': 'Comparative: "Best project management software vs Trello"',
      'geoChecklist.task.tp_2_2.example3':
        'Problem-solving: "How to track deadlines in project management software?"',
      'geoChecklist.task.tp_2_2.example4':
        'Transactional: "Where to buy affordable project management tools?"',
      'geoChecklist.task.tp_2_3.title': 'Używaj naturalnego języka użytkowników',
      'geoChecklist.task.tp_2_4.title': 'Wykorzystaj wewnętrzne FAQ / dane supportu',
      'geoChecklist.task.tp_2_4.description':
        'Przykład: FAQ: "Czy narzędzie integruje się ze Slack?" → Prompt: "Czy oprogramowanie do zarządzania projektami integruje się ze Slack?"',
      'geoChecklist.task.tp_2_5.title':
        'Regularnie oceniaj prompty na różnych platformach i w różnych regionach',
      'geoChecklist.task.tp_3_1.title':
        'Dodaj prompty do platformy monitoringu/analityki jak Chatbeat i Brand24',
      'geoChecklist.task.tp_3_2.title': 'Sprawdź wyniki po 24–48 godzinach',
      'geoChecklist.task.tp_4_1.title': 'Myśl w kategoriach tematów, nie pojedynczych słów kluczowych',
      'geoChecklist.task.tp_4_1.description':
        'Zamiast śledzić "tanie loty", stwórz projekt "Ceny i oferty lotów"',
      'geoChecklist.task.tp_4_2.title':
        'Skup się na intencji użytkownika (pełne zdania, naturalne pytania)',
      'geoChecklist.task.tp_4_2.description':
        'Lepiej: "Jaki jest najlepszy sposób na znalezienie tanich lotów do Europy?" Mniej skuteczne: "tanie loty Europa"',
      'geoChecklist.task.tp_4_3.title': 'Priorytetyzuj trafność nad ilością',
      'geoChecklist.task.tp_4_3.description':
        'Lepiej: "Która strona turystyczna ma najdokładniejsze recenzje hoteli?" Mniej skuteczne: "Dobre strony z recenzjami hoteli"',
      'geoChecklist.task.tp_5_1.title': 'Regularnie przeglądaj i aktualizuj prompty',
      'geoChecklist.task.tp_5_2.title': 'Dodaj nowe tematy/prompty w miarę zmiany potrzeb',
      'geoChecklist.task.tp_5_3.title': 'Optymalizuj zestaw promptów na podstawie wyników monitoringu',
      'geoChecklist.task.av_1_1.title': 'Odblokuj crawlery AI',
      'geoChecklist.task.av_1_1.description':
        'Upewnij się, że crawlery AI - takie jak OpenAI, Anthropic, Google, Perplexity i Microsoft - mają dostęp do Twojej strony. Zablokowane crawlery nie mogą odkryć ani pobrać Twojego contentu.',
      'geoChecklist.task.av_1_2.title': 'Wdróż llms.txt',
      'geoChecklist.task.av_1_2.description':
        'Utwórz plik llms.txt, aby wyróżnić swój najcenniejszy content i wskazać systemom AI łatwiejszą ścieżkę do najważniejszych stron i dokumentacji.',
      'geoChecklist.task.av_1_3.title': 'Zadbaj o czytelność contentu dla AI',
      'geoChecklist.task.av_1_3.description':
        'Modele AI przetwarzają przede wszystkim HTML, a nie warstwę wizualną. Zadbaj, aby najważniejsze informacje były dostępne w czystym, ustrukturyzowanym HTML, zamiast polegać na JavaScripcie, obrazach czy elementach interaktywnych.',
      'geoChecklist.task.av_1_4.title': 'Trzymaj ważny content publicznie dostępny',
      'geoChecklist.task.av_1_4.description':
        'Zadbaj, aby najcenniejsze strony były dostępne bez logowania i paywalla, tak by modele AI mogły je pobrać i się do nich odwoływać.',
      'geoChecklist.task.av_1_5.title': 'Popraw strukturę swojej strony',
      'geoChecklist.task.av_1_5.description':
        'Uporządkuj stronę z logiczną nawigacją, linkowaniem wewnętrznym, opisowymi nagłówkami i czytelną hierarchią, aby systemy AI lepiej rozumiały zależności między tematami.',
      'geoChecklist.task.av_1_6.title': 'Utrzymuj szybką i niezawodną stronę',
      'geoChecklist.task.av_1_6.description':
        'Popraw szybkość ładowania, niezawodność i kondycję techniczną. Wolne lub niestabilne strony są crawlowane mniej efektywnie i oferują gorsze doświadczenie zarówno użytkownikom, jak i systemom AI.',
      'geoChecklist.task.av_1_7.title': 'Przyspiesz odkrywanie treści',
      'geoChecklist.task.av_1_7.description':
        'Pomóż AI szybciej odkrywać nowy lub zaktualizowany content - utrzymuj mapy witryny, publikuj regularnie świeże treści i zdobywaj linki z często crawlowanych stron.',
      'geoChecklist.task.av_2_1.title': 'Odpowiadaj na prawdziwe pytania użytkowników',
      'geoChecklist.task.av_2_1.description':
        'Twórz content, który wprost odpowiada na pytania zadawane przez Twoich klientów. Skup się na rozwiązywaniu realnych problemów, zamiast publikować ogólne artykuły marketingowe.',
      'geoChecklist.task.av_2_2.title': 'Dodaj podsumowania, które AI może wykorzystać',
      'geoChecklist.task.av_2_2.description':
        'Umieszczaj zwięzłe podsumowania, kluczowe wnioski i konkluzje, które modele AI łatwo zrozumieją, wyodrębnią i wykorzystają w generowanych odpowiedziach.',
      'geoChecklist.task.av_2_3.title': 'Strukturyzuj content pod AI',
      'geoChecklist.task.av_2_3.description':
        'Organizuj content za pomocą opisowych nagłówków, krótkich akapitów, list i tabel, aby zarówno użytkownicy, jak i modele AI szybko rozumieli informacje.',
      'geoChecklist.task.av_2_4.title': 'Pokrywaj tematy kompleksowo',
      'geoChecklist.task.av_2_4.description':
        'Omawiaj temat z wielu perspektyw - definicje, przypadki użycia, porównania, FAQ i praktyczne przykłady - aby stać się najbardziej kompletnym źródłem.',
      'geoChecklist.task.av_2_5.title': 'Pisz prostym językiem',
      'geoChecklist.task.av_2_5.description':
        'Unikaj zbędnego żargonu i nadmiernie skomplikowanego słownictwa. Jasny język ułatwia zrozumienie contentu zarówno użytkownikom, jak i modelom AI.',
      'geoChecklist.task.av_2_6.title': 'Twórz content porównawczy',
      'geoChecklist.task.av_2_6.description':
        'Publikuj strony porównawcze, „alternatywy”, „versus” oraz „najlepsze”, które pomagają klientom oceniać opcje w trakcie zakupu i zwiększają szansę na rekomendację przez AI.',
      'geoChecklist.task.av_2_7.title': 'Jasno wyjaśnij swoją markę',
      'geoChecklist.task.av_2_7.description':
        'Jasno opisz, czym zajmuje się Twoja firma, komu służy i czym różni się od konkurencji, aby modele AI mogły trafnie sklasyfikować i rekomendować Twoją markę.',
      'geoChecklist.task.av_2_8.title': 'Optymalizuj pod wybór przez AI',
      'geoChecklist.task.av_2_8.description':
        'Modele AI nie cytują każdej znalezionej strony. Twórz wiarygodny, dobrze ustrukturyzowany i kompleksowy content, który zasługuje na wybór i rekomendację.',
      'geoChecklist.task.av_3_1.title': 'Buduj rozpoznawalną markę',
      'geoChecklist.task.av_3_1.description':
        'Zwiększaj widoczność swojej marki w sieci. Modele AI chętniej rekomendują marki, które są konsekwentnie wspominane i rozpoznawalne w swojej kategorii.',
      'geoChecklist.task.av_3_2.title': 'Zdobywaj wzmianki na zaufanych stronach',
      'geoChecklist.task.av_3_2.description':
        'Zwiększaj swoją obecność w autorytatywnych publikacjach, na branżowych stronach, w społecznościach i zaufanych mediach, z których modele AI często korzystają jako ze źródeł informacji.',
      'geoChecklist.task.av_3_3.title': 'Zdobywaj rekomendacje, nie tylko wzmianki',
      'geoChecklist.task.av_3_3.description':
        'Skup się na treści i pozycjonowaniu marki, które skłaniają zewnętrzne źródła do aktywnego rekomendowania Twoich produktów lub usług, a nie tylko wspominania o firmie.',
      'geoChecklist.task.av_3_4.title': 'Buduj silne sygnały z recenzji',
      'geoChecklist.task.av_3_4.description':
        'Zachęcaj do autentycznych recenzji klientów i aktywnie zarządzaj reputacją online. Modele AI często uwzględniają jakość recenzji i ogólny sentyment przy generowaniu rekomendacji.',
      'geoChecklist.task.av_3_5.title': 'Utrzymuj spójny przekaz marki',
      'geoChecklist.task.av_3_5.description':
        'Stosuj spójne opisy, pozycjonowanie, terminologię i propozycje wartości na swojej stronie i w źródłach zewnętrznych, aby modele AI otrzymywały jasne i wiarygodne sygnały.',
      'geoChecklist.task.av_3_6.title': 'Utrzymuj profile firmowe aktualne',
      'geoChecklist.task.av_3_6.description':
        'Regularnie aktualizuj informacje o firmie w katalogach, panelach wiedzy, profilach społecznościowych i wizytówkach, aby dostarczać modelom AI dokładnych i spójnych danych.',
      'geoChecklist.task.av_4_1.title': 'Publikuj poza swoją stroną',
      'geoChecklist.task.av_4_1.description':
        'Zwiększaj widoczność w sieci, publikując wartościowy content na platformach, które modele AI często crawlują, cytują i z których się uczą - nie tylko na własnej stronie.',
      'geoChecklist.task.av_4_2.title': 'Uczestnicz w dyskusjach branżowych',
      'geoChecklist.task.av_4_2.description':
        'Angażuj się w istotne społeczności, takie jak Reddit, LinkedIn, GitHub, Quora, fora i grupy branżowe. Modele AI coraz częściej uczą się z autentycznych rozmów i dyskusji ekspertów.',
      'geoChecklist.task.av_4_3.title': 'Przerabiaj swój najlepszy content',
      'geoChecklist.task.av_4_3.description':
        'Adaptuj wartościowy content do wielu formatów - wpisów blogowych, wideo, prezentacji, newsletterów i postów społecznościowych - aby poszerzyć swój ślad widoczności w AI.',
      'geoChecklist.task.av_4_4.title': 'Wykorzystuj YouTube z transkrypcjami',
      'geoChecklist.task.av_4_4.description':
        'Publikuj filmy edukacyjne z wysokiej jakości transkrypcjami. Modele AI coraz częściej korzystają z contentu i transkrypcji z YouTube, aby rozumieć tematy, marki i ekspertyzę.',
      'geoChecklist.task.av_5_1.title': 'Zweryfikuj swoją widoczność w AI',
      'geoChecklist.task.av_5_1.description':
        'Sprawdź, czy Twoja marka faktycznie pojawia się w odpowiedziach generowanych przez AI, gdy potencjalni klienci zadają pytania o Twoją kategorię, produkty lub usługi. Nie zakładaj - zweryfikuj to na realnych odpowiedziach AI.',
      'geoChecklist.task.av_5_2.title': 'Monitoruj pozycję i kontekst, nie tylko wzmianki',
      'geoChecklist.task.av_5_2.description':
        'Sama widoczność nie wystarczy. Mierz, gdzie Twoja marka pojawia się w rekomendacjach AI i jak jest opisywana. Czy jest pozycjonowana jako lider kategorii, rozwiązanie premium, czy tylko wspomniana wśród wielu alternatyw?',
      'geoChecklist.task.av_5_3.title': 'Zidentyfikuj źródła wpływające na AI',
      'geoChecklist.task.av_5_3.description':
        'Zrozum, jakie strony, społeczności, recenzje, dokumentacja i media są wykorzystywane przez różne modele AI do generowania odpowiedzi. Porównaj wykorzystanie źródeł między modelami i znajdź miejsca, w których Twoja marka jest niedoreprezentowana w porównaniu z konkurencją.',
      'geoChecklist.task.av_5_4.title': 'Porównaj, jak modele AI rekomendują marki',
      'geoChecklist.task.av_5_4.description':
        'Każdy model AI inaczej pozyskuje, klasyfikuje i cytuje informacje. Monitoruj ChatGPT, Gemini, Claude, Perplexity, Copilot i inne osobno, aby zrozumieć, gdzie Twoja widoczność jest najsilniejsza, a gdzie wymaga optymalizacji.',
      'geoChecklist.task.av_5_5.title': 'Mierz ruch napędzany przez AI',
      'geoChecklist.task.av_5_5.description':
        'Śledź, jak widoczność w AI przekłada się na realny wpływ biznesowy, monitorując ruch z poleceń AI obok zmian w pozycjach i rekomendacjach.',
      'geoChecklist.task.av_5_6.title': 'Priorytetyzuj prompty o wysokiej intencji',
      'geoChecklist.task.av_5_6.description':
        'Skup się na promptach, które wpływają na decyzje zakupowe. Korzystaj z Sugerowanych Promptów opartych na realnych wyszukiwaniach użytkowników lub monitoruj zapytania z etapu decyzji - o ceny, funkcje, alternatywy, porównania, integracje, recenzje i dostępność.',
      'geoChecklist.task.av_5_7.title': 'Porównuj się z konkurencją',
      'geoChecklist.task.av_5_7.description':
        'Porównuj swoją widoczność w AI z konkurencją. Analizuj, które marki są rekomendowane częściej, pojawiają się na wyższych pozycjach i dominują w ważnych zapytaniach klientów.',
      'geoChecklist.task.av_5_8.title': 'Znajdź luki w widoczności',
      'geoChecklist.task.av_5_8.description':
        'Zidentyfikuj prompty, w których rekomendowana jest konkurencja, a Twojej marki brakuje. Następnie przeanalizuj, które źródła wspominają konkurencję, ale nie Twoją markę, aby odkryć możliwości contentowe o największym wpływie.',
      'geoChecklist.task.av_5_9.title': 'Buduj ciągłą pętlę optymalizacji',
      'geoChecklist.task.av_5_9.description':
        'AI Search nieustannie się zmienia. Pojawiają się nowe źródła, zmieniają się pozycje, ewoluują modele. Regularnie monitoruj widoczność, wdrażaj usprawnienia, mierz wyniki i powtarzaj ten proces w sposób ciągły.',
      'geoChecklist.task.av_6_1.title': 'Stwórz własnego asystenta AI',
      'geoChecklist.task.av_6_1.description':
        'Zbuduj Custom GPT lub asystenta AI, który pomoże klientom odkryć Twoje produkty, usługi, dokumentację i ekspertyzę bezpośrednio na platformach AI.',
      'geoChecklist.task.av_6_2.title': 'Dostarczaj ustrukturyzowaną wiedzę',
      'geoChecklist.task.av_6_2.description':
        'Organizuj informacje o produktach, dokumentację, FAQ, API i materiały wsparcia w ustrukturyzowanych formatach, które systemy AI mogą łatwo pobrać i zrozumieć.',
      'geoChecklist.task.av_6_3.title': 'Przyspiesz odkrywanie przez AI',
      'geoChecklist.task.av_6_3.description':
        'Aktywnie zgłaszaj i promuj nowy content kanałami, które pomagają systemom AI szybciej odkrywać aktualizacje, zamiast czekać, aż zostaną zcrawlowane naturalnie.',
      'geoChecklist.task.tp_1_1.instruction':
        'Zdefiniuj główne filary tematów dla marki i branży. Uwzględnij kontekst klienta, intencje i priorytety biznesowe przed budową promptów.',
      'geoChecklist.task.tp_1_2.instruction':
        'Utwórz oddzielną grupę tematów dla każdej linii produktu lub usługi. Dodaj synonimy i warianty nazewnictwa używane przez użytkowników.',
      'geoChecklist.task.tp_1_3.instruction':
        'Przełóż potrzeby i problemy klientów na grupy tematów. Używaj języka odzwierciedlającego realne cele użytkownika.',
      'geoChecklist.task.tp_1_4.instruction':
        'Dodaj trendy rynkowe wpływające na decyzje zakupowe. Regularnie aktualizuj tę listę, aby prompty były aktualne.',
      'geoChecklist.task.tp_1_5.instruction':
        'Śledź tematy konkurencyjne i alternatywy wprost. To pokazuje, gdzie marka pojawia się lub znika w odpowiedziach porównawczych.',
      'geoChecklist.task.tp_1_6.instruction':
        'Rozdziel tematy wg regionów i języków, gdy intencje się różnią. Lokalny kontekst zmienia frazowanie i zestaw konkurentów.',
      'geoChecklist.task.tp_1_7.instruction':
        'Zacznij od małej, kontrolowanej puli szerokich tematów. Najpierw sprawdź jakość, potem skaluj.',
      'geoChecklist.task.tp_2_1.instruction':
        'Generuj wiele promptów na temat, aby pokryć różne sposoby zadawania pytań. Każdy prompt powinien być konkretny i porównywalny w czasie.',
      'geoChecklist.task.tp_2_2.instruction':
        'Celowo zbalansuj typy promptów. Łącz intencje informacyjne, porównawcze, problemowe i transakcyjne.',
      'geoChecklist.task.tp_2_3.instruction':
        'Pisz prompty naturalnym językiem, a nie zbitkami słów kluczowych. Preferuj pełne pytania.',
      'geoChecklist.task.tp_2_4.instruction':
        'Wykorzystaj zgłoszenia supportu i FAQ jako źródło promptów. Priorytetyzuj powtarzalne pytania użytkowników.',
      'geoChecklist.task.tp_2_5.instruction':
        'Oceniaj jakość promptów na poziomie platformy, modelu i regionu. Usuwaj słabe prompty i poprawiaj sformułowania.',
      'geoChecklist.task.tp_3_1.instruction':
        'Załaduj pełny zestaw promptów do platformy monitoringu. Wprowadź spójne nazewnictwo tematów, intencji i rynków.',
      'geoChecklist.task.tp_3_2.instruction':
        'Sprawdź pierwsze wyniki po 24–48 godzinach. To pozwala szybko wykryć luki w indeksacji i słabe prompty.',
      'geoChecklist.task.tp_4_1.instruction':
        'Buduj monitoring na klastrach tematycznych, a nie pojedynczych frazach. Daje to lepsze pokrycie realnych ścieżek użytkownika.',
      'geoChecklist.task.tp_4_2.instruction':
        'Optymalizuj prompty pod kątem jednoznacznej intencji. Jeśli prompt jest wieloznaczny, przepisz go na konkretną potrzebę.',
      'geoChecklist.task.tp_4_3.instruction':
        'Wybieraj mniej, ale mocniejszych promptów. Trafność poprawia jakość insightów i ogranicza szum.',
      'geoChecklist.task.tp_5_1.instruction':
        'Ustal cykliczny harmonogram przeglądu jakości promptów. Aktualizuj je wraz ze zmianą intencji i priorytetów.',
      'geoChecklist.task.tp_5_2.instruction':
        'Dodawaj nowe tematy z launchy, sezonowości i feedbacku klientów. Traktuj coverage promptów jako żywy system.',
      'geoChecklist.task.tp_5_3.instruction':
        'Iteruj na podstawie widoczności i jakości odpowiedzi. Zostawiaj to, co działa, poprawiaj lub usuwaj to, co nie działa.',
      'geoChecklist.task.av_1_1.instruction':
        'Narzędzia AI (jak ChatGPT czy Perplexity) używają botów do czytania Twojej strony. Jeśli nie mają dostępu - Twoja marka nie pojawi się w odpowiedziach.\n\nCo zrobić:\n• Zaktualizuj plik robots.txt\n• Zezwól na: GPTBot, ChatGPT-User, PerplexityBot, Google-Extended\n• Upewnij się, że nie blokują ich:\n  – Cloudflare / CDN\n  – ochrona przed botami\n  – restrykcje geograficzne\n• Sprawdź dostęp do:\n  – stron produktowych\n  – bloga\n  – landing pages\n  – centrum pomocy\n\nJak sprawdzić:\n• Przejrzyj logi serwera (czy boty odwiedziły?)\n• Użyj narzędzi do testowania crawlowania\n\nPro tip:\nWiększość zespołów „zezwala botom" - ale boty nigdy nie docierają do kluczowych stron.',
      'geoChecklist.task.av_1_2.instruction':
        'To prosty plik, który mówi AI, co jest ważne na Twojej stronie.\n\nCo uwzględnić:\n• strony produktowe\n• kluczowe artykuły blogowe\n• porównania\n• dokumentację\n\nPro tip:\nNie wymieniaj wszystkiego - podkreśl tylko najlepszy content.',
      'geoChecklist.task.av_1_3.instruction':
        'AI czyta surowy kod HTML, nie to co użytkownicy widzą na ekranie.\n\nCo zrobić:\n• Renderuj kluczowe treści po stronie serwera\n• Unikaj ukrywania contentu za JavaScriptem\n• Nie polegaj na obrazkach zamiast tekstu\n• Sprawdź, czy treść faktycznie jest widoczna w źródle\n\nPro tip:\nJeśli treść jest ukryta za JS - AI może ją zignorować.',
      'geoChecklist.task.av_1_4.instruction':
        'Co zrobić:\n• Trzymaj kluczowe strony publicznie dostępne\n• Unikaj bramkowania:\n  – porównań\n  – opisów produktów\n  – treści edukacyjnych\n\nPro tip:\nJeśli Twój content jest zablokowany, AI użyje contentu konkurencji.',
      'geoChecklist.task.av_1_5.instruction':
        'AI używa struktury Twojej strony, aby zrozumieć co jest ważne i jak strony się ze sobą łączą.\n\nCo zrobić:\n• Stosuj czytelną hierarchię nagłówków (H1 → H2 → H3)\n• Trzymaj URL-e krótkie i opisowe\n• Linkuj powiązane strony ze sobą konsekwentnie\n• Używaj breadcrumbów i menu nawigacji\n\nPro tip:\nJeśli AI nie rozumie mapy Twojej strony - nie nadpriorytyzuje Twojego contentu.',
      'geoChecklist.task.av_1_6.instruction':
        'Wolne strony są depriorytetyzowane przez crawlery. Jeśli strona ładuje się za długo, boty mogą ją pominąć.\n\nCo zrobić:\n• Optymalizuj Core Web Vitals (LCP, CLS, INP)\n• Zmniejsz czas odpowiedzi serwera (TTFB < 200ms)\n• Unikaj częstych przestojów i błędów 5xx\n\nJak sprawdzić:\n• Użyj Google PageSpeed Insights\n• Monitoruj uptime narzędziem jak UptimeRobot\n\nPro tip:\nStabilność jest ważniejsza niż szybkość - strona, która leży, nie może być zcrawlowana.',
      'geoChecklist.task.av_1_7.instruction':
        'Czasem AI nie znajdzie Twojego contentu, dopóki go nie naprowadzisz.\n\nCo zrobić:\n• Użyj ChatGPT Deep Research lub Agent Mode do eksploracji strony\n• Uruchom kontrolowane prompty odwołujące się do Twojego contentu\n• Udostępniaj treści w kontekstach aktywnie indeksowanych przez AI\n\nPro tip:\nNie czekaj, aż AI Cię odkryje - sam wywołaj odkrycie.',
      'geoChecklist.task.av_2_1.instruction':
        'Modele AI szukają bezpośrednich odpowiedzi na pytania użytkowników. Jeśli Twój content zaczyna się od ogólników, zostaje pominięty.\n\nCo zrobić:\n• Zacznij od jasnej, zwięzłej odpowiedzi\n• Dodaj kontekst poniżej\n• Używaj dokładnych sformułowań, których szuka Twoja grupa docelowa\n\nPro tip:\nNapisz odpowiedź, którą zajęta osoba skopiowałaby i wkleiła.',
      'geoChecklist.task.av_2_2.instruction':
        'AI preferuje content łatwy do wyciągnięcia i cytowania. Długie bloki tekstu bez struktury są pomijane.\n\nCo zrobić:\n• Dodaj TL;DR na początku długich artykułów\n• Dołącz sekcje z kluczowymi wnioskami\n• Używaj punktorów dla głównych konkluzji\n\nPro tip:\nJeśli Twój artykuł nie ma podsumowania - AI podsumuje artykuł konkurencji.',
      'geoChecklist.task.av_2_3.instruction':
        'Dobrze ustrukturyzowany content jest łatwiejszy do podzielenia, zindeksowania i trafnego pobrania przez AI.\n\nCo zrobić:\n• Stosuj spójną hierarchię nagłówków\n• Dziel treść na logiczne sekcje\n• Używaj list, tabel i FAQ\n• Dodawaj tabele porównawcze tam, gdzie to ma sens\n\nPro tip:\nStrona z czytelnymi sekcjami jest cytowana częściej niż ściana tekstu.',
      'geoChecklist.task.av_2_4.instruction':
        "Powierzchowny content przegrywa z kompleksowymi zasobami. AI rekomenduje najbardziej autorytatywne źródło.\n\nCo zrobić:\n• Idź w głąb swoich kluczowych tematów\n• Pokryj edge case'y i powiązane pytania\n• Dołącz oryginalne dane, przykłady lub case study\n\nPro tip:\nBądź stroną, która odpowiada na każde pytanie uzupełniające.",
      'geoChecklist.task.av_2_5.instruction':
        'Jeśli Twój content jest trudny do czytania, AI może mieć problem z wyciągnięciem sensu - albo wybierze prostsze źródło.\n\nCo zrobić:\n• Pisz na poziomie zrozumiałym dla odbiorców\n• Unikaj zbędnego żargonu\n• Definiuj terminy techniczne, gdy ich używasz\n\nPro tip:\nJasne pisanie sygnalizuje eksperckość, nie prostotę.',
      'geoChecklist.task.av_2_6.instruction':
        'Zapytania porównawcze ("X vs Y", "alternatywy dla Z") mają wysoką intencję zakupową - AI rekomenduje marki bezpośrednio.\n\nCo zrobić:\n• Twórz dedykowane strony porównawcze\n• Dołącz uczciwe za i przeciw\n• Pokryj głównych konkurentów z nazwy\n\nPro tip:\nJeśli nie stworzysz porównania - ktoś inny to zrobi.',
      'geoChecklist.task.av_2_7.instruction':
        'AI musi pewnie zaklasyfikować Twoją markę, aby ją polecić. Niejasne pozycjonowanie prowadzi do pominięcia.\n\nCo zrobić:\n• Używaj jasnego, spójnego opisu marki\n• Określ swoją kategorię wprost\n• Opisz czym się zajmujesz w jednym zdaniu\n\nPro tip:\nJeśli AI nie potrafi wyjaśnić Twojej marki w jednym zdaniu - nie poleci jej.',
      'geoChecklist.task.av_2_8.instruction':
        'AI nie używa wszystkiego co znajdzie - wybiera najlepsze. Samo zindeksowanie nie wystarczy.\n\nCo zrobić:\n• Bądź konkretny i autorytatywny\n• Dostarczaj unikalną wartość, której konkurencja nie ma\n• Popieraj twierdzenia danymi i przykładami\n\nPro tip:\nZapytaj siebie: dlaczego AI miałoby wybrać MÓJ content spośród 100 innych?',
      'geoChecklist.task.av_3_1.instruction':
        'Modele AI faworyzują marki pojawiające się często i konsekwentnie w jakościowych źródłach.\n\nCo zrobić:\n• Inwestuj w rozpoznawalność marki w wielu kanałach\n• Publikuj treści thought leadership\n• Występuj na wydarzeniach i pojawiaj się w mediach\n\nPro tip:\nSiła marki w realnym świecie = siła marki w odpowiedziach AI.',
      'geoChecklist.task.av_3_2.instruction':
        'Wzmianki ze stron trzecich to silny sygnał dla AI. Jeśli zaufane strony Cię cytują, AI też Ci ufa.\n\nCo zrobić:\n• Pojawiaj się w publikacjach branżowych\n• Pisz artykuły gościnne na odpowiednich blogach\n• Pojawiaj się w rankingach i listach "najlepszych"\n\nPro tip:\nJedna wzmianka na zaufanej stronie > 10 wzmianek na nieznanych blogach.',
      'geoChecklist.task.av_3_3.instruction':
        'Wzmianka mówi, że istniejesz. Rekomendacja mówi, że jesteś dobry. AI waży to inaczej.\n\nCo zrobić:\n• Celuj w kontekst "polecamy X, bo..."\n• Buduj case study z partnerami\n• Zachęcaj do ekspertyzach i rekomendacji\n\nPro tip:\nSame name dropy nie działają - liczą się prawdziwe rekomendacje.',
      'geoChecklist.task.av_3_4.instruction':
        'Modele AI używają sentymentu recenzji jako sygnału przy rekomendacjach.\n\nCo zrobić:\n• Aktywnie zbieraj recenzje na G2, Trustpilot, Capterra\n• Odpowiadaj na recenzje (pozytywne i negatywne)\n• Zachęcaj do szczegółowego, konkretnego feedbacku\n\nPro tip:\nProdukt z 200 recenzjami wygrywa z tym z 20 - nawet przy tej samej ocenie.',
      'geoChecklist.task.av_3_5.instruction':
        'Niespójne nazewnictwo i pozycjonowanie myli AI co do tego, kim jesteś.\n\nCo zrobić:\n• Ujednolij nazwę marki we wszystkich kanałach\n• Używaj tych samych opisów wszędzie\n• Trzymaj pozycjonowanie kategorii spójne\n\nPro tip:\nJeśli tu nazywasz się "platforma AI", a tam "narzędzie ML" - AI też się gubi.',
      'geoChecklist.task.av_3_6.instruction':
        'Modele AI pobierają dane z baz wiedzy jako źródła główne. Nieaktualne profile = nieaktualne odpowiedzi AI.\n\nCo zrobić:\n• Zaktualizuj Wikipedię, Crunchbase, LinkedIn\n• Trzymaj profile G2, Trustpilot aktualne\n• Zweryfikuj informacje w katalogach branżowych\n\nPro tip:\nTe profile są często pierwszym, co AI czyta o Twojej marce.',
      'geoChecklist.task.av_4_1.instruction':
        'Sama strona ogranicza Twój zasięg. AI crawluje wiele platform - bądź obecny tam, gdzie szuka.\n\nCo zrobić:\n• Publikuj na Medium, Substack lub blogach branżowych\n• Pisz artykuły gościnne dla odpowiednich publikacji\n• Dziel się insightami w artykułach LinkedIn\n\nPro tip:\nWięcej zindeksowanych domen wspominających o Tobie = silniejszy sygnał AI.',
      'geoChecklist.task.av_4_2.instruction':
        'Fora społecznościowe są intensywnie indeksowane przez AI. Szczere, pomocne odpowiedzi mają dużą wagę.\n\nCo zrobić:\n• Angażuj się na Reddit, Quora, Stack Overflow\n• Odpowiadaj na pytania w swojej dziedzinie\n• Bądź pomocny - nie promocyjny\n\nPro tip:\nPomocna odpowiedź na Reddit może wpłynąć na AI bardziej niż post na blogu.',
      'geoChecklist.task.av_4_3.instruction':
        'Przerabiaj jeden artykuł na:\n• posty na LinkedIn\n• wątki\n• krótkie insighty\n\nPro tip:\nWięcej formatów = więcej szans na pojawienie się.',
      'geoChecklist.task.av_4_4.instruction':
        'Co zrobić:\n• publikuj filmy edukacyjne\n• włącz trenowanie AI w YouTube Studio\n\nPro tip:\nModele AI intensywnie korzystają z transkryptów YouTube.',
      'geoChecklist.task.av_5_1.instruction':
        'Nie zoptymalizujesz tego, czego nie mierzysz. Zacznij od sprawdzenia, czy AI wie że istniejesz.\n\nCo zrobić:\n• Zapytaj ChatGPT, Claude, Gemini o swoją kategorię\n• Sprawdź, czy Twoja marka pojawia się w rekomendacjach\n• Zanotuj, gdzie się plasujesz i w jakim kontekście\n\nPro tip:\nRób to co miesiąc - odpowiedzi AI zmieniają się szybciej niż wyniki wyszukiwania.',
      'geoChecklist.task.av_5_2.instruction':
        'Samo pojawienie się w odpowiedziach AI nie wystarczy - liczy się pozycja. Pierwsza wzmianka vs pogrzebanie na dole to ogromna różnica.\n\nCo zrobić:\n• Śledź, czy jesteś wspomniany 1., 2. czy 3.+\n• Monitoruj jak Twoja pozycja zmienia się w czasie\n• Porównuj pozycję w różnych modelach AI\n\nPro tip:\nPozycja 1 zbiera większość kliknięć - tak jak w wyszukiwarce.',
      'geoChecklist.task.av_5_3.instruction':
        'AI cytuje konkretne domeny i strony. Jeśli wiesz, którym źródłom ufa, możesz je targetować.\n\nCo zrobić:\n• Zidentyfikuj domeny cytowane przez AI w Twojej kategorii\n• Celuj w te strony ze wzmiankami lub partnerstwami\n• Twórz content na platformach, którym AI już ufa\n\nPro tip:\nPojawianie się na zaufanych źródłach AI to skrót do pojawienia się w odpowiedziach.',
      'geoChecklist.task.av_5_4.instruction':
        'Każdy model AI używa innych strategii retrievalu i rankingu. Co działa dla ChatGPT, może nie działać dla Gemini.\n\nCo zrobić:\n• Testuj widoczność w ChatGPT, Claude, Gemini, Perplexity\n• Sprawdzaj, które modele cytują Twój content, a które nie\n• Dostosuj strategię pod każdy model\n\nPro tip:\nNie optymalizujesz pod "AI" - optymalizujesz pod konkretny model.',
      'geoChecklist.task.av_5_5.instruction':
        'W GA4:\n• filtruj po źródle:\n  – chatgpt.com\n  – perplexity.ai\n\nPro tip:\nRuch z AI rośnie, ale często jest ukryty.',
      'geoChecklist.task.av_5_6.instruction':
        'Nie wszystkie zapytania AI są równe. Skup się na tych najbliższych decyzji zakupowej.\n\nCo zrobić:\n• Monitoruj zapytania typu "najlepszy X do Y"\n• Śledź "X vs Y" i "alternatywy dla Z"\n• Depriorytetyzuj czysto informacyjne zapytania\n\nPro tip:\nZapytania z wysoką intencją generują przychód - informacyjne generują metryki próżności.',
      'geoChecklist.task.av_5_7.instruction':
        'Zrozumienie, co konkurencja robi inaczej w AI, daje Ci strategiczną przewagę.\n\nCo zrobić:\n• Śledź widoczność konkurencji w odpowiedziach AI\n• Sprawdzaj, który content AI cytuje dla nich\n• Identyfikuj strategie, które możesz replikować lub ulepszyć\n\nPro tip:\nStrategia AI Twojej konkurencji jest widoczna - wystarczy zadać odpowiednie pytania.',
      'geoChecklist.task.av_5_8.instruction':
        'Najcenniejsze możliwości to zapytania, gdzie powinieneś się pojawiać, ale nie pojawiasz się.\n\nCo zrobić:\n• Znajdź kategorie, gdzie konkurencja się pojawia, a Ty nie\n• Zidentyfikuj pytania Twoich odbiorców, na które nie odpowiadasz\n• Priorytetyzuj luki według wpływu biznesowego\n\nPro tip:\nZamknięcie jednej luki widoczności może być warte więcej niż 10 nowych postów na blogu.',
      'geoChecklist.task.av_5_9.instruction':
        'GEO to nie jednorazowy projekt. Odpowiedzi AI zmieniają się stale wraz z aktualizacjami modeli.\n\nCo zrobić:\n• Ustal miesięczny lub kwartalny cykl przeglądu\n• Monitoruj → analizuj → optymalizuj → powtarzaj\n• Aktualizuj content, gdy odpowiedzi AI się zmienią\n\nPro tip:\nMarki, które wygrywają w AI, to te które się nie poddają.',
      'geoChecklist.task.av_6_1.instruction':
        'Własny GPT umieszcza Twoją markę bezpośrednio w ekosystemie ChatGPT.\n\nCo zrobić:\n• Zbuduj GPT na platformie ChatGPT\n• Dołącz bazę wiedzy i info o produktach\n• Zoptymalizuj opis GPT pod odkrywalność\n\nPro tip:\nTwój GPT to branded kanał wewnątrz AI - traktuj go jak stronę produktową.',
      'geoChecklist.task.av_6_2.instruction':
        'Systemy AI konsumują dane ustrukturyzowane łatwiej niż nieustrukturyzowany content.\n\nCo zrobić:\n• Dodaj Schema.org markup i JSON-LD do strony\n• Stwórz czyste feedy danych i API\n• Udostępnij pliki wiedzy do pobrania\n\nPro tip:\nDane ustrukturyzowane to język, którym AI mówi natywnie.',
      'geoChecklist.task.av_6_3.instruction':
        'Nie czekaj, aż AI Cię znajdzie - aktywnie wprowadzaj swój content do kanałów odkrywania AI.\n\nCo zrobić:\n• Zgłaszaj content do indeksów wyszukiwarek AI\n• Używaj promptów Deep Research odwołujących się do Twojego contentu\n• Twórz treści projektowane specjalnie pod odkrycie przez AI\n\nPro tip:\nProaktywne odkrywanie zawsze wygrywa z biernym czekaniem.',
      'geoReport.title': 'Audyty GEO',
      'geoReport.emptyState':
        'Brak audytów - uruchom pierwszy audyt,</br>aby sprawdzić jak Twoja strona wypada w AI',
      'geoReport.subtitle':
        'Audyt dostępności, treści, metadanych i autorytetu Twojej strony w celu odkrycia możliwości widoczności w AI.',
      'geoReport.navLabel': 'Audyty GEO',
      'geoReport.formTitle': 'Wygeneruj nowy audyt GEO',
      'geoReport.urlPlaceholder': 'example.com',
      'geoReport.urlInvalid': 'Wprowadź poprawną domenę',
      'geoReport.generateBtn': 'Generuj audyt',
      'geoReport.generating': 'Generowanie...',
      'geoReport.generatingInfoTitle': 'Generujemy Twój audyt...',
      'geoReport.generatingInfo':
        'Zwykle zajmuje to 5–10 minut, w zależności od wielkości Twojej strony. Możesz opuścić tę stronę – raport będzie gotowy, gdy wrócisz.',
      'geoReport.limitReached': 'Osiągnięto miesięczny limit audytów.',
      'geoReport.usageCounter': '{{used}}/{{limit}} audytów wykorzystanych w tym miesiącu',
      'geoReport.noReports':
        'Brak audytów. Wpisz adres URL powyżej, aby wygenerować pierwszy audyt GEO.',
      'geoReport.colUrl': 'URL',
      'geoReport.colStatus': 'Status',
      'geoReport.colScore': 'Wynik GEO',
      'geoReport.colDate': 'Data',
      'geoReport.colActions': 'Akcje',
      'geoReport.viewBtn': 'Podgląd',
      'geoReport.hideBtn': 'Ukryj',
      'geoReport.downloadPdf': 'Pobierz audyt',
      'geoReport.pdfGenerating': 'Generowanie...',
      'geoReport.geoScore': 'Wynik GEO',
      'geoReport.noContent': 'Brak treści audytu.',
      'geoReport.cachedResultNote':
        'Ten wynik pochodzi z Twojego niedawnego audytu (z pamięci podręcznej). Audyty GEO odświeżają się co 48 godzin - uruchom ponownie po tym czasie, aby wymusić świeży crawl.',
      'geoReport.status.pending': 'Oczekuje',
      'geoReport.status.generating': 'Generowanie',
      'geoReport.status.completed': 'Ukończony',
      'geoReport.status.failed': 'Błąd',
      'geoReport.reportsTitle': 'Audyty',
      'botsActivity.navLabel': 'Bots Activity',
      'botsActivity.title': 'Bots Activity',
      'botsActivity.connect.title': 'Połącz ze swoją stroną',
      'botsActivity.connect.subtitle': 'Wybierz dostawcę, aby zacząć śledzić ruch crawlerów AI',
      'botsActivity.crawlActivity': 'Bots Activity',
      'botsActivity.crawlBreakdown': 'Podział ruchu',
      'botsActivity.content': 'Content Activity',
      'botsActivity.byFolder': 'By Section',
      'botsActivity.byUrl': 'Top URLs',
      'botsActivity.homepage': 'Strona główna',
      'botsActivity.byFolderExcludedHint_one':
        '{{count}} wizyta bota do pliku konfiguracyjnego (np. robots.txt) jest widoczna tylko w Według URL.',
      'botsActivity.byFolderExcludedHint_few':
        '{{count}} wizyty botów do plików konfiguracyjnych (np. robots.txt, sitemap.xml) są widoczne tylko w Według URL.',
      'botsActivity.byFolderExcludedHint_many':
        '{{count}} wizyt botów do plików konfiguracyjnych (np. robots.txt, sitemap.xml) jest widocznych tylko w Według URL.',
      'botsActivity.byFolderExcludedHint_other':
        '{{count}} wizyt botów do plików konfiguracyjnych (np. robots.txt, sitemap.xml) jest widocznych tylko w Według URL.',
      'botsActivity.byFolderEmptyFilesOnly':
        'W tym okresie żadna sekcja serwisu nie była crawlowana - tylko pliki konfiguracyjne (robots.txt, sitemap.xml). Szczegóły w Według URL.',
      'botsActivity.byPlatform': 'Według platformy',
      'botsActivity.byBot': 'Według bota',
      'botsActivity.byBotType': 'Według typu bota',
      'botsActivity.noData': 'Brak danych. Połącz dostawcę, aby zacząć śledzenie.',
      'botsActivity.vsLastPeriod': 'vs poprzedni okres',
      'botsActivity.backfillInProgress':
        'Pobieramy dane historyczne - najnowsze godziny pojawiają się jako pierwsze, starsze dolewają się przez kilka kolejnych minut.',
      'botsActivity.backfillOnly':
        'Połączono - pobieramy pierwsze dane, zwykle trwa to do minuty. Jeśli po kilku minutach nic się nie pojawi, oznacza to, że dostawca nie widział jeszcze ruchu botów AI w tym okresie.',
      'botsActivity.ranges.1d': 'Ostatnie 24 godziny',
      'botsActivity.ranges.7d': 'Ostatnie 7 dni',
      'botsActivity.ranges.30d': 'Ostatnie 30 dni',
      'botsActivity.ranges.90d': 'Ostatnie 90 dni',
      'botsActivity.ranges.365d': 'Ostatni rok',
      'botsActivity.totalBotVisits': 'Łączne wizyty botów',
      'botsActivity.indexedUrls': 'Indeksowane URL',
      'botsActivity.indexedUrlsHint': 'Pokrycie indeksowania Twojej strony.',
      'botsActivity.botRequestErrorsHint': 'Udział nieudanych zapytań botów AI na Twojej stronie.',
      'botsActivity.totalBotVisitsHint': 'Łączna liczba zapytań botów AI do Twojej strony.',
      'botsActivity.botsActivityHint':
        'Pokazuje, jak często boty i crawlery AI odwiedzają Twoją stronę w czasie.',
      'botsActivity.contentActivityHint':
        'Sprawdź, które sekcje i strony otrzymują najwięcej ruchu crawlerów AI.',
      'botsActivity.bySectionHint': 'Rozkład aktywności botów AI według sekcji strony.',
      'botsActivity.topUrlsHint':
        'Pokazuje pojedyncze strony najczęściej odwiedzane przez boty i crawlery AI.',
      'botsActivity.lastIndexed': 'Ostatnio indeksowane',
      'botsActivity.change': 'Zmiana',
      'botsActivity.never': '-',
      'botsActivity.timeAgo.justNow': 'przed chwilą',
      'botsActivity.timeAgo.minutes_one': '{{count}} minutę temu',
      'botsActivity.timeAgo.minutes_few': '{{count}} minuty temu',
      'botsActivity.timeAgo.minutes_many': '{{count}} minut temu',
      'botsActivity.timeAgo.minutes_other': '{{count}} minut temu',
      'botsActivity.timeAgo.hours_one': '{{count}} godzinę temu',
      'botsActivity.timeAgo.hours_few': '{{count}} godziny temu',
      'botsActivity.timeAgo.hours_many': '{{count}} godzin temu',
      'botsActivity.timeAgo.hours_other': '{{count}} godzin temu',
      'botsActivity.timeAgo.days_one': '{{count}} dzień temu',
      'botsActivity.timeAgo.days_few': '{{count}} dni temu',
      'botsActivity.timeAgo.days_many': '{{count}} dni temu',
      'botsActivity.timeAgo.days_other': '{{count}} dni temu',
      'botsActivity.botVisits': 'Wizyty botów',
      'botsActivity.activeBots': 'Aktywne boty',
      'botsActivity.failureRate': 'Błędne zapytania botów',
      'botsActivity.urlsCrawled': 'Sprawdzone URL',
      'botsActivity.visitOverTime': 'Wizyty w czasie',
      'botsActivity.noPlatformData': 'Brak danych o platformach',
      'botsActivity.noTrafficData': 'Brak danych o ruchu agentów AI dla tego okresu',
      'botsActivity.viewDetails': 'Szczegóły',
      'botsActivity.vsLastDays': 'vs ostatnie {{days}} dni',
      'botsActivity.connect.setupHint': 'Wybierz skąd Chatbeat ma pobierać logi żądań botów AI.',
      'botsActivity.connect.logsProvider': 'Dostawca logów:',
      'botsActivity.connect.pleaseSelect': 'Wybierz',
      'botsActivity.connect.cdnPartners': 'Partnerzy CDN',
      'botsActivity.connect.noProvider': 'Nie widzisz swojego dostawcy?',
      'botsActivity.connect.requestIntegration': 'Poproś o integrację',
      'botsActivity.connect.viewAnalysis': 'Zobacz analizę',
      'botsActivity.connect.viewAnalysisAria': 'Otwórz analizę BotsActivity',
      'botsActivity.connect.uploadFile': 'Wgraj plik',
      'botsActivity.connect.openSetup': 'Otwórz konfigurację',
      'botsActivity.connect.noBotsMatched':
        'Sparsowano {{count}} linii logu, ale żadna nie pasuje do znanego crawlera AI. Pulpit śledzi wyłącznie boty AI (GPTBot, ClaudeBot, PerplexityBot itd.), więc ten plik nie wygenerował zdarzeń. Wgraj log zawierający ruch tych user-agentów, żeby zobaczyć dane.',
      dismiss: 'Zamknij',
      'botsActivity.sourceMenuAria': 'Akcje źródła',
      'botsActivity.uploadLog': 'Wgraj plik logów',
      'botsActivity.disconnectCloudflare': 'Rozłącz Cloudflare',
      'botsActivity.openConnect': 'Zarządzaj integracjami',
      'botsActivity.disconnectConfirmHeader': 'Rozłącz Cloudflare',
      'botsActivity.disconnectConfirmMessage':
        'Czy na pewno chcesz rozłączyć Cloudflare? Zbieranie danych o crawlowaniu zostanie zatrzymane.',
      'botsActivity.clearLogData': 'Wyczyść dane z logów',
      'botsActivity.clearingLogData': 'Czyszczenie...',
      'botsActivity.clearLogDataConfirmHeader': 'Wyczyść dane z logów',
      'botsActivity.clearLogDataConfirmMessage':
        'Tej operacji nie da się cofnąć: usuniemy wszystkie wgrane pliki logów i wszystkie zdarzenia crawl wyciągnięte z tych plików dla tego projektu. Wykresy stracą dane historyczne. Kontynuować?',
      'botsActivity.sourceLockedByCloudflare': 'Rozłącz Cloudflare, aby wgrać pliki logów.',
      'botsActivity.sourceLockedByLogs': 'Wyczyść dane z logów, aby przełączyć się na to źródło.',
      'botsActivity.connectErrorCloudflareActive':
        'Integracja z Cloudflare jest aktywna. Najpierw ją rozłącz, aby zmienić źródło.',
      'botsActivity.connectErrorLogHistory':
        'Projekt ma historię wgranych plików logów. Wyczyść dane z logów, aby przełączyć się na Cloudflare.',
      'cloudflare.disconnecting': 'Rozłączanie...',
      'botsActivity.connectionRequired': 'Podłącz dostawcę, aby zobaczyć analizę',
      'botsActivity.connectionRequiredHint':
        'BotsActivity wymaga logów żądań z Twojej strony. Otwórz ekran konfiguracji, aby podłączyć Cloudflare lub przesłać plik logu.',
      'botsActivity.noActivityYet':
        'Brak aktywności. Dane pojawią się tutaj gdy boty AI zaczną odwiedzać Twoją stronę.',
      'botsActivity.emptyBannerTitle': 'Brak danych o botach',
      'botsActivity.emptyBannerHint':
        'Cloudflare pobiera dane z Twojej strefy co 15 minut. Możesz uruchomić analizę teraz, aby pobrać najnowsze zdarzenia od razu.',
      'botsActivity.emptyBannerHintLog':
        'Wgrane pliki logów są agregowane co kilka minut. Wgraj kolejne pliki lub poczekaj na następny cykl agregacji.',
      'botsActivity.runAnalysis': 'Uruchom analizę teraz',
      'botsActivity.runningAnalysis': 'Uruchamianie analizy...',
      'botsActivity.runAnalysisOk': 'Analiza zakończona · pobrano {{rows}} nowych zdarzeń',
      'botsActivity.runAnalysisOkEmptyCloudflare':
        'Analiza zakończona · Cloudflare nie zwrócił nowych zdarzeń w ostatnim oknie',
      'botsActivity.runAnalysisOkEmptyFastly':
        'Analiza zakończona · Fastly nie zwrócił nowych zdarzeń w ostatnim oknie',
      'botsActivity.runAnalysisOkEmptyLog':
        'Analiza zakończona · zaktualizowano agregację z wgranych logów',
      'botsActivity.runAnalysisRateLimited':
        'Poczekaj {{seconds}}s przed kolejnym uruchomieniem analizy.',
      'botsActivity.runAnalysisAuthFailedCloudflare':
        'Cloudflare odrzucił token API - połącz integrację ponownie.',
      'botsActivity.runAnalysisAuthFailedFastly':
        'Fastly odrzucił token API - połącz integrację ponownie.',
      'botsActivity.runAnalysisFailed': 'Nie udało się uruchomić analizy · {{error}}',
      'botsActivity.runAnalysisNoIntegration':
        'Brak aktywnej integracji. Podłącz Cloudflare, Fastly lub wgraj plik logów, aby uruchomić analizę.',
      'botsActivity.botVisitTrend': 'Trend wizyt botów - według platformy',
      'botsActivity.contentHint': 'Czego szukają boty - według folderów i stron',
      'botsActivity.breakdownHint': 'Kto odwiedza Twoją stronę - według platformy, agenta i celu',
      'botsActivity.allPlatforms': 'Wszystkie platformy',
      'botsActivity.allBotTypes': 'Wszystkie typy botów',
      'botsActivity.allBots': 'Wszystkie boty',
      'botsActivity.updatedAt': 'Odświeżono · {{date}}',
      'botsActivity.vsLastDaysShort': 'vs ostatnie {{days}} dni',
      'botsActivity.showMore': 'Pokaż więcej ({{count}})',
      'botsActivity.showLess': 'Pokaż mniej',
      'botsActivity.unknownPlatform': 'Nieznana',
      'botsActivity.visits': 'Wizyty',
      'cloudflare.planFree': 'Free',
      'botsActivity.headline':
        '{{platform}} prowadzi z {{sharePct}}% zapytań - {{folder}} to najczęściej odwiedzany folder',
      'botsActivity.headlineFallback': 'Przegląd aktywności botów AI',
      'botsActivity.heroSubtitle':
        'Boty AI wysłały {{visits}} zapytań na {{urls}} adresach URL w ostatnich {{days}} dniach',
      visits: 'Wizyty',
      noDataYet: 'Brak danych - czekamy na pierwsze eventy',
      'botAccess.navLabel': 'Bots Access',
      'botAccess.title': 'Bots Access',
      'botAccess.heroTitle':
        '{{project}} - {{restrictions}} botów z ograniczeniami, {{open}} w pełni otwartych',
      'botAccess.heroSubtitle': 'Jak boty AI mają dostęp do Twojej domeny na podstawie reguł robots.txt',
      'botAccess.reloadRobots': 'Odśwież robots.txt',
      'botAccess.viewRobots': 'Pokaż robots.txt',
      'botAccess.cooldownMinutes_one': '{{count}} minutę',
      'botAccess.cooldownMinutes_few': '{{count}} minuty',
      'botAccess.cooldownMinutes_many': '{{count}} minut',
      'botAccess.cooldownMinutes_other': '{{count}} minut',
      'botAccess.cooldownToast':
        'Robots.txt zostało właśnie odświeżone. Kolejne sprawdzenie możliwe za {{time}}.',
      'botAccess.refreshError': 'Nie udało się odświeżyć robots.txt. Spróbuj ponownie.',
      'botAccess.aiBotCrawlRules': 'Reguły crawlowania botów AI',
      'botAccess.botCount': '{{visible}} z {{total}}',
      'botAccess.searchPlaceholder': 'Szukaj nazwy bota',
      'botAccess.noData':
        'Brak danych Bots Access. Kliknij Odśwież robots.txt, aby uruchomić sprawdzanie.',
      'botAccess.noWebsite':
        'Brak skonfigurowanej strony dla tego projektu. Dodaj adres URL w ustawieniach projektu, aby włączyć sprawdzanie Bots Access.',
      'botAccess.goToSettings': 'Przejdź do ustawień projektu',
      'botAccess.colBot': 'Bot',
      'botAccess.colType': 'Typ',
      'botAccess.colPlatform': 'Platforma',
      'botAccess.colStatus': 'Status',
      'botAccess.statusOpen': 'Otwarty',
      'botAccess.statusDefaultAllow': 'Domyślnie dozwolony',
      'botAccess.statusBlocked': 'Zablokowany',
      'botAccess.statusNotVerified': 'Niezweryfikowany',
      'botAccess.tileOpenHint': 'Boty mogą swobodnie indeksować całą stronę',
      'botAccess.tileDefaultAllowHint':
        'Niezablokowane w robots.txt - domyślnie dozwolone do indeksowania',
      'botAccess.tileBlockedHint': 'Całkowicie zabronione - bot nie może indeksować żadnej strony',
      'botAccess.categoryTraining': 'Trening',
      'botAccess.categorySearch': 'Wyszukiwanie',
      'botAccess.categoryAgent': 'Agent',
      'botAccess.categoryEcosystem': 'Ekosystem',
      'providers.cloudflare.title': 'Cloudflare',
      'providers.cloudflare.description':
        'Połącz strefę Cloudflare, aby automatycznie pobierać dane ruchu crawlerów AI.',
      'providers.fastly.title': 'Fastly',
      'providers.fastly.description':
        'Strumieniuj dane logów w czasie rzeczywistym z Fastly do Chatbeat.',
      'providers.log.title': 'Plik logów',
      'providers.log.description':
        'Wgraj logi dostępowe serwera (Apache CLF / Nginx / Caddy / JSON Lines) albo eksport CSV z kolumnami timestamp + user_agent.',
      'providers.log.uploadTitle': 'Wyślij plik logów',
      'providers.log.recentUploads': 'Ostatnie pliki',
      'providers.log.quotaRemaining': '{{used}} / {{limit}} uploadów wykorzystane dzisiaj',
      'providers.log.dropzoneText': 'Kliknij, aby wybrać lub przeciągnij plik logów',
      'providers.log.dropzoneHint': '.csv, .log, .txt - maks. 100 MB',
      'providers.log.errorExtension': 'Nieprawidłowy typ pliku. Wyślij plik .csv, .log lub .txt.',
      'providers.log.errorTooLarge': 'Plik jest za duży. Maksymalny rozmiar to 100 MB.',
      'providers.log.errorUploadFailed': 'Wgrywanie nie powiodło się. Spróbuj ponownie.',
      'providers.log.noUploads': 'Brak plików',
      'providers.log.formatTitle': 'Oczekiwany format pliku',
      'providers.log.formatIntro':
        'Obsługujemy dwa formaty. Wymagane kolumny to <0>timestamp</0> i <1>user_agent</1>; pozostałe są opcjonalne.',
      'providers.log.formatClf':
        'Apache/Nginx Combined Log Format (.log) - standardowe linie access logu.',
      'providers.log.formatCsv':
        'CSV z wierszem nagłówka. Akceptowane nazwy kolumn (jedna z grupy): timestamp/ts/time/datetime · user_agent/ua · path/url/uri · method · status_code/status · bytes/size · ip/client_ip.',
      'providers.log.downloadExample': 'Pobierz przykładowy CSV',
      connected: 'Połączone',
      uploading: 'Wgrywanie...',
      upload: 'Wyślij',
      details: 'Szczegóły',
      events: 'Zdarzenia',
      filename: 'Plik',
      failed: 'błędów',
      'csvStatus.PENDING': 'Oczekuje',
      'csvStatus.PROCESSING': 'Przetwarzanie',
      'csvStatus.COMPLETED': 'Ukończone',
      'csvStatus.FAILED': 'Błąd',
      'csvDetails.parsed': 'przetworzonych',
      'cloudflare.infoDescription':
        'Aby połączyć Cloudflare, potrzebujesz tokena API z uprawnieniami Zone:Read i Zone:Analytics:Read.',
      'cloudflare.createTokenButton': 'Utwórz token w Cloudflare',
      'cloudflare.manualStepsToggle': 'Lub utwórz ręcznie',
      'cloudflare.manualStep1': '1. Wejdź na dash.cloudflare.com → Mój profil → Tokeny API',
      'cloudflare.manualStep2': '2. Kliknij "Utwórz token"',
      'cloudflare.manualStep3': '3. Wybierz "Utwórz niestandardowy token"',
      'cloudflare.manualStep4': '4. Dodaj uprawnienia: Zone > Zone (Odczyt) i Zone > Analytics (Odczyt)',
      'cloudflare.manualStep5': '5. Ustaw Zasoby strefy na "Wszystkie strefy" lub konkretną strefę',
      'cloudflare.manualStep6': '6. Kliknij "Przejdź do podsumowania", a następnie "Utwórz token"',
      'cloudflare.apiTokenLabel': 'Token API',
      'cloudflare.apiTokenPlaceholder': 'Wklej swój token API Cloudflare',
      'cloudflare.testConnectionButton': 'Testuj połączenie',
      'cloudflare.testingConnection': 'Testowanie...',
      'cloudflare.errorEmptyToken': 'Token API jest wymagany',
      'cloudflare.errorInvalidToken': 'Nieprawidłowy token lub brak dostępnych stref',
      'cloudflare.errorInsufficientPermissions':
        'Nieprawidłowy token lub niewystarczające uprawnienia. Upewnij się, że token ma Zone:Read i Zone:Analytics:Read.',
      'cloudflare.errorRateLimit': 'Przekroczono limit zapytań. Spróbuj za chwilę.',
      'cloudflare.errorGeneric':
        'Test połączenia nie powiódł się. Sprawdź swój token i spróbuj ponownie.',
      'cloudflare.errorConnectFailed': 'Połączenie nie powiodło się. Spróbuj ponownie.',
      'cloudflare.bestMatch': 'Najlepsze dopasowanie',
      'cloudflare.searchZones': 'Szukaj stref...',
      'cloudflare.confirmZoneLabel': 'Strefa:',
      'cloudflare.confirmPlanLabel': 'Plan:',
      'cloudflare.backfillInfo':
        'Pobierzemy maksymalną historię na jaką pozwala Twój plan Cloudflare. Nowe dane lecą co 15 minut.',
      'cloudflare.connecting': 'Łączenie...',
      'cloudflare.confirmConnect': 'Połącz',
      'cloudflare.stepInfoTitle': 'Połącz z Cloudflare',
      'cloudflare.stepTokenTitle': 'Wprowadź token API',
      'cloudflare.stepZonesTitle': 'Wybierz strefę',
      'cloudflare.stepConfirmTitle': 'Potwierdź połączenie',
      'fastly.infoDescription':
        'Aby połączyć Fastly, wklej token API z uprawnieniami `global:read` i `stats`. Użyjemy go do pobrania listy Twoich usług oraz historycznych statystyk ruchu crawlerów AI.',
      'fastly.createTokenButton': 'Utwórz token w Fastly',
      'fastly.apiTokenLabel': 'Token API',
      'fastly.apiTokenPlaceholder': 'Wklej swój token API Fastly',
      'fastly.testConnectionButton': 'Testuj połączenie',
      'fastly.testingConnection': 'Testowanie...',
      'fastly.errorEmptyToken': 'Token API jest wymagany',
      'fastly.errorInvalidToken': 'Nieprawidłowy token lub brak dostępnych usług',
      'fastly.errorInsufficientPermissions':
        'Nieprawidłowy token lub niewystarczające uprawnienia. Upewnij się, że token ma uprawnienia global:read i stats.',
      'fastly.errorRateLimit': 'Przekroczono limit zapytań. Spróbuj za chwilę.',
      'fastly.errorGeneric': 'Test połączenia nie powiódł się. Sprawdź swój token i spróbuj ponownie.',
      'fastly.errorConnectFailed': 'Połączenie nie powiodło się. Spróbuj ponownie.',
      'fastly.bestMatch': 'Najlepsze dopasowanie',
      'fastly.searchServices': 'Szukaj usług...',
      'fastly.confirmServiceLabel': 'Usługa:',
      'fastly.confirmServiceIdLabel': 'ID usługi:',
      'fastly.backfillInfo': 'Pobierzemy historię z ostatnich 30 dni. Nowe dane lecą co 15 minut.',
      'fastly.connecting': 'Łączenie...',
      'fastly.confirmConnect': 'Połącz',
      'fastly.stepInfoTitle': 'Połącz z Fastly',
      'fastly.stepServicesTitle': 'Wybierz usługę',
      'fastly.stepConfirmTitle': 'Potwierdź połączenie',
      'botsActivity.sourceLockedByFastly': 'Rozłącz Fastly, aby przełączyć się na to źródło.',
      'aiSignals.navLabel': 'AI Signals',
      'ads.navLabel': 'Reklamy',
      'ads.title': 'AI Ads',
      'ads.desc': 'Śledzenie reklam jest obecnie dostępne tylko dla ChatGPT.',
      'ads.reportingPausedNotice':
        'ChatGPT zmienił format reklam, dlatego raportowanie reklamodawców jest tymczasowo wstrzymane. Wznowimy je, gdy reklamy znów będą dostępne.',
      'ads.dismissNotice': 'Ukryj',
      'ads.adsDetected': 'Reklamy',
      'ads.adsDetectedSub': 'Wystąpienia reklam · {{count}} unikalnych reklam',
      'ads.adsDetectedTooltip':
        'Reklamy - łączna liczba wystąpień reklam na monitorowanych promptach; każde wykrycie liczy się osobno. Unikalne reklamy ({{count}}) - liczba unikalnych kreacji: reklamodawca + nagłówek + opis + kanoniczny adres docelowy (bez parametrów trackingowych typu UTM).',
      'ads.promptsWithAds': 'Prompty z reklamami',
      'ads.promptsWithAdsSub': '{{percent}}% monitorowanych promptów',
      'ads.promptsWithAdsTooltip':
        'Monitorowane prompty, przy których w wybranym okresie pojawiła się co najmniej jedna reklama - {{percent}}% wszystkich monitorowanych promptów.',
      'ads.advertisersDetected': 'Reklamodawcy',
      'ads.advertisersDetectedSub': 'unikalne marki kupujące reklamy',
      'ads.advertisersDetectedTooltip':
        'Liczba różnych marek, których reklamy wykryliśmy w wybranym okresie.',
      'ads.advertisersCount': 'Reklamodawcy: {{count}}',
      'ads.showMore': 'Pokaż więcej ({{count}})',
      'ads.showLess': 'Pokaż mniej',
      'ads.presenceTitle': 'Obecność reklam w czasie',
      'ads.presenceDesc': 'Zobacz, jak często reklamy pojawiają się w monitorowanych odpowiedziach AI.',
      'ads.viewOccurrences': 'Wystąpienia reklam',
      'ads.viewByAdvertiser': 'Wg reklamodawcy',
      'ads.byAdvertiserNote':
        'Każdy {{unit}} pokazuje swoich {{top}} najczęstszych reklamodawców; {{ads}} reklam spoza tej listy nie jest rysowanych.',
      'ads.otherAdvertisers': 'Pozostali reklamodawcy',
      'ads.unitDay': 'dzień',
      'ads.unitWeek': 'tydzień',
      'ads.unitMonth': 'miesiąc',
      'ads.yourBrand': 'Twoja marka',
      'ads.otherBrands': 'Inne marki',
      'ads.tooltipTotal': 'Razem',
      'ads.shareTitle': 'Udział reklamodawców',
      'ads.shareDesc': 'Ranking reklamodawców według udziału w wykrytych wystąpieniach reklam.',
      'ads.colAdvertiser': 'Reklamodawca',
      'ads.colShare': 'Udział',
      'ads.colSeen': 'Wyświetlenia',
      'ads.colPrompts': 'Prompty',
      'ads.colAdvertiserDomain': 'Domena reklamodawcy',
      'ads.colFirstSeen': 'Pierwsze wystąpienie',
      'ads.colAdCopy': 'Treść reklamy',
      'ads.colAdCreative': 'Kreacja i treść reklamy',
      'ads.colSendsTo': 'Prowadzi do',
      'ads.colTimesSeen': 'Liczba wystąpień',
      'ads.colModel': 'Model',
      'ads.colVisibility': 'Widoczność',
      'ads.colAdCoverage': 'Pokrycie reklamami',
      'ads.adCoverageTooltip':
        'Udział monitorowanych odpowiedzi na ten prompt, w których pojawiła się co najmniej jedna reklama (odpowiedzi z reklamą / zmierzone).',
      'ads.colPrompt': 'Prompt',
      'ads.colAds': 'Reklamy',
      'ads.colAdvertisers': 'Reklamodawcy',
      'ads.colLatest': 'Ostatnio',
      'ads.visibilityTooltip': 'Organiczna widoczność Twojej marki dla tego promptu.',
      'ads.youBadge': 'Ty',
      'ads.tabByAdvertiser': 'Wg reklamodawcy',
      'ads.tabByAd': 'Wg reklamy',
      'ads.tabByPrompt': 'Wg promptu',
      'ads.breakdownTitle': 'Szczegółowa analiza',
      'ads.breakdownTooltip':
        'Analizuj wykryte reklamy według reklamodawcy lub kreacji. Wyszukiwanie i eksport CSV dotyczą aktywnego widoku.',
      'ads.searchPlaceholder':
        'Szukaj reklam lub reklamodawców...',
      'ads.searchPromptsPlaceholder': 'Szukaj promptów...',
      'ads.promptsTooltip': 'Monitorowane prompty, przy których pojawiły się reklamy: kto się reklamował, ile było wystąpień reklam i jaka jest organiczna widoczność Twojej marki dla tego promptu.',
      'ads.allAdvertisers': 'Wszyscy reklamodawcy',
      'ads.advertisersSelected': 'wybranych reklamodawców',
      'ads.searchAdvertisers': 'Szukaj reklamodawców…',
      'ads.sponsoredLabel': 'Sponsorowane',
      'ads.emptyTitle': 'Brak reklam dla wybranych filtrów.',
      'ads.emptyDesc': 'Zmień zakres dat lub grupę promptów.',
      'ads.errorTitle': 'Coś poszło nie tak.',
      'ads.errorDesc': 'Nie udało się załadować danych.',
      'ads.notEnabledTitle': 'Monitorowanie AI Ads nie jest włączone dla tego projektu.',
      'ads.notEnabledDesc':
        'Ten projekt nie monitoruje ChatGPT - śledzenie reklam jest obecnie dostępne tylko dla ChatGPT.',
      'ads.announcement.badge': 'Nowość w Chatbeat',
      'ads.announcement.titlePrefix': 'AI Ads jest już',
      'ads.announcement.titleAccent': 'dostępne',
      'ads.announcement.desc':
        'Zobacz, które reklamy pojawiają się w odpowiedziach AI - kto je kupuje, gdzie prowadzą i czy Twoja marka jest częścią rozmowy.',
      'ads.announcement.previewTitle': 'Obecność reklam w czasie',
      'ads.announcement.statAds': 'Reklamy',
      'ads.announcement.statPrompts': 'Prompty z reklamami',
      'ads.announcement.statAdvertisers': 'Reklamodawcy',
      'ads.announcement.later': 'Może później',
      'ads.announcement.cta': 'Zobacz AI Ads',
      'aiVisibilityReport.navLabel': 'Raport widoczności w AI',
      'aiVisibilityReport.title': 'Raport widoczności w AI',
      'aiVisibilityReport.subtitle':
        'Wygeneruj raport AI z insightami o widoczności Twojej marki.',
      'aiVisibilityReport.periodLabel': 'Okres',
      'aiVisibilityReport.generateBtn': 'Generuj raport',
      'aiVisibilityReport.generating': 'Uruchamianie…',
      'aiVisibilityReport.generatingInfoTitle': 'Trwa generowanie raportu…',
      'aiVisibilityReport.generatingInfo':
        'To może zająć około 15 minut. Możesz opuścić stronę - raport pojawi się na liście, gdy będzie gotowy.',
      'aiVisibilityReport.periodTooLong': 'Okres może mieć maksymalnie {{max}} dni.',
      'aiVisibilityReport.runsTitle': 'W trakcie',
      'aiVisibilityReport.reportsTitle': 'Raporty',
      'aiVisibilityReport.emptyState':
        'Brak raportów. Wybierz okres powyżej, aby wygenerować pierwszy.',
      'aiVisibilityReport.colPeriod': 'Okres',
      'aiVisibilityReport.colStatus': 'Status',
      'aiVisibilityReport.colDate': 'Utworzono',
      'aiVisibilityReport.colActions': 'Akcje',
      'aiVisibilityReport.downloadBtn': 'Pobierz PDF',
      'aiVisibilityReport.deleteBtn': 'Usuń',
      'aiVisibilityReport.dismissBtn': 'Ukryj',
      'aiVisibilityReport.cancelBtn': 'Anuluj',
      'aiVisibilityReport.confirmCancelRunHeader': 'Anuluj generowanie',
      'aiVisibilityReport.confirmCancelRun':
        'Anulować generowanie tego raportu? Możesz wygenerować go ponownie dla tego samego okresu.',
      'aiVisibilityReport.confirmDeleteReport':
        'Czy na pewno chcesz usunąć ten raport? Potem będzie można wygenerować go ponownie dla tego samego okresu.',
      'aiVisibilityReport.confirmDismissRun':
        'Czy na pewno chcesz ukryć ten nieudany run? Zniknie z listy.',
      'aiVisibilityReport.status.pending': 'Oczekuje',
      'aiVisibilityReport.status.generating': 'Generowanie',
      'aiVisibilityReport.status.failed': 'Nieudane',
      'aiVisibilityReport.errorReportExists':
        'Raport dla tego okresu już istnieje. Usuń go, aby wygenerować ponownie.',
      'aiVisibilityReport.errorActiveRun': 'Raport dla tego okresu jest już generowany.',
      'aiVisibilityReport.errorMonthlyLimit':
        'Wyczerpano miesięczny limit raportów na tym koncie. Anuluj trwające generowanie lub poczekaj na odnowienie.',
      'aiVisibilityReport.quotaRemaining':
        'Pozostało {{remaining}} z {{limit}} raportów w tym miesiącu · odnowienie {{date}}',
      'aiVisibilityReport.quotaExhausted':
        'Wykorzystano miesięczny limit ({{limit}}) · odnowienie {{date}}',
      'aiVisibilityReport.errorGeneric': 'Nie udało się uruchomić generowania raportu.',
      'aiVisibilityReport.errorDownload': 'Nie udało się pobrać PDF.',
      'promptAnalyst.navLabel': 'Prompt Analyst',
      'promptAnalyst.title': 'Prompt Analyst',
      'promptAnalyst.subtitle': 'Sprawdź prompt, zanim zaczniesz go monitorować: jakie marki wymienia AI, gdzie jest Twoja i jak lepiej go sformułować.',
      'promptAnalyst.promptPlaceholder': 'Wpisz pytanie, które ludzie mogą zadać AI…',
      'promptAnalyst.analyzeBtn': 'Analizuj',
      'promptAnalyst.analyzing': 'Uruchamianie…',
      'promptAnalyst.quotaRemaining': 'Zostało {{remaining}} z {{limit}} przeglądów w tym miesiącu (odnowienie {{date}})',
      'promptAnalyst.quotaExhausted': 'Limit {{limit}} przeglądów w tym miesiącu wykorzystany - odnowienie {{date}}',
      'promptAnalyst.errorMonthlyLimit': 'Wykorzystano miesięczny limit przeglądów.',
      'promptAnalyst.errorDemo': 'Projekty demo są tylko do odczytu.',
      'promptAnalyst.errorInvalidPrompt': 'Prompt musi mieć od 3 do 500 znaków.',
      'promptAnalyst.errorGeneric': 'Nie udało się uruchomić przeglądu.',
      'promptAnalyst.errorAddPrompt': 'Nie udało się dodać promptu.',
      'promptAnalyst.historyTitle': 'Historia',
      'promptAnalyst.newAnalysis': 'Nowa analiza',
      'promptAnalyst.composerTitle': 'Który prompt chcesz sprawdzić?',
      'promptAnalyst.searchHistory': 'Szukaj analiz…',
      'promptAnalyst.historyEmpty': 'Nie znaleziono analiz.',
      'promptAnalyst.collapseHistory': 'Zwiń historię',
      'promptAnalyst.expandHistory': 'Rozwiń historię',
      'promptAnalyst.today': 'Dziś',
      'promptAnalyst.yesterday': 'Wczoraj',
      'promptAnalyst.status.PENDING': 'W kolejce',
      'promptAnalyst.status.RUNNING': 'Analiza',
      'promptAnalyst.status.DONE': 'Gotowe',
      'promptAnalyst.status.FAILED': 'Błąd',
      'promptAnalyst.inProgress': 'Analizujemy - zwykle trwa to krócej niż minutę.',
      'promptAnalyst.failed': 'Przegląd się nie udał. Nie wliczył się do miesięcznego limitu - spróbuj ponownie.',
      'promptAnalyst.verdict.keep': 'Zostawić',
      'promptAnalyst.verdict.rewrite': 'Przeformułować',
      'promptAnalyst.verdict.add_variants': 'Dodać warianty',
      'promptAnalyst.verdict.worth_adding': 'Warto monitorować',
      'promptAnalyst.questionType.neutral': 'Pytanie neutralne',
      'promptAnalyst.questionType.positive': 'Pytanie pozytywne',
      'promptAnalyst.questionType.negative': 'Pytanie negatywne',
      'promptAnalyst.aiOverview': 'AI Overview w Google',
      'promptAnalyst.similarAccounts': 'Monitorowany przez {{value}} innych kont',
      'promptAnalyst.summaryTitle': 'Podsumowanie analizy',
      'promptAnalyst.summaryTooltip': 'Analizowany prompt, wydźwięk pytania i krótkie podsumowanie, jak odpowiada na nie AI.',
      'promptAnalyst.tileOwnAnswers': 'Odpowiedzi z Twoją marką',
      'promptAnalyst.tileOwnAnswersTooltip': 'W ilu odpowiedziach AI z ostatnich 30 dni pojawia się Twoja marka (z wariantami).',
      'promptAnalyst.tileAvgPosition': 'Śr. pozycja',
      'promptAnalyst.tileAvgPositionTooltip': 'Średnia pozycja Twojej marki w odpowiedziach, które ją wymieniają.',
      'promptAnalyst.tileBrandsPerAnswer': 'Marek na odpowiedź',
      'promptAnalyst.tileBrandsPerAnswerTooltip': 'Ile marek średnio wymienia odpowiedź. Mniej niż 2 oznacza, że prompt prawie nie mierzy konkurencji.',
      'promptAnalyst.tileSourcesPerAnswer': 'Źródeł na odpowiedź',
      'promptAnalyst.tileSourcesPerAnswerTooltip': 'Ile źródeł z sieci średnio cytuje odpowiedź.',
      'promptAnalyst.tileMentioned': 'Marka wymieniona',
      'promptAnalyst.tileMentionedTooltip': 'Czy Twoja marka (lub jej wariant) pojawia się w odpowiedzi.',
      'promptAnalyst.tilePosition': 'Pozycja w odpowiedzi',
      'promptAnalyst.tilePositionTooltip': 'Na którym miejscu wśród wymienionych marek jest Twoja.',
      'promptAnalyst.tileBrands': 'Porównane marki',
      'promptAnalyst.tileBrandsTooltip': 'Ile marek, produktów lub dostawców odpowiedź poleca albo porównuje.',
      'promptAnalyst.tileSources': 'Cytowane źródła',
      'promptAnalyst.tileSourcesTooltip': 'Ile źródeł z sieci cytuje odpowiedź.',
      'promptAnalyst.tileVerdict': 'Werdykt',
      'promptAnalyst.tileVerdictTooltip': 'Liczony z danych: przeformułować, gdy odpowiedzi wymieniają mniej niż 2 marki; dodać warianty, gdy Twoja marka jest w mniej niż 20% odpowiedzi.',
      'promptAnalyst.answersTitle': 'Jak odpowiada AI (ostatnie 30 dni)',
      'promptAnalyst.answersTooltip': 'Marki najczęściej wymieniane w odpowiedziach AI na ten prompt z ostatnich 30 dni.',
      'promptAnalyst.liveTitle': 'Jak odpowiada AI',
      'promptAnalyst.liveTooltip': 'Jedna odpowiedź ChatGPT z wyszukiwarką, pobrana podczas przeglądu - próbka, nie pomiar.',
      'promptAnalyst.brand': 'Marka',
      'promptAnalyst.brandAnswers': 'Odpowiedzi',
      'promptAnalyst.avgPosition': 'Śr. pozycja',
      'promptAnalyst.noBrands': 'Odpowiedź nie wymienia żadnych marek.',
      'promptAnalyst.answerTitle': 'Odpowiedź AI',
      'promptAnalyst.answerTooltip': 'Cała odpowiedź ChatGPT z przeglądu. Źródła są wypisane wyżej.',
      'promptAnalyst.citedSources': 'Cytowane źródła',
      'promptAnalyst.citedSourcesTooltip': 'Źródła z sieci, które zacytował model.',
      'promptAnalyst.noSources': 'Brak cytowanych źródeł.',
      'promptAnalyst.domain': 'Domena',
      'promptAnalyst.searchQueries': 'Czego szukało AI',
      'promptAnalyst.searchQuery': 'Zapytanie',
      'promptAnalyst.searchQueriesTooltip': 'Zapytania, które model wysłał do wyszukiwarki, odpowiadając.',
      'promptAnalyst.improveTitle': 'Co poprawić',
      'promptAnalyst.improveTooltip': 'Obserwacje na podstawie danych powyżej.',
      'promptAnalyst.rewrites': 'Polecane prompty',
      'promptAnalyst.rewritesTooltip': 'Alternatywne prompty, które lepiej zmierzą temat. Dodasz je do projektu jednym kliknięciem.',
      'promptAnalyst.suggestionsCount': 'propozycje: {{value}}',
      'promptAnalyst.peopleTitle': 'O co pytają ludzie w Google',
      'promptAnalyst.peopleTooltip': 'Podobne pytania i wyszukiwania z Google - jak prawdziwi ludzie formułują ten temat.',
      'visibilityReport.navLabel': 'Raporty',
      'visibilityReport.title': 'Raporty',
      'visibilityReport.subtitle':
        'Zbuduj raport widoczności marki w chatbotach AI, gotowy do wysłania. Wybierz filtry i pobierz go od razu.',
      'visibilityReport.periodLabel': 'Okres',
      'visibilityReport.modelsLabel': 'Modele AI',
      'visibilityReport.modelsAll': 'Wszystkie modele',
      'visibilityReport.dialogTitle': 'Generowanie raportu',
      'visibilityReport.periodHint': 'Maksymalnie 3 miesiące',
      'visibilityReport.periodTypeLabel': 'Gradacja',
      'visibilityReport.periodTypeHint': 'Jak grupujemy statystyki',
      'visibilityReport.colPeriodType': 'Gradacja',
      'visibilityReport.previewLabel': 'Podgląd raportu',
      'visibilityReport.generateBtn': 'Generuj raport',
      'visibilityReport.generating': 'Generuję…',
      'visibilityReport.generatingInfo':
        'Liczę dane - to potrwa kilka sekund. Raport otworzy się od razu po zakończeniu.',
      'visibilityReport.periodTooLong': 'Okres nie może przekraczać 3 miesięcy.',
      'visibilityReport.emptyState': 'Dla tego projektu nie ma jeszcze żadnego raportu',
      'visibilityReport.colName': 'Nazwa',
      'visibilityReport.reportName': 'Raport {{period}}',
      'visibilityReport.colBrand': 'Marka',
      'visibilityReport.colModels': 'Modele AI',
      'visibilityReport.colDate': 'Utworzono',
      'visibilityReport.colActions': 'Akcje',
      'visibilityReport.openBtn': 'Otwórz raport',
      'visibilityReport.deleteBtn': 'Usuń',
      'visibilityReport.confirmDelete':
        'Na pewno usunąć ten raport? Link przestanie działać wszystkim, którzy go dostali.',
      'visibilityReport.confirmUnshare':
        'Wyłączyć udostępnianie? Link przestanie działać wszystkim, którzy go dostali.',
      'visibilityReport.confirmDeleteMany':
        'Usunąć zaznaczone raporty ({{count}})? Ich linki przestaną działać wszystkim, którzy je dostali.',
      'visibilityReport.bulkRemove': 'Usuń zaznaczone raporty',
      'visibilityReport.selectMode': 'Zarządzaj zaznaczonymi raportami',
      'visibilityReport.backToList': 'Wróć do raportów',
      'visibilityReport.notFound': 'Ten raport jest niedostępny.',
      'visibilityReport.errorGeneric': 'Nie udało się wygenerować raportu.',
      'visibilityReport.modelsHint': 'Modele z danymi w wybranym okresie',
      'visibilityReport.promptsLabel': 'Prompty',
      'visibilityReport.promptsHint': 'Puste = raport obejmie wszystkie prompty',
      'visibilityReport.promptsAll': 'Wszystkie prompty',
      'visibilityReport.promptsSelected': 'Wybrane prompty: {{count}}',
      'visibilityReport.promptsSearch': 'Szukaj promptów...',
      'visibilityReport.noDataInPeriod': 'W tym okresie żaden model nie zebrał danych - wybierz inny zakres.',
      'visibilityReport.shareBtn': 'Udostępnij link',
      'visibilityReport.shareEnabled': 'Raport udostępniony publicznie',
      'visibilityReport.shareCopyLink': 'Kopiuj link',
      'visibilityReport.shareRevoke': 'Wyłącz udostępnianie',
      'visibilityReport.sharedUnavailableTitle': 'Ten raport jest już niedostępny',
      'visibilityReport.sharedUnavailableDesc':
        'Link został wyłączony albo raport usunięto. Poproś nadawcę o nowy.',
      'aiSignals.title': 'Brand24 AI Signals',
      'aiSignals.badge': 'Dodatek',
      'aiSignals.subtitle':
        'Łączymy realne wzmianki o marce z narracjami generowanymi przez AI - dzięki temu wpływasz na to, jak modele AI mówią o Twojej marce.',
      'aiSignals.priceLabel': 'Cena dodatku',
      'aiSignals.price': '$199',
      'aiSignals.pricePeriod': '/ miesiąc',
      'aiSignals.priceNote': 'Rozliczane dodatkowo do Twojego planu Chatbeat.',
      'aiSignals.activate': 'Aktywuj dodatek',
      'aiSignals.addProject': 'Dodaj projekt do Brand24',
      'aiSignals.unlink': 'Odłącz projekt',
      'aiSignals.contact': 'Skontaktuj się z opiekunem konta, aby włączyć.',
      'aiSignals.included': 'Co zawiera',
      'aiSignals.highlight.title': 'Kontekst i sentyment wzmianek w źródłach AI',
      'aiSignals.highlight.desc':
        'Klasyfikacja sentymentu dla każdego źródła, benchmarking konkurencji AI Backlink oraz szczegółowy rozkład narracji zasilających modele AI.',
      'aiSignals.features.integration.title': 'Integracja Chatbeat × Brand24',
      'aiSignals.features.integration.desc':
        'Ujednolicony widok wzmianek o marce w sieci i czatach AI - synchronizacja wzmianek Brand24 w czasie rzeczywistym, mapowanych z social media, newsów i forów na odpowiedzi AI.',
      'aiSignals.features.topics.title': 'Najważniejsze tematy w branży - Sugerowane prompty',
      'aiSignals.features.topics.desc':
        'Wykrywanie trendujących tematów z milionów wzmianek wraz z automatycznie generowanymi sugestiami promptów powiązanymi z kluczowymi tematami w Twojej branży.',
      'aiSignals.features.anomaly.title': 'Alerty o anomaliach marki',
      'aiSignals.features.anomaly.desc':
        'Wykrywanie anomalii w źródłach cytowanych przez AI (Reddit, Forbes, YouTube, LinkedIn, wydawcy niszowi) - reaguj, zanim narracje utrwalą się w odpowiedziach AI.',
      'aiSignals.footer': 'Potrzebujesz tego dla swojego zespołu? Skontaktuj się z opiekunem konta w sprawie dostępności.',
      'aiSignals.activation.title': 'Aktywacja AI Signals',
      'aiSignals.activation.subtitle': 'To potrwa tylko chwilę…',
      'aiSignals.activation.step1': 'Aktywujemy Twój projekt',
      'aiSignals.activation.step2': 'Zbieramy informacje i wzmianki',
      'aiSignals.activation.step3': 'Sprawdzamy sentyment źródeł',
      'aiSignals.activation.step4': 'Budujemy AI Backlinks Index',
      'aiSignals.results.header': 'AI Signals',
      'aiSignals.results.title': 'Wzmianki w źródłach AI',
      'aiSignals.results.subtitle':
        'Monitoruj wzmianki marki w źródłach AI, analizuj sentyment i buduj przewagę konkurencyjną.',
      'aiSignals.results.mentions.title': 'Wzmianki w źródłach AI',
      'aiSignals.results.mentions.of': 'z',
      'aiSignals.results.mentions.desc':
        'Udział wzmianek o Twojej marce, które trafiają na źródła cytowane przez modele AI - jaka część całego pokrycia znajduje się na domenach widocznych dla AI. Wyższy udział oznacza, że więcej wzmianek o marce jest tam, skąd AI może je wydobyć; niższy wskazuje pokrycie, z którego AI jeszcze nie korzysta.',
      'aiSignals.results.competitors.title': 'Konkurenci AI Backlink',
      'aiSignals.results.competitors.brands': 'Marki',
      'aiSignals.results.competitors.mentions': 'Wzmianki',
      'aiSignals.results.competitors.backlinks': 'AI Backlinki',
      'aiSignals.results.competitors.sentiment': 'Sentyment',
      'aiSignals.results.sources.added': 'Dodano',
      'aiSignals.results.sources.notAdded': 'Nie dodano',
      'aiSignals.results.trend.title': 'Wzmianki w źródłach AI - Trend',
      'aiSignals.results.domains.title': 'Najczęstsze domeny w źródłach AI',
      'aiSignals.results.domains.tooltip':
        'Najczęściej cytowane domeny dla każdego modelu AI, uszeregowane według liczby wzmianek.',
      'aiSignals.results.sourcesPerModel.title': 'Wzmianki według modelu - Najlepsze źródła',
      'aiSignals.results.sourcesPerModel.note': 'Top 6 źródeł we wszystkich modelach AI',
      'aiSignals.results.context.title': 'Kontekst dyskusji',
      'aiSignals.results.context.share': 'Występuje w {{share}}% wzmianek',
      'aiSignals.results.context.tooltip':
        'Najczęstsze terminy pojawiające się obok Twojej marki w dyskusjach cytowanych przez AI.',
      'aiSignals.results.context.showSentiment': 'Pokaż sentyment',
      'aiSignals.results.context.hideSentiment': 'Ukryj sentyment',
      'aiSignals.results.sentiment.positive': 'Pozytywny',
      'aiSignals.results.sentiment.neutral': 'Neutralny',
      'aiSignals.results.sentiment.negative': 'Negatywny',
      'aiSignals.results.topics.title': 'Tematy dyskusji',
      'aiSignals.results.topics.subtitle':
        'Automatycznie wykryte tematy ze źródeł cytowanych przez AI. Dodaj wybrane do śledzonych tagów.',
      'aiSignals.results.topics.addToTags': 'Dodaj do tagów',
      'aiSignals.results.topics.removeTag': 'Usuń',
      'aiSignals.results.topics.topic': 'Temat',
      'aiSignals.results.topics.sentiment': 'Sentyment',
      'aiSignals.results.topics.mentions': 'Wzmianki',
      'aiSignals.results.backlinks.title': 'AI Backlinks',
      'aiSignals.results.backlinks.source': 'Źródło',
      'aiSignals.results.backlinks.mentions': 'Wzmianki',
      'aiSignals.results.backlinks.models': 'Modele',
      'aiSignals.results.backlinks.reach': 'Zasięg',
      'aiSignals.results.backlinks.sentiment': 'Sentyment',
      agencyStats: 'Agencja',
      agencyStatsTitle: 'Statystyki agencji',
      agencyHub: 'Agency Hub',
      agencyHubSubtitle: 'Zarządzaj projektami i dostępem klientów.',
      agencyHubInUse: 'w użyciu',
      agencyHubNoLimit: 'Bez limitu',
      agencyHubAllocatedAcrossProjects: 'Użyte w projektach',
      agencyHubTeamNote: '{{active}} aktywnych · {{pending}} oczekujących',
      agencyHubUpgradePlan: 'Zmień plan',
      agencyHubProjectsTooltip: 'Wszystkie projekty konta z alokacją promptów.',
      agencyHubTeamTooltip: 'Wszyscy z dostępem do konta, pogrupowani według roli.',
      aiModels: 'Modele AI',
      agencyHubModelsUnit: 'aktywnych',
      agencyHubModelLocked: '{{model}} · dostępny w wyższym planie',
      agencyHubAdminsNote: 'Pełny dostęp do wszystkich projektów i tego panelu',
      agencyHubUsersNote: 'Dostęp do wszystkich projektów, bez tego panelu',
      agencyHubGuestsNote: 'Tylko odczyt udostępnionych projektów',
      allProjectsCount: 'Wszystkie projekty · {{count}}',
      inviteMember: 'Zaproś do zespołu',
      member: 'Członek',
      admins: 'Administratorzy',
      guests: 'Goście',
      assign: 'Przypisz',
      removeMember: 'Usuń członka',
      start: 'Uruchom',
      allocatePrompts: 'Alokuj prompty',
      allocatePromptsSubtitle: 'Rozdziel pulę promptów planu między projekty.',
      allocated: 'Użyte',
      promptsLeftInPool: 'Zostało {{count}} promptów w puli',
      promptsOverLimit: '{{count}} ponad limit planu',
      minUsed: 'min. {{count}} (w użyciu)',
      allocateStartPoolShort: 'Za mało wolnych promptów w puli (brakuje {{count}})',
      needMorePrompts: 'Potrzebujesz więcej promptów? Zmień plan',
      changeLimit: 'Zmień limit',
      shareProject: 'Udostępnij projekt',
      shareProjectHint: 'Goście widzą tylko projekty, które im udostępnisz.',
      shareProjectNoGuests: 'Nie masz jeszcze gości. Zaproś gościa, żeby udostępnić mu tylko wybrane projekty.',
      roleChanged: '{{name}}: rola zmieniona na {{role}}',
      guestOnlyProject: 'jedyny projekt',
      guestOnlyProjectHint:
        'Gość musi mieć co najmniej jeden projekt. Udostępnij mu inny albo usuń go z zespołu.',
      pauseProject: 'Zatrzymaj projekt',
      startProject: 'Uruchom projekt',
      removeProjectsConfirm:
        'Usunąć {{count}} wybranych projektów? Ich prompty przestaną zbierać dane, a alokacje wrócą do puli.',
      removeMemberConfirm: 'Usunąć {{name}} z zespołu?',
      projectRemoved: 'Projekt usunięty',
      projectsRemoved_one: 'Usunięto {{count}} projekt',
      projectsRemoved_few: 'Usunięto {{count}} projekty',
      projectsRemoved: 'Usunięto {{count}} projektów',
      memberRemoved: 'Usunięto z zespołu',
      promptAllocation: 'Alokacja promptów',
      promptAllocationHint:
        'Rezerwacja z puli konta dla tego projektu. Co najmniej tyle, ile promptów w projekcie.',
      promptAllocationFree: 'wolne w puli: {{count}}',
      promptAllocationNoLimit: 'bez limitu',
      agencyHubNoAllocationLimit: 'bez limitu alokacji',
      agencyHubPausedPrompts_one: 'Wstrzymany · {{count}} prompt',
      agencyHubPausedPrompts_few: 'Wstrzymany · {{count}} prompty',
      agencyHubPausedPrompts: 'Wstrzymany · {{count}} promptów',
      agencyHubPausedNoPrompts: 'Wstrzymany · brak promptów do wznowienia',
      agencyHubPausedPromptsHint: 'Po starcie projekt zarezerwuje te prompty z puli',
      overAllocationLimit: '({{count}} ponad limit alokacji)',
      promptAllocationMissing:
        'Brakuje {{count}} promptów w puli. Zmień alokację innych projektów.',
      promptAllocationPaused: 'Wstrzymany projekt nie rezerwuje promptów. Alokację ustawisz przy uruchomieniu.',
      promptAllocationLowerHint: 'Żeby obniżyć alokację, wstrzymaj lub usuń prompty projektu',
      startProjectMissing:
        'Brakuje {{count}} promptów, żeby uruchomić. Zwolnij pulę w dialogu „Alokuj prompty” albo usuń część promptów projektu.',
      projectsPaused_one: 'Wstrzymano {{count}} projekt',
      projectsPaused_few: 'Wstrzymano {{count}} projekty',
      projectsPaused: 'Wstrzymano {{count}} projektów',
      projectsStarted_one: 'Uruchomiono {{count}} projekt',
      projectsStarted_few: 'Uruchomiono {{count}} projekty',
      projectsStarted: 'Uruchomiono {{count}} projektów',
      allocationsSaved: 'Alokacje zapisane',
      allocationLimitTooltip: 'Limit alokacji projektu osiągnięty ({{used}} / {{allocation}})',
      projectPausedInHubTooltip: 'Projekt wstrzymany',
      allocationExceededTitle: 'Limit promptów projektu',
      allocationExceeded:
        'Projekt „{{name}}” wykorzystuje {{used}} z {{allocation}} przydzielonych promptów. Zwiększ alokację w ustawieniach projektu, żeby dodać lub wznowić kolejne.',
      allocationExceededAskAdmin:
        'Projekt „{{name}}” wykorzystuje {{used}} z {{allocation}} przydzielonych promptów. Poproś administratora konta o zwiększenie alokacji, żeby dodać lub wznowić kolejne.',
      projectPausedInHubTitle: 'Projekt wstrzymany',
      projectPausedInHub: 'Projekt „{{name}}” jest wstrzymany. Uruchom go, żeby wznowić jego prompty.',
      projectPausedInHubAskAdmin:
        'Projekt „{{name}}” został wstrzymany przez administratora konta. Poproś administratora o jego uruchomienie.',
      confirmPauseProject:
        'Prompty projektu przestaną zbierać dane po dzisiejszym cyklu, a alokacja wróci do puli. Wstrzymać?',
      bulkPauseProjects: 'Zatrzymaj wybrane projekty',
      bulkStartProjects: 'Uruchom wybrane projekty',
      bulkRemoveProjects: 'Usuń wybrane projekty',
      agencyStatsProjects: 'Projekty',
      agencyStatsPrompts: 'Prompty',
      agencyStatsActive: 'Aktywne',
      agencyStatsPaused: 'Zapauzowane',
      agencyStatsPending: 'Oczekujące',
      agencyStatsDeletedPrompts: 'Usunięte',
      agencyStatsTotals: 'Razem',
      agencyStatsAdded: 'Dodane (okres)',
      agencyStatsDeleted: 'Usunięte (okres)',
      agencyStatsPromptsPerGroup: 'Prompty na grupę',
      agencyStatsProjectDistribution: 'Rozkład projektów',
      agencyStatsEstCost: 'Szac. koszt',
      agencyStatsCostPerPrompt: 'Koszt per prompt',
      agencyStatsActiveOverTime: 'Aktywne prompty w czasie',
      agencyStatsPromptsOverTime: 'Projekty w czasie',
      agencyStatsTableTitle: 'Statystyki grup projektów',
      agencyStatsShareOfTotal: 'Udział %',
      agencyStatsProjectsDelta: 'Projekty Δ',
      agencyStatsPromptsDelta: 'Prompty Δ',
      agencyStatsUsageScore: 'Użycie',
      agencyStatsNewPrompts: 'Nowe',
      agencyStatsExisting: 'Istniejące',
      agencyStatsStatus: 'Status',
      agencyStatsTrend: 'Trend',
      agencyStatsDailyAvg: 'Śr./dzień',
      agencyStatsFastestGrowing: 'Najszybciej rosnąca',
      agencyStatsInsightsTitle: 'Kluczowe wskaźniki',
      agencyStatsHighestUsage: 'Najwyższe użycie',
      agencyStatsLowestActivity: 'Najniższa aktywność',
      usageHigh: 'Wysokie',
      usageMedium: 'Średnie',
      usageLow: 'Niskie',
      alertHighGrowth: 'Wysoki wzrost',
      alertSpike: 'Skok',
      alertLowActivity: 'Niska aktywność',
      groups: 'Grupy projektów',
      groupsTooltip: 'Liczba grup projektów',
      projectsTooltip: 'Łączna liczba projektów',
      promptsTooltip: 'Łączna liczba promptów',

      'botsActivity.dataQuality.badge.fastlyBmOn': 'Tylko boty AI',
      'botsActivity.dataQuality.badge.fastlyBmOff': 'Wszystkie boty',
      'botsActivity.dataQuality.badge.cloudflareBmOn': 'Pełna precyzja',
      'botsActivity.dataQuality.badge.cloudflareBmOff': 'Identyfikacja po UA',
      'botsActivity.dataQuality.badge.log': 'Logi serwera',

      'botsActivity.dataQuality.popover.log.title': 'Najwyższa precyzja (logi serwera)',
      'botsActivity.dataQuality.popover.log.body':
        'Boty rozpoznane po User-Agent z Twojego pliku logów. Pełen podział per bot, per URL, per status - taka sama jakość jak Cloudflare z Bot Management.',
      'botsActivity.dataQuality.popover.log.secondary':
        'Wgraj kolejne pliki logów aby rozszerzyć historię. Każdy upload dodaje się do istniejących danych (drugi upload tego samego pliku podwoi liczniki).',

      'botsActivity.dataQuality.popover.fastlyBmOn.title': 'Liczymy tylko boty AI',
      'botsActivity.dataQuality.popover.fastlyBmOn.body':
        'Fastly Bot Management jest włączony - liczba obejmuje wyłącznie zweryfikowane crawlery AI (GPTBot, ClaudeBot, Perplexity, …).',
      'botsActivity.dataQuality.popover.fastlyBmOn.secondary':
        'Fastly nie udostępnia podziału per bot ani per URL. Aby zobaczyć, który bot trafił w który URL, dodatkowo podłącz Cloudflare lub wgraj logi serwera.',

      'botsActivity.dataQuality.popover.fastlyBmOff.title': 'Licznik zawiera wszystkie boty',
      'botsActivity.dataQuality.popover.fastlyBmOff.body':
        'Bez Bot Management Fastly nie odróżnia AI od pozostałych botów (wyszukiwarki, scrapery, monitoring). Realny udział AI to zwykle 20–40% widocznej wartości.',
      'botsActivity.dataQuality.popover.fastlyBmOff.cta': 'Jak włączyć Bot Management w Fastly',
      'botsActivity.dataQuality.popover.fastlyBmOff.secondary':
        'Aby zobaczyć podział na konkretne boty (GPTBot, ClaudeBot, …) podłącz Cloudflare lub wgraj logi serwera.',

      'botsActivity.dataQuality.popover.cloudflareBmOn.title': 'Najwyższa precyzja',
      'botsActivity.dataQuality.popover.cloudflareBmOn.body':
        'Boty rozpoznawane po Detection ID Cloudflare. Podział per bot, per URL i per status działa na zweryfikowanych sygnaturach - najbardziej precyzyjny dostępny widok.',

      'botsActivity.dataQuality.popover.cloudflareBmOff.title': 'Boty identyfikowane po User-Agent',
      'botsActivity.dataQuality.popover.cloudflareBmOff.body':
        'Pełen podział per bot, per URL i per status nadal działa. Identyfikacja konkretnego bota czytana jest z nagłówka User-Agent - mniej precyzyjnie niż Detection ID Cloudflare (te są dostępne na planach Business / Enterprise).',
      'botsActivity.dataQuality.popover.cloudflareBmOff.cta': 'Zobacz plany Cloudflare',

      'fastly.botManagementInfoTitle': 'Co zobaczysz, zależy od Bot Management',
      'fastly.botManagementInfoLine1':
        'Z Bot Management (płatny add-on Fastly): liczymy wyłącznie zweryfikowane crawlery AI (GPTBot, ClaudeBot, Perplexity, …).',
      'fastly.botManagementInfoLine2':
        'Bez Bot Management: liczymy wszystkie wykryte boty (AI + Googlebot/Bingbot + scrapery + monitoring) - realny AI to zwykle 20–40% tej liczby.',
      'fastly.botManagementInfoLimit':
        'W obu trybach Fastly Stats nie udostępnia podziału per bot ani per URL. Dla tego podłącz dodatkowo Cloudflare lub wgraj logi serwera.',

      'cloudflare.planInfoTitle': 'Wyższy plan Cloudflare = większa precyzja i dłuższa historia',
      'cloudflare.planInfoLine1':
        'Free: 1 dzień historii w pierwszym pobraniu, boty identyfikowane po User-Agent.',
      'cloudflare.planInfoLine2': 'Pro: 7 dni historii, boty identyfikowane po User-Agent.',
      'cloudflare.planInfoLine3':
        'Business / Enterprise: 30 dni historii, boty identyfikowane po Detection ID Cloudflare (znacznie precyzyjniej).',
      'cloudflare.planInfoLimit':
        'Zawsze możesz wgrać logi serwera obok Cloudflare dla dodatkowej precyzji.',

      'cloudflare.backfillInfoFree':
        'Dla Twojego planu Free pobierzemy historię z ostatniego 1 dnia (twardy limit Cloudflare). Nowe dane lecą co 15 minut. Wyższe plany dają dłuższy backfill.',
      'cloudflare.backfillInfoPro':
        'Dla Twojego planu Pro pobierzemy historię z ostatnich 7 dni (twardy limit Cloudflare). Nowe dane lecą co 15 minut. Plany Business / Enterprise dają backfill 30-dniowy.',
      'cloudflare.backfillInfoBusiness':
        'Dla Twojego planu Business pobierzemy historię z ostatnich 30 dni. Nowe dane lecą co 15 minut.',
      'cloudflare.backfillInfoEnterprise':
        'Dla Twojego planu Enterprise pobierzemy historię z ostatnich 30 dni. Nowe dane lecą co 15 minut.',
      pageTraffic: 'Cytowania adresów URL',
      pageTrafficTooltip: 'Jak często adresy URL są cytowane w odpowiedziach AI.',
      pageTrafficEmptyTitle: 'Nie wykryto żadnych zmian',
      pageTrafficEmptyDescription: 'Nie wykryliśmy żadnych zmian adresów URL w wybranym okresie.',
      pageTrafficNoDomainTitle: 'Projekt nie ma ustawionej domeny',
      pageTrafficNoDomainDescription:
        'Musimy wiedzieć, która domena jest Twoja. Dodaj swoją stronę do projektu albo oznacz domenę jako własną w sekcji Udział Twojej domeny.',
      pageTrafficTabTop: 'Top',
      pageTrafficTabTopTooltip:
        'Najczęściej używane URL-e w bieżącym okresie, według łącznej liczby użyć - bez względu na wzrost.',
      pageTrafficTabTopGainers: 'Najszybciej rosnące',
      pageTrafficTabTopGainersTooltip:
        'URL-e, których liczba cytowań wzrosła najmocniej względem poprzedniego okresu.',
      pageTrafficTabTopDecliners: 'Najszybciej tracące',
      pageTrafficTabTopDeclinersTooltip:
        'URL-e, których liczba cytowań spadła najmocniej względem poprzedniego okresu.',
      pageTrafficTabNewlyCited: 'Nowo cytowane',
      pageTrafficTabNewlyCitedTooltip:
        'URL-e cytowane po raz pierwszy w bieżącym okresie - wcześniej nie pojawiały się w projekcie.',
      pageTrafficTabDroppedOff: 'Zanikające',
      pageTrafficTabDroppedOffTooltip:
        'URL-e, które były cytowane w poprzednim okresie, a w bieżącym przestały się pojawiać.',
      lastUsed: 'Ostatnie użycie',
      models: 'Modele',
      top: 'Top',
      pageTrafficShowingTopN: 'Pokazujemy {{shown}} z {{total}} adresów URL',
      noPromptsForSource: 'Żaden prompt nie cytował tego URL-a w wybranym okresie.',
      openInNewTab: 'Otwórz w nowej karcie',
      promptsCitingThisPage: 'Prompty cytujące tę stronę',
      scanFormTitle: 'Sprawdź, jak modele AI widzą Twoją markę',
      scanFormDesc:
        'Zadajemy ChatGPT, Gemini, Perplexity i innym modelom pytania, które zadają Twoi klienci - i zamieniamy ich odpowiedzi w raport widoczności.',
      scanFormSubmit: 'Chcę darmowy raport',
      scanFormNote:
        'Wysyłamy link potwierdzający na Twój adres. Zebranie odpowiedzi zajmuje kilka minut.',
      scanEmailSentTitle: 'Sprawdź skrzynkę',
      scanEmailSentDesc:
        'Wysłaliśmy link potwierdzający. Kliknij go, a zaczniemy pytać modele o Twoją markę.',
      scanRequestFailed: 'Nie udało się rozpocząć skanu. Spróbuj ponownie za chwilę.',
      scanTooManyRequests: 'Wykorzystałeś dzisiejszy limit skanów. Spróbuj jutro.',
      scanProgressTitle: 'Zbieramy odpowiedzi modeli',
      scanProgressDesc: 'Pytamy modele o {{domain}}. Zwykle zajmuje to kilka minut.',
      scanProgressDescGeneric: 'Pytamy modele o Twoją markę. Zwykle zajmuje to kilka minut.',
      scanProgressNote: 'Możesz zamknąć tę stronę - link z maila zawsze tu wraca.',
      scanStepQuestions: 'Generujemy pytania dla Twojej kategorii',
      scanStepAsking: 'Pytamy modele AI',
      scanStepBuilding: 'Budujemy raport',
      scanFailedTitle: 'Nie udało się dokończyć tego skanu',
      scanFailedDesc: 'Coś poszło nie tak przy zbieraniu odpowiedzi. Poproś o nowy skan.',
      reportSavePdf: 'Zapisz jako PDF',
      reportCoverSubtitle: 'Raport widoczności',
      reportAllResponses: 'Wszystkie odpowiedzi',
      reportSummaryTitle: 'Gdzie jesteś',
      reportSummaryTitleAccent: 'dzisiaj.',
      reportSummarySubtitle:
        '{{brand}} pojawia się w {{visibility}}% istotnych odpowiedzi AI i ma {{share}}% share of voice.',
      reportPlatformTitle: 'Platform',
      reportPlatformTitleAccent: 'Performance.',
      reportPlatformEven: 'Wyrównana widoczność',
      reportPlatformEvenDesc: 'Twoja marka wypada tak samo na wszystkich {{count}} platformach.',
      reportPlatformDominant: 'Dominujący model',
      reportPlatformWeakest: 'Najsłabszy model',
      reportPlatformShare: '{{value}}% udziału widoczności',
      reportPlatformMetricsTitle: 'Metryki platform',
      reportPlatformMetricsDesc: 'Udział widoczności na platformach AI.',
      reportRankingTitle: 'Zajmujesz {{rank}} miejsce',
      reportRankingTitleAccent: 'w widoczności AI.',
      reportRankingSubtitle:
        'Udział odpowiedzi AI, w których pojawia się każda z marek, we wszystkich śledzonych promptach. Ranking pokazuje, jak {{brand}} wypada na tle konkurencji.',
      reportRankingYourBrand: 'Twoja marka',
      reportSovTitle: 'Share of',
      reportSovTitleAccent: 'Voice.',
      reportSovLeads:
        '{{brand}} prowadzi na rynku z {{share}}% udziału, wyprzedzając {{rival}} o {{gap}} pkt proc.',
      reportSovTrails:
        '{{brand}} ma {{share}}% udziału - {{gap}} pkt proc. za {{rival}}.',
      reportSovOnly: '{{brand}} ma {{share}}% share of voice.',
      reportSovChartTitle: 'Podział udziałów',
      reportSovChartDesc: 'Jak odpowiedzi rozkładają się między Ciebie a konkurencję.',
      reportMatrixTitle: 'Competitor',
      reportMatrixTitleAccent: 'Visibility.',
      reportMatrixSubtitle:
        'Jak konkurenci wypadają w poszczególnych modelach AI. Ciemniejsze komórki to mocniejsza obecność.',
      reportMatrixFootnote:
        'Widoczność na danej platformie; „-" oznacza brak danych dla tej marki.',
      reportTrendTitle: 'Wynik marki i',
      reportTrendVisibilityAccent: 'widoczność.',
      reportTrendSubtitle: 'Jak marka radziła sobie dzień po dniu w wybranym okresie.',
      reportTopicsTitle: 'Udział',
      reportTopicsTitleAccent: 'tematów.',
      reportTopicsSubtitle: 'Które tematy generują rozmowy AI, w których pojawia się Twoja marka.',
      reportPresenceTitle: 'Obecność marek',
      reportPresenceTitleAccent: 'w tematach.',
      reportPresenceSubtitle:
        'Gdzie każda marka pojawia się w tematach, o które Twoi klienci pytają AI.',
      reportFunnelTitle: 'Od wzmianki',
      reportFunnelTitleAccent: 'do rekomendacji.',
      reportFunnelSubtitle:
        'Lejek pokazuje, ile odpowiedzi AI przechodzi od „wzmianki" do „rekomendacji".',
      reportFunnelMentioned: 'Wzmianki',
      reportFunnelMentionedDesc: '{{responses}} z {{total}} odpowiedzi AI zawiera markę {{brand}}',
      reportFunnelTop3: 'Top-3 (rozważane)',
      reportFunnelTop3Desc: '{{responses}} odpowiedzi z marką na pierwszych trzech pozycjach',
      reportFunnelTop1: 'Top-1 (rekomendowane)',
      reportFunnelTop1Desc: '{{responses}} odpowiedzi z marką {{brand}} na pierwszym miejscu',
      reportFunnelStepTop3: 'Wzmianka Top-3',
      reportFunnelStepTop3Desc: '{{value}}% wzmianek trafia do zbioru rozważanych.',
      reportFunnelStepTop1: 'Wzmianka Top-1',
      reportFunnelStepTop1Desc: '{{value}}% wzmianek kończy na pierwszej pozycji.',
      reportGapsTitle: 'Luki',
      reportGapsTitleAccent: 'kontekstowe.',
      reportGapsSubtitle:
        'Tematy, w których konkurencja jest przed Tobą - tu najszybciej zyskasz na treściach.',
      reportDomainsTitle: 'Najczęściej cytowane',
      reportDomainsTitleAccent: 'domeny.',
      reportDomainsSubtitle:
        'Domeny, na których modele AI opierają odpowiedzi w Twojej kategorii.',
      reportDomainsShare: '{{value}}% wszystkich cytowań',
      reportPagesTitle: 'Najczęściej cytowane',
      reportPagesTitleAccent: 'strony.',
      reportPagesSubtitle:
        'Konkretne strony, które modele AI cytują najczęściej - treści kształtujące Twoje odpowiedzi.',
      reportPromptsTitle: 'Analiza',
      reportPromptsTitleAccent: 'promptów.',
      reportPromptsSubtitle:
        'Szczegółowy rozkład wyników na poziomie promptów. Momentum jest pozytywne, z mocnymi sygnałami widoczności w najlepiej radzących sobie promptach.',
      'publicScanGate.title': 'Ta strona nie jest jeszcze publiczna',
      'publicScanGate.desc': 'Podaj hasło dostępu, żeby kontynuować.',
      'publicScanGate.placeholder': 'Hasło dostępu',
      'publicScanGate.submit': 'Odblokuj',
      'publicScanGate.error': 'Błędne hasło.',
      reportPromptsLockedTitle: 'Analiza promptów jest częścią pełnego raportu',
      reportPromptsLockedDesc:
        'Zobacz, które prompty wprowadzają Twoją markę do odpowiedzi AI, a które oddają je konkurencji.',
      reportPromptsLockedCta: 'Załóż darmowe konto',
      reportPromptsTopTitle: 'Prompty z najlepszym wynikiem',
      reportPromptsTopDesc: 'Prompty z najwyższą widocznością marki w odpowiedziach AI.',
      reportPromptsTopTitleGroups: 'Prompty i grupy promptów',
      reportPromptsTopDescGroups:
        'Widoczność marki dla każdego promptu; grupy zbierają powiązane pytania.',
      reportPromptsGroupTag: 'Grupa',
      reportPromptsGroupTagCount: 'Grupa · {{count}} promptów',
      reportPromptsEven: 'Wyrównana widoczność',
      reportPromptsEvenDesc: 'Żadnych słabych punktów - wszystkie {{count}} prompty wypadają tak samo.',
      reportPromptsBest: 'Najwyższa widoczność',
      reportPromptsWorst: 'Najniższa widoczność',
      reportPromptsLowest: 'Prompt z najniższą widocznością',
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    load: 'languageOnly',
    detection: {
      order: ['navigator', 'htmlTag', 'localStorage', 'cookie', 'path', 'subdomain'],
      caches: ['localStorage', 'cookie'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
